import React, { createContext, useContext } from 'react';

export type Language = 'fa' | 'en' | 'sv';

export interface TranslationDictionary {
  [key: string]: string;
}

export const translations: Record<Language, TranslationDictionary> = {
                  fa: {
    languageLearningTitle: "آموزش زبان",
    languageLearningSubtitle: "سیستم روزانه یادگیری زبان مبتنی بر مهارت‌های ۴ گانه",
    langLearnSetupTitle: "راه‌اندازی اولیه سامانه آموزش زبان",
    langLearnSetupSubtitle: "زبان مادری و زبان‌های هدفی که قصد یادگیری آن‌ها را دارید انتخاب کنید.",
    langLearnSourceLang: "زبان مبدأ (زبان مادری شما)",
    langLearnTargetLangs: "زبان‌های هدف (زبان‌هایی که می‌خواهید یاد بگیرید)",
    langLearnDailyAvail: "زمان کل اختصاصی در روز (دقیقه)",
    langLearnDailyAvailDesc: "سیستم به صورت خودکار این زمان را بین ۴ مهارت تقسیم خواهد کرد.",
    langLearnStartBtn: "شروع سفر یادگیری",
    langLearnSaveSettings: "ذخیره تنظیمات و اهداف",
    langLearnAddTargetBtn: "افزودن زبان هدف جدید",
    langLearnTargetLangName: "نام زبان هدف",
    langLearnTargetLangLevel: "سطح تسلط فعلی (CEFR)",
    langLearnChangeLevel: "تغییر سطح تسلط",
    langLearnLevelChangedSuccess: "سطح تسلط زبان با موفقیت تغییر یافت. تمرینات جدید با این سطح ارائه می‌شوند.",
    langLearnEditTargetBtn: "ویرایش و تغییر سطح زبان",
    langLearnDailyGoalMinutes: "هدف روزانه این زبان (دقیقه)",
    langLearnListening: "شنیداری (Listening)",
    langLearnSpeaking: "گفتاری (Speaking)",
    langLearnReading: "خوانداری (Reading)",
    langLearnWriting: "نوشتاری (Writing)",
    langLearnListeningDesc: "گوش دادن به اخبار، پادکست، ویدئو و درک مطلب صوتی",
    langLearnSpeakingDesc: "مکالمه شبیه‌سازی‌شده، تلفظ صحیح و ادای جملات",
    langLearnReadingDesc: "خواندن متون طبقه‌بندی‌شده، اخبار ساده و واژگان در متن",
    langLearnWritingDesc: "نگارش جملات روزمره، یادداشت و تصحیح هوشمند نگارشی",
    langLearnTodayPlanTitle: "برنامه تمرینی امروز زبان",
    langLearnRecommendedSplit: "تقسیم هوشمند زمان بر اساس مهارت‌های ۴ گانه",
    langLearnCustomisePlan: "تغییر دستی زمان‌بندی مهارت‌ها",
    langLearnTotalPlanned: "کل برنامه ریزی شده: {{min}} دقیقه",
    langLearnCompletedMin: "{{min}} دقیقه تکمیل شده",
    langLearnOfPlanned: "از {{total}} دقیقه",
    langLearnAllSkillsDone: "🎉 آفرین! تمام مهارت‌های برنامه‌ریزی‌شده امروز را تکمیل کردید.",
    langLearnStartPractice: "شروع تمرین",
    langLearnPracticeTitle: "اتاق تمرین تعاملی",
    langLearnAudioListen: "پخش و شنیدن تلفظ متن",
    langLearnSpeakNow: "تمرین تلفظ و گفتار",
    langLearnReadContent: "متن و تمرین درک مطلب",
    langLearnWriteResponse: "پاسخ یا نگارش متن شما:",
    langLearnVoiceInputTip: "برای صحبت کردن و تبدیل گفتار به متن از دکمه میکروفون استفاده کنید.",
    langLearnGenerateAiExercise: "تولید تمرین جدید با هوش مصنوعی",
    langLearnRequestAiFeedback: "بررسی و تصحیح هوشمند با AI",
    langLearnAiGenerating: "در حال تولید تمرین متناسب با سطح شما...",
    langLearnAiFeedbackTitle: "بازخورد، تصحیح و نکات گرامری",
    langLearnCorrections: "موارد اصلاح‌شده در نگارش:",
    langLearnOriginal: "متن اولیه:",
    langLearnCorrected: "متن اصلاح‌شده:",
    langLearnImprovementTip: "نکته آموزشی:",
    langLearnCompleteSession: "ثبت و اتمام جلسه تمرین",
    langLearnSessionSaved: "جلسه تمرین با موفقیت در ابری ذخیره شد.",
    langLearnResourcesTitle: "منابع و پایگاه‌های یادگیری خارجی",
    langLearnResourcesSubtitle: "لینک‌های معتبر و طبقه‌بندی‌شده برای تقویت مهارت‌ها",
    langLearnFilterAll: "همه مهارت‌ها",
    langLearnAddResourceBtn: "افزودن لینک منبع جدید",
    langLearnResourceTitle: "عنوان منبع",
    langLearnResourceUrl: "آدرس اینترنتی (URL)",
    langLearnResourceSource: "نام پایگاه / وب‌سایت",
    langLearnDifficultyLevel: "سطح دشواری",
    langLearnVisitResource: "مشاهده منبع در سایت اصلی",
    langLearnDeleteResource: "حذف منبع",
    langLearnStatsTitle: "پیشرفت کلی و آمار مهارت‌ها",
    langLearnTotalTime: "کل زمان تمرین‌شده",
    langLearnSessionsCount: "تعداد جلسات",
    langLearnStreakDays: "روزهای متوالی تمرین (Streak)",
    langLearnHistoryTitle: "تاریخچه جلسات ثبت‌شده",
    langLearnNoHistory: "هنوز جلسه‌ای برای این زبان ثبت نشده است. اولین تمرین امروز خود را آغاز کنید!",
    langLearnTargetLangRequired: "حداقل یک زبان هدف برای شروع الزامی است.",
    langLearnSelectSourcePlaceholder: "زبان مادری خود را انتخاب کنید",
    langLearnSelectTargetPlaceholder: "زبان هدف را انتخاب کنید",
    langLearnLanguagePersian: "فارسی (Persian)",
    langLearnLanguageSwedish: "سوئدی (Swedish)",
    langLearnLanguageEnglish: "انگلیسی (English)",
    langLearnLanguageGerman: "آلمانی (German)",
    langLearnLanguageFrench: "فرانسوی (French)",
    langLearnLanguageSpanish: "اسپانیایی (Spanish)",
    langLearnLanguageItalian: "ایتالیایی (Italian)",
    langLearnLanguageArabic: "عربی (Arabic)",
    langLearnLanguageTurkish: "ترکی (Turkish)",
    langLearnLevelA1: "سطح A1 (مبتدی)",
    langLearnLevelA2: "سطح A2 (پایه)",
    langLearnLevelB1: "سطح B1 (متوسط)",
    langLearnLevelB2: "سطح B2 (پیشرفته کاربردی)",
    langLearnLevelC1: "سطح C1 (تسلط حرفه‌ای)",
    langLearnLevelAll: "مناسب برای تمام سطوح",
    dashLanguageLearningTitle: "آموزش زبان: برنامه روزانه",
    dashLanguageLearningProgress: "{{completed}} از {{total}} دقیقه تمرین شده",
    sleep: "ساعت خواب",
    water: "آب مصرفی",
    weight: "پایش وزن و هدف",
    dailyScratchpad: "یادداشت‌ها و وظایف سریع روز",
    swedishTitle: "آموزش سوئدی",
    viewingDate: "مشاهده روز دیگر",
    schedulesCurrentActiveTaskTitle: "📌 فعالیت هم‌اکنون شما",
    schedulesTodayBadge: "امروز",
    prevDay: "روز قبل",
    nextDay: "روز بعد",
    schedulesBackToToday: "🕒 بازگشت به امروز",
    schedulesNowBadge: "در حال انجام | NOW",
    schedulesNextBadge: "رویداد بعدی | NEXT",
    dashTodaysPlanTitle: "برنامه و وظایف روزانه",
    dashLoadingPlan: "در حال دریافت برنامه امروز...",
    dashErrorLoadingPlan: "خطا در دریافت برنامه امروز",
    retry: "تلاش مجدد",
    dashTasksProgressSummary: "{{completed}} از {{total}} فعالیت انجام شده",
    dashTodayExercisePlanTitle: "برنامه تمرینی امروز: فیزیوتراپی و اصلاحی",
    dashRehabProgress: "{{completed}} از {{total}} حرکت انجام شده ({{percent}}٪)",
    dashAllExercisesDone: "🎉 آفرین! تمام حرکات تمرینی امروز با موفقیت انجام شد.",
    dashExpandExercises: "نمایش لیست کامل حرکات",
    dashCollapseExercises: "بستن لیست حرکات",
    dashNoExercisesForToday: "هیچ حرکتی برای برنامه امروز تعریف نشده است.",
    dashManageInRehab: "مدیریت در فیزیوتراپی",
    dashViewExerciseList: "مشاهده حرکات روز ({{count}} حرکت)",
    dashNoTasksToday: "هیچ روتینی برای این روز ثبت نشده است",
    dashRestDayTitle: "روز استراحت و ریکاوری",
    dashRestDayDesc: "هیچ فعالیت موظفی برای این روز ثبت نشده است.",
    schedulesAddActivity: "+ افزودن برنامه",
    dashNextCardTitle: "بعدی",
    dashTaskRequired: "الزامی",
    dashTaskOptional: "اختیاری",
    dashAllTasksDoneCongrats: "تمام فعالیت‌های برنامه‌ریزی‌شده امروز با موفقیت تکمیل شدند!",
    sleepStartTime: "ساعت شروع خواب",
    sleepWakeTime: "ساعت بیدارشدن",
    weightTargetReached: "🎉 به وزن هدف رسیده‌اید",
    weightTargetProgress: "هدف: {{target}} kg (مانده: {{remaining}} kg)",
    weightTargetEstDate: "تاریخ تخمینی رسیدن به هدف:",
    viewProfileMetrics: "مشاهده نمودار و پایش وزن",
    quickAccessModules: "دسترسی سریع به ماژول‌های برنامه",
    newsBulletin: "مشاهده اخبار",
    rehabTitle: "فیزیوتراپی و تمرینات اصلاحی",
    fatLossTitle: "چربی‌سوزی و کاردیو",
    nutritionTitle: "تغذیه و کالری",
    notesTitle: "دفترچه و یادداشت",
    schedulesTitle: "پلنر هفتگی و روال‌های روزانه",
    allCategories: "همه دسته‌بندی‌ها",
    taskReqStandard: "الزامی / استاندارد",
    taskReqBonus: "اختیاری / مازاد",
    schedulesCatWork: "کار و اشتغال",
    schedulesCatRehab: "فیزیوتراپی و دیسک کمر",
    schedulesCatFatLoss: "ورزش و کاردیو",
    schedulesCatSwedish: "آموزش و یادگیری (سوئدی/دوره/موسیقی/SFI)",
    schedulesCatNutrition: "تغذیه و سلامت",
    schedulesCatRoutine: "روتین شخصی و عمومی",
    schedulesNoTasksFilter: "هیچ فعالیتی با فیلتر انتخابی شما یافت نشد.",
    schedulesCurrentActiveTask: "هم‌اکنون",
    schedulesSelectDayToManage: "انتخاب روز هفته جهت ویرایش و برنامه‌ریزی:",
    schedulesCopyDayToAllWeek: "کپی این روز به تمام هفته",
    schedulesCopyDayToAllWeekTooltip: "کپی تمام برنامه‌های روز انتخابی به تمام روزهای هفته",
    schedulesFormDay: "روز هفته:",
    schedulesFormCategory: "دسته‌بندی:",
    isRequiredTaskLabel: "فعالیت الزامی (در لیست وظایف موظف روزانه)",
    schedulesFormIsWork: "ثبت به‌عنوان شیفت کاری",
    schedulesAddActivityTitle: "تعریف فعالیت جدید در برنامه هفتگی",
    schedulesEditActivityTitle: "ویرایش فعالیت در برنامه هفتگی",
    schedulesErrorSave: "خطا در ذخیره فعالیت در دیتابیس D1",
    schedulesErrorDelete: "خطا در حذف فعالیت از دیتابیس D1",
    schedulesAddRoutineBtn: "افزودن فعالیت جدید",
    schedulesRehabDescriptionPattern: "تمرینات فیزیوتراپی و ریکاوری ستون فقرات ({{count}} حرکت)",
    schedulesTodayScheduleTitle: "جدول زمان‌بندی و برنامه روتین امروز ({{day}})",
    schedulesTodayScheduleSub: "فعالیت‌های موظف خود را پس از اجرا علامت بزنید تا وضعیت روزانه شما به‌روزرسانی شود.",
    schedulesAddQuickRoutine: "افزودن به امروز",
    schedulesNoRoutinesToday: "هیچ روتینی برای امروز ثبت نشده است!",
    schedulesNoRoutinesTodayDesc: "می‌توانید با استفاده از تب «مدیریت کل هفته» یا دکمه افزودن، برای امروز روتین‌های کاری، آموزشی یا ورزشی تعریف کنید.",
    schedulesGoToManage: "ورود به مدیریت هفتگی",
    schedulesCompletedStatus: "انجام شد",
    schedulesMarkComplete: "علامت انجام",
    schedulesRoutinesForDay: "فعالیت‌های ثبت‌شده برای {{day}}",
    schedulesFormTitlePlaceholder: "مثلاً: شیفت کاری، فیزیوتراپی، کلاس سوئدی، تمرین موسیقی...",
    schedulesFormDescPlaceholder: "توضیحات اختیاری، اهداف یا جزئیات اجرایی این فعالیت...",
    markCompleted: "ثبت انجام فعالیت",
    schedulesPendingStatus: "انجام نشده",
    doneUnit: "انجام شده",


    manageContactsHeaderBtn: "مخاطبین تاییدشده ({{count}})",
    shopShareModalTitle: "اشتراک‌گذاری خانوادگی دفترچه خرید",
    shopShareModalSubtitle: "اشتراک‌گذاری «{{name}}»",
    shopShareModalDesc: "می‌توانید با یک کلیک از لیست مخاطبین تاییدشده انتخاب کنید یا ایمیل جدید وارد نمایید.",
    approvedContactsQuickTitle: "اشتراک سریع با مخاطبین تاییدشده:",
    manageContactsBtn: "مدیریت مخاطبین",
    noContactsYetHint: "هنوز مخاطب تاییدشده‌ای ثبت نکرده‌اید.",
    addFirstContact: "افزودن مخاطب جدید (همسر، برادر، همکار...)",
    shopRecipientEmail: "یا وارد کردن دستی ایمیل مخاطب:",
    autoSaveToContactsCheck: "حفظ خودکار این ایمیل در لیست مخاطبین تاییدشده من",
    shopMembersWithAccess: "اعضای دارای دسترسی به این دفترچه:",
    contactsManagerSubtitle: "لیست مخاطبین تاییدشده و اعضای مجاز",
    contactsManagerTitle: "مدیریت مخاطبین اشتراک‌گذاری",
    contactsManagerDesc: "اطلاعات همسر، هم‌خانه‌ای یا همکاران خود را ذخیره کنید تا هنگام اشتراک‌گذاری دفترچه‌های خرید، نیازی به تایپ مجدد ایمیل نباشد.",
    addNewContactHeading: "افزودن مخاطب جدید:",
    contactNameLabel: "نام یا عنوان (مثلا: همسر - مریم):",
    contactNamePlaceholder: "نام یا عنوان مخاطب",
    contactEmailLabel: "آدرس ایمیل:",
    contactRelationLabel: "نسبت/دسته‌بندی:",
    saveContactBtn: "ذخیره مخاطب",
    savedContactsListHeader: "مخاطبین تاییدشده ذخیره‌شده ({{count}}):",
    searchContactsPlaceholder: "جستجوی مخاطب...",
    noContactsInList: "هیچ مخاطب تاییدشده‌ای ثبت نشده است. از فرم بالا مخاطب جدید اضافه کنید.",
    deleteContact: "حذف مخاطب",
    relationFamily: "خانواده (همسر / فرزند / برادر...)",
    relationFriend: "دوست / هم‌خانه‌ای",
    relationWork: "همکار / کاری",
    relationOther: "سایر",
    shopSharedSuccessWithName: "دفترچه با موفقیت با {{name}} ({{email}}) به اشتراک گذاشته شد.",
    batchPastePlaceholder: "متن یا کپی صورت‌حساب بانک / اکسپورت خود را در اینجا پیست کنید. مثال:\n2026-08-01, Hemköp Stockholm, -485 SEK, Hemköp Card\n2026-08-02, SL Buss Månadskort, -970 SEK, Handelsbanken Debit\n2026-08-03, Swish to Ali, -250 SEK\n2026-08-07, Lön Handelsbanken, +38500 SEK",
    cancel: "انصراف",
    learningAiResponseTag: "پاسخ هوش مصنوعی",
    learningDocumentExtracted: "متن استخراج‌شده از این سند (خلاصه در ۱۸۰۰ کاراکتر):\n{{text}}",
    learningDocumentName: "نام فایل پیوست: {{name}}",
    learningHeaderDesc: "مدیریت دوره‌های آموزشی، استخراج خودکار متون و فیلم‌ها، تدریس هوشمند خصوصی با AI",
    learningHeaderTitle: "دستیار یادگیری و مدیریت منابع هوشمند",
    learningTeacherNoteTag: "یادداشت استاد",
    learningUserMsgTag: "ورودی / مبحث کاربر",
    learningVideoUrlPlaceholder: "https://www.youtube.com/watch?v=... یا https://www.aparat.com/v/...",
    newsActiveTopicsLabel: "موضوعات فعال برای پایش زنده اخبار:",
    newsAddAndMonitorBtn: "افزودن و پایش اخبار",
    newsAiAnalyzingWait: "در حال پایش و دریافت آخرین اخبار ۷ روز اخیر با هوش مصنوعی...",
    newsAiSearchingEvents: "جستجوی رویدادها و تحولات تازه‌تر درباره موضوعات شما",
    newsCopiedSuccess: "کپی شد!",
    newsCopyFullReport: "کپی کل گزارش",
    newsDeleteTopicTooltip: "حذف موضوع",
    newsEmptyDescNoTopics: "کافیست موضوعات یا شهرهای مورد نظر خود را در کادر بالا وارد کنید تا اخبار داغ هفته اخیر را دریافت کنید.",
    newsEmptyDescReady: "بر روی دکمه زیر کلیک کنید تا هوش مصنوعی آخرین اخبار مربوط به موضوعات شما را پایش و تحلیل کند.",
    newsEmptyTitleNoTopics: "موضوعات مورد علاقه خود را اضافه کنید",
    newsEmptyTitleReady: "آماده دریافت آخرین اخبار ۷ روز اخیر",
    newsErrorAddTopicFirst: "لطفاً ابتدا حداقل یک موضوع مورد علاقه را وارد و اضافه کنید.",
    newsErrorAiFetch: "خطا در دریافت اخبار از هوش مصنوعی. لطفاً اتصال اینترنت را بررسی کنید.",
    newsFetchAiBtn: "پایش و دریافت اخبار ۷ روز اخیر با هوش مصنوعی",
    newsFetchingStatus: "در حال پایش و دریافت اخبار...",
    newsHeaderDesc: "پایش آخرین تحولات تکنولوژی، خلاصه‌سازی اختصاصی بولتن خبری با AI و تحلیل رویدادها",
    newsHeaderTitle: "رادار هوشمند اخبار، هوش مصنوعی و فناوری",
    newsNoSearchResults: "### 🔍 هیچ موردی متناسب با عبارت \"{{query}}\" یافت نشد.\n\nلطفاً کلمه دیگری را جستجو کنید یا دکمه بروزرسانی اخبار را فشار دهید.",
    newsNoTopicsHint: "هنوز هیچ موضوعی اضافه نکرده‌اید. موضوع مورد نظرتان را در کادر بالا تایپ کنید!",
    newsPresetAi: "آخرین اخبار هوش مصنوعی و LLMها",
    newsPresetAiDesc: "مدلهای جدید Gemini, OpenAI, Claude و ابزارهای AI",
    newsPresetHardware: "عینک‌های هوشمند و گجت‌های پوشیدنی",
    newsPresetHardwareDesc: "گجت‌های پوشیدنی جدید مانند Ray-Ban Meta و Vision Pro",
    newsPresetIsfahan: "اخبار رویدادها و تحولات شهری",
    newsPresetIsfahanDesc: "پایش اخبار شهری، پروژه‌ها و رویدادهای مهم منطقه‌ای",
    newsPresetSemiconductors: "بازار بورس فناوری و نیمه‌هادی‌ها",
    newsPresetSemiconductorsDesc: "تحلیل بازار چیپست‌ها و بورس بین‌الملل",
    newsPresetWulf: "سهام و دیتاسنترهای AI",
    newsPresetWulfDesc: "آخرین تحلیل قیمت، گزارش مالی و قراردادهای مرتبط",
    newsQuickInputPlaceholder: "موضوع دلخواه خود را تایپ کنید (مثلاً: اخبار فناوری، سهام دیتاسنترها، عینک هوشمند...)",
    newsQuickPresetsTitle: "پیشنهادهای سریع برای اضافه کردن موضوع:",
    newsSaveAndConfirmBtn: "ذخیره و تایید",
    newsSearchPlaceholder: "جستجو در اخبار دریافت شده...",
    newsSettingsModalTitle: "تنظیمات موضوعات و لحن گزارش",
    newsSettingsToneBtn: "تنظیمات و لحن",
    newsTitle: "رادار اخبار و هوش مصنوعی",
    newsToneAnalytical: "🎯 تحلیلی و مدیریتی (تمرکز بر تحلیل و فرصت‌ها)",
    newsToneDeepTech: "🔬 عمیق و تخصصی (بررسی جزئیات کامل)",
    newsToneFastSummary: "⚡ سریع و بولتی (فقط خلاصه‌های بسیار کوتاه)",
    newsToneLabel: "لحن و شخصیت گزارش اخبار:",
    newsToneStandard: "📰 روزنامه‌نگاری و خبررسانی روان",
    newsTopicLiveMonitorDesc: "پایش زنده اخبار ۷ روز اخیر درباره {{topic}}",
    newsUpdate7DaysBtn: "بروزرسانی اخبار ۷ روز اخیر",
    newsYourTopics: "موضوعات شما:",
    shopAllBoughtHint: "تمام اقلام خریداری شده‌اند یا موردی در این دسته‌بندی یافت نشد.",
    shopListEmptyHint: "این دفترچه خالی است! اقلام مورد نیاز را در کادر بالا یا انتخاب سریع وارد کنید.",
    shopOneKg: "۱ کیلو",
    shopPresetBBQ: "کباب و پیک‌نیک",
    shopPresetFruits: "خرید میوه و سبزی",
    shopPresetHome: "خرید هفتگی خانه",
    shopPresetOnline: "خرید آنلاین",
    shopPresetPharmacy: "داروخانه و بهداشتی",
    shopPresetSupermarket: "خواربار و سوپرمارکت",
    shopQty1kg: "۱ کیلو",
    shopQty1pack: "۱ بسته",
    shopQty1pcs: "۱ عدد",
    shopQty2kg: "۲ کیلو",
    shopQty2pack: "۲ بسته",
    shopQty2pcs: "۲ عدد",
    shopQty3kg: "۳ کیلو",
    shopQty5kg: "۵ کیلو",
    shopQtyHalfKg: "نیم کیلو",
    "2d": 'دوبعدی',
    actions: 'عملیات',
    activeMonthlySavingsBudget: 'بودجه پس‌انداز ماهانه فعال:',
    activities: 'ثبت فعالیت‌های متفرقه',
    activityAthlete: 'ورزشکار حرفه‌ای / تمرین سنگین روزانه',
    activityHigh: 'تحرک زیاد (۶-۷ روز در هفته)',
    activityLight: 'تحرک سبک (۱-۳ روز در هفته)',
    activityModerate: 'تحرک متوسط (۳-۵ روز در هفته)',
    activitySedentary: 'کم‌تحرک / بدون ورزش',
    actualSpentHeader: 'هزینه‌کرد واقعی:',
    add: 'افزودن',
    addBtn: 'افزودن',
    addFoodLog: 'ثبت وعده غذایی جدید',
    addGoogleCalendar: 'افزودن مستقیم به تقویم گوگل',
    addInvoiceCostBtn: 'ثبت فاکتور / هزینه جدید',
    addItem: 'افزودن کالا به لیست خرید',
    addItemTitle: 'عنوان اقلام / کالا',
    addNewRow: 'افزودن ردیف جدید',
    addNewRowBtn: 'افزودن ردیف جدید',
    addReminder: 'افزودن یادآور جدید',
    addReminderBtn: 'ثبت یادآور جدید',
    addScheduleTask: 'افزودن برنامه جدید',
    addTodoPlaceholder: 'افزودن کار جدید...',
    addTransaction: 'ثبت تراکنش جدید',
    adminBadge: 'مدیر ارشد',
    advisorClearConfirm: 'آیا از پاکسازی و شروع مجدد تاریخچه گفتگو با مشاور مالی اطمینان دارید؟',
    advisorHeaderDesc: 'تحلیل زنده درآمد خالص، رفتار هزینه‌ای، سقف بودجه و اهداف مالی برای ارائه توصیه‌های راهبردی',
    advisorLiveAnalysisDesc: 'تحلیل زنده درآمد خالص، رفتار هزینه‌ای، سقف بودجه و اهداف مالی برای ارائه توصیه‌های راهبردی',
    advisorTab: 'مشاور هوشمند مالی',
    advisorWelcomeText: 'سلام و درود! من **مشاور ارشد هوشمند مالی و استراتژیست ثروت** شما هستم. 💼🌟\\\\\\\\\\\\\\\\n\\\\\\\\\\\\\\\\nمن آگاهی کامل و لحظه‌ای به **درآمد خالص، هزینه‌ها، سقف بودجه، رادار مصرف اقلام و اهداف مالی فعال شما** دارم. می‌توانید سوالات تخصصی خود را بپرسید.',
    afterRecordingBudgetLabel: 'پس از ثبت:',
    afterRecordingMsg: 'پس از ثبت: {{amount}} {{currency}}',
    aiAnalysisTab: 'بولتن تحلیلی AI',
    aiBriefingTitle: 'خلاصه اختصاصی هوش مصنوعی',
    aiFinancialAdvisor: 'مشاور هوشمند مالی',
    aiScannerTab: 'اسکنر هوشمند فاکتور (AI)',
    alertAiAnalysisError: 'خطا در تحلیل هوش مصنوعی',
    alertAiScanError: 'خطا در ارتباط با هوش مصنوعی برای اسکن فاکتور',
    alertBatchImportSuccess: 'تعداد {{count}} تراکنش با موفقیت به دفتر مالی شما افزوده شد.',
    alertInvalidFileType: 'لطفاً فایلی از نوع PDF، تصویر یا متنی انتخاب کنید.',
    alertInvoiceSavedSuccess: 'فاکتور با تمام اقلام ریز با موفقیت در سیستم ثبت شد!',
    alertNoRowsExtracted: 'هیچ ردیفی با موفقیت استخراج نشد. لطفاً قالب متن کپی‌شده را بررسی کنید.',
    alertNoTextFoundInReceipt: 'متن کافی در رسید/فاکتور یافت نشد.',
    alertPasteBankStatement: 'لطفاً ابتدا متنی از صورت‌حساب بانک را در کادر بالا پیست کنید.',
    alertReceiptScannedSuccess: 'فاکتور اسکن و اقلام آن با موفقیت استخراج گردید.',
    alertScanOrEnterFirst: 'ابتدا فاکتوری را اسکن کنید یا متنی وارد نمایید.',
    all: 'همه',
    allCardsOption: '💳 همه کارت‌ها و حساب‌ها',
    allTxAssignedToCard: 'تمامی {{count}} تراکنش به این کارت منتسب می‌شوند',
    allTxsAssignedToCard: 'تمامی {{count}} تراکنش به این کارت منتسب می‌شوند.',
    allergiesDefault: 'حساسیت خاصی ندارم',
    allergiesNone: 'حساسیت خاصی ندارم',
    allocationSurplusOverCap: 'تخصیص مازاد بر سقف کل هزینه‌ها:',
    amount: 'مبلغ',
    amountColumnHeader: 'مبلغ',
    analyticsDashboardDesc: 'توزیع کالاها و هزینه‌های ریز فاکتورها',
    analyticsDashboardTitle: 'تحلیل اقلام و هزینه‌ها',
    appAdminVersionList: 'مشاهده لیست تغییرات نسخه‌ها (مخصوص مدیریت)',
    appAdminVersionListCustom: 'مشاهده لیست تغییرات نسخه‌ها (مخصوص salim.zarepour@gmail.com)',
    appCheckingAccount: 'در حال بررسی وضعیت حساب کاربری شما...',
    appCloudDb: 'ابری D1',
    appCloudDbDesc: 'پایگاه داده ابری D1 • ذخیره‌سازی ایمن',
    appComponentStandby: 'اجزا در حالت آماده‌باش قرار دارند.',
    appLogoutMenu: 'خروج از حساب کاربری',
    appMobileMenuTitle: 'منوی ناوبری پیشرفت',
    appName: 'پیشرفت - مدیریت زندگی و سلامت',
    appShortName: 'پیشرفت',
    appSlogan: 'سامانه آنلاین برنامه‌ریزی و پایش روزانه پیشرفت',
    appVersionOnly: 'نسخه {{version}}',
    appVersionPrefix: 'پیشرفت نسخه {{version}}',
    appWeeklyReminderBody: 'زمان انجام فعالیت «{{title}}» فرا رسیده است.',
    appWeeklyReminderTitle: '⏰ یادآور برنامه هفتگی: {{title}}',
    askDoctor: 'شرح علائم یا پرسش پزشکی خود را بنویسید...',
    askDoctorPlaceholder: 'علائم بیماری، سوابق یا پرسش پزشکی خود را بنویسید...',
    autoAllocateCaps: 'تخمین خودکار سقف دسته‌بندی‌ها ({{pct}}٪)',
    back: 'بازگشت',
    balance: 'موجودی',
    balanceLabel: 'مانده:',
    balanceShort: 'مانده: {{amount}} {{currency}}',
    baseCurrencyLabel: 'ارز پایه پیش‌فرض سیستم (Base Currency):',
    baseCurrencySyncDesc: 'تغییر این گزینه، تمام محاسبات بودجه‌بندی، کارت‌های شاخص، اسکنر AI و اهداف مالی را همگام‌سازی می‌کند.',
    batchCardAccountConnected: 'کارت / حساب متصل به تمامی تراکنش‌های این صورت‌حساب:',
    batchColAmount: 'مبلغ ({{currency}})',
    batchColTxTitle: 'عنوان تراکنش',
    batchConfirmSave: 'تأیید و ثبت نهایی در پایگاه داده',
    batchDuplicate: '⚠️ تکراری با {{title}} (صرف‌نظر از ثبت تکراری)',
    batchExtractedCount: 'نمایش تراکنش‌های استخراج‌شده ({{count}} مورد)',
    batchImportDesc: 'متن خروجی یا CSV صورت‌حساب بانک یا فروشگاه را کپی کرده و مستقیماً در کادر متنی زیر پیست (Paste) کنید. (نیاز به آپلود فایل نیست)',
    batchImportHeaderDesc: 'متن خروجی یا CSV صورت‌حساب بانک یا فروشگاه را کپی کرده و مستقیماً در کادر متنی زیر پیست (Paste) کنید. (نیاز به آپلود فایل نیست)',
    batchImportHeaderTitle: 'ورود دسته‌ای و هوشمند تراکنش‌های بانک و صورت‌حساب‌ها (Batch Import)',
    batchImportSectionTitle: 'ورود دسته‌ای و هوشمند تراکنش‌های بانک و صورت‌حساب‌ها (Batch Import)',
    batchImportTab: 'ورود دسته‌ای صورت‌حساب',
    batchMatchBank: '🔄 تطبیق با تراکنش بانک {{title}} (جزئیات خرید جایگزین بانک می‌شود)',
    batchMatchPurchase: '⚡ تطبیق با خرید {{title}} (کارت بانک به خرید اعمال می‌شود)',
    batchNew: '🟢 جدید',
    batchPreviewTableTitle: 'جدول پیش‌نمایش تراکنش‌های استخراج‌شده ({{count}} مورد)',
    batchReadyToImportCount: 'تعداد {{count}} تراکنش انتخابی آماده ثبت نهایی است.',
    batchSelectedReady: 'تعداد {{count}} تراکنش انتخابی آماده ثبت نهایی است.',
    batchTotalExpense: 'مجموع هزینه: {{amount}} {{currency}}',
    batchTotalIncome: 'مجموع درآمد/ورودی: {{amount}} {{currency}}',
    batchUpload: 'ورود دسته‌ای صورت‌حساب / CSV',
    bellyFat: 'کاردیو چربی شکم',
    bellyFatHeaderDesc: 'تمرینات اینتروال چربی‌سوزی، تایمر اختصاصی ست‌ها و محاسبه کالری مصرفی',
    bellyFatHeaderTitle: 'کاردیو، چربی‌سوزی شکم و تناسب اندام',
    billsCategory: '💳 قبوض و امور مالی',
    birthdaysCategory: '🎂 تولد و مناسبت‌ها',
    bmiCategoryLabel: 'وضعیت شاخص BMI',
    bought: 'خریداری شد',
    boughtCount: 'خریده شده',
    branding: 'پوسته و رنگ‌های برنامه',
    brandingHeaderDesc: 'انتخاب رنگ برتر، تم تاریک/روشن و شخصی‌سازی کارت‌های رابط کاربری',
    brandingHeaderTitle: 'پوسته، تم رنگی و سفارشی‌سازی ظاهر برنامه',
    budgetAllocationPercent: '{{percent}}٪ از درآمد خالص',
    budgetAllocationSummary: 'هزینه ({{expense}}%) + پس‌انداز ({{saving}}%) = ۱۰۰%',
    budgetAndNetIncome: 'بودجه‌بندی و درآمد خالص',
    budgetCapHeader: 'سقف بودجه:',
    budgetCapShort: 'سقف: {{amount}} {{currency}}',
    budgetExceeded: 'تخطی از بودجه:',
    budgetExceededMsg: 'تخطی از بودجه: {{amount}} {{currency}} اضافی هزینه شده!',
    budgetHistoryDesc: 'بررسی مقایسه‌ای سقف بودجه، هزینه‌کرد واقعی و مانده/مازاد بودجه در ماه‌های گذشته',
    budgetHistorySectionDesc: 'بررسی مقایسه‌ای سقف بودجه، هزینه‌کرد واقعی و مانده/مازاد بودجه در ماه‌های گذشته',
    budgetHistorySectionTitle: 'تاریخچه و خلاصه عملکرد بودجه‌بندی ماه‌های مختلف',
    budgetHistoryTitle: 'تاریخچه و خلاصه عملکرد بودجه‌بندی ماه‌های مختلف',
    budgetPatternNote: 'الگوی سقف بودجه به‌صورت خودکار بر همه ماه‌ها اعمال می‌شود؛ تغییر ماه برای بررسی عملکرد آن دوره است.',
    budgetRemainingLabel: '✓ مانده: {{amount}} {{currency}}',
    budgetSettingsDesc: 'تنظیم درآمد و سقف هزینه‌های ماهانه',
    budgetSettingsTitle: 'تنظیمات بودجه‌بندی',
    budgetSpentShort: 'مصرفی: {{amount}} {{currency}}',
    budgetStatusLabel: 'وضعیت بودجه:',
    budgetSurplusLabel: '⚠️ مازاد: {{amount}} {{currency}}',
    budgetTotalUsedRatio: '{{pct}}٪ از کل بودجه استفاده شده',
    budgetUsagePercent: '{{percent}}٪ از سقف بودجه',
    budgetUsageStatusIn: 'وضعیت مصرف بودجه در {{month}}',
    budgetUsageStatusInMonth: 'وضعیت مصرف بودجه در {{month}}',
    budgets: 'بودجه‌بندی و اهداف مالی',
    bulkDeleteBtn: 'حذف موارد انتخابی',
    calculateAiCalories: 'محاسبه هوشمند کالری هدف با AI',
    calendarTab: 'نمای تقویم ماهانه',
    calories: 'کالری',
    caloriesGoal: 'کالری هدف روزانه',
    capLabel: 'سقف:',
    carbs: 'کربوهیدرات',
    carbsGoal: 'کربوهیدرات (گرم)',
    cardBreakdownTitle: 'تفکیک کارت‌ها و حساب‌ها',
    cardConnectedToAllTxs: 'کارت / حساب متصل به تمامی تراکنش‌های این صورت‌حساب:',
    catCarMaintenance: 'خودرو/بیمه',
    catCharityGifts: 'هدیه/خیریه',
    catClothing: 'پوشاک',
    catEducation: 'آموزش',
    catElectronics: 'الکترونیک',
    catEntertainment: 'تفریح',
    catFamily: 'خانواده',
    catGroceries: 'سوپرمارکت',
    catHealth: 'سلامت',
    catHomeDecor: 'لوازم خانگی',
    catHousing: 'مسکن',
    catInvestment: 'سرمایه',
    catMain: 'اصلی و دستیاران',
    catOther: 'سایر',
    catPets: 'پت‌شاپ',
    catPlanning: 'برنامه‌ریزی، یادگیری و گزارش',
    catRestaurants: 'رستوران',
    catSalary: 'حقوق',
    catSettings: 'تنظیمات و مدیریت',
    catSubscriptions: 'اشتراک/SaaS',
    catTransport: 'حمل‌ونقل',
    catUtilities: 'قبوض',
    categoriesWithBudgetCapCount: '{{count}} دسته‌بندی دارای سقف بودجه',
    categoriesWithCapCount: '{{count}} دسته‌بندی دارای سقف بودجه',
    categoriesWithoutCapTitle: 'دسته‌بندی‌های بدون سقف اختصاصی (صرفاً گزارش هزینه‌کرد):',
    category: 'دسته‌بندی',
    categoryCapsDesc: 'تعیین سقف مجاز هزینه برای مسکن، سوپرمارکت، قبوض، حمل‌ونقل و... (امکان درج ۰ برای بخش‌های بدون هزینه)',
    categoryCapsLabel: 'سقف بودجه مجاز دسته‌بندی‌های غنی:',
    categoryInvestment: 'سرمایه‌گذاری',
    categoryPets: 'حیوانات خانگی',
    categorySalary: 'حقوق و دستمزد',
    categorySubscriptions: 'اشتراک و نرم‌افزار',
    categoryTitle: 'دسته‌بندی کالا',
    clearAndStartChat: 'پاکسازی و شروع گفتگو',
    clearChatHistoryTitle: 'پاکسازی تاریخچه گفتگو',
    clearCompleted: 'پاکسازی موارد خریداری‌شده',
    clearFilters: 'پاکسازی فیلترها',
    close: 'بستن',
    closeBtn: 'بستن',
    cloudSyncActive: 'همگام‌سازی ابری فعال',
    commonCancel: 'انصراف',
    confirm: 'تأیید',
    confirmBatchImportBtn: 'تأیید و ثبت نهایی در پایگاه داده',
    confirmClearAdvisorHistory: 'آیا از پاکسازی و شروع مجدد تاریخچه گفتگو با مشاور مالی اطمینان دارید؟',
    confirmDepositBtn: 'تایید واریزی',
    createGoalBtn: 'ایجاد هدف',
    createShoppingList: 'ایجاد لیست خرید جدید',
    currentCardsCount: 'کارت‌های فعلی شما ({{count}} مورد):',
    currentExpensesShare: 'سهم هزینه‌های جاری:',
    currentExpensesShareLabel: 'سهم هزینه‌های جاری:',
    currentMonthBtn: 'ماه جاری',
    currentMonthLabel: 'ماه جاری',
    currentWeightLabel: 'وزن فعلی (کیلوگرم)',
    dailyScore: 'امتیاز عملکرد امروز',
    darkMode: 'حالت تاریک',
    dashAddBtn: 'افزودن',
    dashAllGoalsDone: '🎉 تمام تمرین‌ها و هدف‌های امروز کامل شده است!',
    dashBackToToday: 'برگشت به امروز',
    dashBmiTarget: 'شاخص آناتومی و هدف وزن',
    dashCalorieExcessWarning: '⚠️ کالری مصرفی از هدف روزانه فراتر رفته است.',
    dashCalorieGoodDesc: 'برای تثبیت یا کاهش وزن، نسبت درشت‌مغذی‌ها را رعایت کنید.',
    dashCaloriesToday: 'کالری دریافتی امروز',
    dashCompletedRemaining: 'انجام‌شده · {{remaining}} مورد باقی‌مانده',
    dashCurrentWeight: 'وزن فعلی: {{weight}} کیلوگرم',
    dashDailyTasks: 'چک‌لیست کارهای روزانه (امروز)',
    dashDiaryAdd: 'افزودن مشاهدات فیزیکی',
    dashDiaryTitle: 'بررسی سریع وضعیت امروز',
    dashDone: '✅ انجام شد',
    dashEditProfile: 'ویرایش مشخصات و محاسبات در تنظیمات',
    dashFatDesc: '{{completed}} از {{total}} فعالیت کاردیو امروز تیک خورد',
    dashFatTitle: 'تمرینات چربی‌سوزی و کاردیو',
    dashGoalsProgress: '⚡ {{completed}} از {{total}} هدف امروز انجام شد',
    dashGregorian: 'میلادی:',
    dashHabitScore: 'امتیاز عادات روزانه',
    dashHeight: '| قد: {{height}} سانتی‌متر',
    dashHijri: 'قمری:',
    dashHydration: 'پیگیری هیدراتاسیون (آب)',
    dashHydrationDesc: 'نوشیدن کافی آب، از سلامت دیسک‌های ستون فقرات در برابر شوک محافظت می‌کند.',
    dashIranEvent: 'مناسبت ایران:',
    dashLearningDesc: 'طراحی هوشمند موضوعات، جزوات و کوییزهای تعاملی',
    dashLearningTitle: 'دستیار هوشمند یادگیری',
    dashMaxScore: '/ {{max}} حداکثر',
    dashModulesChecklist: 'چک‌لیست سریع ماژول‌های برنامه',
    dashMood: 'وضعیت روحی:',
    dashNewTaskPlaceholder: 'افزودن کار جدید برای امروز... (مانند: مصرف داروها، پیاده‌روی عصرگاهی، خودآموزی سوئدی)',
    dashNewsDesc: 'پایش زنده اخبار ۷ روز اخیر درباره موضوعات و شهرهای دلخواه شما (مانند اخبار اصفهان یا بورس)',
    dashNewsHeadlines: '📌 خلاصه‌ای از جدیدترین اخبار (۷ روز اخیر):',
    dashNewsLastUpdate: 'آخرین بروزرسانی:',
    dashNewsLive: 'تحلیل زنده',
    dashNewsNoTopics: '✨ هنوز هیچ دسته‌بندی خبری انتخاب نکرده‌اید.',
    dashNewsTitle: 'رادار اخبار و تحلیلهای اختصاصی (AI Personalized News Radar)',
    dashNewsTopics: 'موضوعات فعال شما:',
    dashNewsView: 'مشاهده اخبار و تحلیل‌ها',
    dashNextDay: 'روز بعد',
    dashNoSymptoms: 'هیچ علامتی برای امروز ثبت نشده است.',
    dashNoTasks: 'هیچ کاری برای امروز تعریف نشده است. یک مورد اضافه کنید!',
    dashNotDone: '❌ آف/ثبت‌نشده',
    dashNutritionDesc: 'کالری دریافتی امروز: {{calories}} کیلوکالری',
    dashNutritionTitle: 'ماژول ۳ — ثبت و پیگیری تغذیه روزانه',
    dashPainLevel: 'شدت درد ستون فقرات کمر',
    dashPainLevelDesc: 'سطح {{level}} از {{max}}',
    dashPrevDay: 'روز قبل',
    dashProgress: 'میزان پیشرفت برنامه‌ها',
    dashReadyForDay: '✨ آماده برای یک روز پرانرژی و مفید',
    dashRehabDesc: '{{completed}} از {{total}} حرکت اصلاحی امروز انجام شد',
    dashRehabTitle: 'فیزیوتراپی و تمرینات اصلاحی',
    dashRemainingKcalToTarget: 'باقیمانده تا سقف هدف:',
    dashScheduleTitle: 'ماژول ۵ — برنامه‌ریزی و روتین‌های هفتگی',
    dashScoreDesc: 'شاخص ترکیبی با اولویت‌دهی به توانبخشی ستون فقرات (۴۰٪) و تمرینات کاردیو چربی شکم (۲۵٪).',
    dashScoreV2Title: 'شاخص عملکرد و امتیاز روزانه',
    dashTimeWeightedPerformance: 'شاخص عملکرد روزانه (زمان‌محور)',
    dashScheduledMinutesDone: '{{completed}} از {{total}} برنامه انجام شد',
    dashTimeWeight: 'وزن زمانی: {{percent}}٪ ({{duration}})',
    dashTimeWeightedDesc: 'محاسبه دقیق زمان‌محور بر مبنای مجموع ساعات برنامه‌ریزی‌شده در پلنر هفتگی',
    dashBonusMinutes: '+{{minutes}} پاداش زمان',
    dashScoreV2Desc: 'محاسبه شفاف و پویا بر مبنای وظایف سررسیدشده در پلنر هفتگی (Single Source of Truth)',
    dashAvailablePoints: 'امتیازهای دردسترس:',
    dashEarnedPoints: 'امتیاز کسب‌شده:',
    dashBonusPoints: 'امتیاز پاداش اختیاری:',
    dashCompletionRate: 'نرخ تکمیل:',
    dashRequiredTasksCount: 'وظایف اجباری امروز:',
    dashOpenWeeklyPlanner: 'مدیریت برنامه هفتگی (Weekly Planner)',
    dashPointsShort: 'امتیاز',
    dashTaskCompleted: 'تکمیل شد',
    dashTaskPending: 'در انتظار انجام',
    dashTodayOccurrences: 'برنامه و تمرین‌های موظف امروز',
    dashSelectedDayOccurrences: 'برنامه و تمرین‌های موظف این روز',
    dashSelectedDay: 'روز انتخابی',
    dashSfiClass: 'کلاس زبان سوئدی: ',
    dashSfiDone: '✅ کلاس رفتم',
    dashSfiNotDone: '❌ غایب/برگزارنشده',
    dashSleep: 'پیگیری میزان خواب روزانه',
    dashSleepBedtime: 'ساعت خوابیدن:',
    dashSleepDesc: 'خواب کافی (۷ تا ۸ ساعت) اثر مستقیم بر ترمیم دیسک‌های ستون فقرات و سلامت کمر دارد.',
    dashSleepTarget: '/ ۸ ساعت هدف',
    dashSleepWakeup: 'ساعت بیداری:',
    dashSwedenEvent: 'مناسبت سوئد:',
    dashSwedishDesc: '{{completed}} از {{total}} بخش خودآموز زبان سوئدی امروز ثبت شد',
    dashSwedishTitle: 'ماژول ۴ — پیگیری یادگیری زبان سوئدی',
    dashSymptoms: 'علائم فیزیکی ثبت‌شده',
    dashTargetKcal: '/ {{target}} کیلوکالری',
    dashTasksCompleted: '{{completed}} از {{total}} کار انجام شد',
    dashToday: 'امروز',
    dashWeightGainRemaining: 'افزایش وزن باقیمانده',
    dashWeightGoal: 'وزن هدف شما:',
    dashWeightLossRemaining: 'کاهش وزن باقیمانده',
    dashWeightNoGoal: 'برای تعیین وزن هدف و کالری دقیق، به بخش تنظیمات مراجعه کنید.',
    dashWeightRemainingDiff: '({{diff}} کیلوگرم {{status}})',
    dashWorkShift: 'شیفت کاری: ',
    dashboard: 'داشبورد سلامت',
    date: 'تاریخ',
    dayFri: 'جمعه',
    dayMon: 'دوشنبه',
    dayOfWeekLabel: 'روز هفته',
    daySat: 'شنبه',
    daySun: 'یکشنبه',
    dayThu: 'پنج‌شنبه',
    dayTue: 'سه‌شنبه',
    dayWed: 'چهارشنبه',
    decrease: 'کاهش',
    defaultCard: 'کارت بانکی',
    defaultCategoryForBatch: 'دسته‌بندی پیش‌فرض برای موارد نامشخص:',
    defaultUser: 'کاربر',
    defaultUserApp: 'کاربر پیشرفت',
    defineCategoryCapsHint: 'در فرم بالا با دکمه «تخمین خودکار» یا درج دستی مبلغ، می‌توانید برای هر دسته‌بندی سقف تعیین کنید تا گیج‌های گرافیکی آن فعال گردد.',
    defineExpenseCapsDesc: 'تعیین سقف مجاز هزینه برای مسکن، سوپرمارکت، قبوض، حمل‌ونقل و... (امکان درج ۰ برای بخش‌های بدون هزینه)',
    delete: 'حذف',
    deleteAll: 'حذف همه',
    deleteAllCards: 'حذف همه',
    deleteItemTitle: 'حذف کالا',
    deleteTransaction: 'حذف تراکنش',
    depositModalTitle: 'افزایش پس‌انداز: {{title}}',
    depositToGoalTitle: 'افزایش پس‌انداز: {{title}}',
    descPlaceholder: 'مثال: خرید خواروبار هفتگی',
    description: 'توضیحات',
    deselectAll: 'لغو انتخاب همه',
    dictionaryTab: 'مرجع متغیرها و ترجمه‌ها',
    doctorAgeVal: '{{age}} سال',
    doctorAiAnswerTitle: 'پاسخ پزشک و توصیه‌های بالینی',
    doctorAiError: 'خطا در برقراری ارتباط با پزشک هوش مصنوعی',
    doctorAiSubmit: 'ارسال به پزشک هوش مصنوعی',
    doctorCancel: 'انصراف',
    doctorClearText: 'پاکسازی متن',
    doctorCopyAnswer: 'کپی پاسخ',
    doctorDeleteConfirm: 'آیا از حذف این سابقه مشاوره اطمینان دارید؟',
    doctorDeleteError: 'خطا در حذف سابقه',
    doctorDisclaimer: 'توجه: اطلاعات ارائه شده توسط هوش مصنوعی جنبه آگاهی‌بخشی دارد و جایگزین تشخیص مستقیم پزشک نیست.',
    doctorEditActivity: 'سطح فعالیت روزانه',
    doctorEditAge: 'سن (سال)',
    doctorEditAllergies: 'حساسیت‌های دارویی یا غذایی',
    doctorEditAllergiesPh: 'مثلا: پنی‌سیلین، بادام‌زمینی...',
    doctorEditGender: 'جنسیت',
    doctorEditGoals: 'اهداف سلامتی',
    doctorEditGoalsPh: 'مثلا: رسیدن به وزن ۷۵، بهبود فشار خون...',
    doctorEditHeight: 'قد (سانتی‌متر)',
    doctorEditMedCond: 'بیماری‌های مزمن یا زمینه‌ای',
    doctorEditMedCondPh: 'مثلا: فشار خون، دیابت نوع ۲...',
    doctorEditMeds: 'داروهای در حال مصرف',
    doctorEditMedsPh: 'مثلا: متفورمین، ویتامین دی...',
    doctorEditProfileHeader: 'بروزرسانی پرونده سلامت فردی',
    doctorEditProfileTitle: 'ویرایش پروفایل پزشکی',
    doctorEditWeight: 'وزن (کیلوگرم)',
    doctorGenderF: 'زن',
    doctorGenderM: 'مرد',
    doctorHeaderDesc: 'پاسخگویی به پرسش‌های پزشکی، تحلیل علائم بیماری، توصیه دارویی و بررسی آزمایشگاه',
    doctorHeaderTitle: 'دستیار و پزشک اختصاصی هوش مصنوعی (AI Doctor)',
    doctorHistoryCount: '{{count}} مشاوره ثبت شده',
    doctorHistoryEmpty: 'هنوز سابقه‌ای برای مشاوره پزشکی ثبت نشده است',
    doctorHistoryEmptyDesc: 'اولین سوال پزشکی خود را در بالا مطرح کنید تا پاسخ‌های تحلیلی را اینجا مشاهده فرمایید.',
    doctorHistoryLoading: 'در حال بارگذاری تاریخچه مشاوره...',
    doctorHistoryQuestion: 'مشاوره:',
    doctorHistoryTitle: 'تاریخچه مشاوره‌های پزشکی',
    doctorLiveCalories: 'تخمین کالری پایه روزانه: {{cal}} کیلوکالری',
    doctorNewQueryDesc: 'پرسش و مشاوره تخصصی در زمینه علائم، آزمایش‌ها، رژیم غذایی یا داروها',
    doctorNewQueryTitle: 'مشاوره پزشکی جدید',
    doctorProfileActivity: 'میزان فعالیت بدنی',
    doctorProfileAgeGender: 'سن و جنسیت',
    doctorProfileAllergies: 'حساسیت‌ها و آلرژی‌ها',
    doctorProfileBadge: 'داده‌های محرمانه',
    doctorProfileDesc: 'پارامترهای سلامتی شما جهت ارائه مشاوره‌های دقیق هوش مصنوعی',
    doctorProfileEditBtn: 'ویرایش پروفایل',
    doctorProfileGoals: 'اهداف سلامتی و تناسب اندام',
    doctorProfileHeightWeight: 'قد و وزن',
    doctorProfileMedCond: 'بیماری‌ها و شرایط خاص',
    doctorProfileMeds: 'داروهای مصرفی',
    doctorProfileNoMeds: 'دارویی مصرف نمی‌شود',
    doctorProfileNotRegistered: 'ثبت نشده',
    doctorProfileSaveError: 'خطا در ذخیره پروفایل پزشکی',
    doctorProfileTitle: 'پروفایل پزشکی و پرونده سلامت',
    doctorQ1: 'چگونه فواصل روزه‌داری متناوب و سطح انرژی‌ام را بهینه کنم؟',
    doctorQ2: 'چه غذاهایی به کاهش سریع‌تر چربی احشایی شکم کمک می‌کنند؟',
    doctorQ3: 'علائم اخیرم را تحلیل کنید و توصیه‌های تغییر سبک زندگی بدهید.',
    doctorQ4: 'چه مکمل‌هایی به ترمیم مفاصل و ریکاوری عضلات کمک می‌کنند؟',
    doctorQueryPlaceholder: 'پرسش پزشکی، شرح علائم یا سوال سلامتی خود را اینجا بنویسید...',
    doctorSaveToDb: 'ذخیره در پرونده پزشکی',
    doctorSaving: 'در حال ذخیره...',
    doctorSpecialtyLabel: 'تخصص پزشکی مورد نظر',
    doctorSuggestedQueries: 'پرسش‌های پیشنهادی:',
    doctorTitle: 'پزشک اختصاصی هوش مصنوعی (AI Doctor)',
    doctorWeightHeightVal: '{{weight}} کیلوگرم / {{height}} سانتی‌متر',
    dueToday: 'سررسید امروز',
    duplicateWithTx: 'تکراری با {{title}} (صرف‌نظر از ثبت تکراری)',
    edit: 'ویرایش',
    email: 'ایمیل',
    english: 'English (انگلیسی)',
    enterIncomeFirst: 'لطفاً ابتدا درآمد خالص ماهانه را وارد کنید تا مانده تخصیص‌نیافته محاسبه گردد.',
    error: 'خطا',
    estimatedFutureMonths: '{{count}} ماه آینده',
    estimatedMonthsFuture: '{{count}} ماه آینده',
    exerciseDuration: 'مدت زمان (دقیقه)',
    expense: 'هزینه',
    exportCalendar: 'خروجی به تقویم گوگل / ICS',
    exportCalendarIcs: 'خروجی فایل تقویم (ICS)',
    exportExcelReport: 'خروجی فایل Excel',
    exportPdfReport: 'دانلود خروجی PDF جامع',
    extraExpenseSuffix: 'اضافی هزینه شده!',
    extractRowsSmartBtn: 'استخراج و شناسایی هوشمند سطرها',
    familyCategoriesTab: 'دسته‌بندی‌ها و افراد خانواده',
    familyCategory: '👨‍👩‍👧‍👦 امور خانوادگی',
    fat: 'چربی',
    fatActivationDesc: 'کاهش چربی‌های شکم عمدتاً از طریق پیاده‌روی، تمرینات هوازی ملایم و مستمر چربی‌سوز، و انقباض‌های ایزومتریک دیواره شکم (بدون چرخاندن یا خم کردن خطرناک پایین کمر) به دست می‌آید. از انجام درازونشست‌های سنتی و پرخطر پرهیز کنید.',
    fatActivationTitle: 'فعال‌سازی و بسیج انرژی با فشار کم',
    fatActiveKcal: 'کیلوکالری فعال',
    fatCalBurnedTitle: 'کالری تخمینی سوزانده‌شده',
    fatCalories: 'کالری',
    fatExerciseXofY: 'تمرین {{current}} از {{total}}',
    fatExitSession: 'خروج از جلسه',
    fatFullInstructions: 'دستورالعمل کامل تمرین:',
    fatGoal: 'چربی (گرم)',
    fatGuidedComplete: 'فوق‌العاده بود! تمرین چربی‌سوزی به پایان رسید',
    fatGuidedCompleteDesc: 'امروز کالری چشمگیری سوزاندید و ماهیچه‌های شکمی را فعال کردید.',
    fatGuidedSaveReturn: 'ثبت و بازگشت به لیست',
    fatGuidedStatusPrepare: 'آماده‌باش',
    fatGuidedStatusRest: 'استراحت و نفس‌گیری',
    fatGuidedStatusRunning: 'در حال اجرا',
    fatKcalBurn: '{{kcal}} کیلوکالری چربی‌سوزی',
    fatLossCardio: 'کاردیو و چربی‌سوزی',
    fatMute: 'قطع صدا',
    fatNextEx: 'ثبت و حرکت بعدی',
    fatPause: 'توقف موقت',
    fatPrevEx: 'حرکت قبلی',
    fatProgressTitle: 'پیشرفت برنامه‌های روزانه',
    fatProgressXofY: '{{completed}} از {{total}} حرکت',
    fatReps: 'تکرار',
    fatRest: 'استراحت',
    fatResume: 'ادامه',
    fatSeconds: 'ثانیه',
    fatSets: 'ست‌ها',
    fatSkipRest: 'رد کردن استراحت',
    fatStartGuided: 'شروع جلسه چربی‌سوزی هدایت‌شده با صدا',
    fatSubtitle: 'تمرینات هوازی و انقباض‌های ایزومتریک شکم بدون خمش کمر؛ حامی سلامت ستون فقرات و دیسک‌ها.',
    fatTargetMuscles: 'عضلات تحت فشار',
    fatTargetPurpose: 'هدف حرکت',
    fatTitle: 'تمرینات چربی‌سوزی و کاردیو',
    fatTrainerName: 'مربی مجازی چربی‌سوزی شکم',
    fatUnmute: 'وصل صدا',
    filter: 'فیلتر',
    filterAllCategories: 'همه دسته‌بندی‌ها',
    filterAllPayments: 'همه روش‌های پرداخت',
    filterByMonth: 'فیلتر بر اساس ماه',
    filterCard: 'کارت بانکی',
    filterCash: 'نقد (Cash)',
    filterDateLabel: 'فیلتر تاریخ:',
    filterFrom: 'از:',
    filterLast3Months: '۳ ماه اخیر',
    filterSwish: 'سوئیش (Swish)',
    filterThisMonth: 'این ماه',
    filterThisMonthTransactions: 'فیلتر تراکنش‌های این ماه',
    filterTo: 'تا:',
    filterToday: 'امروز',
    filterTransfer: 'انتقال حساب',
    filtered: 'فیلتر شده',
    finalAmountRecorded: 'مبلغ نهایی ثبت در حساب: {{amount}} {{currency}}',
    finalAmountToRecord: 'مبلغ نهایی ثبت در حساب:',
    finance: 'مدیریت مالی و فاکتورها (AI)',
    financeAddCardBtn: 'افزودن کارت',
    financeAddItemRow: '+ افزودن کالا',
    financeAddItemsSection: 'افزودن اقلام فاکتور (کالاهای داخل خرید):',
    financeAdvisorThinking: 'مشاور هوشمند در حال تحلیل فاکتورها، بودجه و تدوین پاسخ تخصصی شماست...',
    financeAiAddNewRow: 'افزودن ردیف جدید',
    financeAiAdvisorGreeting: 'سلام و درود! من مشاور ارشد هوشمند مالی و استراتژیست ثروت شما هستم. 💼🌟 من آگاهی کامل و لحظه‌ای به درآمد خالص، هزینه‌ها، سقف بودجه و اهداف مالی شما دارم.',
    financeAiAdvisorRole: 'مشاور هوشمند مالی',
    financeAiAdvisorSubtitle: 'تحلیل زنده درآمد خالص، رفتار هزینه‌ای، سقف بودجه و اهداف مالی برای ارائه توصیه‌های راهبردی',
    financeAiAdvisorTitle: 'مشاور هوشمند مالی و استراتژیست ثروت',
    financeAiAnalyzeBtn: 'تحلیل هوشمند فاکتور با هوش مصنوعی',
    financeAiBankMatchNotice: 'تراکنش هم‌پوشان بانکی پیدا شد: {{store}} با مبلغ {{amount}} {{currency}} (تاریخ {{date}}). هنگام ثبت، فاکتور کامل اسکن‌شده جایگزین این تراکنش خام خواهد شد.',
    financeAiCardLabel: 'حساب / کارت بانکی:',
    financeAiColAction: 'حذف',
    financeAiColCategory: 'دسته‌بندی',
    financeAiColItemName: 'نام کالا (قابل ویرایش)',
    financeAiColQty: 'تعداد',
    financeAiColTotal: 'مجموع (بعد تخفیف)',
    financeAiColUnitPrice: 'قیمت واحد',
    financeAiConfirmSave: 'تایید و ذخیره نهایی فاکتور',
    financeAiDateLabel: 'تاریخ تراکنش:',
    financeAiExtractedItems: 'اقلام و کالاهای استخراج شده (قابلیت ویرایش و تغییر قیمت):',
    financeAiExtracting: 'در حال استخراج اقلام توسط AI...',
    financeAiFinalCharge: 'مبلغ نهایی ثبت در حساب: {{amount}} {{currency}}',
    financeAiInvoiceAnalysis: 'تحلیل هوشمند فاکتور {{store}}',
    financeAiNewInvoiceTitle: 'فاکتور جدید',
    financeAiNoResponse: 'پاسخی از سرور دریافت نشد',
    financeAiParseError: 'استخراج اطلاعات فاکتور ناموفق بود.',
    financeAiParsedTitle: 'نتیجه استخراج فاکتور توسط هوش مصنوعی (قابل ویرایش)',
    financeAiPaymentMethod: 'روش پرداخت:',
    financeAiPurchaseFrom: 'خرید از {{store}}',
    financeAiReadyToSave: 'آماده ذخیره نهایی',
    financeAiRowCount: '{{count}} ردیف',
    financeAiScannerDesc: 'متن فاکتور یا رسید خرید خود (سوئیش، ICA، Willys و...) را جای‌گذاری کنید تا اقلام، قیمت و دسته‌بندی استخراج شوند.',
    financeAiScannerHeader: 'اسکن و تحلیل هوشمند متن فاکتور با هوش مصنوعی (AI)',
    financeAiScannerNote: 'ثبت شده توسط اسکنر AI',
    financeAiSmartReplaceNote: 'جایگزینی هوشمند تراکنش خام بانک با جزئیات فاکتور اسکن‌شده',
    financeAiStoreLabel: 'عنوان / فروشگاه:',
    financeAiTotalCalculated: 'مبلغ کل (محاسبه از اقلام):',
    financeAskPh: 'سوال مالی خود را بنویسید (مثال: چطور هزینه‌های سوپرمارکت این ماه رو کنترل کنم؟)...',
    financeBatchCleanupSubtitle: 'حذف گروهی فاکتورها بر اساس ماه، سال، فیلتر یا پاکسازی کامل',
    financeBatchCleanupTitle: 'مدیریت و پاکسازی دسته‌ای تراکنش‌ها',
    financeBatchColAction: 'حذف',
    financeBatchColAmount: 'مبلغ ({{currency}})',
    financeBatchColCard: 'کارت / حساب پرداختی',
    financeBatchColCategory: 'دسته‌بندی',
    financeBatchColDate: 'تاریخ',
    financeBatchColSelect: 'انتخاب',
    financeBatchColStore: 'فروشگاه / عنوان',
    financeBatchColType: 'نوع',
    financeBatchConfirmBtn: 'تأیید و ثبت نهایی در پایگاه داده',
    financeBatchDefaultNotes: 'ثبت شده از ورود دسته‌ای',
    financeBatchMergeStoreNotes: 'تکمیل‌شده با فاکتور فروشگاه {{store}}',
    financeBatchRowExpense: 'هزینه',
    financeBatchRowIncome: 'درآمد',
    financeBatchRowSavings: 'پس‌انداز',
    financeBatchRowsReady: 'تعداد {{count}} تراکنش انتخابی آماده ثبت نهایی است.',
    financeBatchStatusBankMerge: '{{count}} تراکنش بانکی با خرید فروشگاهی (ICA/...) تطبیق و کارت بانک اعمال گردید',
    financeBatchStatusNew: '{{count}} تراکنش جدید ثبت شد',
    financeBatchStatusSkip: '{{count}} مورد تکراری نادیده گرفته شد',
    financeBatchStatusStoreMerge: '{{count}} فاکتور فروشگاه جایگزین تراکنش بانکی شد',
    financeBatchTotalExpense: 'مجموع هزینه: {{amount}} {{currency}}',
    financeBatchTotalIncome: 'مجموع درآمد/ورودی: {{amount}} {{currency}}',
    financeBulkDeleteAlert: 'لطفاً کلمه DELETE را جهت تایید حذف کامل تایپ کنید.',
    financeCalcFromItems: 'محاسبه خودکار از اقلام ({{count}})',
    financeCancelBtn: 'انصراف',
    financeCardOrAccountLabel: 'کارت / حساب پرداختی:',
    financeCardsModalSubtitle: 'کارت‌های دلخواه خود را تعریف کنید تا در ثبت فاکتورها و ورود دسته‌ای استفاده شوند.',
    financeCardsModalTitle: 'مدیریت کارت‌ها و حساب‌های بانکی شخصی',
    financeCategoryLabel: 'دسته‌بندی غنی:',
    financeCategoryNameCarMaintenance: 'تعمیرات خودرو و بیمه',
    financeCategoryNameCharityGifts: 'هدایا، کادو و خیریه',
    financeCategoryNameClothing: 'پوشاک، کفش و زیبایی',
    financeCategoryNameDefault: 'خدمات و متفرقه',
    financeCategoryNameEducation: 'آموزش و توسعه فردی',
    financeCategoryNameElectronics: 'کالای دیجیتال و الکترونیک',
    financeCategoryNameEntertainment: 'تفریح، ورزش و سفر',
    financeCategoryNameFamily: 'امور فرزندان و خانواده',
    financeCategoryNameGroceries: 'سوپرمارکت و خواربار',
    financeCategoryNameHealth: 'سلامت، درمان و دارو',
    financeCategoryNameHomeDecor: 'لوازم خانگی و دکوراسیون',
    financeCategoryNameHousing: 'مسکن و اجاره/رهن',
    financeCategoryNameInvestment: 'پس‌انداز و سرمایه‌گذاری',
    financeCategoryNamePets: 'حیوانات خانگی و پت‌شاپ',
    financeCategoryNameRestaurants: 'رستوران، کافه و غذا',
    financeCategoryNameSalary: 'حقوق و درآمد اصلی',
    financeCategoryNameSubscriptions: 'اشتراک‌های دیجیتال و AI',
    financeCategoryNameTransport: 'حمل‌و‌نقل و سوخت',
    financeCategoryNameUtilities: 'قبوض، انرژی و اینترنت',
    financeCurrencyIRR: 'ریال (IRR)',
    financeCurrencyToman: 'تومان (Toman)',
    financeCurrencySEK: 'کرون سوئد (SEK)',
    financeCurrencyEUR: 'یورو (EUR)',
    financeCurrencyUSD: 'دلار آمریکا (USD)',
    financeClearAllCards: 'حذف همه',
    financeCloseBtn: 'بستن',
    financeConfirmDeposit: 'تایید واریزی',
    financeCopied: 'کپی شد',
    financeCopyAnswer: 'کپی پاسخ',
    financeCreateGoalBtn: 'ایجاد هدف',
    financeDateLabel: 'تاریخ:',
    financeDefineNewCard: '➕ تعریف کارت جدید...',
    financeDefineNewGoalBtn: 'تعریف هدف جدید',
    financeDeleteCardTitle: 'حذف این کارت',
    financeDeleteFilteredTxs: 'حذف موارد فیلترشده فعلی',
    financeDeleteMonthTxs: 'حذف تراکنش‌های یک ماه',
    financeDeleteMonthTxsDesc: 'حذف تمام فاکتورهای ماه انتخابی',
    financeDeleteYearTxs: 'حذف تراکنش‌های یک سال',
    financeDeleteYearTxsDesc: 'حذف تمام فاکتورهای سال انتخابی',
    financeDepositAmountLabel: 'مبلغ واریزی جدید:',
    financeDepositModalTitle: 'افزایش پس‌انداز: {{title}}',
    financeDescOptional: 'توضیحات (اختیاری):',
    financeDescPh: 'مثال: خرید خواربار هفته دوم',
    financeEditCardTitle: 'ویرایش نام کارت',
    financeEditGoalBtn: 'ویرایش هدف',
    financeEditGoalModalTitle: 'ویرایش هدف پس‌انداز: {{title}}',
    financeSaveGoalChangesBtn: 'ذخیره تغییرات هدف',
    financeGoalCategoryLabel: 'دسته‌بندی هدف:',
    financeGoalNotesLabel: 'یادداشت یا توضیحات:',
    financeGoalCategoryHousing: 'مسکن و ملک',
    financeGoalCategoryCar: 'خودرو و نقلیه',
    financeGoalCategoryTravel: 'سفر و تفریح',
    financeGoalCategoryEmergency: 'صندوق اضطراری',
    financeGoalCategoryInvestment: 'سرمایه‌گذاری و پس‌انداز',
    financeGoalCategoryOther: 'سایر و متفرقه',
    financeEditTx: 'ویرایش تراکنش',
    financeEnterYearToDelete: 'سال مورد نظر جهت حذف را وارد کنید (مثلاً 2026):',
    financeFilteredTxsCount: '{{count}} تراکنش انتخابی',
    financeFinalDeleteBtn: 'حذف نهایی تراکنش‌ها',
    financeFinancialHealthScore: 'شاخص سلامت مالی شما:',
    financeGoalAddDepositBtn: 'افزایش پس‌انداز',
    financeGoalCurrency: 'ارز:',
    financeGoalCurrentBalance: 'موجود: {{amount}} {{currency}}',
    financeGoalDepositNote: 'افزایش موجودی هدف {{goalTitle}}',
    financeGoalDepositTitle: 'پس‌انداز برای: {{goalTitle}}',
    financeGoalInitialSavings: 'پس‌انداز اولیه:',
    financeGoalNameLabel: 'عنوان هدف:',
    financeGoalNamePh: 'مثال: خرید خانه در استکهلم / سفر تابستانی',
    financeGoalProgressPercent: '{{percent}}٪ تکمیل شده',
    financeGoalRemainingAmount: 'باقی‌مانده: {{amount}} {{currency}}',
    financeGoalTargetAmount: 'مبلغ هدف:',
    financeGoalTargetAmountLabel: 'هدف: {{amount}} {{currency}}',
    financeGoalTargetDate: 'تاریخ هدف (اختیاری):',
    financeGoalTargetDateLabel: 'تاریخ هدف: {{date}}',
    financeGoalsTitle: 'اهداف پس‌انداز و برنامه‌ریزی مالی',
    financeHeaderDesc: 'بودجه‌بندی درآمد خالص پس از مالیات، اسکن خودکار فاکتورها با هوش مصنوعی و پیگیری اهداف پس‌انداز',
    financeHeaderTitle: 'مدیریت هوشمند فاکتورها، بودجه و اهداف مالی',
    financeItemNamePh: 'نام کالا (مثال: شیر)',
    financeItemQtyPh: 'تعداد (۱)',
    financeItemUnitPricePh: 'قیمت واحد',
    financeItemsRecorded: '{{count}} کالا ثبت شده',
    financeNewCardInputPh: 'نام کارت جدید (مثال: SEB Credit, ICA Kort, Swish...)',
    financeNewCardPh: 'نام کارت یا حساب پرداختی (مثال: کلارنا، مسترکارت...)',
    financeNewGoalTitle: 'تعریف هدف مالی و پس‌انداز جدید',
    financeNewTx: 'ثبت فاکتور یا تراکنش مالی جدید',
    financeNoCardsYet: 'هیچ کارتی تعریف نشده است. نام کارت جدید خود را بالا بنویسید و افزودن را بزنید یا دکمه بازنشانی را بفشارید.',
    financeNoGoalsYet: 'هنوز هدفی برای پس‌انداز ثبت نشده است.',
    financeNoProductMatches: 'کالایی با این عنوان ثبت نشده است.',
    financePaymentCard: 'کارت بانکی',
    financePaymentCash: 'نقد (Cash)',
    financePaymentMethodLabel: 'روش پرداخت:',
    financePaymentSwish: 'سوئیش (Swish)',
    financePaymentTransfer: 'انتقال حساب',
    financeProductAnalyticsTitle: 'تحلیل و گزارش مصرف کالاها (مثال: میزان خرید شیر، نان...)',
    financeProductAnalyticsTotal: 'مجموع کالاها: {{count}} نوع کالا',
    financePrompt1: '💡 تحلیل بیشترین هزینه‌ها و دسته‌بندی‌های این ماه',
    financePrompt1Text: 'چطور می‌تونم پس‌انداز ماهانه‌ام رو ۱۰ درصد بیشتر کنم؟',
    financePrompt2: '🔍 ۵ راهکار عملی برای کاهش مخارج غیرضروری',
    financePrompt2Text: 'لطفاً وضعیت هزینه‌ها، سقف بودجه و رفتار مصرفی این ماه من رو تحلیل دقیق کن.',
    financePrompt3: '📈 با درآمد خالص فعلی چطور هوشمندانه پس‌انداز کنم؟',
    financePrompt3Text: 'با توجه به درآمد و هزینه‌های فعلی من، مانده پس‌اندازم رو چطور در بازارهای مالی سرمایه‌گذاری کنم؟',
    financePrompt4: '🛡️ استراتژی ساخت صندوق اضطراری',
    financePrompt4Text: 'برای ساخت صندوق اضطراری با توجه به هزینه‌های ماهانه من چه برنامه‌ای داری؟',
    financePrompt5: '🎯 برنامه شتاب‌دهی رسیدن به اهداف مالی',
    financePrompt5Text: 'اهداف مالی ثبت‌شده من رو بررسی کن و بگو چطور می‌تونم سریع‌تر به اون‌ها برسم؟',
    financeRemainingBudgetLabel: 'مانده بودجه هزینه ماه:',
    financeResetChatConfirm: 'آیا از پاکسازی و شروع مجدد تاریخچه گفتگو با مشاور مالی اطمینان دارید؟',
    financeResetToDefaultCards: 'بازنشانی به کارت‌های پیش‌فرض',
    financeSaveCard: 'ذخیره',
    financeSaveTxBtn: 'ذخیره تراکنش',
    financeScoreExcellent: 'عالی 🟢',
    financeScoreModerate: 'متوسط 🟡',
    financeScoreNeedsWork: 'نیازمند اصلاح 🔴',
    financeSearchPlaceholder: 'جستجو در فاکتورها، عنوان فروشگاه، کارت یا نام اقلام...',
    financeSearchProductPh: 'جستجوی نام کالا (مثلا: شیر، نان، گوشت...)',
    financeSelectCleanupScope: 'دامنه عملیات حذف را انتخاب کنید:',
    financeSelectMonthToDelete: 'ماه مورد نظر جهت حذف را انتخاب کنید:',
    financeSend: 'ارسال',
    financeStoreOrTitle: 'عنوان یا نام فروشگاه:',
    financeStoreOrTitlePh: 'مثال: خرید از Willys / حقوق ماهانه',
    financeTitle: 'مدیریت مالی و فاکتورها (AI)',
    financeTotalAmountLabel: 'مبلغ کل (عدد):',
    financeTotalPurchasedQty: 'کل حجم خرید:',
    financeTotalSpentOnProd: 'کل هزینه:',
    financeTotalTxsRecorded: '{{count}} کل تراکنش‌های ثبت‌شده',
    financeTypeDeleteToConfirm: 'جهت تایید نهایی کلمه DELETE را در کادر زیر تایپ کنید:',
    financeTypeExpense: 'هزینه / فاکتور',
    financeTypeIncome: 'درآمد / دریافتی',
    financeTypeSavings: 'پس‌انداز',
    financeWipeAllData: 'پاکسازی کامل کل داده‌ها',
    financeWipeWarning: '⚠️ هشدار مهم: این عمل غیرقابل بازگشت است و تمام {{count}} تراکنش شما را به طور کامل پاک می‌کند!',
    financeYou: 'شما',
    financeYourCurrentCards: 'کارت‌های فعلی شما ({{count}} مورد):',
    financial_advisor: 'مشاور مالی هوشمند',
    fixSalaryBtn: 'اصلاح خودکار به درآمد (+)',
    fixTransferBtn: 'اصلاح خودکار به پس‌انداز/انتقال',
    foodCat_Breakfast: 'صبحانه',
    foodCat_Dairy: 'لبنیات',
    foodCat_Drinks: 'نوشیدنی‌ها',
    foodCat_Fruits: 'میوه‌ها و مرکبات',
    foodCat_Nuts: 'مغزها و آجیل',
    foodCat_Persian: 'غذاهای اصیل ایرانی',
    foodCat_Protein: 'پروتئین‌ها',
    foodCat_RiceGrains: 'برنج و غلات',
    foodCat_Vegetables: 'سبزیجات',
    foodCat_all: 'همه خوراکی‌ها',
    glp1MealPlan: 'برنامه غذایی اختصاصی GLP-1',
    goalCompletedSuffix: 'تکمیل شده',
    goalCurrentAmount: 'موجود: {{amount}} {{currency}}',
    goalCurrentLabel: 'موجود:',
    goalForecastNote: 'با اختصاص دادن منظم {{amount}} {{currency}} در ماه، این هدف تا حدود {{months}} ماه آینده تکمیل خواهد شد.',
    goalProgressPercent: '{{pct}}٪ تکمیل شده',
    goalRemainingAmount: 'باقی‌مانده: {{amount}} {{currency}}',
    goalRemainingLabel: 'باقی‌مانده:',
    goalTargetAmount: 'هدف: {{amount}} {{currency}}',
    goalTargetLabel: 'هدف:',
    goalsDefault: 'کاهش وزن، بهبود سلامت عمومی، افزایش انرژی',
    goalsEmptyDesc: 'هنوز هدفی برای پس‌انداز ثبت نشده است.',
    goalsForecastDesc: 'محاسبه هوشمند بر اساس سهم پس‌انداز ماهانه ({{ratio}}%)',
    goalsForecastLabel: 'تخمین زمان تکمیل تمامی اهداف:',
    goalsForecastTitle: 'تحلیل و تخمین زمان تحقق اهداف مالی',
    goalsSectionTitle: 'اهداف پس‌انداز و برنامه‌ریزی مالی',
    goalsSystemGuide: 'با اختصاص دادن منظم {{amount}} {{currency}} در هر ماه به صندوق پس‌انداز، می‌توانید تمامی اهداف تعریف شده را در زمان مقرر محقق سازید.',
    goalsSystemTip: 'راهنمای سیستم: با اختصاص دادن منظم {{amount}} {{currency}} در هر ماه به صندوق پس‌انداز، می‌توانید تمامی اهداف تعریف شده را در زمان مقرر محقق سازید.',
    goalsTab: 'اهداف مالی',
    goalsWeightLoss: 'کاهش وزن و لاغری',
    graph1Subtitle: 'به ترتیب بیشترین درصد',
    graph1Title: '۱. سهم هزینه‌ها بر اساس دسته‌بندی (Where / Category):',
    graph2Subtitle: 'به تفکیک ماه',
    graph2Title: '۲. مقایسه ماهانه هزینه‌ها و پس‌انداز در طول سال (Monthly Comparison):',
    healthScoreOf100: '{{score}}/۱۰۰',
    highPriority: '🚨 اولویت بالا (فوری)',
    highestQtyProducts: 'پرتعدادترین کالاها (Highest Quantity):',
    highestSavingsMonth: 'بیشترین پس‌انداز ماهانه:',
    highestSpentProducts: 'گران‌ترین کالاها (Highest Spent):',
    income: 'درآمد',
    incomePlaceholder: 'مثلاً ۵۰۰,۰۰۰,۰۰۰',
    increase: 'افزایش',
    increaseSavingsBtn: 'افزایش پس‌انداز',
    initialSavingsLabel: 'پس‌انداز اولیه:',
    insertCsvSample: 'درج نمونه خروجی CSV صورت‌حساب بانک',
    invoiceItemsTitle: 'اقلام ریز و جزئیات فاکتور:',
    invoiceSamplePlaceholder: 'نمونه متن فاکتور: فروشگاه، اقلام، قیمت‌ها...',
    invoices: 'فاکتورها و رسیدهای خریدمان',
    item: 'کالا',
    itemUnit: 'عدد',
    itemUnitRows: 'ردیف',
    itemsCountInRow: '{{count}} ردیف کالا',
    itemsCountSuffix: 'قلم کالا',
    itemsDetails: 'اقلام جزئیات',
    itemsRecordedCount: '{{count}} کالا ثبت شده',
    itemsRecordedSuffix: 'کالا ثبت شده',
    itemsUnitCount: 'عدد',
    labReportAnalysis: 'تفسیر جواب آزمایشگاه',
    language: 'زبان برنامه',
    languageSectionDesc: 'زبان نمایش رابط کاربری و جهت چیدمان برنامه را انتخاب کنید.',
    languageSectionTitle: 'زبان و منطقه جغرافیایی (Language & Region)',
    largestShare: 'بزرگ‌ترین سهم',
    latestHeadlinesTab: 'سرتیترهای داغ اخبار',
    learningActionDeleteAttachment: 'حذف پیوست',
    learningActionDownload: 'دانلود',
    learningActionPlayVideo: 'پخش ویدیو',
    learningActionViewDoc: 'مشاهده سند',
    learningActionViewOnline: 'مشاهده آنلاین',
    learningAddMsgHint: 'متن یا یادداشت‌های مارک‌داون خود را وارد نمایید',
    learningAddMsgTitle: 'افزودن یادداشت / مطلب',
    learningAddTeacherNote: 'افزودن یادداشت مدرس / استاد',
    learningAddVideoFile: 'افزودن ویدیو / لینک',
    learningAiCustomPrompt: 'درخواست سفارشی...',
    learningAiInfoLabel: 'دستیار هوشمند یادگیری و تحلیل متون آموزشی',
    learningAiKeyPoint: 'نکته کلیدی:',
    learningAiModalCancel: 'انصراف',
    learningAiModalLabel: 'سوال یا دستور خود را پیرامون یادداشت‌ها بنویسید:',
    learningAiModalPh: 'مثلا: نکات کلیدی را خلاصه کن، اصطلاحات را توضیح بده، فلش‌کارت بساز...',
    learningAiModalTitle: 'ارسال پرامپت به دستیار آموزش هوش مصنوعی',
    learningAiNoResponse: 'پاسخی دریافت نشد، لطفاً مجدداً امتحان کنید.',
    learningAiPromptCustom: 'دستور و پرامپت اختصاصی برای یادداشت‌های این درس',
    learningAiPromptQuiz: 'تولید ۵ پرسش و آزمون چهارگزینه‌ای جهت سنجش تسلط',
    learningAiPromptScenario: 'طراحی سناریو و کیس عملی بالینی بر اساس این مبحث',
    learningAiPromptSummarize: 'خلاصه‌سازی کلیدی و استخراج نکات برجسته به صورت موردی',
    learningAiPromptTranslateFa: 'ترجمه یادداشت‌ها به فارسی سلیس همراه با توضیح اصطلاحات تخصصی',
    learningAiPromptTranslateSv: 'ترجمه یادداشت‌ها به سوئدی دقیق و روان',
    learningAiQuiz: 'طراحی آزمون',
    learningAiSummarize: 'خلاصه‌سازی AI',
    learningAiSummarizeDesc: 'خلاصه فوری تولیدشده توسط هوش مصنوعی',
    learningAiTransFa: 'ترجمه به فارسی',
    learningAiTransSv: 'ترجمه به سوئدی',
    learningAiTranslateFa: 'ترجمه به فارسی',
    learningAiTranslateSv: 'ترجمه به سوئدی (Svenska)',
    learningAllMessagesDeleted: 'تمامی پیام‌های این جلسه پاک شد',
    learningAnalyzeGenerateBtn: 'تحلیل و پردازش با هوش مصنوعی',
    learningAssistant: 'دستیار یادگیری',
    learningAttachmentOptions: 'گزینه‌های پیوست',
    learningAttachments: 'پیوست‌ها و اسناد مرتبط',
    learningAttachmentsHint: 'فایل‌های صوتی، تصویری، پی‌دی‌اف یا عکس آموزشی را اضافه نمایید.',
    learningAttachmentsLabel: 'پیوست‌های جلسه',
    learningCopied: 'کپی شد!',
    learningCopyFullSession: 'کپی کامل یادداشت‌های این درس',
    learningCopyText: 'کپی',
    learningCreateFirstTopic: 'اولین سرفصل خود را جهت سازماندهی دروس ایجاد کنید',
    learningCreateMainTopic: 'سرفصل جدید',
    learningDeleteAiMsg: 'حذف پیام',
    learningDeleteConfirmBtn: 'حذف همیشگی',
    learningDeleteModalDesc1: 'آیا از حذف این سرفصل و تمامی جلسات و فایل‌های آن اطمینان دارید؟',
    learningDeleteSession: 'حذف جلسه',
    learningDeleteSubtopic: 'حذف بخش',
    learningDeleteTeacherNote: 'حذف یادداشت',
    learningDeleteTopic: 'حذف سرفصل',
    learningDirectionLTR: 'چپ‌چین',
    learningDirectionRTL: 'راست‌چین',
    learningEditMainTopic: 'ویرایش سرفصل',
    learningExtractedTextTitle: 'متن استخراج‌شده از پیوست:',
    learningFileNotfound: 'فایل یافت نشد',
    learningFileR2Error: 'خطا در دسترسی به حافظه ابری',
    learningFileUploadError: 'خطا در آپلود فایل "{{name}}": {{message}}',
    learningFileVideoAlert: 'لطفاً فرمت فایل یا لینک ویدیویی را بررسی فرمایید',
    learningFormatSize: '{{size}} مگابایت',
    learningGeneratingNotes: 'در حال تولید یادداشت‌های هوشمند با AI...',
    learningMainTopicDescPh: 'توضیحات کلی سرفصل یا دوره...',
    learningMainTopicPh: 'مثلا: فیزیولوژی غدد و تغذیه بالینی',
    learningMainTopicTitle: 'ایجاد سرفصل مطالعاتی جدید',
    learningMsgInputPh: 'متن یادداشت را اینجا تایپ کنید...',
    learningNewSession: 'جلسه گفتگوی جدید',
    learningNewSessionDesc: 'ثبت یادداشت‌های جامع، پیوست فایل‌های آموزشی و تولید کوئیزهای هوشمند',
    learningNewTopic: 'مبحث جدید',
    learningNoAttachmentsYet: 'هنوز فایلی به این جلسه پیوست نشده است.',
    learningNoExtraDesc: 'بدون توضیحات تکمیلی',
    learningNoExtractedTextMsg: 'هنوز متنی از این فایل استخراج نشده است.',
    learningNoSessionMatch: 'جلسه‌ای مطابق با جستجو پیدا نشد',
    learningNoTopicMatch: 'سرفصلی مطابق با جستجوی شما یافت نشد',
    learningNoTopicsYet: 'هنوز سرفصلی ایجاد نشده است',
    learningPromptGrammar: 'بررسی و بهبود روان‌سازی نگارش این یادداشت‌ها',
    learningPromptGrammarBtn: 'اصلاح نگارش و لحن',
    learningPromptPresetsTitle: 'ابزارهای کمکی هوش مصنوعی:',
    learningPromptQuiz: 'تولید کوئیز و آزمونک',
    learningPromptQuizBtn: 'تولید آزمون (Quiz)',
    learningPromptScenario: 'سناریوهای تعاملی',
    learningPromptScenarioBtn: 'سناریوهای بالینی',
    learningSearchClear: 'پاکسازی جستجو',
    learningSearchPh: 'جستجو در سرفصل‌ها، جلسات یا یادداشت‌ها...',
    learningSearchPlaceholder: 'جستجو در مباحث، جلسات یا پیوست‌ها...',
    learningSelectedTopic: 'سرفصل فعال: {{name}}',
    learningSendAiPrompt: 'ارسال پرامپت',
    learningSessionAiDefaultReply: 'سلام! در یادگیری و تسلط بر این مبحث چه کمکی از دست من برمی‌آید؟',
    learningSessionAttachmentsTitle: 'فایل‌ها و رسانه‌های ضمیمه',
    learningSessionIntroPh: 'خلاصه کوتاه معرفی این درس یا جلسه...',
    learningSessionMinReq: 'عنوان باید حداقل ۲ حرف باشد',
    learningSessionTitlePh: 'مثلا: فصل چهارم: آناتومی و فیزیولوژی متابولیسم',
    learningSessionTitleReq: 'لطفاً عنوانی برای جلسه درس وارد نمایید',
    learningSessionUploadWait: 'در حال آپلود رسانه...',
    learningSessionsCount: '{{count}} جلسه',
    learningSessionsRegistered: 'جلسات ثبت‌شده',
    learningShareVideoBtn: 'ثبت پیوند ویدیو',
    learningShareVideoModalTitle: 'افزودن ویدیو / پیوند آموزشی',
    learningShareVideoSm: 'ویدیو',
    learningSharedFilesTab: 'مدیریت فایل‌های اشتراکی',
    learningSizeUnknown: 'حجم نامشخص',
    learningStartNewSession: 'جلسه جدید',
    learningSubtopicNotesPh: 'یادداشت‌های درس، فرمول‌ها، نکات طلایی و خلاصه‌ها را اینجا بنویسید...',
    learningSubtopicTitlePh: 'عنوان مبحث فرعی...',
    learningSubtopicsList: 'مباحث و بخش‌های فرعی',
    learningTeacherNoteLabel: 'یادداشت استاد:',
    learningTextCopied: 'یادداشت‌ها در کلیپ‌بورد کپی شد!',
    learningTitle: 'دستیار یادگیری و هوش مصنوعی',
    learningToggleDirection: 'تغییر جهت متن (راست‌چین/چپ‌چین)',
    learningTopicCreated: 'سرفصل با موفقیت ایجاد شد',
    learningTopicLabel: 'سرفصل:',
    learningTopicTitle: 'مباحث آموزشی من',
    learningTopicsCount: '{{count}} سرفصل',
    learningTopicsOf: 'جلسات درس {{topic}}',
    learningTotalSessions: 'مجموع جلسات:',
    learningUnknownError: 'خطای ناشناخته رخ داده است',
    learningUpdateTopicBtn: 'ذخیره تغییرات',
    learningUploadingStatus: 'پردازش و استخراج خودکار متن...',
    learningUploadingTitle: 'در حال بارگذاری فایل...',
    learningUploadingWait: 'لطفاً تا اتمام آپلود منتظر بمانید...',
    learningUserMsgLabel: 'یادداشت دانشجو',
    learningVideoOnlineDefault: 'ویدیوی آموزشی',
    learningVideoOnlineLink: 'پیوند ویدیو آنلاین',
    learningVideoTitlePh: 'عنوان ویدیو یا موضوع (اختیاری)...',
    learningVideoUnsupported: 'پخش مستقیم این فرمت در پیش‌نمایش پشتیبانی نمی‌شود',
    learningVideoUrlHint: 'آدرس کامل لینک ویدیویی را وارد کنید',
    learningVideoUrlLabel: 'آدرس اینترنتی ویدیو (YouTube, Vimeo, MP4):',
    learning_assistant: 'دستیار هوشمند آموزش و یادگیری',
    lightMode: 'حالت روشن',
    listColorLabel: 'رنگ برچسب دفترچه',
    listNameLabel: 'عنوان دفترچه خرید',
    listNamePlaceholder: 'مثال: خرید خواربار هفته...',
    liveGaugesDesc: 'تحلیل هزینه‌کرد ماه جاری در برابر سقف مجاز برای هر یک از دسته‌بندی‌های دارای بودجه',
    liveGaugesTitle: 'گیج‌های زنده و گیج بودجه‌بندی دسته‌بندی‌ها:',
    loading: 'در حال بارگذاری...',
    logWeightBtn: 'ثبت وزن جدید',
    login: 'ورود به حساب کاربری',
    loginAppTitle: 'Progress',
    loginBadgeFinance: '💰 مدیریت مالی و فاکتور AI',
    loginBadgeGrowth: '🌱 رشد و عادت‌ها',
    loginBadgeRehab: '🩺 توانبخشی و سلامت',
    loginDescription: 'سامانه هوشمند مدیریت سلامت، برنامه روزانه و امور مالی',
    loginEmailLabel: 'آدرس ایمیل',
    loginEmailSeparator: 'یا از طریق ایمیل',
    loginErrorCreate: 'خطا در ایجاد حساب کاربری',
    loginErrorFillAll: 'لطفا تمام فیلدها را پر کنید.',
    loginErrorGoogleToken: 'خطا در تایید حساب گوگل',
    loginErrorName: 'لطفا نام خود را وارد کنید.',
    loginErrorPassLength: 'رمز عبور باید حداقل ۶ کاراکتر باشد.',
    loginErrorServer: 'خطا در ارتباط با سرور.',
    loginErrorUnexpected: 'یک خطای غیرمنتظره رخ داد. لطفا مجددا تلاش کنید.',
    loginErrorWrong: 'ایمیل یا رمز عبور اشتباه است.',
    loginFullNameLabel: 'نام و نام خانوادگی',
    loginFullNamePlaceholder: 'مثال: سلیم زارع‌پور',
    loginGoogle: 'ورود سریع با گوگل (Google OAuth)',
    loginGoogleClientPrompt: 'جهت فعال‌سازی ورود گوگل، VITE_GOOGLE_CLIENT_ID را در مت متغیرهای محیطی سیستم قرار دهید.',
    loginGoogleError: 'ورود با حساب گوگل ناموفق بود یا توسط کاربر لغو شد.',
    loginGoogleManualInputClose: 'بستن فرم ورود دستی',
    loginGoogleManualInputPrompt: 'یا کلاینت‌آیدی گوگل را اینجا وارد کنید (تست سریع)',
    loginGoogleManualInputSave: 'ذخیره و فعال‌سازی فوری',
    loginGuest: 'ورود به عنوان کاربر مهمان',
    loginPasswordLabel: 'رمز عبور',
    loginSlogan: 'سامانه جامع رشد شخصی، توانبخشی و ورزش، مدیریت هوشمند مالی و بودجه‌بندی فاکتورها، سلامت و پیگیری اهداف زندگی',
    loginSubmitNewAccount: 'ایجاد حساب کاربری جدید',
    loginSubmitSignIn: 'ورود به سیستم',
    loginToggleToSignIn: 'حساب کاربری دارید؟ از اینجا وارد شوید',
    loginToggleToSignUp: 'حساب کاربری ندارید؟ ثبت‌نام کنید',
    loginVerifyingGoogle: 'در حال تایید امن حساب گوگل...',
    logout: 'خروج از حساب',
    lowPriority: '🌱 اولویت عادی',
    lowestSpentProducts: 'ارزان‌ترین/کم‌هزینه‌ترین کالاها (Lowest Spent):',
    manageFamilyMembers: 'مدیریت اعضای خانواده',
    manualAdd: 'ثبت دستی',
    matchWithBankTx: 'تطبیق با تراکنش بانک {{title}} (جزئیات خرید جایگزین بانک می‌شود)',
    matchWithPurchase: 'تطبیق با خرید {{title}} (کارت بانک به خرید اعمال می‌شود)',
    matchingBankTxFoundMsg: 'تراکنش هم‌پوشان بانکی پیدا شد: {{title}} با مبلغ {{amount}} {{currency}} (تاریخ {{date}}). هنگام ثبت، فاکتور کامل اسکن‌شده جایگزین این تراکنش خام خواهد شد تا از ثبت دوتایی جلوگیری شود.',
    matchingBankTxNotice: 'تراکنش هم‌پوشان بانکی پیدا شد: {{title}} با مبلغ {{amount}} {{currency}} (تاریخ {{date}}). هنگام ثبت، فاکتور کامل اسکن‌شده جایگزین این تراکنش خام خواهد شد تا از ثبت دوتایی جلوگیری شود.',
    medCondDefault: 'ندارم',
    medicalCategory: '🩺 پزشکی و دارو',
    medicationAdvice: 'مشاوره و تداخلات دارویی',
    mediumPriority: '⚡ اولویت متوسط',
    medsDefault: 'مصرف نمی‌کنم',
    month1: 'ژانویه',
    month10: 'اکتبر',
    month11: 'نوامبر',
    month12: 'دسامبر',
    month2: 'فوریه',
    month3: 'مارس',
    month4: 'آوریل',
    month5: 'می',
    month6: 'ژوئن',
    month7: 'ژوئیه',
    month8: 'اوت',
    month9: 'سپتامبر',
    monthExpenseLabel: 'هزینه: {{amount}}',
    monthSavingsLabel: 'پس‌انداز: {{amount}} {{currency}}',
    monthlyBudgetRemainingLabel: 'مانده بودجه هزینه ماه:',
    monthlyCategoryAnalysisDesc: 'تحلیل هزینه‌کرد ماه جاری در برابر سقف مجاز برای هر یک از دسته‌بندی‌های دارای بودجه',
    monthlyExpenseCapLabel: 'سقف مجاز کل هزینه‌های ماهانه ({{ratio}}%):',
    monthlySavingPower: 'قدرت پس‌انداز ماهانه:',
    monthlySavingsShare: 'سهم پس‌انداز ماهانه:',
    monthlySavingsShareLabel: 'سهم پس‌انداز ماهانه:',
    monthsInHistory: '{{count}} ماه در تاریخچه',
    monthsUnit: 'ماه',
    moodTracker: 'ارزیابی خلق‌و‌خو و انرژی روزانه',
    mostExpensiveMonth: 'پرمصرف‌ترین ماه سال:',
    myCardsAndAccounts: '💳 کارت‌ها و حساب‌های من',
    navDashboard: 'داشبورد',
    navMenu: 'فهرست',
    navNutrition: 'تغذیه',
    navReminders: 'یادآورها',
    navSport: 'ورزش',
    needToBuy: 'نیاز به خرید',
    netBalance: 'تراز مالی فعلی',
    netMonthlyIncomeHeader: 'درآمد خالص ماهانه:',
    netMonthlyIncomeLabel: 'درآمد خالص ماهانه پس از مالیات (Net Income):',
    newGoalModalTitle: 'تعریف هدف مالی و پس‌انداز جدید',
    newItemPlaceholder: 'کالای جدید',
    newListModalTitle: 'ساخت دفترچه خرید جدید',
    newNoteBtn: 'یادداشت جدید',
    news: 'رادار اخبار و هوش مصنوعی',
    newsCategoriesLabel: 'دسته‌بندی اخبار',
    newsRadarTitle: 'آخرین اخبار هوش مصنوعی و فناوری',
    newsSource: 'منبع خبر',
    newsSourceLabel: 'منبع خبر',
    newsTopicsTab: 'موضوعات و کلیدواژه‌ها',
    news_radar: 'رادار اخبار و مقالات سلامت',
    nextMonth: 'ماه بعد',
    noActiveGoals: 'بدون هدف فعال',
    noBudgetPlaceholder: '۰ (بدون بودجه)',
    noCappedCategoriesMsg: 'هیچ دسته‌بندی دارای سقف بودجه مشخصی برای این ماه نیست.',
    noCategoryCapsDefinedYet: 'هنوز سقف اختصاصی برای هیچ‌یک از دسته‌بندی‌ها ثبت نشده است.',
    noCategoryCapsHelp: 'در فرم بالا با دکمه «تخمین خودکار» یا درج دستی مبلغ، می‌توانید برای هر دسته‌بندی سقف تعیین کنید تا گیج‌های گرافیکی آن فعال گردد.',
    noCategoryCapsRecorded: 'هنوز سقف اختصاصی برای هیچ‌یک از دسته‌بندی‌ها ثبت نشده است.',
    noCategoryData: 'تراکنشی جهت نمایش نمودار دسته‌بندی ثبت نشده است.',
    noGoalsYet: 'هنوز هدفی برای پس‌انداز ثبت نشده است.',
    noMonthlyData: 'داده ماهانه‌ای جهت مقایسه یافت نشد.',
    noProductFound: 'کالایی یافت نشد.',
    noTransactionsFound: 'هیچ فاکتور یا تراکنشی یافت نشد.',
    notes: 'یادداشت‌ها و خلق‌و‌خو',
    notesEnergyLevelTitle: 'سطح انرژی جسمی (۱ تا ۱۰)',
    notesEnergyScoreLabel: 'امتیاز انرژی: {{score}}/۱۰',
    notesHeaderDesc: 'ثبت افکار، برنامه‌ها، احساسات روزانه و دسته‌بندی موضوعی یادداشت‌ها',
    notesHeaderTitle: 'دفترچه یادداشت‌های شخصی و پایش خلق‌و‌خو (Mood)',
    notesLabel: 'یادداشت‌ها',
    notesMoodTitle: 'خلق‌وخو و انرژی ذهنی',
    notesNotebooksTitle: 'دفترچه‌های یادداشت سلامت و روزنگار',
    notesObservationsLabel: 'مشاهدات روزانه سلامت',
    notesObservationsPlaceholder: 'تغییرات فیزیکی، واکنش به غذاها یا نکات سلامتی روز را یادداشت کنید...',
    notesPainDesc0: 'کاملاً بدون درد، احساس عالی',
    notesPainDesc10: 'شدیدترین درد ممکن، شرایط اورژانسی',
    notesPainDesc2: 'ناراحتی بسیار خفیف، به سختی احساس می‌شود',
    notesPainDesc4: 'درد قابل توجه، قابل تحمل بدون نیاز به دارو',
    notesPainDesc6: 'درد متوسط تا شدید، مخل فعالیت‌های روزمره',
    notesPainDesc8: 'درد بسیار شدید و ناتوان‌کننده، نیاز به استراحت کامل',
    notesPainLevelTitle: 'مقیاس سنجش درد و ناراحتی جسمانی',
    notesPainScale0: '۰ - بدون درد',
    notesPainScoreLabel: 'میزان درد: {{score}}/۱۰',
    notesPhysicalStatusPrefix: 'وضعیت فیزیکی:',
    notesRemindersLabel: 'یادآوری‌های سلامتی و اقدامات بعدی',
    notesRemindersPlaceholder: 'مثلا: نوبت آزمایش خون، خرید مکمل، نوشیدن بیشتر آب...',
    notesSymptomsLabel: 'علائم و نشانه‌های مشاهده‌شده بدن',
    notificationsTitle: 'تنظیمات اعلان‌ها و یادآوری‌ها',
    nutriAdd: 'افزودن',
    nutriAddFav: 'افزودن به علاقه‌مندی‌ها',
    nutriAiAnalysis: 'غذا/تحلیل AI',
    nutriAiAnalyzing: 'در حال تحلیل AI...',
    nutriAiEstimate: 'تخمین با AI',
    nutriAiQueryWeight: 'استعلام کالری و درشت‌مغذی این وزن از هوش مصنوعی',
    nutriAiRecalculating: 'در حال محاسبه دقیق وزن با AI...',
    nutriBreakfast: 'صبحانه',
    nutriCalLabel: 'کالری (kcal)',
    nutriCalcResult: 'ارزش غذایی محاسبه‌شده',
    nutriCalories: 'کالری مصرفی',
    nutriCarbLabel: 'کربوهیدرات (گرم)',
    nutriCarbShort: 'کربوهیدرات:',
    nutriCarbs: 'کربوهیدرات',
    nutriChatAssistant: 'دستیار چت',
    nutriChatPlaceholder: 'مثلاً: برای کاهش چربی شکم و افزایش عضله چه خوراکی‌هایی توصیه می‌کنی؟',
    nutriChatSubtitle: 'سوالات تخصصی رژیم، محاسبه کالری و برنامه غذایی خود را بپرسید',
    nutriChatTitle: 'دستیار هوشمند چت تغذیه و رژیم',
    nutriCustomAddTitle: 'ثبت غذا یا تحلیل اتوماتیک هوش مصنوعی',
    nutriDeleteFood: 'حذف خوراکی',
    nutriDietTip: '💡 توصیه تغذیه‌ای امروز',
    nutriDietTipText: 'برای دستیابی بهتر به اهداف ورزشی، پیشنهاد می‌شود پروتئین روزانه خود را در تمام ۴ وعده تقسیم کنید و حتماً حداقل ۲.۵ لیتر آب بنوشید.',
    nutriDinner: 'شام',
    nutriFat: 'چربی‌های مفید',
    nutriFatLabel: 'چربی (گرم)',
    nutriFatShort: 'چربی:',
    nutriFavorites: 'علاقه‌مندی‌ها ({{count}})',
    nutriFoodNameDesc: 'نام غذا / شرح وعده',
    nutriFoodNamePlaceholder: 'مثلاً: یک بشقاب استانبولی پلو با ماست و سالاد شیرازی',
    nutriFrom: 'از',
    nutriGlassWater: '۱ لیوان (+۲۵۰ml)',
    nutriGrams: 'گرم',
    nutriHeaderTitle: 'مدیریت هوشمند تغذیه و کالری',
    nutriItem: 'مورد',
    nutriKcal: 'کیلوکالری',
    nutriLogBtn: 'ثبت',
    nutriLogToDiary: 'ثبت در دفترچه روزانه',
    nutriLogToFoodDiary: 'ثبت در دفترچه غذایی',
    nutriLunch: 'ناهار',
    nutriMealCount: 'تعداد وعده:',
    nutriMealType: 'نوع وعده',
    nutriNextDay: 'روز بعد',
    nutriNoFoodForMeal: 'هیچ خوراکی برای این وعده ثبت نشده است.',
    nutriOrEnterExactWeight: 'یا وارد کردن وزن دقیق (گرم):',
    nutriPrevDay: 'روز قبل',
    nutriProtLabel: 'پروتئین (گرم)',
    nutriProtShort: 'پروتئین:',
    nutriProtein: 'پروتئین',
    nutriQtyPlaceholder: 'مثلاً: ۱۵۰ گرم / ۱ بشقاب کامل',
    nutriQtyWeight: 'مقدار / وزن / سروینگ',
    nutriQuickAdd: 'افزودن سریع',
    nutriReduceWater: 'کاهش آب',
    nutriRefUnit: 'واحد مرجع:',
    nutriReport: 'گزارش',
    nutriReportTitle: 'گزارش و تحلیل پیشرفت تغذیه‌ای',
    nutriSearchPlaceholder: 'جستجوی خوراکی (مانند: سینه مرغ، برنج، تخم مرغ...)',
    nutriSelectMeal: 'انتخاب وعده غذایی:',
    nutriServingMultiplier: 'ضریب واحد مصرفی:',
    nutriSnack: 'میان‌وعده',
    nutriSourceAi: '✨ هوش مصنوعی',
    nutriSourceStd: '⚡ محاسبه استاندار',
    nutriSummaryTitle: 'خلاصه وضعیت تغذیه امروز',
    nutriToday: 'امروز',
    nutriTodayMeals: 'وعده‌های ثبت‌شده امروز',
    nutriTotalCalToday: 'مجموع کالری امروز',
    nutriTotalCarbToday: 'کربوهیدرات امروز',
    nutriTotalProtToday: 'پروتئین امروز',
    nutriWater: 'میزان آب مصرفی:',
    nutriWaterConsumed: 'آب مصرفی',
    nutriWaterTarget: '(هدف: {{target}} ml)',
    nutriWeightPlaceholder: 'مثلاً: {{base}} (گرم)',
    nutrition: 'ثبت و پیگیری تغذیه',
    nutritionHeaderDesc: 'محاسبه کالری روزانه، پروتئین، کربوهیدرات و چربی به همراه اسکن وعده‌های غذایی با AI',
    nutritionHeaderTitle: 'ثبت و پیگیری هوشمند تغذیه و درشت‌مغذی‌ها',
    ofIncome: 'از درآمد',
    ofTotalBudget: 'از کل بودجه',
    ofTotalBudgetUsed: 'از کل بودجه استفاده شده',
    offlineMode: 'حالت آفلاین (ذخیره محلی)',
    offsetAtTime: 'همان لحظه سررسید',
    offsetBefore: 'قبل',
    offsetDay: 'روز',
    offsetHour: 'ساعت',
    offsetMin: 'دقیقه',
    offsetWeek: 'هفته',
    or: 'یا',
    overAllocationWarning: '⚠️ تخصیص مازاد بر {{title}}',
    overlappingBankTxFound: 'تراکنش هم‌پوشان بانکی پیدا شد: {{title}} با مبلغ {{amount}} {{currency}} (تاریخ {{date}}). هنگام ثبت، فاکتور کامل اسکن‌شده جایگزین این تراکنش خام خواهد شد تا از ثبت دوتایی جلوگیری شود.',
    overviewAndTxs: 'نمای کلی و تراکنش‌ها',
    painLevelTracker: 'شاخص سنجش میزان درد (۱ تا ۱۰)',
    password: 'رمز عبور',
    paymentMethodCard: '💳 کارت بانکی (Card)',
    paymentMethodCash: '💵 نقدی (Cash)',
    paymentMethodSwish: '📱 سوئیش (Swish)',
    paymentMethodTransfer: '🏦 انتقال بانکی (Transfer)',
    pendingCount: 'در انتظار خرید',
    perMonthSuffix: 'ماه',
    persian: 'فارسی (Persian)',
    personalDoctor: 'پزشک اختصاصی (AI)',
    preset15m: '۱۵ دقیقه قبل',
    preset1d: '۱ روز قبل',
    preset1h: '۱ ساعت قبل',
    preset1w: '۱ هفته قبل',
    preset3d: '۳ روز قبل',
    presetAtTime: 'همان لحظه',
    presetTitle: 'پیشنهادهای آماده خرید (Presets)',
    prevMonth: 'ماه قبل',
    productAnalyticsTab: 'تحلیل مصرف کالاها',
    profileSettings: 'تنظیمات پروفایل و سلامت',
    progressCompleted: '{{progress}}% تکمیل شده',
    protein: 'پروتئین',
    proteinGoal: 'پروتئین (گرم)',
    purchaseDateLabel: 'تاریخ پیشنهادی خرید',
    quantity: 'تعداد',
    quantityCount: '{{count}} عدد',
    quantityTitle: 'مقدار / تعداد',
    quickAccess: 'دسترسی سریع به بخش‌ها',
    quickCurrencyChange: 'تغییر سریع ارز پایه:',
    rankingProductsTitle: '۳. رتبه‌بندی کالاها و ریزاقلام فاکتورها (Which product most or less):',
    recordedExpensesThisMonth: 'هزینه‌های ثبت‌شده این ماه:',
    recurringReminders: 'یادآورهای تکرارشونده',
    refreshNews: 'به‌روزرسانی اخبار با AI',
    refreshNewsBtn: 'به‌روزرسانی و پردازش هوشمند اخبار',
    register: 'ثبت‌نام',
    registeredItemsCount: '{{count}} کالا ثبت شده',
    rehab: 'فیزیوتراپی و اصلاحی',
    rehabAiAlert: 'توصیه‌ها توسط هوش مصنوعی آنلاین تولید می‌شوند. در صورت بروز درد شدید غیرمعمول تمرین را متوقف کنید.',
    rehabAiFormEq: 'تجهیزات در دسترس:',
    rehabAiFormEqPh: 'مثال: مت یوگا، کش پیلاتس، صندلی',
    rehabAiFormExp: 'سابقه ورزشی:',
    rehabAiFormExpA: 'حرفه‌ای (ورزشکار منظم)',
    rehabAiFormExpB: 'مبتدی (بدون سابقه ورزشی)',
    rehabAiFormExpM: 'متوسط (تمرینات پراکنده)',
    rehabAiFormLevel: 'شدت درد ({{level}} از ۱۰):',
    rehabAiFormLevelMax: 'شدید (۱۰)',
    rehabAiFormLevelMid: 'متوسط (۵)',
    rehabAiFormLevelMin: 'خیلی خفیف (۱)',
    rehabAiFormLimit: 'محدودیت‌های حرکتی:',
    rehabAiFormLimitPh: 'مثال: عدم امکان خم شدن، درد هنگام نشستن طولانی',
    rehabAiFormLoc: 'محل درد اصلی:',
    rehabAiFormLocPh: 'مثال: کمر، گردن، زانو، شانه',
    rehabAiFormTitle: 'ارزیابی وضعیت بدنی و درد',
    rehabAiSubtitle: 'تنظیم تمرینات تخصصی فیزیوتراپی بر اساس ارزیابی کامل وضعیت جسمانی و درد شما',
    rehabAiTitle: 'تولید هوشمند تمرین توانبخشی (هوش مصنوعی)',
    rehabAlertDesc: 'اگر در هر یک از این حرکات دچار افزایش درد موضعی یا دردهای تیرکشنده به سمت باسن یا پا شدید، بلافاصله تمرین را متوقف کنید. حرکات دکومپرشن و کشش پسواس باید همیشه بدون درد و در کمال آرامش عضلانی انجام پذیرند.',
    rehabAlertTitle: 'احتیاط در تمرینات کمر',
    rehabCardCancel: 'انصراف',
    rehabCardEdit: 'ویرایش و پیوست رسانه به حرکت',
    rehabCardEditShort: 'ویرایش / پیوست رسانه',
    rehabCardImageDel: 'حذف تصویر',
    rehabCardImageLabel: 'پیوست تصویر یا گیف آموزشی',
    rehabCardImagePreview: 'پیش‌نمایش تصویر:',
    rehabCardSave: 'ذخیره تغییرات رسانه و حرکت',
    rehabCardTagImage: 'عکس آموزشی',
    rehabCardTagRehab: 'فیزیوتراپی',
    rehabCardTagVideo: 'فیلم آموزشی',
    rehabCardVideoLabel: 'پیوست فیلم آموزشی (آپلود فایل یا لینک ویدیو)',
    rehabCardVideoPreview: 'پیش‌نمایش ویدیو:',
    rehabChatApply: 'افزودن این تمرین به لیست برنامه‌ها',
    rehabChatPh: 'شرح کامل درد یا سوال خود درباره حرکات را بنویسید...',
    rehabChatSub: 'پاسخ مستقیم و هوشمند بر اساس ارزیابی بدنی شما',
    rehabChatTitle: 'گفتگوی هوشمند توانبخشی و طراحی تمرین',
    rehabCustomAddSub: 'یک حرکت دلخواه یا توصیه شده پزشک را به برنامه شخصی خود اضافه کنید',
    rehabCustomAddTitle: 'افزودن تمرین فیزیوتراپی سفارشی',
    rehabCustomClose: 'بستن فرم',
    rehabCustomDesc: 'توضیح کامل حرکت و نحوه انجام',
    rehabCustomDescPh: 'حرکت را دقیقاً توصیف کنید تا هنگام تمرین راهنما باشد...',
    rehabCustomDiff: 'درجه سختی',
    rehabCustomDiffA: 'پیشرفته',
    rehabCustomDiffB: 'مبتدی',
    rehabCustomDiffM: 'متوسط',
    rehabCustomImage: 'تصویر آموزشی حرکت (اختیاری)',
    rehabCustomImageReady: 'تصویر بارگذاری شد',
    rehabCustomName: 'نام حرکت',
    rehabCustomNamePh: 'مثال: کشش گربه-شتر ملایم',
    rehabCustomOpen: 'باز کردن فرم',
    rehabCustomPurpose: 'هدف حرکت (چرا کمک می‌کند؟)',
    rehabCustomPurposePh: 'مثال: کاهش فشردگی مهره‌های L4-S1',
    rehabCustomReps: 'تکرار / مکث',
    rehabCustomRest: 'مدت استراحت',
    rehabCustomSets: 'تعداد ست',
    rehabCustomSubmit: 'ثبت و ذخیره حرکت سفارشی',
    rehabCustomTarget: 'عضلات تحت تأثیر',
    rehabCustomTargetPh: 'مثال: فیله کمر، ستون فقرات',
    rehabCustomTime: 'زمان (دقیقه)',
    rehabCustomTip1: 'با باز کردن فرم می‌توانید هر حرکتی را به همراه جزئیات کامل ست‌ها، تکرارها، عضلات هدف و تصاویر/فیلم‌های آموزشی اختصاصی به لیست روزانه خود متصل نمایید.',
    rehabCustomTip2: 'حرکاتی که به این جدول اضافه می‌کنید هم در بخش ورزش‌های روزانه هم در برنامه هدایت صوتی پویا به صورت خودکار قرار خواهند گرفت.',
    rehabCustomVideo: 'فیلم آموزشی حرکت (اختیاری)',
    rehabCustomVideoDel: 'حذف ویدیو',
    rehabCustomVideoPh: 'یا لینک ویدیو (اینستاگرام، یوتیوب، آپارات، MP4)...',
    rehabCustomVideoReady: 'ویدیو آماده است',
    rehabFolderBtnClose: 'بستن پوشه فایل‌ها',
    rehabFolderBtnOpen: 'پوشه فایل‌ها و اسناد فیزیوتراپی',
    rehabFullInstructions: 'آموزش گام‌به‌گام انجام حرکت:',
    rehabGraphicPlaceholder: '[نمای شماتیک فیزیوتراپی]',
    rehabGuidedCompleteDesc: 'مجموعه تمرینات ریکاوری کمر با موفقیت در جدول پیشرفت ذخیره شدند.',
    rehabGuidedCompleteTitle: 'عالی بود! تمرین امروز تکمیل شد',
    rehabGuidedSaveReturn: 'تایید و بازگشت به لیست',
    rehabHeaderDesc: 'برنامه اختصاصی حرکت‌درمانی، تقویت عضلات و پیگیری روزانه تمرینات اصلاحی',
    rehabHeaderTitle: 'فیزیوتراپی، تمرینات اصلاحی و کاهش درد',
    rehabLevelMid: 'متوسط',
    rehabLevelSafe: 'سطح مبتنی ایمن',
    rehabPlayImage: 'مشاهده تصویر حرکت',
    rehabPlayVideo: 'مشاهده فیلم آموزشی',
    rehabProgress: 'فیزیوتراپی و تمرینات',
    rehabStartGuided: 'شروع جلسه تمرینی هدایت‌شده با صدا',
    rehabStatsTimeActive: 'دقیقه تمرین فعال',
    rehabStatsTimeTip: 'استمرار در تمرینات کلید اصلی بهبودی است!',
    rehabStatsTimeTitle: 'مدت‌زمان ریکاوری مفید',
    rehabStatsTitleCompleted: 'تمرینات تکمیل‌شده کمردرد',
    rehabStatsTotalDaily: '/ {{total}} تمرین روزانه',
    rehabStatusPrepare: 'آماده‌باش',
    rehabStatusRest: 'استراحت و ریکاوری',
    rehabStatusRunning: 'در حال اجرا',
    rehabSubtitle: 'برنامه تمرینی ملایم برای آزادسازی پسواس، افزایش دامنه حرکتی و تقویت عضلات پایدارکننده؛ استخراج شده از فیزیوتراپی پیشرفته.',
    rehabTargetMuscles: 'عضلات تثبیت‌کننده:',
    rehabTargetPurpose: 'هدف کلیدی تمرین:',
    rehabTimerSkip: 'رد کردن استراحت',
    rehabTimerStandby: 'آماده‌به‌کار',
    rehabTimerStart30: 'شروع ۳۰ ثانیه',
    rehabTimerTip: 'برای خون‌رسانی و ریکاوری بافت‌های همبند کمر، اختصاص دادن ۳۰ ثانیه استراحت بین تکرارها سودمند است.',
    rehabTimerTitle: 'تایمر استراحت آزاد',
    rehabVideoIg: 'پست / ریلز اینستاگرام',
    rehabVideoIgOpen: 'باز کردن مستقیم در اپ اینستاگرام',
    rehabVideoWeb: 'مشاهده و پخش لینک ویدیو (اینستاگرام / وب)',
    rehabVoiceActive: 'دستیار صوتی فعال است',
    voiceInputNormal: 'ورودی صوتی',
    voiceInputStop: 'توقف ضبط',
    voiceInputProcessing: 'در حال تبدیل صدا به متن...',
    voiceInputProcessingShort: 'تبدیل صدا...',
    voiceInputBtnLabel: 'صدا',
    voiceInputPermissionDenied: 'دسترسی به میکروفون داده نشد.',
    voiceInputRecordingError: 'ضبط صدا با مشکل مواجه شد.',
    voiceInputTranscribeError: 'تبدیل صدا به متن انجام نشد. لطفاً دوباره تلاش کنید.',
    voiceInputNoSpeechDetected: 'صدایی برای تبدیل به متن تشخیص داده نشد.',
    voiceInputTitleForField: 'ورودی صوتی برای عنوان مبحث',
    voiceInputTitleForNotes: 'ورودی صوتی برای توضیحات و مباحث فرعی',
    rehabEmptyTitle: 'هنوز تمرینی در این ماژول ثبت نشده است',
    rehabEmptyDesc: 'می‌توانید با استفاده از دکمه «درون‌ریزی دسته‌جمعی فعالیت‌ها» تمرینات خود را از فایل JSON وارد کنید یا به صورت تکی تمرین جدید اضافه نمایید.',
    rehabNoExercisesAlert: 'ابتدا باید حداقل یک تمرین به این ماژول اضافه یا ایمپورت کنید.',
    remainingAllowedExpense: 'باقیمانده مجاز هزینه این ماه:',
    remainingBudgetCapHeader: 'مانده سقف بودجه:',
    remainingBudgetMonth: 'مانده بودجه هزینه ماه: {{amount}} {{currency}}',
    remainingExpenseBudgetMsg: '✓ باقیمانده مجاز هزینه این ماه: {{amount}} {{currency}}',
    reminderActiveCount: '{{count}} زمان یادآوری فعال',
    reminderAddBtn: 'ثبت یادآور جدید',
    reminderAddCustomOffsetBtn: 'افزودن',
    reminderAddForDate: 'افزودن برای این تاریخ',
    reminderAddShort: 'افزودن',
    reminderAllCatsCount: 'همه دسته‌ها ({{count}})',
    reminderAllPersons: 'همه افراد',
    reminderCantRemoveMe: 'امکان حذف مخاطب اصلی «خودم» وجود ندارد',
    reminderCardAddGcal: 'افزودن مستقیم این یادآور به گوگل کلندر (Google Calendar)',
    reminderCardDelete: 'حذف',
    reminderCardEdit: 'ویرایش',
    reminderCardGcal: 'گوگل کلندر',
    reminderCardTime: 'ساعت {{time}}',
    reminderCatBills: 'قبوض و مالی',
    reminderCatBirthday: 'تولد و سالگردها',
    reminderCatEvent: 'رویداد و قرار ملاقات',
    reminderCatFamily: 'مدیریت خانواده',
    reminderCatMedical: 'پزشکی و سلامت',
    reminderCatPersonal: 'امور شخصی و اداری',
    reminderCatSchool: 'مدرسه و آموزش',
    reminderCatShopping: 'خرید و مرسولات',
    reminderCategoryLabel: 'دسته‌بندی',
    reminderClearAllBtn: 'پاکسازی همه',
    reminderCustomOffset: 'زمان سفارشی:',
    bulkImportModalTitle: 'درون‌ریزی دسته‌جمعی تمرینات و فعالیت‌ها (JSON Bulk Import)',
    bulkImportModalSubtitle: 'ثبت و ذخیره پایدار در پایگاه داده ابری Cloudflare D1',
    bulkImportD1NoticeTitle: 'ذخیره‌سازی دائمی و یکپارچه در پایگاه داده Cloudflare D1',
    bulkImportD1NoticeDesc: 'تمام فعالیت‌های وارد شده مستقیماً در جدول دیتابیس با شناسه اختصاصی و رابطه ماژول ثبت می‌شوند و با تغییر صفحه، رفرش یا خروج از حساب کاربری کاملاً پایدار خواهند ماند.',
    bulkImportModuleSelect: 'ماژول مقصد (Destination Module):',
    module1RehabName: 'فیزیوتراپی و تمرینات اصلاحی',
    module2BellyName: 'تمرینات چربی‌سوزی و کاردیو',
    moduleCustomActivities: 'فعالیت‌های عمومی روزانه',
    bulkImportStrategySelect: 'راهبرد مدیریت موارد تکراری (Duplicate Strategy):',
    strategyUpdate: 'به‌روزرسانی موارد موجود + درج موارد جدید (Update / Upsert)',
    strategySkip: 'صرف‌نظر از تکراری‌ها + فقط درج موارد جدید (Skip duplicates)',
    strategyInsert: 'همیشه درج با شناسه جدید (Always Insert as New)',
    bulkImportJsonLabel: 'محتوای JSON آرایه تمرینات:',
    copied: 'کپی شد',
    copySample: 'کپی نمونه',
    loadSampleJson: 'بارگذاری نمونه JSON',
    jsonEmptyError: 'لطفاً متن JSON فعالیت‌ها را در کادر وارد نمایید.',
    jsonNoItemsFound: 'هیچ شیء یا آرایه‌ای از فعالیت‌ها در داده‌های ورودی یافت نشد.',
    jsonMissingNameError: 'تمام تمرینات باید حداقل شامل فیلد "name" یا "title" باشند.',
    jsonSyntaxError: 'خطای ساختار JSON:',
    validItemsCount: 'تعداد {{count}} تمرین معتبر آماده درون‌ریزی یافت شد:',
    readyToImport: 'آماده ارسال به D1',
    importSuccessTitle: 'عملیات درون‌ریزی در دیتابیس با موفقیت انجام شد!',
    importFailedTitle: 'خطا در فرآیند درون‌ریزی',
    importSummaryDesc: 'مجموع: {{total}} | افزوده شده: {{ins}} | به‌روزرسانی شده: {{upd}} | رد شده: {{skp}}',
    validateJsonBtn: 'اعتبارسنجی داده‌ها (Validate JSON)',
    startImportBtn: 'انجام درون‌ریزی به پایگاه داده ({{count}} فعالیت)',
    importingProgress: 'در حال ذخیره‌سازی در D1...',
    bulkImportOpenBtn: 'درون‌ریزی دسته‌جمعی فعالیت‌ها (JSON Import)',
    reminderClearAllConfirm: 'آیا از حذف کامل تمام یادآورهای خانوادگی اطمینان دارید؟ این عمل غیرقابل بازگشت است.',
    reminderClearAllTitle: 'پاکسازی کامل تمام یادآورهای فعلی',
    reminderDateLabel: 'تاریخ سررسید',
    reminderDownloadIcsBtn: 'دانلود تقویم (.ics)',
    reminderDownloadIcsTitle: 'دانلود تمام یادآورهای فعال در قالب فایل تقویم .ics جهت همگام‌سازی روی آیفون، سامسونگ یا گوگل کلندر',
    reminderEditTitle: 'ویرایش یادآور',
    reminderFamilyExist: 'این نام قبلاً در لیست افراد ثبت شده است.',
    reminderFormCancel: 'انصراف',
    reminderFormCatLabel: 'دسته‌بندی',
    reminderFormCustomPerson: 'شخص جدید / سفارشی...',
    reminderFormCustomPersonLabel: 'نام شخص سفارشی',
    reminderFormCustomPersonPh: 'مثلاً: علی / مریم',
    reminderFormDate: 'تاریخ',
    reminderFormDesc: 'توضیحات تکمیلی (اختیاری)',
    reminderFormDescPh: 'آدرس کلینیک، کد مرسوله، یادداشت‌های ضروری...',
    reminderFormPersonLabel: 'مربوط به کدام شخص؟',
    reminderFormPri: 'اولویت',
    reminderFormRepeat: 'تکرار',
    reminderFormSubmitAdd: 'ثبت یادآور',
    reminderFormSubmitEdit: 'ذخیره تغییرات',
    reminderFormTime: 'ساعت',
    reminderFormTitleLabel: 'عنوان یادآور',
    reminderFormTitlePh: 'مثلاً: تولد همسر / پرداخت قبض / آزمایش تیرویید...',
    reminderHeaderDesc: 'ثبت یادآورهای پزشکی، قبوض، تولدها و امور مدرسه همراه با همگام‌سازی ابری و خروجی تقویم',
    reminderHeaderTitle: 'دفترچه یادآور هوشمند خانوادگی و برنامه‌های سررسید',
    reminderItemsCount: '{{count}} مورد',
    reminderManageMembersBtn: 'مدیریت اعضا',
    reminderManageMembersTitle: 'مدیریت، افزودن یا حذف اعضای خانواده',
    reminderMe: 'من',
    reminderMembersAdd: 'افزودن',
    reminderMembersClose: 'تأیید و بستن',
    reminderMembersCurrent: 'اعضای فعلی ثبت‌شده ({{count}}):',
    reminderMembersDesc: 'تعریف، افزودن یا حذف افراد برای تخصیص یادآورها',
    reminderMembersPh: 'نام فرد جدید (مثلاً: بنیتا، مریم، علی)...',
    reminderMembersRemove: 'حذف {{member}}',
    reminderMembersTitle: 'مدیریت اعضای خانواده',
    reminderModalDesc: 'تنظیم زمان‌بندی، اولویت و عضو مربوطه در خانواده',
    reminderNewItem: 'جدید',
    reminderNewTitle: 'ایجاد یادآور جدید',
    reminderNoForDate: 'هیچ یادآوری برای تاریخ {{date}} ثبت نشده است.',
    reminderNoIcsError: 'هیچ یادآور فعالی برای خروجی تقویم وجود ندارد.',
    reminderNoInCat: 'هیچ یادآوری در این دسته وجود ندارد.',
    reminderNoTodayDesc: 'یک یادآور جدید برای قرارهای امروز ثبت کنید.',
    reminderNoTodayMsg: 'امروز هیچ یادآور معوقی ندارید!',
    reminderNoUpcoming: 'هیچ یادآوری برای روزهای آینده ثبت نشده است.',
    reminderNoOffsets: 'بدون یادآوری',
    reminderOffsetsTitle: 'زمان‌بندی اعلان و یادآوری قبل از سررسید',
    reminderPastTitle: 'یادآورهای گذشته ({{count}})',
    reminderPersonFilter: 'فرد:',
    reminderPersonLabel: 'فرد مرتبط / عضو خانواده',
    reminderPresetsLabel: 'افزودن سریع زمان‌های متداول:',
    reminderPreset1Name: 'تولد و سالگرد',
    reminderPreset1Title: 'تولد و سالگرد ازدواج',
    reminderPreset2Name: 'پرداخت قبوض',
    reminderPreset2Title: 'پرداخت قبض برق و گاز',
    reminderPreset3Name: 'مدرسه / دانشگاه',
    reminderPreset3Title: 'جلسه اولیا و مربیان مدرسه',
    reminderPreset4Name: 'آزمایش تیرویید',
    reminderPreset4Title: 'تست خون تیرویید و آزمایش',
    reminderPreset5Name: 'پیگیری سفارش',
    reminderPreset5Title: 'پیگیری مرسوله پستی سفارش',
    reminderPreset6Name: 'رویداد خانوادگی',
    reminderPreset6Title: 'ملاقات خانوادگی و مهمانی',
    reminderPriHigh: 'فوری',
    reminderPriHighText: 'فوری / بالا',
    reminderPriLow: 'عادی',
    reminderPriLowText: 'عادی',
    reminderPriMed: 'متوسط',
    reminderPriMedText: 'متوسط',
    reminderPriorityLabel: 'سطح اولویت',
    reminderQuickPresets: 'پیشنهادهای سریع:',
    reminderRegisteredCount: '{{count}} یادآور ثبت‌شده',
    reminderRemoveOffsetBtn: 'حذف این زمان یادآوری',
    reminderRepeatDaily: 'روزانه',
    reminderRepeatLabel: 'تکرار یادآور',
    reminderRepeatMonthly: 'ماهانه',
    reminderRepeatNone: 'بدون تکرار',
    reminderRepeatWeekly: 'هفتگی',
    reminderRepeatYearly: 'سالانه',
    reminderSearchPh: 'جستجو در عنوان یادآور، شخص یا توضیحات...',
    reminderSelectedDate: 'یادآورهای روز {{date}}',
    reminderStatsDone: 'انجام‌شده',
    reminderStatsMed: 'کارهای پزشکی و دارویی',
    reminderStatsToday: 'یادآوری‌های امروز',
    reminderStatsUpcoming: 'پیش‌رو در روزهای آینده',
    reminderTabCalendar: 'تقویم ماهانه',
    reminderTabCategories: 'دسته‌بندی‌ها',
    reminderTabToday: 'امروز و پیش‌رو',
    reminderTimeLabel: 'ساعت یادآوری',
    reminderTitleLabel: 'عنوان یادآور',
    reminderTodayTitle: 'امروز',
    reminderUnknown: 'نامشخص',
    reminderUpcomingTitle: 'روزهای آینده و پیش‌رو',
    reminders: 'دفترچه یادآور خانوادگی',
    remindersTitle: 'دفترچه یادآور خانوادگی',
    renameListTitle: 'ویرایش مشخصات دفترچه خرید',
    repetitionCount: 'تعداد تکرار',
    reports: 'گزارش‌گیری و خروجی AI',
    reportsHeaderDesc: 'دریافت خروجی PDF و Excel از سلامت، بودجه مالی، تمرینات و گزارش AI برای ارائه به پزشک یا مشاور',
    reportsHeaderTitle: 'گزارش‌گیری جامع و خروجی تحلیلی AI',
    reportsTitle: 'گزارش‌گیری جامع و تحلیلی AI',
    adminAnonymousUser: 'کاربر مهمان',
    adminFilterAllPages: 'همه صفحات',
    adminModuleDesc: 'مشاهده لیست کاربران فعال، آخرین زمان ورود، صفحه‌ای که در آن حضور دارند و تاریخچه فعالیت‌ها',
    adminModuleTitle: 'مدیریت و پایش کاربران سیستم',
    adminNoLogs: 'هیچ فعالیتی برای این کاربر ثبت نشده است.',
    adminRefreshBtn: 'به‌روزرسانی لیست',
    adminSearchPlaceholder: 'جستجوی کاربر بر اساس نام یا ایمیل...',
    adminSystemUser: 'کاربر سیستم',
    adminThActions: 'جزئیات',
    adminThEmail: 'ایمیل',
    adminThJoined: 'تاریخ عضویت',
    adminThLastActive: 'آخرین فعالیت',
    adminThLastPage: 'صفحه فعلی',
    adminThUser: 'کاربر',
    adminTotalUsers: 'تعداد کل کاربران ثبت‌شده:',
    adminUserLogsTitle: 'تاریخچه فعالیت‌های اخیر کاربر',
    adminUsersCount: '{{count}} کاربر',
    adminSelectUserPromptTitle: 'انتخاب کاربر جهت پایش ردیابی',
    adminSelectUserPromptDesc: 'روی یکی از کاربران سمت راست کلیک کنید تا جزئیات ورود و صفحات بازدید شده توسط ایشان نمایش داده شود.',
    adminLoadingUsers: 'در حال بارگذاری لیست کاربران فعال...',
    adminConnErrorTitle: 'بروز خطا در برقراری ارتباط',
    adminNoUsersFound: 'کاربری یافت نشد',
    adminNoUsersDesc: 'هیچ کاربری با شرایط جستجوی شما مطابقت ندارد.',
    adminSysAdminBadge: 'مدیر سیستم 🛡️',
    adminPageLabel: 'صفحه:',
    adminJoinDate: 'تاریخ عضویت:',
    adminLastActive: 'آخرین فعالیت:',
    adminLastPage: 'آخرین صفحه:',
    adminRecentViews: 'تاریخچه بازدید صفحات اخیر',
    adminLoggedUnit: 'ثبت شده',
    adminLoadingLogs: 'در حال بارگذاری لاگ فعالیت‌ها...',
    adminPageView: 'مشاهده صفحه',
    adminUnknown: 'نامشخص',
    settingsTitle: 'تنظیمات عمومی و ساعت یادآورها',
    settingsDesc: 'ساعت‌های هشدار روزانه، اهداف فیزیکی و کالری مورد نظر، نام کاربری و تنظیمات نوتیفیکیشن را شخصی‌سازی کنید.',
    settingsSaved: 'تغییرات ذخیره شد!',
    settingsSaveBtn: 'ذخیره تنظیمات',
    settingsProfileHeader: 'پروفایل شخصی و اهداف سلامت',
    settingsNameLabel: 'نام یا نام مستعار شما',
    settingsCalorieGoalLabel: 'کالری هدف تغذیه روزانه (کیلوکالری)',
    settingsWaterGoalLabel: 'میزان آب هدف روزانه (میلی‌لیتر)',
    settingsLocalStorageNotice: 'کلیه داده‌ها، تنظیمات و اطلاعات سلامت شما به صورت مستقیم، امن و بی‌واسطه در پایگاه‌داده ابری Cloudflare D1 ذخیره و همگام‌سازی می‌شوند.',
    settingsCalcHeader: 'محاسبه‌گر قد، وزن و کالری هدف روزانه',
    settingsCalcSub: 'فرمول استاندارد Mifflin-St Jeor بر اساس آناتومی',
    settingsHeightLabel: 'قد (سانتی‌متر)',
    settingsWeightLabel: 'وزن فعلی (کیلوگرم)',
    settingsWeightGoalLabel: 'وزن هدف (کیلوگرم)',
    settingsAgeLabel: 'سن (سال)',
    settingsGenderLabel: 'جنسیت',
    genderMale: 'آقا (مرد)',
    genderFemale: 'خانم (زن)',
    settingsActivityLevelLabel: 'سطح فعالیت روزانه',
    actSedentary: 'کم‌تحرک (کار پشت‌میزی)',
    actLight: 'فعالیت سبک (۱-۳ روز ورزش/پیاده‌روی)',
    actModerate: 'فعالیت متوسط (۳-۵ روز ورزش در هفته)',
    actActive: 'فعالیت زیاد (۶-۷ روز ورزش سنگین)',
    actVeryActive: 'خیلی فعال (ورزشکار حرفه‌ای/کار بدنی)',
    settingsGoalTypeLabel: 'هدف وزنی شما',
    goalTypeLose: 'کاهش وزن (کاهش چربی سالم ~ ۵۰۰ کالری نقصان)',
    goalTypeMaintain: 'تثبیت و حفظ وزن فعلی',
    goalTypeGain: 'افزایش وزن و عضله‌سازی (عالی برای حجم)',
    settingsAlarmsTitle: 'زمان‌بندی آلارم و هشدارهای روتین',
    settingsNotificationTestBtn: 'تست و فعال‌سازی نوتیفیکیشن',
    settingsAlarmsIntegratedTitle: 'مدیریت یکپارچه آلارم‌ها و هشدارهای روزانه در برنامه هفتگی',
    settingsAlarmsIntegratedDesc: 'تمامی آلارم‌ها، هشدارهای گوشی، و یادآورهای روتین روزانه شما از این پس به صورت مستقیم و اختصاصی در بخش «برنامه‌ریزی و روتین‌های هفتگی» تنظیم می‌شوند. برای هر فعالیت می‌توانید هشدار نوتیفیکیشن گوشی و همگام‌سازی تقویم گوگل را به دلخواه فعال کنید.',
    settingsGoToWeeklySchedule: 'ورود به تنظیمات برنامه هفتگی و آلارم‌ها',
    settingsCalendarExportTitle: 'خروجی تقویم جامع برنامه هفتگی و مرکز یادآورهای خانوادگی (.ics)',
    settingsDownloadIcsBtn: 'دانلود تقویم همه‌کاره (.ics)',
    settingsIcsGuide: '💡 راهنما: با کلیک روی دکمه فوق، فایل جامع .ics شامل تمام روتین‌های هفتگی و یادآورهای فعال مرکز یادآورهای خانوادگی دانلود می‌شود. با وارد کردن این فایل در Google Calendar، آیفون یا سامسونگ، تمام آلارم‌ها و یادآورهای شما روی تقویم بومی گوشی فعال می‌گردند.',
    settingsNotificationNoticeTitle: 'نکته همگام‌سازی نوتیفیکیشن‌های دستگاه',
    settingsNotificationNoticeDesc: 'اعلان‌های هوشمند برنامه به اجازه دسترسی در مرورگر شما (Notification Permission) متکی هستند. لطفاً دسترسی نوتیفیکیشن را در مرورگر تلفن همراه یا دسکتاپ خود صادر کنید تا یادآورها را منظم دریافت کنید.',
    settingsIosNoticeTitle: '📱 راهنمای مخصوص کاربران آیفون (iOS) برای فعال‌سازی اعلان‌ها',
    settingsIosNoticeDesc: 'سیستم‌عامل iOS اپل به دلایل امنیتی، دریافت نوتیفیکیشن را در صفحات وب معمولی غیرفعال می‌کند. برای حل این مشکل و دریافت منظم آلارم‌ها، لطفاً مراحل کوتاه زیر را انجام دهید:',
    settingsIosStep1Title: 'مرحله اول: افزودن به صفحه اصلی',
    settingsIosStep1Desc: 'در مرورگر Safari گوشی خود، دکمه Share (اشتراک‌گذاری) را در پایین فشار داده و سپس گزینه Add to Home Screen را انتخاب کنید.',
    settingsIosStep2Title: 'مرحله دوم: تایید دسترسی',
    settingsIosStep2Desc: 'برنامه وکسا را از روی صفحه اصلی آیفون باز کنید، به این بخش (تنظیمات) آمده و روی دکمه تست و فعال‌سازی نوتیفیکیشن بزنید تا مجوز صادر شود.',
    settingsMedicalCondLabel: 'بیماری‌ها و سوابق پزشکی',
    settingsMedicalCondPh: 'مثلاً: کبد چرب، فشار خون',
    settingsMedsLabel: 'داروهای مصرفی و مکمل‌ها',
    settingsMedsPh: 'مثلاً: ویتامین D3، متفورمین',
    settingsAllergiesLabel: 'حساسیت‌ها و آلرژی‌ها',
    settingsAllergiesPh: 'مثلاً: حساسیت به پنسلین، لاکتوز',
    settingsDietGoalsLabel: 'اهداف سلامتی و تغذیه‌ای',
    settingsDietGoalsPh: 'مثلاً: کاهش چربی شکمی، تنظیم قند خون',
    settingsNamePlaceholder: 'نام شما',
    settingsAiCalibrating: 'در حال آنالیز و محاسبه با هوش مصنوعی...',
    settingsAiCalibrateBtn: 'محاسبه و تنظیم هوشمند هدف کالری با هوش مصنوعی',
    targetWeightEtaTitle: 'پیش‌بینی زمان رسیدن به وزن هدف',
    targetWeightEtaDesc: 'محاسبه سرعت کاهش یا افزایش وزن با توجه به کالری هدف روزانه',
    targetWeightReached: 'تبریک! شما در حال حاضر در وزن هدف خود هستید.',
    targetWeightEstimatedTime: 'زمان تخمینی تا وزن هدف:',
    targetWeightWeeks: 'حدود {{weeks}} هفته ({{months}} ماه)',
    targetWeightWeeklyTakt: 'تغییر وزن هفتگی:',
    targetWeightMaintain: 'کالری در سطح تثبیت وزن قرار دارد (تغییر وزن صفر)',
    settingsAiStatusTitle: 'وضعیت سرویس هوش مصنوعی آنلاین',
    settingsAiStatusDesc: 'برنامه برای تحلیل تغذیه، تخمین کالری وعده‌ها و تولید برنامه‌های توانبخشی از سرویس هوش مصنوعی آنلاین استفاده می‌کند.',
    settingsAiStatusConnected: 'ارتباط با سرویس هوش مصنوعی فعال و برقرار است.',
    medCondNone: 'ندارم (سلامت کامل)',
    medsNone: 'مصرف نمی‌کنم (بدون داروی خاص)',
    weightTrendOverallStatus: 'وضعیت کلی روند وزن:',
    weightTrendDown: 'کاهش فیزیکی {{weight}} کیلوگرم',
    weightTrendUp: 'افزایش فیزیکی {{weight}} کیلوگرم',
    weightTrendStable: 'بدون نوسان محسوس (ثبات وزن)',
    weightPlateauTitle: 'تحلیل هوشمند علت استپ وزنی و راهکارهای عملی شکستن استپ',
    weightPlateauDesc: 'اگر بیش از ۱ تا ۲ هفته وزن شما تغییر نکرده و ثابت مانده است، عوامل فیزیولوژیک و راهکارهای زیر به شما در خروج سریع از استپ وزنی کمک می‌کنند.',
    weightPlateauDetectedBadge: 'استپ وزنی شناسایی شد',
    weightPlateauNormalBadge: 'روند تغییرات نرمال',
    weightPlateauAiAnalyzeBtn: 'تحلیل اختصاصی استپ وزنی من با هوش مصنوعی (AI Diagnostic)',
    weightPlateauAnalyzing: 'در حال تحلیل نوسانات وزن، کالری و فعالیت‌های شما...',
    weightPlateauCause1Title: '۱. کاهش متابولیسم پایه (Adaptive Thermogenesis)',
    weightPlateauCause1Desc: 'در رژیم‌های طولانی کم‌کالری، بدن برای محافظت از انرژی، میزان سوخت‌وساز پایه (RMR) را کاهش می‌دهد. راهکار: ۱ تا ۲ روز مصرف کالری در حد تثبیت (Refeed Day) با کربوهیدرات‌های پیچیده برای بازسازی هورمون لپتین و تیروئید.',
    weightPlateauCause2Title: '۲. کالری‌های پنهان و خطای اندازه‌گیری حجم غذا',
    weightPlateauCause2Desc: 'روغن‌های پخت‌وپز، سس‌ها، آجیل و نوشیدنی‌ها بدون ثبت دقیق می‌توانند ۲۰۰ تا ۴۰۰ کالری اضافه وارد بدن کنند. راهکار: تمام غذاها و روغن مصرفی را به مدت ۳ روز با ترازو دیجیتال آشپزخانه وزن کنید.',
    weightPlateauCause3Title: '۳. احتباس آب، سدیم و کورتیزول (استرس و کم‌خوابی)',
    weightPlateauCause3Desc: 'استرس، خواب کمتر از ۷ ساعت یا مصرف سدیم زیاد، هورمون کورتیزول را بالا برده و تا ۲ کیلوگرم آب در بدن نگه می‌دارد و چربی‌سوزی واقعی را روی ترازو پنهان می‌کند. راهکار: خواب شبانه کامل و مصرف ۲.۵ لیتر آب روزانه.',
    weightPlateauCause4Title: '۴. عضله‌سازی همزمان با چربی‌سوزی (Body Recomposition)',
    weightPlateauCause4Desc: 'با انجام منظم تمرینات فیزیوتراپی و چربی‌سوزی، توده عضلانی افزایش می‌یابد. ترازو ثابت می‌ماند اما سایز دور شکم کاهش می‌یابد! راهکار: به جای ترازو، سایز دور کمر را متر بزنید.',
    weightPlateauCause5Title: '۵. کاهش ناخودآگاه تحرک غیرورزشی روزانه (NEAT)',
    weightPlateauCause5Desc: 'در کمبود کالری، بدن بدون اینکه متوجه شوید تکان خوردن، ایستادن و قدم زدن خود را کم می‌کند. راهکار: پیاده‌روی روزانه را به ۷,۰۰۰ تا ۱۰,۰۰۰ گام برسانید.',
    weightPlateauCause6Title: '۶. التهاب دیسک کمر و پاسخ ایمنی ستون فقرات',
    weightPlateauCause6Desc: 'دردهای مزمن کمر باعث ایجاد پاسخ التهابی و ماندگاری مایعات میان‌بافتی می‌شوند. راهکار: ادامه تمرینات کششی آب‌رسانی به دیسک و دمنوش‌های ضدالتهاب.',
    brandingAboutP1: 'نام پیشین برنامه (Växa / وکسا) کلمه‌ای سوئدی به معنی رشد تدریجی بود. بنابر بازخوردهای ارزشمند کاربران و در جهت بومی‌سازی ملموس‌تر، نام رسمی برنامه به «پیشرفت» تغییر یافت.',
    brandingAboutP2: 'برنامه پیشرفت یک همیار خودمراقبتی و هوشمند با ذخیره‌سازی ابری ایمن است که مأموریت آن بهبود دیسک کمر، کاهش چربی شکم، پایش تغذیه آسان، یادگیری روزانه سوئدی و ارائه گزارش‌های بهینه شده با هوش مصنوعی جمینی در یک محیط کاملا خصوصی و همگام است.',
    brandingAboutTitle: 'درباره نام تجاری جدید «پیشرفت»',
    brandingAccentSub: 'با انتخاب هر کدام از پالت‌های زیر، تمام دکمه‌ها، نمودارها، نوارهای پیشرفت و آیکون‌های برنامه به صورت زنده به آن رنگ آراسته خواهند شد.',
    brandingAccentTitle: 'انتخاب پالت رنگ اصلی (Accent Color)',
    brandingHeaderSub: 'رنگ شاخص و فضای بصری میز کار خود را متناسب با سلیقه و انگیزه روزانه خود شخصی‌سازی کنید.',
    brandingMockBackExercise: 'تمرین کمر (سگ پرنده)',
    brandingMockCompleted: '۷۲٪ کامل شده',
    brandingMockHabitProgress: 'میزان پیشرفت روزانه عادت‌ها',
    brandingMockHeader: 'پیش‌نمایش داشبورد',
    brandingMockRehabBtn: 'انجام فیزیوتراپی',
    brandingMockSaveBtn: 'ذخیره تغییرات',
    brandingMockTwoSets: '۲ ست کامل',
    brandingPresetAmberDesc: 'پویا، گرم و ایجاد انگیزه فراوان برای تمرینات کاردیو.',
    brandingPresetAmberName: 'نارنجی طلایی و انرژی',
    brandingPresetEmeraldDesc: 'طبیعی، تداعی‌کننده احیا، سلامتی و توانبخشی فعال.',
    brandingPresetEmeraldName: 'سبز تندرستی و بهبود',
    brandingPresetIndigoDesc: 'آرام، متعادل و عالی برای تمرکز و پایداری بر عادت‌ها.',
    brandingPresetIndigoName: 'آبی آرامش (پیش‌فرض)',
    brandingPresetRoseDesc: 'مدرن، با نشاط و الهام‌بخش روتین‌های روزانه خودمراقبتی.',
    brandingPresetRoseName: 'صورتی مدرن و شادابی',
    brandingPresetSkyDesc: 'سبک، آرامش‌بخش و نماد ذهنی باز و بدون دغدغه.',
    brandingPresetSkyName: 'آسمان روشن و زلال',
    brandingPresetVioletDesc: 'عمیق، الهام‌بخش برای مطالعه مستمر زبان سوئدی و تمرکز.',
    brandingPresetVioletName: 'بنفش عمیق و خلاقیت',
    brandingPreviewSub: 'تغییرات رابط کاربری را به صورت آنی در این ماکاپ زنده مشاهده کنید:',
    brandingPreviewTitle: 'پیش‌نمایش زنده پوسته',
    brandingSuccessMessage: 'تغییرات با موفقیت بر کل سیستم اعمال شد',
    dictionaryCatAll: 'همه متغیرها',
    dictionaryCatCommon: 'عمومی و دکمه‌ها',
    dictionaryCatFinance: 'مدیریت مالی (Finance)',
    dictionaryCatHealth: 'سلامت و پزشک',
    dictionaryCatNav: 'ناوبری و منوها',
    dictionaryCatNews: 'اخبار و AI',
    dictionaryCatReminders: 'یادآورها',
    dictionaryCatSettings: 'تنظیمات',
    dictionaryCatShopping: 'لیست خرید',
    dictionaryCopyTooltip: 'کپی دستور t(\'key\')',
    dictionaryDesc: 'تعریف متمرکز تمام متون، عناوین و کلیدهای برنامه‌نویسی به ۳ زبان فارسی (fa)، انگلیسی (en) و سوئدی (sv) با همگام‌سازی زنده',
    dictionaryFilteredResults: 'تعداد نتایج فیلتر شده:',
    dictionaryItemsUnit: 'عنوان',
    dictionaryKeysUnit: 'کلید',
    dictionarySearchPlaceholder: 'جستجو در نام کلید، متن فارسی، انگلیسی یا سوئدی...',
    dictionaryThActions: 'عملیات',
    dictionaryThEn: '🇬🇧 انگلیسی (en)',
    dictionaryThFa: '🇮🇷 فارسی (fa)',
    dictionaryThKey: 'نام کلید متغیر (Key Name)',
    dictionaryThSv: '🇸🇪 سوئدی (sv)',
    dictionaryTotalKeys: 'کل متغیرهای تعریف شده در دیکشنری:',
    reminderGeneralSettingsTitle: 'تنظیمات عمومی و ساعت یادآورها',
    reminderHeaderSub: 'مدیریت یادآورهای روزانه، قرار ملاقات‌های پزشکی، زمان‌بندی قبوض، تولدها و همگام‌سازی تقویم گوگل',
    notesMood_Calm: '😌 آرامش',
    notesMood_Energetic: '⚡ پرانرژی',
    notesMood_SoreTense: '😣 کوفته/گرفتگی',
    notesMood_Tired: '🥱 خسته',
    notesMood_Anxious: '😰 مضطرب',
    reportsActiveMinutes: 'کل دقایق فعالیت بدنی:',
    reportsAiExportSub: 'با قرار دادن این متن در چت، مربی هوشمند تحلیلی ارگونومیک ارائه خواهد کرد.',
    reportsAiExportTitle: 'کد خروجی ساختاریافته برای چت هوش مصنوعی (ChatGPT / Gemini / Claude)',
    reportsAvgEnergyLabel: 'میانگین سطح انرژی بدنی:',
    reportsAvgPainLabel: 'میانگین شدت درد کمر:',
    reportsAvgSleepLabel: 'میانگین خواب:',
    reportsAvgWaterLabel: 'وضعیت هیدراتاسیون آب:',
    reportsCaloriesBurned: 'کالری سوزانده‌شده ورزشی:',
    reportsChart1LegendBar: 'تعداد تمرین فیزیوتراپی',
    reportsChart1LegendLine: 'میزان درد (0-10)',
    reportsChart1Sub: 'مقایسه تعداد تمرینات فیزیوتراپی انجام‌شده (ستون‌های سبز) با شدت درد کمر ثبت‌شده (خط نارنجی).',
    reportsChart1Title: 'رابطه تمرینات فیزیوتراپی و کاهش درد کمر (Spine Rehab vs Pain Correlation)',
    reportsChart1TtBar: 'تمرینات کمر',
    reportsChart1TtLine: 'شدت درد ستون فقرات',
    reportsChart2Target: 'سقف target: {{target}} kcal',
    reportsChart2Title: 'کالری دریافتی و پروتئین روزانه',
    reportsChart2TtCal: 'کالری مصرفی',
    reportsChart2TtProt: 'پروتئین دریافتی',
    reportsChart3Target: 'هدف آب: {{target}} ml',
    reportsChart3Title: 'هیدراتاسیون آب (ml) و ساعات خواب',
    reportsChart3TtSleep: 'ساعات خواب',
    reportsChart3TtWater: 'مصرف آب',
    reportsChart4Goal: 'هدف: {{goal}}',
    reportsChart4GoalLabel: 'وزن هدف',
    reportsChart4Title: 'روند تغییرات وزن و هدف (Weight Trajectory)',
    reportsChart4TtWeight: 'وزن ثبت‌شده',
    reportsChart5Sub: 'میانگین پروتئین، کربوهیدرات و چربی روزانه',
    reportsChart5Title: 'نسبت درشتمغذی‌ها (Macros)',
    reportsChartDatePrefix: 'تاریخ:',
    reportsCopied: 'کپی شد!',
    reportsCopyBtn: 'کپی کل متن خروجی',
    reportsDailyWaterGoal: 'هدف روزانه: {{target}} ml',
    reportsDownloadCsvBtn: 'دانلود خروجی CSV (مناسب پزشک و اکسل)',
    reportsDownloadDesc: 'می‌توانید گزارش کامل داده‌های خود را به صورت CSV برای استفاده در نرم‌افزارهایی مثل اکسل یا گزارش‌های پزشکی و فایل JSON کامل دانلود کنید.',
    reportsDownloadJsonBtn: 'دانلود پشتیبان کامل JSON',
    reportsDownloadTitle: 'دانلود و پشتیبان‌گیری از تمام داده‌ها',
    reportsEnergyPainSummaryTitle: 'سطح انرژی و کنترل درد',
    reportsFatLossSub: 'میزان اجرای تمرینات هوازی و کالری‌سوز',
    reportsFatLossTitle: 'تمرینات چربی‌سوزی کاردیو و آب‌کردن شکم',
    reportsFoodNotFound: 'هیچ ماده غذایی در این بازه یا با این عبارت جستجو یافت نشد.',
    reportsFoodSearchPlaceholder: 'جستجوی غذا یا وعده...',
    reportsHoursUnit: 'ساعت',
    reportsKpiCalories: 'میانگین کالری',
    reportsKpiCaloriesSub: 'هدف: {{target}}',
    reportsKpiPain: 'شاخص درد کمر',
    reportsKpiPainSub: 'میانگین شدت درد ستون فقرات',
    reportsKpiRehab: 'فیزیوتراپی کمر',
    reportsKpiRehabSub: 'تعداد کل حرکات کامل',
    reportsKpiRehabUnit: 'تمرین',
    reportsKpiScore: 'امتیاز پایداری',
    reportsKpiScoreSub: 'میانگین دوره انتخاب‌شده',
    reportsKpiSleep: 'میانگین خواب',
    reportsKpiSleepSub: 'هدف: ۷ تا ۸ ساعت روزانه',
    reportsKpiSleepUnit: 'ساعت',
    reportsKpiWater: 'آب مصرفی روزانه',
    reportsKpiWaterSub: 'هدف: {{target}} ml',
    reportsMacroCarbs: 'کربوهیدرات (گرم)',
    reportsMacroFat: 'چربی مفید (گرم)',
    reportsMacroProtein: 'پروتئین (گرم)',
    reportsMealBreakfast: 'صبحانه',
    reportsMealDinner: 'شام',
    reportsMealLunch: 'ناهار',
    reportsMealSnack: 'میان‌وعده',
    reportsMinUnit: 'دقیقه',
    reportsMoodCalm: 'آرام',
    reportsNoPain: '۰ (بدون درد)',
    reportsNutritionCount: 'تعداد کل غذاهای ثبت‌شده در این بازه: {{count}} مورد',
    reportsNutritionTitle: 'لیست جامع مواد غذایی و درشتمغذی‌های ثبت‌شده',
    reportsOf10Unit: 'از ۱۰',
    reportsOf5Unit: 'از ۵',
    reportsPainOf10: 'از ۱۰',
    reportsPrintBtn: 'چاپ / PDF',
    reportsPrintTooltip: 'چاپ یا ذخیره PDF',
    reportsRange30d: '۳۰ روز اخیر',
    reportsRange7d: '۷ روز اخیر',
    reportsRange90d: '۹۰ روز',
    reportsRangeAll: 'کل تاریخچه',
    reportsRehabDrillsSub: 'میزان تکرار هر حرکت فیزیوتراپی در بازه انتخابی',
    reportsRehabDrillsTitle: 'تکمیل تمرینات فیزیوتراپی و التیام دیسک کمر',
    reportsShiftWorkTag: 'شیفت کاری',
    reportsShiftsUnit: 'شیفت',
    reportsSleepDiscRole: 'نقش در ترمیم دیسک کمر:',
    reportsSleepDiscRoleVal: 'بسیار بالا (عامل کلیدی)',
    reportsSleepGoalLabel: 'هدف استاندارد خواب:',
    reportsSleepGoalVal: '۷ تا ۸ ساعت',
    reportsSleepGood: 'خوب و مناسب',
    reportsSleepIdeal: 'عالی و ایده‌آل',
    reportsSleepLow: 'کمتر از استاندارد',
    reportsSleepNotRecorded: 'ثبت‌نشده',
    reportsSleepSummaryTitle: 'خلاصه خواب و ریکاوری شبانه',
    reportsTabAiExport: 'خروجی هوش مصنوعی و فایل',
    reportsTabCharts: 'داشبورد نمودارهای تعاملی',
    reportsTabNutrition: 'گزارش کامل تغذیه و غذاها',
    reportsTabRehab: 'گزارش فیزیوتراپی و حرکات',
    reportsTabSleepWork: 'خواب و شیفت کاری',
    reportsTable1Sub: 'گزارش تک‌تک روزهای ثبت‌شده با میزان ساعات استراحت، سطح انرژی و وضعیت درد کمر',
    reportsTable1Title: 'جدول روزانه پایش خواب و ریکاوری شبانه (Daily Sleep & Recovery Log)',
    reportsTable2Sub: 'ثبت دقیق هیدراتاسیون روزانه به میلی‌لیتر و درصد دستیابی به هدف',
    reportsTable2Title: 'جدول روزانه آب مصرفی (Daily Water Consumption Log)',
    reportsTargetLabel: 'هدف',
    reportsThCalories: 'کالری (kcal)',
    reportsThCarbs: 'کربوهیدرات (g)',
    reportsThDate: 'تاریخ',
    reportsThEnergy15: 'سطح انرژی (۱-۵)',
    reportsThFat: 'چربی (g)',
    reportsThFoodName: 'نام ماده غذایی',
    reportsThGoalMl: 'هدف (ml)',
    reportsThHydrationStatus: 'وضعیت هیدراتاسیون',
    reportsThMeal: 'وعده',
    reportsThMood: 'حس و حال (Mood)',
    reportsThNotes: 'یادداشت و علائم',
    reportsThPain010: 'درد کمر (۰-۱۰)',
    reportsThProgressPercent: 'درصد پیشرفت',
    reportsThProtein: 'پروتئین (g)',
    reportsThQty: 'مقدار',
    reportsThRestEval: 'ارزیابی استراحت',
    reportsThShift: 'شیفت کاری',
    reportsThSleepHours: 'میزان خواب (ساعت)',
    reportsThWaterMl: 'میزان آب (ml)',
    reportsTimesCount: '{{count}} بار ({{percent}}٪)',
    reportsTotalDaysCount: 'مجموع روزها: {{count}} روز',
    reportsUndefined: 'تعریف نشده',
    reportsUnitDrills: 'حرکت فیزیوتراپی',
    reportsUnitOf10: 'از ۱۰',
    reportsWaterFull: '💧 هیدراته کامل (عالی)',
    reportsWaterGood: 'مناسب و مطلوب',
    reportsWaterLow: 'کمتر از حد مجاز',
    reportsWaterNeedMore: 'نیازمند افزایش نوشیدن',
    reportsWorkDaysCount: 'تعداد شیفت کاری ثبت‌شده:',
    reportsWorkSummaryTitle: 'شیفت‌های کاری و فعالیت‌ها',
    salaryMisclassifiedDesc: 'این تراکنش‌ها عنوان «حقوق/Lön/واریزی» دارند اما به عنوان هزینه ثبت شده‌اند. با یک کلیک نوع آنها به درآمد (+) اصلاح می‌شود.',
    salaryMisclassifiedTitle: 'تشخیص {{count}} تراکنش حقوق/واریزی (Lön)',
    save: 'ذخیره',
    saveBtn: 'ذخیره',
    saveBudgetFormulaBtn: 'ذخیره فرمول و سقف بودجه‌بندی',
    saveChanges: 'ذخیره تغییرات',
    saveTransaction: 'ذخیره تراکنش',
    saveTransactionBtn: 'ذخیره تراکنش',
    savedSuccessfully: 'با موفقیت ذخیره شد ✅',
    savingAndGoalsShare: 'سهم پس‌انداز و هدف‌گذاری ({{ratio}}%):',
    savingsAndTargetShare: 'سهم پس‌انداز و هدف‌گذاری ({{ratio}}%):',
    savingsGoalsAndPlanning: 'اهداف پس‌انداز و برنامه‌ریزی مالی',
    scanReceipt: 'اسکن رسید با هوش مصنوعی',
    scannerSamplePlaceholder: 'Willys\\n2x MJÖLK 1.5L - 37 SEK\\n1x BRÖD - 28 SEK\\nTotalt: 65 SEK\\nBetalt med Swish',
    schedules: 'برنامه‌ریزی هفتگی',
    schedulesHeaderDesc: 'فعالیت‌های شخصی، کاری، آموزشی و روتین‌های خود را برای هر روز برنامه‌ریزی و مدیریت کنید.',
    schedulesHeaderTitle: 'برنامه‌ریزی هفتگی و روال روزانه',
    schedulesSearchPlaceholder: 'جستجو در نام یا توضیحات روتین...',
    schedulesPresetTemplates: 'الگوی آماده فعالیت (پرکردن سریع):',
    schedulesPresetWork: 'شیفت کاری (۸ ساعت)',
    schedulesPresetRehab: 'فیزیوتراپی ستون فقرات (۳۰ دقیقه)',
    schedulesPresetEducation: 'جلسه آموزشی / مطالعه (۲ ساعت)',
    schedulesPresetCardio: 'کاردیو و پیاده‌روی (۴۵ دقیقه)',
    schedulesPresetNutrition: 'تغذیه و سلامت (۳۰ دقیقه)',
    schedulesPresetWorkTitle: 'شیفت کاری روزانه',
    schedulesPresetWorkDesc: 'تمرکز کاری همراه با استراحت‌های کوتاه‌مدت ۵ دقیقه‌ای برای کشش کمر.',
    schedulesPresetRehabTitle: 'تمرینات فیزیوتراپی و اصلاحی کمر',
    schedulesPresetRehabDesc: 'تمرینات کششی دیسک کمر، فیزیوتراپی ناشتا و ثبات‌دهی ستون فقرات.',
    schedulesPresetEduTitle: 'جلسه آموزشی / مطالعه (زبان سوئدی / دوره)',
    schedulesPresetEduDesc: 'کلاس سوئدی، دوره‌های تخصصی، تمرین برنامه‌نویسی یا یادگیری مهارت جدید.',
    schedulesPresetCardioTitle: 'تمرین کاردیو و پیاده‌روی چربی‌سوزی',
    schedulesPresetCardioDesc: 'پیاده‌روی تند، کاردیو کم‌برخورد، کنترل چربی شکمی و کالری‌سوزی.',
    schedulesPresetNutritionTitle: 'صرف وعده اصلی و تنظیم برنامه‌ غذایی',
    schedulesPresetNutritionDesc: 'مصرف پروتئین کافی، مکمل‌ها و هیدرئیشن منظم روزانه.',
    schedulesTotalWeeklyTasks: 'کل فعالیت‌های هفته',
    schedulesTotalScheduledHours: 'ساعات زمان‌بندی‌شده',
    schedulesTodayCompletion: 'تکمیل امروز',
    schedulesNoFilteredRoutines: 'هیچ فعالیتی با فیلتر انتخابی شما یافت نشد.',
    schedulesGoogleCalDirectTitle: 'ثبت مستقیم در تقویم گوگل (وب)',
    schedulesAddToGoogleCalDirect: 'ثبت در Google Cal',
    schedTaskCountUnit: 'کار',
    schoolCategory: '🎓 مدرسه و آموزش',
    search: 'جستجو...',
    seasonalMealPlan: 'برنامه غذایی فصلی (GLP-1)',
    seasonalRecipes: 'دستور پخت‌های فصلی',
    selectAll: 'انتخاب همه',
    selectLanguage: 'انتخاب زبان / Select Language / Välj språk',
    selectMonthForBudgetAnalysis: 'انتخاب ماه جهت تحلیل بودجه:',
    selectedMonthLabel: 'انتخاب‌شده',
    selectedRowsCount: 'تعداد {{count}} ردیف انتخاب‌شده',
    settings: 'تنظیمات و همگام‌سازی',
    settingsHeaderDesc: 'مدیریت پروفایل، اتصال به پایگاه‌داده ابری Cloudflare D1، تنظیمات ایمیل و کلیدهای هوش مصنوعی',
    settingsHeaderTitle: 'تنظیمات سیستم، پشتیبان‌گیری و همگام‌سازی ابری D1',
    settingsSaveSuccess: '✓ تنظیمات با موفقیت ذخیره شد',
    shareEmailLabel: 'ایمیل عضو خانواده یا همکار',
    shareEmailPlaceholder: 'مثال: family@example.com',
    shareError: 'خطا در ثبت ایمیل اشتراک‌گذاری.',
    shareListBtn: 'اشتراک‌گذاری لیست',
    shareModalTitle: 'مدیریت دسترسی و اشتراک‌گذاری لیست خرید',
    shareSuccess: 'دسترس با موفقیت اعطا شد.',
    shiftTypeLabel: 'نوع شیفت / فعالیت',
    shopAddItemBtn: 'افزودن',
    shopAddNewItemTo: 'افزودن کالا به {{name}}',
    shopAddNewList: 'افزودن دفترچه جدید',
    shopAddToListNamed: 'افزودن به {{name}}',
    shopAdjustQtyModalTitle: 'تنظیم مقدار و وزن کالا',
    shopAllItemsCount: 'همه موارد ({{count}})',
    shopAllLists: 'همه دفترچه‌ها ({{count}})',
    shopAllPresets: 'همه ({{count}})',
    shopBoughtItems: '{{count}} خریداری‌شده',
    shopCancel: 'انصراف',
    shopCatDairy: 'لبنیات و پروتئین',
    shopCatGrocery: 'خواربار و سوپرمارکت',
    shopCatHousehold: 'لوازم خانه و بهداشتی',
    shopCatMeat: 'گوشت و مرغ',
    shopCatOther: 'متفرقه',
    shopCatProduce: 'میوه و سبزیجات',
    shopClearAll: 'حذف همه',
    shopClearBought: 'پاک‌سازی خریده‌شده‌ها',
    shopClickToAdjust: 'برای تنظیم مقدار و افزودن کلیک کنید',
    shopCloseModal: 'بستن',
    shopCollaboratorAccess: 'دسترسی همکار',
    shopCollaboratorTooltip: 'تنها مالک لیست اجازه تغییر نام، حذف یا اشتراک‌گذاری دارد',
    shopConfirmClearAll: 'آیا مطمئن هستید می‌خواهید کل این لیست را پاک کنید؟',
    shopConfirmClearBought: 'آیا مطمئن هستید می‌خواهید تمام اقلام خریده‌شده را پاک کنید؟',
    shopConfirmDeleteList: 'آیا از حذف لیست «{{name}}» اطمینان دارید؟ تمامی کالاهای آن به طور کامل پاک خواهند شد.',
    shopAiTranslateList: 'ترجمه موقت برای خرید (AI)',
    shopAiTranslateListTooltip: 'نمایش ترجمه موقت اقلام به سوئدی یا انگلیسی بدون تغییر داده‌های اصلی در پایگاه داده',
    shopTranslateModalTitle: 'ترجمه موقت اقلام خرید (بدون تغییر دیتابیس)',
    shopTranslateModalDesc: 'زبان مورد نظر برای مشاهده ترجمه اقلام در فروشگاه را انتخاب کنید. این ترجمه فقط برای نمایش بوده و عناوین اصلی ذخیره‌شده در پایگاه داده هرگز تغییر نخواهند کرد:',
    shopTranslateTargetSv: '🇸🇪 سوئدی (Svenska) - مناسب خرید در ICA, Willys, Coop',
    shopTranslateTargetEn: '🇬🇧 انگلیسی (English) - اصطلاحات بین‌المللی خواربار',
    shopTranslateTargetFa: '🇮🇷 فارسی (Persian) - زبان فارسی',
    shopTranslatingWait: 'در حال دریافت ترجمه اقلام با هوش مصنوعی... لطفاً چند لحظه صبر کنید',
    shopTranslateSuccess: 'ترجمه موقت به زبان {{lang}} فعال شد! عناوین اصلی در دیتابیس بدون تغییر حفظ شدند.',
    shopActiveTranslationNotice: 'در حال نمایش ترجمه موقت به زبان {{lang}} (عناوین اصلی در دیتابیس محفوظ هستند)',
    shopTranslateNoDbHint: 'داده‌های اصلی پایگاه داده بدون تغییر باقی مانده و تنها برچسب‌های موقت خرید نمایش داده می‌شوند.',
    shopChangeTranslateLang: 'تغییر زبان',
    shopHideTranslation: 'پایان ترجمه موقت',
    shopOriginalLabel: 'عنوان اصلی',
    shopTranslatedLabel: 'ترجمه خرید',
    shopCopyTranslation: 'کپی ترجمه‌ها',
    shopCopied: 'کپی شد!',
    shopTranslationsOverview: 'فهرست مقایسه‌ای اقلام و ترجمه فروشگاه',
    shopViewOnList: 'مشاهده روی لیست خرید',
    shopNoItemsToTranslate: 'آیتمی برای ترجمه در این لیست وجود ندارد.',
    shopTranslateFailed: 'پاسخ هوش مصنوعی قابل پردازش نبود. لطفاً مجدداً امتحان کنید.',
    shopCreateFirstBtn: 'ساخت دفترچه خرید جدید',
    shopCreateListSubmit: 'ایجاد دفترچه',
    shopCreatedBy: '🏠 ایجادکننده: {{name}}',
    shopCreating: 'در حال ایجاد...',
    shopCustomQtyPh: 'مثلا: ۱.۵ کیلو یا ۴ بطری',
    shopDateUnset: 'تعیین نشده',
    shopDecrease: 'کاهش',
    shopDeleteItem: 'حذف',
    shopDeleteList: 'حذف دفترچه',
    shopEditItem: 'ویرایش',
    shopEditTitleDate: 'ویرایش عنوان و تاریخ خرید',
    shopEmptyListHint: 'این دفترچه خالی است! اقلام مورد نیاز را در کادر بالا یا انتخاب سریع وارد کنید.',
    shopEnterSharedList: 'ورود به دفترچه مشترک',
    shopIncrease: 'افزایش',
    shopItemNamePh: 'نام کالا (مثلا: مرغ، کیوی، برنج...)',
    shopItemQtyPh: 'مقدار/وزن (مثلا: ۲ کیلو، ۱ بسته)',
    shopListDateLabel: 'تاریخ خرید / برنامه‌ریزی:',
    shopListNameLabel: 'عنوان دفترچه:',
    shopListNamePh: 'مثلا: خرید کباب جمعه، داروخانه، سوپرمارکت...',
    shopManageShare: 'مدیریت اشتراک',
    shopMarkBought: 'علامت زدن به عنوان خریداری‌شده',
    shopMarkUnbought: 'بازگرداندن به لیست خرید',
    shopMyLists: 'لیست‌های من',
    shopNeededItems: 'اقلام مورد نیاز برای خرید ({{count}})',
    shopNewListBtn: 'دفترچه خرید جدید',
    shopNewListModalSubtitle: 'ایجاد دفترچه خرید شخصی یا خانوادگی',
    shopNewListModalTitle: 'دفترچه خرید جدید',
    shopNewListTitleLabel: 'عنوان جدید دفترچه:',
    shopNoListsDesc: 'روی دکمه «ایجاد اولین لیست خرید» در بالا کلیک کنید',
    shopNoListsYet: 'هنوز هیچ لیست خریدی ایجاد نکرده‌اید',
    shopNoSharedDesc: 'می‌توانید از همسر، اعضای خانواده یا هم‌خانه‌ای خود بخواهید با وارد کردن ایمیل شما در دکمه اشتراک‌گذاری، دفترچه خرید خود را با شما مشترک کنند.',
    shopNoSharedLists: 'هنوز دفترچه‌ای با شما به اشتراک گذاشته نشده است',
    shopOpenList: 'باز کردن دفترچه',
    shopOrCustomQty: 'یا نوشتن مقدار دلخواه:',
    shopOwnerYou: '👑 مالک شما هستید',
    shopPersonalOnly: 'شخصی',
    shopPurchaseDateLabel: 'تاریخ خرید / انجام:',
    shopPurchasedSection: 'اقلام خریداری‌شده ({{count}})',
    shopQuickQtyPick: 'انتخاب سریع مقدار یا کیلو:',
    shopQuickSelectAdjust: 'انتخاب سریع و تنظیم وزن/تعداد:',
    shopQuickThemeCreate: 'ساخت سریع دفترچه موضوعی:',
    shopQuickTitleSuggestions: 'پیشنهاد سریع عنوان:',
    shopRemainingItems: '{{count}} باقیمانده',
    shopRenameList: 'تغییر نام دفترچه',
    shopRenameModalSubtitle: 'تغییر نام لیست «{{name}}»',
    shopRenameModalTitle: 'تغییر نام دفترچه',
    shopRevokeShare: 'لغو اشتراک',
    shopSave: 'ذخیره',
    shopSaveRenameBtn: 'ذخیره تغییرات',
    shopSendShareBtn: 'ارسال اشتراک',
    shopShareBtn: 'اشتراک‌گذاری',
    shopShareRevokedSuccess: 'اشتراک با {{email}} لغو شد.',
    shopShareTooltip: 'اشتراک‌گذاری دفترچه با همسر یا هم‌خانه‌ای',
    shopSharedListFrom: '🏡 دفترچه مشترک ({{name}})',
    shopSharedWith: 'اشتراک با: {{emails}}',
    shopSharedWithCount: 'مشترک با {{count}} نفر',
    shopSharedWithMe: 'به‌اشتراک‌گذاری‌شده با من',
    shopTodayDateFmt: 'امروز ({{date}})',
    shopYouAreOwner: '👑 شما مالک این لیست هستید',
    shopping: 'لیست خرید هوشمند',
    shoppingCatReminder: '🛒 امور خرید',
    shoppingCategories: 'دسته‌بندی‌های خرید',
    shoppingHeaderDesc: 'ایجاد لیست‌های اختصاصی، اشتراک‌گذاری با اعضای خانواده، زمان‌بندی تاریخ خرید و دریافت پیشنهادهای AI',
    shoppingHeaderDescActive: 'اقلام مورد نیاز را اضافه یا خریداری‌شده‌ها را علامت بزنید. تمام تغییرات به صورت زنده برای همسر یا اعضای خانواده بروزرسانی می‌شود.',
    shoppingHeaderDescOverview: 'لیست‌های خرید خانه، کباب و سوپرمارکت را ایجاد کرده و با وارد کردن ایمیل همسر یا هم‌خانه‌ای، آن‌ها را به دفترچه مشترک تبدیل کنید.',
    shoppingHeaderTitle: 'مدیریت لیست خرید و دفترچه‌های هوشمند',
    shoppingTitle: 'دفترچه خرید مشترک خانوادگی',
    showAllCards: 'نمایش همه کارت‌ها',
    signIn: 'ورود',
    smartPromptSuggestions: 'پیشنهادات هوشمند جهت پرسش سریع از مشاور مالی:',
    smtpTitle: 'تنظیمات سرور ایمیل (SMTP)',
    sortNewestFirst: 'ترتیب: جدیدترین به قدیمی‌ترین ⬇️',
    spentAmountLabel: 'هزینه‌شده: {{amount}} {{currency}}',
    spentAmountShort: 'مصرفی: {{amount}} {{currency}}',
    spentLabel: 'هزینه‌شده:',
    startDoctorConsultation: 'شروع مشاوره با پزشک AI',
    startExercise: 'شروع تمرین',
    statBudgetBalance: 'مانده بودجه هزینه',
    statBudgetCap: 'سقف بودجه ماهانه: {{amount}} {{currency}}',
    statExpenseSubtitle: 'خریدها، فاکتورها و پرداخت‌ها',
    statIncomeSubtitle: 'مجموع دریافتی‌ها و حقوق',
    statSwishSubtitle: 'تراکنش‌های سوئیش آنلاین',
    statSwishTotal: 'پرداخت با Swish',
    statTotalExpense: 'هزینه‌ها و فاکتورها',
    statTotalIncome: 'درآمد کل ثبت‌شده',
    status: 'وضعیت',
    statusNew: 'جدید',
    storePlaceholder: 'مثال: ICA Supermarket Stockholm',
    success: 'موفقیت',
    surplusAmountAlert: '{{amount}} {{currency}} مازاد!',
    surplusExceeded: 'مازاد!',
    surplusLabel: 'مازاد:',
    surplusShort: 'مازاد: {{amount}} {{currency}}',
    swedish: 'یادگیری زبان سوئدی',
    swedishHeaderDesc: 'تمرین روزانه واژگان سوئدی، کوییز هوشمند، مکالمات کاری و آماده‌سازی آزمون Yrkessvenska',
    swedishHeaderTitle: 'آموزش زبان سوئدی، SFI و لغات کاربردی',
    swedishLang: 'Svenska (سوئدی)',
    swedishLearning: 'تمرین زبان سوئدی / SFI',
    swedishSfiTitle: 'آموزش زبان سوئدی (SFI & Yrkes)',
    symptomAnalyzer: 'تحلیل‌گر هوشمند علائم',
    syncCloud: 'همگام‌سازی ابری',
    synced: 'همگام‌شده با ابر',
    targetCalories: 'کالری هدف روزانه (کیلوکالری)',
    targetCardForBatch: 'کارت / حساب هدف برای تمام تراکنش‌های این صورت‌حساب:',
    targetWater: 'آب هدف روزانه (میلی‌لیتر)',
    targetWeightLabel: 'وزن هدف (کیلوگرم)',
    title: 'عنوان',
    todaySummary: 'خلاصه وضعیت امروز',
    todayUpcomingTab: 'امروز و سررسیدهای پیش‌رو',
    todosList: 'برنامه‌ها و وظایف روزانه',
    total: 'مجموع',
    totalAllocatedBudget: 'مجموع بودجه تخصیص‌یافته:',
    totalBudgetCapLabel: 'سقف بودجه کل:',
    totalExpenditure: 'مجموع هزینه‌کرد: {{amount}} {{currency}}',
    totalExpenseCap: 'سقف کل هزینه‌ها:',
    totalExpenseLabel: 'مجموع هزینه:',
    totalExpenses: 'مجموع کل هزینه‌ها',
    totalIncome: 'مجموع کل درآمدها',
    totalIncomeLabel: 'مجموع درآمد/ورودی:',
    totalItemsCount: 'مجموع {{count}} کالا',
    totalProductsCount: 'مجموع کالاها: {{count}} نوع کالا',
    totalProductsSummary: 'مجموع کالاها: {{count}} نوع کالا',
    totalSavingsNeeded: 'کل پس‌انداز مورد نیاز اهداف:',
    totalSavingsRequiredForGoals: 'کل پس‌انداز مورد نیاز اهداف:',
    transactionListTitle: 'فهرست تراکنش‌ها و فاکتورها ({{count}})',
    transactionsSuffix: 'تراکنش',
    transferMisclassifiedDesc: 'این تراکنش‌ها تسویه‌حساب کارت یا انتقال بین‌حسابی هستند اما به عنوان هزینه مصرفی ثبت شده‌اند. با یک کلیک نوع آنها به «انتقال/پس‌انداز» تغییر می‌یابد.',
    transferMisclassifiedTitle: 'تشخیص {{count}} تراکنش تسویه کارت اعتباری / انتقال بین‌حسابی',
    txCountInMonth: '({{count}} تراکنش)',
    typeDeleteToConfirm: 'جهت تایید نهایی کلمه DELETE را در کادر زیر تایپ کنید:',
    unallocatedBalanceLabel: '✓ مانده تخصیص‌نیافته (قابل توزیع یا ذخیره):',
    uncappedCategoriesDesc: 'دسته‌بندی‌های بدون سقف اختصاصی (صرفاً گزارش هزینه‌کرد):',
    uncappedCategoriesTitle: 'دسته‌بندی‌های بدون سقف بودجه',
    unitDays: 'روز قبل',
    unitHours: 'ساعت قبل',
    unitMinutes: 'دقیقه قبل',
    unitWeeks: 'هفته قبل',
    usedLabel: 'مصرفی:',
    userName: 'نام کاربر',
    usersAdmin: 'مدیریت و پایش کاربران',
    usersAdminHeaderDesc: 'مشاهده لیست کاربران فعال، سطح دسترسی‌ها و بررسی وضعیت همگام‌سازی دستگاه‌ها',
    usersAdminHeaderTitle: 'مدیریت کاربران و پایش سیستم (Admin Panel)',
    version: 'نسخه',
    versionHistory: 'تاریخچه تغییرات',
    viewGaugesAction: 'مشاهده و تحلیل این ماه',
    viewInTransactionsList: 'مشاهده در فهرست تراکنش‌ها →',
    viewInTxList: 'مشاهده در فهرست تراکنش‌ها →',
    viewingGaugesAction: 'در حال مشاهده گیج‌ها',
    visualGraphsTab: 'گراف‌ها و گزارش‌ها',
    vocabularyQuiz: 'تمرین واژگان و آزمون سریع',
    waterIntake: 'مصرف آب روزانه',
    waterTracker: 'میزان مصرف آب روزانه',
    weeklyMealPlanner: 'برنامه‌ریزی هفتگی وعده‌ها',
    weightAlertGoal: 'لطفاً وزن هدف را به کیلوگرم معتبر وارد نمایید',
    weightAlertHeight: 'لطفاً قد را به سانتی‌متر معتبر وارد کنید',
    weightAlertInvalid: 'لطفاً یک عدد معتبر برای وزن وارد نمایید',
    weightBmiHealthy: 'محدوده نرمال: ۱۸.۵ تا ۲۴.۹',
    weightBmiIndex: 'شاخص BMI: {{val}}',
    weightBmiLabel: 'شاخص توده بدنی',
    weightBmiNeedWeight: 'جهت محاسبه BMI قد و وزن را وارد کنید',
    weightBmiNormal: 'وزن نرمال و ایده‌آل',
    weightBmiNormalAdv: 'محدوده وزن طبیعی و ایده‌آل - عالی پیش می‌روید!',
    weightBmiObeseCat: 'محدوده چاقی - برنامه غذایی هدفمند و مشاوره پزشکی توصیه می‌گردد',
    weightBmiOverweight: 'محدوده اضافه وزن - کسری کالری ملایم و ورزش منظم پیشنهاد می‌شود',
    weightBmiPendingDesc: 'آخرین وزن خود را ثبت نمایید تا وضعیت شاخص توده بدنی محاسبه شود.',
    weightBmiTitle: 'شاخص توده بدنی (BMI)',
    weightBmiUnder: 'کمبود وزن',
    weightBmiUnderweight: 'محدوده کمبود وزن - مصرف غذاهای پرپروتئین و مغذی توصیه می‌شود',
    weightChartFilter30: '۳۰ روز',
    weightChartFilter7: '۷ روز',
    weightChartFilter90: '۹۰ روز',
    weightChartFilterAll: 'کل تاریخچه',
    weightChartNoDataDesc: 'با ثبت وزن در روزهای مختلف، نمودار پیشرفت ترسیم خواهد شد.',
    weightChartNoDataTitle: 'داده‌ای برای این بازه زمانی وجود ندارد',
    weightChartTitle: 'نمودار تغییرات وزن و پیشرفت',
    weightChartTooltipWeight: 'وزن: {{val}} کیلوگرم',
    weightConfirmDel: 'آیا از حذف این رکورد وزن اطمینان دارید؟',
    weightDirectInputBtn: 'ثبت وزن',
    weightDirectInputPh: 'وزن (مثلا: ۸۲.۴)',
    weightGoalChartLabel: 'هدف: {{goal}} کیلوگرم',
    weightHeaderDesc: 'ثبت روند تغییرات وزن، محاسبه هوشمند BMI و رسم نمودار پیشرفت',
    weightHeaderTitle: 'پایش وزن، درصد چربی و شاخص BMI',
    weightHistActions: 'عملیات',
    weightHistBmi: 'شاخص BMI',
    weightHistDelTooltip: 'حذف این رکورد',
    weightHistWeight: 'وزن',
    weightHistoryCount: '{{count}} رکورد ثبت شده',
    weightHistoryEmpty: 'هنوز رکوردی برای وزن ثبت نشده است',
    weightHistoryTitle: 'تاریخچه رکوردهای وزن',
    weightMinus01: '-۰.۱ کیلوگرم',
    weightMinus1: '-۱ کیلوگرم',
    weightPlus01: '+۰.۱ کیلوگرم',
    weightPlus1: '+۱ کیلوگرم',
    weightProfileGoal: 'وزن هدف (کیلوگرم)',
    weightProfileGoalPh: 'مثلا: ۷۵',
    weightProfileHeight: 'قد (سانتی‌متر)',
    weightProfileSaved: 'پروفایل با موفقیت بروزرسانی شد',
    weightProfileTitle: 'پروفایل وزن و تنظیمات هدف',
    weightProfileUpdateBtn: 'ذخیره تنظیمات پروفایل',
    weightQuickAddTitle: 'ثبت سریع وزن روزانه',
    weightTitle: 'پایش وزن و شاخص BMI',
    weightTracker: 'پایش وزن و شاخص BMI',
    weightTrendDownFull: 'روند وزن نزولی و در حال کاهش است (-{{diff}} کیلوگرم)',
    weightTrendOverallStatusFull: 'وضعیت کلی روند: {{status}}',
    weightTrendStableFull: 'وزن تثبیت شده است ({{diff}} کیلوگرم)',
    weightTrendUpFull: 'روند وزن صعودی است (+{{diff}} کیلوگرم)',
    weightUnitKg: 'کیلوگرم',
    welcomeBack: 'خوش آمدید',
    workCategory: '💼 امور کاری و اداری',
    you: 'شما',
    commonCopy: 'کپی',
    doctorAiAnalyzing: 'در حال تجزیه و تحلیل پرونده توسط هوش مصنوعی...',
    doctorCopied: 'رونوشت با موفقیت برداشته شد',
    doctorDeleteCons: 'حذف ویزیت',
    doctorLiveContextTitle: 'پرونده زنده بالینی',
    doctorLiveWater: 'آب مصرفی امروز',
    emailPlaceholder: 'نام یا ایمیل فرد مورد نظر...',
    fatCardDelete: 'حذف کارت',
    financeAdvisorPrompt: 'شما یک مشاور مالی هوشمند و تحلیل‌گر ارشد بودجه هستید.',
    financeAdvisorWelcome: 'سلام! من دستیار هوشمند مالی شما هستم. چطور می‌توانم در مدیریت بودجه یا تحلیل مخارج به شما کمک کنم؟',
    guide: 'راهنما',
    learningAddDocSm: 'پیوست سند',
    learningAddSubtopic: 'افزودن مبحث جدید',
    learningAiCustom: 'درخواست سفارشی',
    learningAiFallbackReply: 'پاسخ هوش مصنوعی بر اساس محتوای آموزشی جلسه تولید شد.',
    learningAiModalSubmit: 'تحلیل و ارسال با AI',
    learningAiNoteTitle: 'تحلیل و جزوه هوش مصنوعی',
    learningAiPromptFromPdf: 'لطفاً نکات کلیدی، تعاریف و سوالات امتحانی مهم از این فایل استخراج کن.',
    learningAiResponse: 'پاسخ هوش مصنوعی',
    learningAttFileNameLabel: 'نام فایل پیوست: {{name}}',
    learningAttLabel: 'پیوست',
    learningAttNotesFmt: '- فایل {{name}} (نوع: {{type}})',
    learningAttachDocsBtn: 'پیوست اسناد (PDF/Word/PPT/عکس)',
    learningAttachDocsSm: 'پیوست فایل (Word / PPT / PDF / عکس)',
    learningAttachedDocsHeader: 'فایل‌ها و اسناد پیوست شده به جلسه:',
    learningBtnDownload: 'دانلود',
    learningBtnOpenFile: 'مشاهده فایل',
    learningCancel: 'انصراف',
    learningCopyFullThread: 'کپی کامل متن این جلسه',
    learningDeleteModalDesc2: 'اطمینان دارید؟ این عملیات قابل بازگشت نیست.',
    learningDeleteModalTitle: 'حذف {{type}}',
    learningDeleteUserMsg: 'حذف این ورودی / مبحث',
    learningEditTopic: 'ویرایش موضوع',
    learningExtractedLabel: 'متن استخراج‌شده از این سند:',
    learningExtractedSummaryDoc: 'متن استخراج‌شده از این سند:',
    learningFileSizeLimit: 'حجم فایل «{{name}}» بیشتر از سقف مجاز (۳۰۰ مگابایت) است.',
    learningInteractiveSession: 'جلسه تعاملی و ثبت نکات',
    learningMainTopicDesc: 'توضیحات کلی موضوع',
    learningMainTopicLabel: 'موضوع اصلی: {{title}}',
    learningMainTopicsList: 'موضوعات اصلی ثبت‌شده',
    learningMsgHint: 'می‌توانید با استفاده از فرم پایین، سوال جدید بپرسید یا یادداشت جدید اضافه کنید.',
    learningMsgLabel: 'پیام / ورودی',
    learningNoSessionsYet: 'هنوز هیچ جلسه‌ای برای این موضوع ثبت نشده است.',
    learningNotesTopicsLabel: 'نکات/مباحث:',
    learningOverallDesc: 'توضیحات کلی:',
    learningPreviewDownload: 'دانلود نسخه اصلی',
    learningPreviewOpenTab: 'باز کردن فایل در زبانه جدید',
    learningPreviewTitle: 'مطالعه و تحلیل سند: {{name}}',
    learningPromptSumm: 'لطفاً خلاصه‌ای جامع، ساختاریافته و ریزبه‌ریز از مفاهیم اصلی و نکات مهم این مبحث به همراه طبقه‌بندی کامل ارائه دهید.',
    learningPromptSummBtn: 'خلاصه جامع و نکات اصلی',
    learningPromptVocab: 'لطفاً تمامی تعاریف، اصطلاحات تخصصی و مفاهیم کلیدی این موضوع را در قالب جدول منظم با مثال‌های روشن تحلیل فرمایید.',
    learningPromptVocabBtn: 'جدول اصطلاحات و تعاریف',
    learningSaveFirstSession: 'ثبت اولین جلسه با هوش مصنوعی',
    learningSaveToSessionBtn: 'ثبت و افزوده شدن به جلسه',
    learningSaveTopicBtn: 'ثبت موضوع',
    learningSessionIntroOpt: 'توضیحات کلی یا مقدمه جلسه (اختیاری)',
    learningSessionLabel: 'جلسه',
    learningSessionMainTitle: 'عنوان کلی جلسه آموزشی',
    learningSessionStartDate: 'تاریخ شروع: {{date}}',
    learningSubtopicFmt: 'مبحث/موضوع {{idx}}: {{title}}\\nنکات: {{notes}}',
    learningSubtopicTitleLabel: 'عنوان مبحث / موضوع فرعی',
    learningTeacherNote: 'یادداشت استاد',
    learningThisItem: 'این مورد',
    learningTopicHint: 'شما می‌توانید موضوعاتی مثل "زبان سوئدی"، "آموزش Docker"، "برنامه‌نویسی Python"، "آشپزی" یا هر مبحث دلخواه را اضافه کنید.',
    learningTopicHistory: 'تاریخچه جلسات این موضوع',
    learningTopicsDiscussed: 'مباحث مطرح‌شده در این جلسه:',
    learningTotalTopics: 'کل موضوعات اصلی',
    learningTrainAiBtn: 'تحلیل و آموزش با هوش مصنوعی',
    learningTrainingBtn: 'در حال آموزش و تحلیل...',
    learningUploadingDesc: 'لطفاً شکیبا باشید. فایل شما در حال ذخیره روی سرور و استخراج محتوا جهت تحلیل هوش مصنوعی است.',
    learningVideoTitleLabel: 'عنوان یا نام ویدیو',
    learningViewSessionContinue: 'مشاهده جلسه و ادامه گفتگو',
    learningViewSessions: 'مشاهده جلسات',
    notesEnergyTooltip: 'درجه انرژی: {{level}}',
    notesPainScale10: '۱۰ - درد غیرقابل تحمل',
    notesPainScale5: '۵ - متوسط',
    notesSymptomsPlaceholder: 'مثال: گرفتگی عضلات صبحگاهی کمر، احساس گزگز خفیف در پای چپ هنگام ایستادن...',
    seasonalMealPlanAiAssistantDesc: 'بر اساس ۵ ترفند علمی تغذیه و سلامت متابولیک جهت بهینه‌سازی برنامه غذایی، جایگزینی مواد یا دستور پخت‌های سالم.',
    seasonalMealPlanAiAssistantTitle: 'دستیار هوش مصنوعی هوشمند تغذیه GLP-1',
    seasonalMealPlanAiGetAdvice: 'دریافت مشاوره از هوش مصنوعی',
    seasonalMealPlanAiLoading: 'در حال دریافت تحلیل و دستور از AI...',
    seasonalMealPlanAiPromptPlaceholder: 'مثلاً: قهوه کولد برو چه کالری و فایده‌ای داره یا جایگزین سالم‌تر برای این وعده بگو...',
    seasonalMealPlanAiPromptAlternative: 'یک جایگزین کم‌کالری یا سالم‌تر برای {{foodName}} و میان‌وعده پیشنهاد بده.',
    seasonalMealPlanAiAnalysisHeader: 'تحلیل و راهنمایی هوشمند هوش مصنوعی:',
    seasonalMealPlanAiResponse: 'پاسخ هوش مصنوعی',
    seasonalMealPlanAiError: 'متأسفانه در دریافت پاسخ از هوش مصنوعی خطایی رخ داد. لطفاً دوباره تلاش کنید.',
    seasonalMealPlanCoffeeNutritionInfo: 'ارزش تغذیه‌ای این نوشیدنی:',
    seasonalMealPlanCoffeeTitle: 'عادت روزانه: قهوه سلامتی (کولد برو / اسپرسو + گردو و چیا)',
    seasonalMealPlanCoffeeRecipeTitle: 'طرز تهیه و ترکیب طلایی قهوه سلامتی:',
    seasonalMealPlanCoffeeBenefits: 'فواید شگفت‌انگیز و اثبات‌شده علمی:',
    seasonalMealPlanCopied: '{{title}} کپی شد!',
    seasonalMealPlanDefaultMenu: 'منوی اولیه',
    seasonalMealPlanDefaultSnackName: 'قهوه سلامتی + ماست یونانی و گردو',
    seasonalMealPlanDefaultSnackIng: 'قهوه سرد + ۱۵۰گ ماست یونانی + ۱۰گ گردو + ۱ ق‌چ دانه چیا + زردچوبه و روغن زیتون',
    seasonalMealPlanDefaultSnackPortion: '۱ لیوان (۲۵۰ml)',
    seasonalMealPlanDefineNewHabit: 'تعریف عادت سلامت جدید',
    seasonalMealPlanDeleteHabitTooltip: 'حذف عادت',
    seasonalMealPlanDiffEasy: 'آسان',
    seasonalMealPlanDiffMed: 'متوسط',
    seasonalMealPlanDiffHard: 'سخت',
    seasonalMealPlanFilterWeek13: 'هفته ۱ و ۳',
    seasonalMealPlanFilterWeek24: 'هفته ۲ و ۴',
    seasonalMealPlanFoodNameLabel: 'نام غذا:',
    seasonalMealPlanHeaderDesc: 'برنامه تغذیه هوشمند و بهینه‌سازی سلامت متابولیک (GLP-1) با ۵ ترفند کلیدی تغذیه سالم در چهار فصل سال.',
    seasonalMealPlanHeaderSubtitle: 'برنامه فصلی تغذیه سالم و بهینه‌سازی متابولیک',
    seasonalMealPlanHeaderTitle: 'برنامه غذایی ماهانه و فصلی تحریک هورمون GLP-1',
    seasonalMealPlanAiConsulting: 'مشاوره و بهینه‌سازی AI',
    seasonalMealPlanRuleFatLabel: 'چربی مفید',
    seasonalMealPlanRuleFatSub: 'زیتون، گردو، ماست یونانی',
    seasonalMealPlanRuleProteinLabel: 'پروتئین بالا',
    seasonalMealPlanRuleProteinSub: 'مرغ، گوشت لخم، ماهی، حبوبات',
    seasonalMealPlanRuleFiberLabel: 'فیبر و طعم تلخ',
    seasonalMealPlanRuleFiberSub: 'شاهی، جعفری، بامیه، اسفناج',
    seasonalMealPlanRuleGoldenLabel: 'ترکیب طلایی',
    seasonalMealPlanRuleGoldenSub: 'زردچوبه + فلفل + روغن زیتون',
    seasonalMealPlanRuleStartLabel: 'استارت با فیبر',
    seasonalMealPlanRuleStartSub: 'شروع وعده با سالاد شیرازی',
    seasonalMealPlanCurrentSeasonLabel: 'فصل جاری',
    seasonalMealPlanTabGrid: 'برنامه ۳۰ روزه ناهار و میان‌وعده',
    seasonalMealPlanTabHabits: 'عادات و توصیه‌های سلامت (قهوه)',
    seasonalMealPlanTabShopping: 'لیست خرید هفتگی',
    seasonalMealPlanTabSummary: 'خلاصه مواد ماهانه',
    seasonalMealPlanTabNutrition: 'تحلیل تغذیه‌ای',
    seasonalMealPlanTabTips: 'ترفندهای آشپزی',
    seasonalMealPlanMealFilterLabel: 'وعده:',
    seasonalMealPlanFilterAll: 'همه',
    seasonalMealPlanFilterLunch: 'ناهار',
    seasonalMealPlanFilterSnack: 'میان‌وعده',
    seasonalMealPlanWeekFilterLabel: 'هفته:',
    seasonalMealPlanGridInfo: 'هر روز شامل ناهار و میان‌وعده سالم مغذی است.',
    seasonalMealPlanDaysCount: 'روزها: {{count}} روز',
    seasonalMealPlanWeekNum: 'هفته {{num}}',
    seasonalMealPlanEditMealsTitle: 'ویرایش ناهار و میان‌وعده',
    seasonalMealPlanLunchTitle: 'وعده ناهار',
    seasonalMealPlanPortionLabel: 'سهم:',
    seasonalMealPlanCalorie: 'کالری',
    seasonalMealPlanProtein: 'پروتئین',
    seasonalMealPlanCarb: 'کربو',
    seasonalMealPlanFat: 'چربی',
    seasonalMealPlanSideDish: 'دورچین:',
    seasonalMealPlanDailyProtocol: 'پروتکل ویژه روزانه',
    seasonalMealPlanGLP1Stimulation: 'تحریک طبیعی هورمون‌های GLP-1 & GIP',
    seasonalMealPlanCompletedToday: 'تکمیل شده برای امروز ✨',
    seasonalMealPlanChecklistTitle: 'چک‌لیست عادات متابولیک و پروتکل‌های روزانه',
    seasonalMealPlanChecklistDesc: 'انجام روزانه این عادات، سرعت سوزاندن چربی و پایداری قند خون را ۲ برابر می‌کند.',
    seasonalMealPlanTodayStatus: 'وضعیت امروز:',
    seasonalMealPlanStatusDone: 'انجام شد ✨',
    seasonalMealPlanStatusPending: 'هنوز انجام نشده',
    seasonalMealPlanMarkedDone: 'تکمیل شد',
    seasonalMealPlanShoppingListTitle: 'لیست خرید هفتگی {{seasonName}}',
    seasonalMealPlanShoppingListDesc: 'مواد اولیه کلیدی جهت تامین فیبر، چربی‌های مفید و ترکیبات تلخ این فصل',
    seasonalMealPlanShoppingListCopyPrefix: 'لیست خرید',
    seasonalMealPlanCopyAllList: 'کپی کل لیست خرید',
    seasonalMealPlanCatProtein: 'منابع پروتئینی و لبنی',
    seasonalMealPlanCatGrains: 'برنج و حبوبات (فیبر بالا)',
    seasonalMealPlanCatVeg: 'سبزیجات و صیفی‌جات تلخ',
    seasonalMealPlanCatFat: 'چربی‌های مفید و ادویه‌جات',
    seasonalMealPlanMonthlySummaryTitle: 'خلاصه مواد مصرفی ماهانه ({{seasonName}})',
    seasonalMealPlanSummProtein: 'پروتئین قرمز و سفید:',
    seasonalMealPlanSummProteinVal: 'حدود ۳.۵ تا ۴ کیلوگرم',
    seasonalMealPlanSummLegumes: 'انواع حبوبات و فیبر:',
    seasonalMealPlanSummLegumesVal: 'حدود ۳ تا ۴ کیلوگرم',
    seasonalMealPlanNutritionAnalysisTitle: 'آنالیز تغذیه‌ای و مکانیزم لاغری GLP-1 ({{seasonName}})',
    seasonalMealPlanNutrProtein: 'سهم پروتئین',
    seasonalMealPlanNutrProteinVal: '۳۰٪ انرژی روزانه',
    seasonalMealPlanNutrCarb: 'کربوهیدرات پیچیده',
    seasonalMealPlanNutrCarbVal: '۴۰٪ (برنج کته محدود)',
    seasonalMealPlanNutrFat: 'چربی مفید',
    seasonalMealPlanNutrFatVal: '۳۰٪ (زیتون و گردو)',
    seasonalMealPlanEditDayTitle: 'ویرایش روز {{dayName}} (ناهار و میان‌وعده)',
    seasonalMealPlanPortionSizeLabel: 'اندازه سهم:',
    seasonalMealPlanIngredientsLabel: 'ترکیبات اصلی:',
    seasonalMealPlanProteinLabel: 'پروتئین (g):',
    seasonalMealPlanCarbLabel: 'کربو (g):',
    seasonalMealPlanFatLabel: 'چربی (g):',
    seasonalMealPlanSideDishLabel: 'دورچین توصیه شده:',
    seasonalMealPlanSnackSettings: 'تنظیمات وعده میان‌وعده',
    seasonalMealPlanSaveToFirebase: 'ذخیره تغییرات در فایربیس',
    seasonalMealPlanHabitTitleLabel: 'عنوان عادت:',
    seasonalMealPlanHabitTitlePlaceholder: 'مثلاً: پیاده‌روی ۲۰ دقیقه‌ای بعد از ناهار',
    seasonalMealPlanHabitDescLabel: 'توضیح مختصر:',
    seasonalMealPlanHabitDescPlaceholder: 'مثلاً: پیاده‌روی برای کاهش سریع قند خون بعد از غذا',
    seasonalMealPlanHabitBenefitLabel: 'مزیت اصلی برای سلامتی:',
    seasonalMealPlanHabitBenefitPlaceholder: 'مثلاً: افزایش حساسیت به انسولین و جلوگیری از خواب‌آلودگی بعد از غذا',
    seasonalMealPlanQuestionLabel: 'سوال یا درخواست تغییر:',
    seasonalMealPlanSnackType: 'میان‌وعده',
    seasonalMealPlanLunchType: 'ناهار',
    seasonalMealPlanLogLunchTitle: 'ثبت ناهار در دفترچه تغذیه',
    seasonalMealPlanLogSnackTitle: 'ثبت میان‌وعده در دفترچه تغذیه',
    seasonalMealPlanMealLogged: 'وعده "{{foodTitle}}" در {{mealType}} امروز ثبت شد 🍲',
    seasonalMealPlanSavedSuccess: 'تغییرات با موفقیت ذخیره شد ✨',
    seasonalMealPlanUpdatedLocally: 'برنامه بروزرسانی شد (جهت ذخیره ابری وارد حساب شوید)',
    seasonalMealPlanSaveError: 'خطا در ذخیره‌سازی',
    seasonalMealPlanResetConfirm: 'آیا از بازنشانی برنامه {{seasonName}} به حالت استاندارد اولیه اطمینان دارید؟',
    seasonalMealPlanResetSuccess: 'برنامه {{seasonName}} به منوی اولیه بازنشانی شد',
    seasonalMealPlanCustomHabitDesc: 'عادت سلامت شخصی کاربر',
    seasonalMealPlanCustomHabitBenefit: 'افزایش انرژی و بهبود سلامتی متابولیک',
    seasonalMealPlanCustomHabitAdded: 'عادت جدید با موفقیت اضافه شد ✨',
    seasonalMealPlanCustomHabitRemoved: 'عادت شخصی حذف شد',
    seasonalMealPlanKeyBenefitsLabel: 'فواید کلیدی:',
    seasonalMealPlanLogCoffeeToday: 'ثبت مصرف قهوه امروز ☕',
    seasonalMealPlanLogLunch: 'ثبت ناهار',
    seasonalMealPlanLogSnack: 'ثبت میان‌وعده',
    seasonalMealPlanLogToday: 'ثبت امروز',
    seasonalMealPlanLunchSettings: 'تنظیمات وعده ناهار',
    seasonalMealPlanPrepTipsTitle: 'ترفندهای صرفه‌جویی در زمان و آماده‌سازی سریع (Meal Prep)',
    seasonalMealPlanResetTooltip: 'بازنشانی برنامه این فصل به حالت اولیه',
    seasonalMealPlanSaveHabitToFirebase: 'ثبت عادت در فایربیس',
    seasonalMealPlanSelectedFood: 'غذا انتخاب‌شده:',
    seasonalMealPlanSnackIngredientsLabel: 'ترکیبات میان‌وعده:',
    seasonalMealPlanSnackNameLabel: 'نام میان‌وعده:',
    seasonalMealPlanSnackTitle: 'وعده میان‌وعده',
    seasonalMealPlanSummOliveOil: 'روغن زیتون فرابکر:',
    seasonalMealPlanSummOliveOilVal: '۲ تا ۴ بطری برای کل خانواده',
    weightBmiObese: 'چاقی مفرط (Obese)',
    weightBmiObeseAdv: 'شاخص توده بدنی شما در محدوده چاقی مفرط است. کاهش تدریجی و علمی وزن، فشار فیزیکی بر دیسک کمر شما را بلافاصله کاهش می‌دهد. پیشنهاد می‌کنیم برنامه غذایی کم‌کالری خود را با پزشک متخصص تنظیم نموده و ورزش‌های سبک بدون جهش ماژول کاردیو را منظم دنبال کنید.',
    weightBmiOver: 'اضافه‌وزن (Overweight)',
    weightBmiOverAdv: 'شما در محدوده اضافه‌وزن خفیف هستید. کاهش ملایم وزن (حدود ۰.۵ کیلوگرم در هفته) با پیگیری کالری در بخش تغذیه و انجام روزانه تمرینات سبک چربی‌سوزی شکم به کاهش دردهای کمر شما کمک بسیار زیادی خواهد کرد.',
    weightBmiPending: 'محاسبه در انتظار قد شماست',
    weightBmiUnderAdv: 'پیشنهاد می‌شود کالری مصرفی روزانه و همچنین پروتئین دریافتی خود را افزایش دهید. تمرینات ملایم قدرتی می‌توانند به افزایش حجم توده عضلانی سالم کمک کنند.',
    weightHistDate: 'تاریخ ثبت',
    weightLogDate: 'ثبت وزن برای تاریخ: {{date}}',
    weightProfileHeightPh: 'مثال: ۱۷۸',
    weightSaveBtn: 'ثبت و ذخیره وزن در تاریخ فوق',
    weightSpecify: 'وزن خود را مشخص کنید (کیلوگرم)',
    targetWeightWeeklyRate: 'نرخ تخمینی: {{rate}} کیلوگرم در هفته',
    seasonalMealPlanAddCustomHabit: 'افزودن عادت شخصی جدید',
    rehabDefaultPainLocation: 'کمر و ستون فقرات',
    rehabDefaultLimitations: 'محدودیت در نشستن طولانی و خم شدن',
    rehabDefaultEquipment: 'مت یوگا، بدون تجهیزات خاص',
    rehabIntakeUserInfo: 'اطلاعات ارزیابی بدنی کاربر:',
    rehabPromptAiInstructions: 'دستورالعمل مهم: پاسخ را بسیار کوتاه (حداکثر ۲ تا ۳ جمله بدون هیچگونه علامت Markdown مانند ## یا ** یا جدول) بنویسید تا مستقیماً به عنوان دستورالعمل تمرین ثبت شود.',
    swedishModuleTitle: 'ماژول ۴ — پایش یادگیری زبان سوئدی',
    swedishModuleDesc: 'برای ثبت پیشرفت و اهدافی که در اپلیکیشن‌های دیگر یاد می‌گیرید؛ همراه با توصیه‌های روزانه ارتقای مهارت‌های SFI.',
    sweTaskVerbsTitle: 'افعال کاربردی سوئدی (Swedish Verbs)',
    sweTaskVerbsTopic: 'تسلط بر افعال حرکتی، زمان حال، گذشته و صرف افعال اصلی',
    sweTaskVerbsDur: '۱۰-۱۵ دقیقه',
    sweTaskEmpTitle: 'واژگان حوزه استخدام و محیط کار (Employee / Arbete)',
    sweTaskEmpTopic: 'اصطلاحات اداری، درخواست کار، صحبت با همکاران و کارفرما',
    sweTaskEmpDur: '۱۰-۱۵ دقیقه',
    sweTaskIndepTitle: 'مطالعه و ممارست مستقل روزانه',
    sweTaskIndepTopic: 'ثبت و پایش یادگیری مستقل انجام‌شده در سایر اپلیکیشن‌ها',
    sweTaskIndepDur: '۱۰-۱۵ دقیقه',
    swedishTodayProgress: 'پیشرفت اهداف امروز',
    swedishTopicsCount: '{{completed}} از {{total}} سرفصل سوئدی',
    swedishTodayStudyTime: 'زمان ثبت‌شده پایش امروز',
    swedishMinutesEquivalent: 'دقیقه معادل',
    swedishChecklistTitle: 'سرفصل‌های آماده برای ثبت خوداظهاری سوئدی',
    swedishTopicDetail: 'جزییات سرفصل:',
    swedishNoticeBox: '💡 توجه داشته باشید: شما روند یادگیری این سرفصل‌ها را در برنامه‌های دیگر (مثل دولینگو، ممرایز یا کلاس‌های SFI) سپری کرده‌اید و در وکسا تنها برای پایش مستمر اهداف روزانه خود ثبت و تیک می‌زنید.',
    swedishDailyTipsTitle: 'توصیه‌های کاربردی روزانه (۳ نکته کلیدی سوئدی)',
    swedishGetNewTips: 'دریافت ۳ نکته جدید',
    swedishDailyKeyword: 'کلید واژه امروز:',
    swedishKeywordColleague: 'Arbetskamrat (همکار)',
    swedishKeywordPronounce: 'تلفظ: آربِتز-کام-رات',
    activityLogTitle: 'ماژول ۷ — دفتر ثبت فعالیت‌های روزانه',
    activityLogDesc: 'رفت‌وآمدها، مراجعات فیزیوتراپی، سرگرمی، خرید و یادگیری‌های متفرقه خود را ثبت کنید تا همواره تراز فیزیکی ستون فقرات در نظر گرفته شود.',
    activityLogActiveTime: 'زمان فعالیت فرعی اضافی',
    activityLogMinutesToday: 'دقیقه امروز',
    activityLogEstimatedCalories: 'کالری تخمینی فرعی',
    activityLogActiveCalories: 'کالری فعال',
    activityLogPresetsTitle: 'الگوهای ثبت سریع فعالیت روزمره',
    activityLogMinutesShort: 'دقیقه',
    activityLogManualFormTitle: 'ثبت دستی فعالیت سفارشی جدید',
    activityLogFieldTitle: 'عنوان فعالیت',
    activityLogFieldTitlePh: 'مثال: شنای ملایم کرال پشت',
    activityLogFieldStartTime: 'زمان شروع',
    activityLogFieldEndTime: 'زمان پایان',
    activityLogFieldDuration: 'مدت (دقیقه)',
    activityLogFieldCalories: 'کالری فرعی (اختیاری)',
    activityLogFieldCaloriesPh: 'مثال: ۱۵۰',
    activityLogFieldNotes: 'توضیحات بدنی / مشاهدات درد و راحتی',
    activityLogFieldNotesPh: 'مثال: هیچگونه احساس دردی در مهره‌های کمر نداشتم. عضلات باسن و شکم به خوبی درگیر شدند.',
    activityLogSaveBtn: 'ذخیره فعالیت',
    activityLogTodayListTitle: 'لیست فعالیت‌های ثبت‌شده امروز',
    activityLogEmptyState: 'هنوز هیچ فعالیت اضافی برای امروز ثبت نشده است. از الگوهای آماده استفاده کنید یا فرم دستی را تکمیل کنید.',
    activityLogDeleteTooltip: 'حذف فعالیت',
    activityLogApproxCal: 'چربی‌سوزی تقریبی: ~{{cal}} کالری',
    schedulesHeaderSubtitle: 'پلنر و مدیریت روتین‌های هفتگی (Weekly Planner & Routine)',
    schedulesDownloadIcsBtn: 'دانلود تقویم برنامه هفتگی (.ics)',
    schedulesDownloadIcsTooltip: 'دانلود فایل تقویم همه‌کاره (.ics) بر اساس برنامه هفتگی جهت تنظیم آلارم بومی گوشی',
    schedulesTabToday: '📋 روتین امروز',
    schedulesTabManage: '⚙️ ویرایش برنامه هفتگی',
    schedulesSelectedDayLabel: 'روز انتخاب شده برای پایش و ویرایش روتین:',
    schedulesRoutineCount: '{{count}} روتین',
    schedulesEmptyDay: 'خالی',
    schedulesTasksChecklistForDay: 'چک‌لیست فعالیت‌ها و روتین {{day}}',
    schedulesTasksCount: '{{count}} وظیفه تعیین‌شده',
    schedulesCopyAllWeek: '📋 کپی به کل هفته',
    schedulesCopyAllWeekTooltip: 'کپی کردن برنامه زمان‌بندی این روز به تمام روزهای هفته',
    schedulesNoTasksTitle: 'برنامه زمانی برای روز {{day}} تعریف نشده است',
    schedulesNoTasksDesc: 'شما در این روز به طور پیش‌فرض برنامه‌ای ندارید. مایلید روتین‌های روزهای کاری را به این روز کپی کنید یا فعالیت جدید بسازید؟',
    schedulesCopyMonday: '📋 کپی روتین دوشنبه به امروز',
    schedulesAddManualTask: '➕ افزودن فعالیت دستی',
    schedulesWorkTag: 'حضور در کار',
    schedulesStudyTag: 'فعالیت آموزشی',
    schedulesPhoneAlarm: 'آلارم گوشی',
    schedulesPhoneAlarmTooltip: 'هشدار آلارم و نوتیفیکیشن فعال است',
    schedulesGoogleCalTooltip: 'افزودن به تقویم گوگل جهت دریافت یادآور شخصی',
    schedulesGoogleCalendar: 'تقویم گوگل (یادآور)',
    schedulesManageRoutineTitle: '⚙️ ویرایش و تنظیم روتین روز:',
    schedulesManageRoutineSubtitle: 'برای فعال/غیرفعال کردن آلارم و یا همگام‌سازی تقویم گوگل، می‌توانید مستقیماً روی دکمه‌های هر کارت کلیک کنید.',
    schedulesCopyThisDayToAll: 'کپی این روز به تمام هفته',
    schedulesAddNewRoutineBtn: 'افزودن فعالیت جدید',
    schedulesEditRoutineFormTitle: '📝 ویرایش فعالیت روتین هفتگی',
    schedulesAddRoutineFormTitle: '➕ افزودن فعالیت روتین جدید',
    schedulesFormDayOfWeek: '📅 روز هفته برای این فعالیت:',
    schedulesFormQuickTime: '⚡ میانبرهای ساعت شروع سریع:',
    schedulesFormStartTime: '🕒 ساعت شروع',
    schedulesFormEndTime: '🕒 ساعت پایان (اختیاری)',
    schedulesFormTitle: '📝 عنوان فعالیت روتین *',
    schedulesFormTitlePh: 'مثلاً: شیفت کاری، ورزش صبحگاهی، خودآموزی سوئدی و...',
    schedulesFormDesc: '💬 جزئیات یا اهداف مربوطه (اختیاری)',
    schedulesFormDescPh: 'توضیحات تکمیلی، یادداشت‌ها یا اهداف این بازه...',
    schedulesFormSyncAttendance: '🔗 همگام‌سازی خودکار حضور:',
    schedulesFormSyncWork: 'ثبت خودکار «حضور در محل کار»',
    schedulesFormSyncStudy: 'ثبت خودکار «فعالیت آموزشی / کلاس»',
    schedulesFormIsEducation: 'این فعالیت آموزشی است (درس/دوره/موسیقی)',
    sleepDuration: 'مدت زمان خواب',
    sleepOptimal: 'خواب عالی 😴',
    sleepLong: 'خواب طولانی 💤',
    sleepModerate: 'خواب متوسط 🌙',
    sleepLow: 'کمبود خواب ⚠️',
    schedulesFormPhoneAlarm: 'آلارم و نوتیفیکیشن گوشی',
    schedulesFormPhoneAlarmDesc: 'در زمان شروع این فعالیت، نوتیفیکیشن بومی روی گوشی ارسال می‌شود.',
    schedulesFormGoogleCal: 'تقویم گوگل (یادآور)',
    schedulesFormGoogleCalDesc: 'این فعالیت در فایل تقویم خروجی (.ics) جهت همگام‌سازی قرار خواهد گرفت.',
    schedulesCancel: 'انصراف',
    schedulesSaveRoutine: 'ذخیره روتین',
    schedulesNoRoutinesForDay: 'هیچ روتینی برای روز {{day}} ثبت نشده است.',
    schedulesNoRoutinesHint: 'برای افزودن فعالیت جدید، روی دکمه «افزودن فعالیت جدید» کلیک کنید یا از گزینه «کپی این روز به تمام هفته» برای کپی سریع برنامه‌ها استفاده نمایید.',
    schedulesPhoneAlarmActive: 'آلارم گوشی: فعال',
    schedulesPhoneAlarmInactive: 'آلارم گوشی: غیرفعال',
    schedulesGoogleCalActive: 'تقویم گوگل (یادآور): فعال',
    schedulesGoogleCalInactive: 'تقویم گوگل (یادآور): غیرفعال',
    schedulesQuickCopyTo: 'کپی سریع این فعالیت به:',
    schedulesEditFull: 'ویرایش',
    schedulesDeleteActivity: 'حذف فعالیت',
    schedulesWeeklyAttendanceStatus: 'وضعیت حضور هفتگی (شنبه - جمعه)',
    schedulesWorkPresence: 'حضور در کار',
    schedulesNonWorkDay: 'غیرکاری',
    schedulesClassPresence: 'کلاس آموزشی',
    schedulesNoStudyDay: 'بدون کلاس',
    schedulesTotalWorkShifts: 'کل حضور شغلی',
    schedulesWorkDaysThisWeek: 'روز کاری این هفته',
    schedulesTotalClasses: 'کل کلاس‌های آموزشی',
    schedulesClassesThisWeek: 'جلسه آموزشی این هفته',
    schedulesConfirmCopyWeek: 'آیا مایلید برنامه روز {{day}} را به تمامی روزهای هفته کپی کنید؟ این کار برنامه‌های قبلی روزهای دیگر را جایگزین می‌کند.',
    schedulesConfirmCopyMonday: 'آیا مایلید روتین دوشنبه را برای روز {{day}} کپی کنید؟',
    schedulesConfirmDelete: 'آیا از حذف این روتین اطمینان دارید؟',
    schedulesCopiedSuccess: 'فعالیت «{{title}}» با موفقیت به روز {{day}} کپی گردید.',
    schedulesNoCalendarAlert: 'هیچ فعالیتی با گزینه «تقویم گوگل (یادآور)» علامت‌گذاری نشده است.\n\nلطفاً در لیست فعالیت‌های برنامه هفتگی، دکمه «تقویم گوگل (یادآور)» را برای کارهای مورد نظر خود فعال کنید تا در تقویم خروجی قرار گیرند.',
    schedMon: 'دوشنبه (Mon)',
    schedTue: 'سه‌شنبه (Tue)',
    schedWed: 'چهارشنبه (Wed)',
    schedThu: 'پنجشنبه (Thu)',
    schedFri: 'جمعه (Fri)',
    schedSat: 'شنبه (Sat)',
    schedSun: 'یکشنبه (Sun)',
    schedUnknownDay: 'نامشخص',

    // Weight, Body Fat & BMI Module Translations
    weightBodyFatSpecify: "درصد چربی بدن (اختیاری ٪)",
    saveToD1Btn: "ذخیره در دیتابیس D1",
    savingToD1Btn: "در حال ذخیره‌سازی...",
    physicalProfileTitle: "مشخصات آناتومیک و اهداف",
    heightCmLabel: "قد (سانتی‌متر)",
    targetWeightKgLabel: "وزن هدف (کیلوگرم)",
    targetBodyFatPctLabel: "درصد چربی هدف (٪)",
    saveProfileBtn: "به‌روزرسانی اهداف",
    profileSavedSuccess: "مشخصات آناتومیک با موفقیت ذخیره شد.",
    currentWeightTitle: "وزن فعلی",
    bmiIndexTitle: "شاخص BMI",
    bmiUnderweight: "کم‌وزن (نیاز به تقویت)",
    bmiNormal: "وزن ایده‌آل و طبیعی",
    bmiOverweight: "اضافه‌وزن (هشدار فشار کمر)",
    bmiObeseCat: "چاقی (نیاز به برنامه کاهش وزن)",
    bmiAdviceUnder: "وزن شما پایین‌تر از حد نرمال است. افزایش توده عضلانی با تغذیه پروتئینی مناسب به پشتیبانی بهتر ستون فقرات کمک می‌کند.",
    bmiAdviceNormal: "شاخص توده بدنی شما در محدوده بسیار مطلوب قرار دارد. این وضعیت فشار را از روی مهره‌های کمری شما کاهش می‌دهد.",
    bmiAdviceOver: "مقداری اضافه‌وزن وجود دارد. کاهش ۳ تا ۵ کیلوگرم وزن، فشار وارده بر دیسک‌های کمر L4-L5 را تا ۱۵٪ کاهش می‌دهد.",
    bmiAdviceObese: "شاخص BMI بالای ۳۰ نشان‌دهنده فشار زیاد بر مفاصل و کمر است. پیشنهاد می‌شود روند کاهش وزن تدریجی را پیگیری کنید.",
    currentBodyFatTitle: "درصد چربی فعلی",
    bodyFatNotLogged: "ثبت نشده",
    fatCatLow: "بسیار کم (ورزشی)",
    fatCatOptimal: "مطلوب و تناسب اندام",
    fatCatModerate: "متوسط",
    fatCatHigh: "بالا (نیاز به چربی‌سوزی)",
    distanceToWeightGoal: "فاصله تا وزن هدف",
    distanceToFatGoal: "فاصله تا چربی هدف",
    goalReached: "رسیده به هدف! 🎉",
    metricWeightToggle: "وزن (کیلوگرم)",
    metricFatToggle: "درصد چربی (٪)",
    rangeAll: "همه سوابق",
    range30Days: "۳۰ روز اخیر",
    range90Days: "۹۰ روز اخیر",
    targetWeightLine: "خط وزن هدف",
    targetFatLine: "خط چربی هدف",
    noChartData: "هنوز داده‌ای ثبت نشده است. اولین وزن خود را وارد کنید.",
    noFatDataForRange: "داده‌ای برای درصد چربی در این بازه وجود ندارد.",
    bodyCompAiTitle: "تحلیل هوشمند ترکیب بدن (Body Composition AI)",
    bodyCompAiSubtitle: "تحلیل هوشمند شاخص‌های وزن، چربی و عضلات بر اساس داده‌های واقعی D1",
    analyzeCurrentStateBtn: "تحلیل هوشمند وضعیت فعلی",
    analyzingStateBtn: "در حال تحلیل...",
    askMusclePreserveBtn: "چگونه عضله را حفظ کنم؟",
    calculatingBtn: "در حال محاسبه...",
    chipCurrentWeightD1: "وزن فعلی D1",
    chipWeightGoalD1: "وزن هدف D1",
    chipBodyFatCurrent: "درصد چربی فعلی",
    chipBodyFatGoalD1: "چربی هدف D1",
    requiresDataLog: "نیازمند ثبت داده",
    aiBodyCompResultTitle: "نتیجه تحلیل هوشمند ترکیب بدن (پزشک متابولیک AI)",
    aiMuscleResultTitle: "پروتکل تخصصی حفظ عضلات هنگام چربی‌سوزی",
    recomTitle: "۳ توصیه عملی برای کاهش چربی و حفظ عضله",
    recom1Text: "مصرف پروتئین کافی: روزانه ۱.۶ تا ۲.۲ گرم پروتئین به ازای هر کیلوگرم وزن بدن مصرف کنید تا جلوی کاتابولیسم و افت توده عضلانی گرفته شود.",
    recom2Text: "تمرینات قدرتی/مقاومتی با بار فزاینده: حداقل ۳ جلسه در هفته تمرینات قدرتی انجام دهید تا سیگنال هیپرتروفی و حفظ عضله فعال بماند.",
    recom3Text: "کسری کالری متعادل (۱۵ تا ۲۰٪): از رژیم‌های گرسنگی شدید پرهیز کنید تا بدن به جای عضله، از ذخایر چربی به‌عنوان انرژی اصلی استفاده کند.",
    plateauTitle: "عیب‌یابی هوشمند استپ وزنی (Plateau AI)",
    plateauSubtitle: "اگر وزن شما برای چند هفته ثابت مانده، دلایل فیزیولوژیک آن را تحلیل کنید",
    analyzePlateauBtn: "تحلیل دلیل استپ وزنی",
    measurementHistoryTitle: "جدول تاریخچه سنجش‌ها",
    colDate: "تاریخ",
    colWeight: "وزن (کیلوگرم)",
    colBodyFat: "درصد چربی (٪)",
    colBMI: "شاخص BMI",
    colActions: "عملیات",
    deleteRecord: "حذف رکورد",
    confirmDeleteWeight: "آیا از حذف این رکورد وزن مطمئن هستید؟",
    d1DataSourceTag: "منبع داده: Cloudflare D1",
    fetchingD1HealthData: "در حال دریافت جدیدترین داده‌های سلامت از Cloudflare D1...",
    nutriBackToToday: "بازگشت به امروز",
    nutriSelectDate: "انتخاب تاریخ",

    // Multi-Day Physiotherapy Program System
    multiDayProgramsTab: "برنامه‌های تمرینی چندروزه",
    exerciseLibraryTab: "بانک حرکات تکی (Library)",
    multiDayProgramsHeader: "مدیریت برنامه‌های تمرینی چندروزه فیزیوتراپی",
    multiDayProgramsDesc: "طراحی برنامه‌های چندروزه، تعریف حرکات مجزا برای هر روز، درون‌ریزی JSON و همگام‌سازی با روتین هفتگی",
    importJsonBtn: "درون‌ریزی JSON برنامه",
    createNewProgramBtn: "ایجاد برنامه تمرینی جدید",
    noProgramsYetTitle: "هنوز برنامه تمرینی چندروزه‌ای تعریف نشده است",
    noProgramsYetDesc: "شما می‌توانید یک برنامه چندروزه جدید ایجاد کنید یا از الگوهای تخصصی آماده فیزیوتراپی (دستورات JSON) استفاده نمایید.",
    loadSampleProgramJson: "بارگذاری برنامه آماده (نمونه JSON)",
    buildManualProgram: "ساخت برنامه دستی",
    activeProgramBadge: "برنامه فعال",
    noProgramDesc: "بدون توضیحات تکمیلی",
    trainingDaysCount: "{{count}} روز تمرینی",
    setAsActiveProgram: "فعال‌سازی این برنامه",
    currentActiveProgram: "برنامه فعال جاری",
    editProgramTooltip: "ویرایش عنوان و ویژگی‌ها",
    deleteProgramTooltip: "حذف برنامه",
    editProgramTitleModal: "ویرایش اطلاعات برنامه تمرینی",
    createProgramTitleModal: "ایجاد برنامه تمرینی جدید",
    programTitleLabel: "عنوان برنامه تمرینی:",
    programTitlePlaceholder: "مثلاً: برنامه ۲۱ روزه درمان دیسک کمر",
    programDescLabel: "شرح و اهداف درمان:",
    programDescPlaceholder: "مثلاً: پروتکل ۳ مرحله‌ای برای آزادسازی عصب سیاتیک...",
    programDifficultyLabel: "سطح دشواری:",
    difficultyBeginnerOption: "مبتدی / سبک",
    difficultyIntermediateOption: "متوسط / استاندارد",
    difficultyAdvancedOption: "پیشرفته / تخصصی",
    savingProgramBtn: "در حال ثبت...",
    saveProgramBtn: "ذخیره برنامه",
    confirmDeleteProgram: "آیا از حذف کامل این برنامه تمرینی و روزهای مربوط به آن اطمینان دارید؟",
    dbSaveError: "خطا در ثبت برنامه در دیتابیس D1.",
    dbDeleteError: "خطا در حذف برنامه از D1.",
    dbActivateError: "خطا در فعال‌سازی برنامه.",
    dbUpdateDaysError: "خطا در به‌روزرسانی روزهای برنامه در D1.",
    addNewProgramDayBtn: "افزودن روز تمرینی جدید",
    programDayDefaultTitle: "روز {{day}} — ریکاوری و تقویت",
    runWorkoutForDay: "اجرای تمرین این روز",
    runGuidedWorkoutForDay: "اجرای تمرین روز",
    scheduleDayInPlanner: "زمان‌بندی در برنامه‌ریز",
    scheduleDayBtn: "افزودن به روتین هفتگی",
    editDayModalTitle: "ویرایش روز {{day}}",
    dayTitleInputLabel: "عنوان روز تمرینی:",
    dayNotesInputLabel: "یادداشت‌ها و راهنمای تمرینی این روز:",
    dayNotesPlaceholder: "مثلاً: انجام تمرینات در ۲ نوبت صبح و عصر...",
    tabPickFromLibrary: "انتخاب از بانک حرکات",
    tabAddCustomExercise: "تعریف حرکت اختصاصی",
    tabJsonEditor: "ویرایش متنی JSON",
    selectedExercisesCount: "حرکات انتخاب‌شده برای این روز ({{count}} مورد):",
    noExercisesSelectedForDay: "هنوز هیچ حرکتی برای این روز انتخاب نشده است.",
    availableLibraryExercises: "بانک حرکات موجود (جهت انتخاب):",
    searchExercisesPlaceholder: "جستجوی حرکت...",
    exerciseAddedTag: "افزوده شد",
    addCustomExNameLabel: "نام حرکت سفارشی:",
    addCustomExNamePh: "مثلاً: کشش فیله با کش",
    addCustomExSetsLabel: "تعداد ست:",
    addCustomExRepsLabel: "تکرار / مکث:",
    addCustomExRestLabel: "استراحت بین ست‌ها:",
    addCustomExDurationLabel: "زمان (دقیقه):",
    addCustomExPurposeLabel: "هدف حرکت:",
    addCustomExTargetLabel: "عضلات هدف:",
    addCustomExDescLabel: "توضیحات انجام:",
    addExerciseToDayBtn: "افزودن این حرکت به روز تمرینی",
    jsonArrayError: "فرمت JSON باید یک آرایه (Array) از تمرینات باشد.",
    confirmDeleteDay: "آیا از حذف این روز تمرینی اطمینان دارید؟",
    saveDayChangesBtn: "ذخیره تغییرات روز",
    importJsonModalTitle: "درون‌ریزی برنامه تمرینی چندروزه (JSON)",
    jsonParseError: "فرمت JSON نامعتبر است: {{error}}",
    importSuccessMsg: "برنامه‌های تمرینی با موفقیت در سیستم ثبت شدند.",
    importFailed: "خطا در درون‌ریزی برنامه تمرینی.",
    pasteSampleJsonBtn: "درج فرمت نمونه کامل (JSON Sample)",
    uploadJsonFileLabel: "آپلود فایل JSON",
    jsonInputLabel: "محتوای ساختاریافته JSON برنامه:",
    jsonInputPlaceholder: "محتوای JSON را اینجا پیست کنید...",
    importingPrograms: "در حال درون‌ریزی...",
    scheduleDayToPlanner: "افزودن تمرین روز به برنامه‌ریزی هفتگی",
    timeRequired: "زمان شروع الزامی است.",
    scheduledSuccessfully: "تمرین این روز با موفقیت به برنامه‌ریزی هفتگی افزوده شد.",
    dayExerciseCountInfo: "تعداد حرکات این روز: {{count}} حرکت",
    selectWeekday: "انتخاب روز هفته:",
    startTime: "زمان شروع:",
    endTime: "زمان پایان (اختیاری):",
    enableReminder: "فعال‌سازی یادآور و هشدار تلفن",
    scheduleConfirmBtn: "ثبت در برنامه‌ریزی هفتگی",
    exerciseDetailModalTitle: "جزئیات کامل تمرین فیزیوتراپی",
    viewExerciseDetails: "مشاهده جزئیات کامل حرکت",
    exerciseDetailClose: "بستن",
    addToProgramModalTitle: "افزودن تمرین به برنامه چندروزه",
    targetProgramLabel: "برنامه تمرینی مقصد:",
    selectProgramPlaceholder: "انتخاب برنامه...",
    noProgramsAvailableWarning: "هنوز هیچ برنامه چندروزه‌ای ساخته نشده است. ابتدا یک برنامه بسازید.",
    targetDayLabel: "روز تمرینی مقصد:",
    selectDayPlaceholder: "انتخاب روز تمرینی...",
    createNewDayOption: "+ ایجاد روز تمرینی جدید در این برنامه",
    newDayTitleLabel: "عنوان روز تمرینی جدید:",
    newDayTitlePlaceholder: "مثلاً: روز تمرکز بر تقویت زنجیره خلفی",
    programDaySelectorOption: "روز {{num}}: {{title}}",
    exerciseSetsLabel: "تعداد ست‌ها:",
    exerciseRepsLabel: "تکرارها / مکث:",
    exerciseRestLabel: "زمان استراحت:",
    exerciseDurationLabel: "مدت تخمینی (دقیقه):",
    addToProgramBtn: "افزودن به برنامه",
    addingToProgram: "در حال افزودن...",
    exerciseAddedSuccess: "تمرین با موفقیت به برنامه تمرینی افزوده شد.",
    exerciseAddFailed: "خطا در افزودن تمرین به برنامه.",
    selectProgramAndDayWarning: "لطفاً برنامه و روز تمرینی را مشخص کنید.",
    exerciseScopeLabel: "دامنه انتشار:",
    exerciseScopeGlobal: "عمومی (الگوی سیستم)",
    exerciseScopePersonal: "شخصی (سفارشی شما)",
    exerciseBadgeGlobal: "عمومی",
    exerciseBadgePersonal: "شخصی",
    exerciseScopeFilterAll: "همه حرکات (عمومی و شخصی)",
    exerciseScopeFilterGlobal: "بانک عمومی",
    exerciseScopeFilterPersonal: "حرکات شخصی من",
    exercisePrecautionsLabel: "نکات ایمنی و موارد منع مصرف:",
    exerciseEquipmentLabel: "تجهیزات مورد نیاز:",
    exerciseEquipmentNone: "بدون نیاز به تجهیزات (فقط وزن بدن)",
    exerciseInstructionsLabel: "راهنما و نحوه اجرای صحیح:",
    exerciseVideoPlayerTitle: "پخش‌کننده ویدیو",
    exerciseImageAlt: "تصویر آموزشی حرکت {{name}}",
    exerciseCreatePersonalCopyBtn: "ایجاد نسخه شخصی",
    exerciseCreatingCopy: "در حال ایجاد نسخه شخصی...",
    exerciseCopySuccess: "نسخه شخصی تمرین ساخته شد و در کتابخانه شما قرار گرفت.",
    exerciseCopyFailed: "خطا در ایجاد نسخه شخصی تمرین.",
    exerciseGlobalCannotEdit: "حرکات عمومی سیستم غیرقابل ویرایش یا حذف مستقیم هستند. می‌توانید نسخه شخصی ایجاد کنید.",
    exerciseDeleteConfirm: "آیا از حذف این حرکت شخصی از کتابخانه اطمینان دارید؟",
    exerciseDeleteSuccess: "تمرین شخصی با موفقیت حذف شد.",
    exerciseDeleteFailed: "خطا در حذف تمرین.",
    exerciseAddToProgramAction: "افزودن به برنامه تمرینی",
    rehabDaysCount: "{{count}} روز تمرینی",
    rehabActiveProgramCurrent: "برنامه فعال جاری",
    rehabEditProgram: "ویرایش اطلاعات برنامه تمرینی",
    rehabCreateProgram: "ایجاد برنامه تمرینی جدید",
    rehabProgramTitleLabel: "عنوان برنامه تمرینی:",
    rehabProgramTitlePlaceholder: "مثلاً: برنامه ۲۱ روزه درمان دیسک کمر",
    rehabProgramDescLabel: "شرح و اهداف درمان:",
    rehabProgramDescPlaceholder: "مثلاً: پروتکل ۳ مرحله‌ای برای آزادسازی عصب سیاتیک...",
    rehabDifficultyLabel: "سطح دشواری:",
    rehabDiffBeginner: "مبتدی / سبک",
    rehabDiffIntermediate: "متوسط / استاندارد",
    rehabDiffAdvanced: "پیشرفته / تخصصی",
    rehabBeginner: "مبتدی",
    rehabIntermediate: "متوسط",
    rehabAdvanced: "پیشرفته",
    rehabSaveBtn: "ذخیره برنامه",
    dbProgramSaveError: "خطا در ثبت برنامه در دیتابیس D1.",
    dbProgramDeleteError: "خطا در حذف برنامه از D1.",
    dbProgramActivateError: "خطا در فعال‌سازی برنامه.",
    dbProgramUpdateDaysError: "خطا در به‌روزرسانی روزهای برنامه در دیتابیس D1.",
    manageProgramDaysTitle: "مدیریت روزهای برنامه‌ی «{{title}}»",
    totalDaysDesigned: "مجموع روزهای طراحی‌شده: {{count}} روز",
    noDaysInProgramYet: "هنوز روز تمرینی برای این برنامه ثبت نشده است.",
    startGuidedWorkoutBtn: "شروع تمرین با هدایت صوتی",
    scheduleWorkoutBtn: "تنظیم زمان‌بندی تمرین",
    selectDayToViewLabel: "انتخاب روز جهت مدیریت:",
    dayNumberLabel: "روز {{num}}",
    dayNumberOption: "روز {{num}}",
    editDayTitleAndNotes: "ویرایش عنوان و یادداشت این روز",
    closeDayEdit: "بستن",
    dayTitleFieldLabel: "عنوان روز:",
    dayTitleFieldPh: "مثال: روز ۱ — دکومپرشن و کشش پسواس",
    dayNotesFieldLabel: "یادداشت‌ها و نکات تمرینی این روز:",
    dayNotesFieldPh: "مثال: این تمرینات را قبل از صبحانه انجام دهید...",
    saveDayDetailsBtn: "ذخیره تغییرات روز",
    deleteThisDayBtn: "حذف این روز",
    addNewTrainingDayBtn: "افزودن روز تمرینی جدید",
    openDayJsonEditorBtn: "ویرایش JSON روز",
    exercisesInDayCount: "{{count}} حرکت در این روز",
    exercisesInDayHeading: "حرکات ثبت‌شده برای روز {{day}} ({{count}} حرکت):",
    hasVideoInstruction: "دارای ویدیو آموزشی",
    hasImageInstruction: "دارای تصویر راهنما",
    viewCompleteExerciseDetails: "مشاهده جزئیات کامل و رسانه حرکت",
    clickForCompleteDetails: "کلیک برای مشاهده جزئیات کامل",
    addExerciseToDaySelect: "افزودن از بانک حرکات...",
    addNewCustomExerciseToDay: "تعریف حرکت سفارشی جدید",
    noExercisesInDay: "هنوز حرکتی برای این روز تعریف نشده است.",
    addFirstExercisePrompt: "از منوی بالا یک حرکت از بانک انتخاب کنید یا حرکت جدیدی بسازید.",
    confirmRemoveExerciseFromDay: "آیا از حذف این حرکت از روز جاری مطمئن هستید؟",
    editDayExercisesJsonTitle: "ویرایش ساختار JSON تمرینات این روز",
    jsonSaveBtn: "اعمال تغییرات JSON",
    customExerciseNameLabel: "نام حرکت:",
    customExerciseNamePh: "مثال: کشش پیریفورمیس روی صندلی",
    customExerciseTargetLabel: "عضلات هدف:",
    customExerciseTargetPh: "مثال: سرینی، عصب سیاتیک",
    customExerciseCategoryLabel: "دسته‌بندی:",
    customExerciseDifficultyLabel: "سطح دشواری:",
    customExerciseSetsLabel: "تعداد ست:",
    customExerciseRepsLabel: "تکرارها:",
    customExerciseRepsPh: "مثال: ۱۰ تکرار یا ۳۰ ثانیه",
    customExerciseRestLabel: "استراحت:",
    customExerciseRestPh: "مثال: ۲۰ ثانیه",
    customExerciseDurationLabel: "مدت کل (دقیقه):",
    customExerciseDescLabel: "دستورالعمل و نحوه انجام حرکت:",
    customExerciseDescPh: "نحوه اجرای صحیح را گام به گام بنویسید...",
    customExercisePrecautionsLabel: "نکات ایمنی و موارد احتیاط:",
    customExercisePrecautionsPh: "مثال: در صورت درد زانو زاویه را کاهش دهید...",
    customExerciseEquipmentLabel: "تجهیزات مورد نیاز:",
    customExerciseEquipmentPh: "مثال: مت، کش بدنسازی، حوله...",
    saveAndAddToDayBtn: "ثبت و افزودن به روز",
    copyTemplate: "کپی الگو",
    sampleCopied: "نمونه ساختار JSON کپی شد.",
    programStartImportBtn: "درون‌ریزی و ذخیره در دیتابیس",
    programJsonEmptyError: "لطفاً محتوای JSON برنامه تمرینی را وارد کنید.",
    programJsonSyntaxError: "خطای نحوی در JSON: {{err}}",
    catRehab: "فیزیوتراپی و اصلاحی",
    catCardio: "کاردیو و هوازی",
    catStrength: "قدرتی و استقامتی",
    catMobility: "تحرک‌پذیری و کششی",
    rehabSets: "ست",
    rehabReps: "تکرار",
    rehabRest: "استراحت",
    rehabDuration: "مدت",
    rehabTargetMusclesShort: "عضلات هدف",
    rehabEquipmentShort: "تجهیزات",
    rehabPrecautionsShort: "احتیاط",
    rehabCategoryShort: "دسته‌بندی",
    rehabDifficultyShort: "سطح",
    rehabNoDescription: "بدون توضیحات تکمیلی",
    rehabEditTitle: "ویرایش عنوان و ویژگی‌ها",
    rehabDeleteTitle: "حذف برنامه",
    syncCloudTooltip: "همگام‌سازی با پایگاه داده Cloudflare D1",
    syncCloudDbTooltip: "همگام‌سازی با پایگاه داده Cloudflare D1",
    selectProgramError: "لطفاً یک برنامه تمرینی را انتخاب کنید.",
    noMultiDayProgramsWarning: "هنوز برنامه چندروزه‌ای ایجاد نکرده‌اید. ابتدا در بخش «برنامه‌های چندروزه» یک برنامه بسازید.",
    dayPrefix: "روز",
    exerciseAddedToProgramSuccess: "حرکت «{{name}}» با موفقیت به برنامه تمرینی افزوده شد.",
    dayDefaultTitle: "روز {{day}} — ریکاوری و تقویت",
    dayNumberFallback: "روز {{day}}",
    dayNotesLabel: "توضیحات روز",
    noExercisesInDayWarning: "هیچ حرکتی در این روز ثبت نشده است. روی دکمه ویرایش کلیک کنید.",
    exercisesCountUnit: "حرکت",
    rehabRestDefault: "۲۰ ثانیه",
    rehabFilterAll: "همه حرکات",
    rehabFilterGlobal: "عمومی",
    rehabFilterPersonal: "شخصی",
    rehabScopeGlobalBadge: "عمومی",
    rehabScopePersonalBadge: "شخصی",
    rehabScopeGlobalDesc: "تمرین عمومی مشترک برای همه کاربران",
    rehabScopePersonalDesc: "تمرین شخصی شما",
    confirmCreatePersonalCopy: "این حرکت عمومی است و مستقیماً تغییر نمی‌کند. آیا مایلید یک نسخه شخصی از آن ایجاد شود تا تغییرات دلخواهتان را روی آن اعمال کنید؟",
    createPersonalCopyTooltip: "ایجاد نسخه شخصی برای ویرایش",
    globalExerciseLockedTooltip: "حرکات عمومی محفوظ بوده و قابل حذف مستقیم نیستند",
    createPersonalCopyConfirmPrompt: "برای اعمال تغییرات روی این حرکت عمومی، یک نسخه شخصی ایجاد می‌شود. ادامه می‌دهید؟",
    addToMyProgramTooltip: "افزودن این حرکت به برنامه‌های تمرینی چندروزه شما",
    createPersonalCopyTooltip2: "کپی کردن این حرکت عمومی در لیست تمرینات شخصی خود تا بتوانید آن را تغییر دهید",
    viewCompleteDetailsTooltip: "مشاهده جزئیات کامل، فیلم، تصویر، عضلات هدف و احتیاط‌ها",
    noExercisesInScopeCategory: "هیچ حرکتی در این دسته‌بندی یافت نشد.",
    noPersonalExercisesYet: "شما هنوز هیچ حرکت شخصی ایجاد نکرده‌اید. با افزودن حرکت جدید یا ایجاد نسخه شخصی از حرکات عمومی شروع کنید.",
    copying: "در حال کپی...",
    createPersonalCopy: "ایجاد نسخه شخصی",
    publishToGlobal: "انتشار در بانک عمومی",
    publishToGlobalTooltip: "انتشار این تمرین در بانک حرکات عمومی برای استفاده همه کاربران (مخصوص مدیریت)",
    publishingToGlobal: "در حال انتشار...",
    publishToGlobalConfirm: "آیا از انتشار این تمرین در بانک عمومی دیتابیس D1 اطمینان دارید؟ پس از انتشار، این تمرین برای همه کاربران به صورت عمومی و استاندارد در دسترس خواهد بود.",
    publishToGlobalSuccess: "تمرین «{{name}}» با موفقیت در بانک حرکات عمومی دیتابیس D1 منتشر شد.",
    publishToGlobalError: "خطا در انتشار تمرین در بانک عمومی: {{err}}",
    publishToGlobalForbidden: "تنها حساب کاربری مدیریت (salim.zarepour@gmail.com) مجاز به انتشار تمرینات در بانک عمومی است.",
    publishToGlobalGenericError: "خطا در انتشار تمرین در بانک عمومی",
    publishAllToGlobal: "انتشار همه حرکات شخصی در بانک عمومی",
    publishAllToGlobalTooltip: "انتقال و انتشار یکپارچه تمامی تمرینات شخصی واجد شرایط به بانک عمومی دیتابیس D1 (مخصوص مدیریت)",
    publishAllConfirmTitle: "انتشار دسته‌جمعی تمرینات در بانک عمومی",
    publishAllConfirmDesc: "آیا مطمئن هستید که می‌خواهید تمام {{count}} حرکت شخصی را در بانک عمومی دیتابیس D1 منتشر کنید؟ این عمل تمریناتی که قبلاً منتشر شده‌اند را بدون ایجاد رکورد تکراری بروزرسانی کرده و تمرینات جدید را به صورت عمومی ثبت می‌کند.",
    publishAllStatusProcessing: "در حال پردازش و همگام‌سازی دسته‌جمعی با بانک عمومی D1...",
    publishAllResultsTitle: "نتیجه انتشار دسته‌جمعی در بانک عمومی",
    publishAllStatTotal: "کل بررسی‌شده",
    publishAllStatPublished: "تازه منتشرشده",
    publishAllStatAlready: "از قبل منتشرشده (همگام)",
    publishAllStatFailed: "ناموفق",
    publishAllNoPersonalFound: "هیچ تمرین شخصی برای انتشار در بانک عمومی یافت نشد.",
    publishAllCloseBtn: "بستن و بازخوانی",
    startPublishAllBtn: "شروع انتشار دسته‌جمعی",
    publishedBadge: "منتشرشده در عمومی",
    publishedBadgeTooltip: "این تمرین در بانک عمومی ثبت شده است و با هر ویرایش شما به طور خودکار همگام می‌شود.",
    syncGlobalNotice: "همگام‌سازی خودکار با نسخه عمومی فعال است",
    editLibraryItem: "ویرایش حرکت",
    editLibraryItemTooltip: "ویرایش عنوان، توضیحات، ست‌ها و رسانه‌های این حرکت",
    globalEditNotAllowedWithCopy: "حرکات عمومی سیستم فقط توسط مدیر قابل ویرایش هستند. مایلید ابتدا نسخه شخصی این حرکت را ایجاد کنید؟",
  },
  en: {
    languageLearningTitle: "Language Learning",
    languageLearningSubtitle: "Daily 4-skill practical language training system",
    langLearnSetupTitle: "Language Learning Initial Setup",
    langLearnSetupSubtitle: "Choose your native language and the target languages you want to master.",
    langLearnSourceLang: "Native / Source Language",
    langLearnTargetLangs: "Target Languages (Languages to learn)",
    langLearnDailyAvail: "Total Daily Available Time (Minutes)",
    langLearnDailyAvailDesc: "The system will automatically balance this time across the 4 core skills.",
    langLearnStartBtn: "Start Learning Journey",
    langLearnSaveSettings: "Save Settings & Goals",
    langLearnAddTargetBtn: "Add New Target Language",
    langLearnTargetLangName: "Target Language Name",
    langLearnTargetLangLevel: "Current CEFR Level",
    langLearnChangeLevel: "Change Proficiency Level",
    langLearnLevelChangedSuccess: "Language level updated successfully. New exercises will adapt to this level.",
    langLearnEditTargetBtn: "Edit Language & Level",
    langLearnDailyGoalMinutes: "Daily Goal for this Language (Minutes)",
    langLearnListening: "Listening",
    langLearnSpeaking: "Speaking",
    langLearnReading: "Reading",
    langLearnWriting: "Writing",
    langLearnListeningDesc: "News audio, podcasts, videos, and oral comprehension",
    langLearnSpeakingDesc: "Simulated conversation, pronunciation, and dialogue",
    langLearnReadingDesc: "Graded reading, easy articles, and vocabulary in context",
    langLearnWritingDesc: "Daily journaling, composition, and AI grammar review",
    langLearnTodayPlanTitle: "Today's Language Learning Plan",
    langLearnRecommendedSplit: "Smart time distribution across 4 core skills",
    langLearnCustomisePlan: "Manually Adjust Planned Times",
    langLearnTotalPlanned: "Total Planned: {{min}} min",
    langLearnCompletedMin: "{{min}} min completed",
    langLearnOfPlanned: "of {{total}} min",
    langLearnAllSkillsDone: "🎉 Awesome! All planned skills for today have been completed.",
    langLearnStartPractice: "Practice",
    langLearnPracticeTitle: "Interactive Practice Room",
    langLearnAudioListen: "Play & Listen to Audio",
    langLearnSpeakNow: "Practice Speaking & Pronunciation",
    langLearnReadContent: "Reading Material & Comprehension",
    langLearnWriteResponse: "Your Written Response or Composition:",
    langLearnVoiceInputTip: "Use the microphone button to speak and convert your voice to text.",
    langLearnGenerateAiExercise: "Generate AI Practice Exercise",
    langLearnRequestAiFeedback: "Check & Correct with AI",
    langLearnAiGenerating: "Generating exercise tailored to your level...",
    langLearnAiFeedbackTitle: "AI Feedback, Corrections & Grammar Tips",
    langLearnCorrections: "Corrected Segments:",
    langLearnOriginal: "Original:",
    langLearnCorrected: "Corrected:",
    langLearnImprovementTip: "Actionable Tip:",
    langLearnCompleteSession: "Complete & Record Session",
    langLearnSessionSaved: "Session saved to cloud database successfully.",
    langLearnResourcesTitle: "Curated External Learning Resources",
    langLearnResourcesSubtitle: "Verified websites and channels to practice each skill",
    langLearnFilterAll: "All Skills",
    langLearnAddResourceBtn: "Add Custom Resource Link",
    langLearnResourceTitle: "Resource Title",
    langLearnResourceUrl: "URL",
    langLearnResourceSource: "Source / Provider Name",
    langLearnDifficultyLevel: "Difficulty Level",
    langLearnVisitResource: "Open External Resource",
    langLearnDeleteResource: "Delete Resource",
    langLearnStatsTitle: "Overall Progress & Skill Stats",
    langLearnTotalTime: "Total Time Practiced",
    langLearnSessionsCount: "Sessions Completed",
    langLearnStreakDays: "Daily Practice Streak",
    langLearnHistoryTitle: "Recorded Practice History",
    langLearnNoHistory: "No sessions recorded for this language yet. Start your first practice today!",
    langLearnTargetLangRequired: "At least one target language is required.",
    langLearnSelectSourcePlaceholder: "Select your native language",
    langLearnSelectTargetPlaceholder: "Select target language",
    langLearnLanguagePersian: "Persian",
    langLearnLanguageSwedish: "Swedish",
    langLearnLanguageEnglish: "English",
    langLearnLanguageGerman: "German",
    langLearnLanguageFrench: "French",
    langLearnLanguageSpanish: "Spanish",
    langLearnLanguageItalian: "Italian",
    langLearnLanguageArabic: "Arabic",
    langLearnLanguageTurkish: "Turkish",
    langLearnLevelA1: "Level A1 (Beginner)",
    langLearnLevelA2: "Level A2 (Elementary)",
    langLearnLevelB1: "Level B1 (Intermediate)",
    langLearnLevelB2: "Level B2 (Upper Intermediate)",
    langLearnLevelC1: "Level C1 (Advanced)",
    langLearnLevelAll: "Suitable for all levels",
    dashLanguageLearningTitle: "Language Learning: Daily Plan",
    dashLanguageLearningProgress: "{{completed}} of {{total}} min practiced",
    sleep: "Sleep Hours",
    water: "Water Intake",
    weight: "Weight & Goal Tracker",
    dailyScratchpad: "Daily Notes & Quick Tasks",
    swedishTitle: "Swedish Education",
    viewingDate: "Viewing another date",
    schedulesCurrentActiveTaskTitle: "📌 Your Current Active Task",
    schedulesTodayBadge: "Today",
    prevDay: "Previous Day",
    nextDay: "Next Day",
    schedulesBackToToday: "🕒 Back to Today",
    schedulesNowBadge: "Active Now | NOW",
    schedulesNextBadge: "Next Event | NEXT",
    dashTodaysPlanTitle: "Daily Plan & Tasks",
    dashLoadingPlan: "Loading today's plan...",
    dashErrorLoadingPlan: "Failed to load today's plan",
    retry: "Retry",
    dashTasksProgressSummary: "{{completed}} of {{total}} activities completed",
    dashTodayExercisePlanTitle: "Today's Exercise Plan: Physiotherapy & Spine Rehab",
    dashRehabProgress: "{{completed}} of {{total}} exercises completed ({{percent}}%)",
    dashAllExercisesDone: "🎉 Excellent! All scheduled exercises for today are completed.",
    dashExpandExercises: "Show full list of exercises",
    dashCollapseExercises: "Collapse exercises",
    dashNoExercisesForToday: "No exercises defined for today's program.",
    dashManageInRehab: "Manage in Rehab Module",
    dashViewExerciseList: "View day's exercises ({{count}} moves)",
    dashNoTasksToday: "No routines scheduled for this day",
    dashRestDayTitle: "Rest & Recovery Day",
    dashRestDayDesc: "No mandatory tasks scheduled for this day.",
    schedulesAddActivity: "+ Add Activity",
    dashNextCardTitle: "Next",
    dashTaskRequired: "Required",
    dashTaskOptional: "Optional",
    dashAllTasksDoneCongrats: "All scheduled activities for today are completed!",
    sleepStartTime: "Bedtime",
    sleepWakeTime: "Wake Time",
    weightTargetReached: "🎉 Target weight reached",
    weightTargetProgress: "Goal: {{target}} kg ({{remaining}} kg left)",
    weightTargetEstDate: "Estimated target date:",
    viewProfileMetrics: "View Weight Chart & Tracking",
    quickAccessModules: "Quick Access Modules",
    newsBulletin: "View News Bulletin",
    rehabTitle: "Physiotherapy & Spine Rehab",
    fatLossTitle: "Fat Loss & Cardio",
    nutritionTitle: "Nutrition & Calories",
    notesTitle: "Notes & Journal",
    schedulesTitle: "Weekly Planner & Daily Routines",
    allCategories: "All Categories",
    taskReqStandard: "Required / Standard",
    taskReqBonus: "Optional / Bonus",
    schedulesCatWork: "Work & Employment",
    schedulesCatRehab: "Physiotherapy & Back Rehab",
    schedulesCatFatLoss: "Workout & Cardio",
    schedulesCatSwedish: "Education & Learning (Swedish/SFI)",
    schedulesCatNutrition: "Nutrition & Health",
    schedulesCatRoutine: "Personal Routine",
    schedulesNoTasksFilter: "No tasks found matching your filter.",
    schedulesCurrentActiveTask: "Active Now",
    schedulesSelectDayToManage: "Select day of the week to edit and plan:",
    schedulesCopyDayToAllWeek: "Copy this day to all week",
    schedulesCopyDayToAllWeekTooltip: "Copy all tasks of selected day to all days of the week",
    schedulesFormDay: "Day of the week:",
    schedulesFormCategory: "Category:",
    isRequiredTaskLabel: "Required activity (in daily mandatory task list)",
    schedulesFormIsWork: "Register as work shift",
    schedulesFormIsEducation: "This is an educational activity (course/study/music)",
    schedulesFormPhoneAlarm: "Alarm & Notification",
    schedulesFormGoogleCal: "Google Calendar (.ics)",
    schedulesAddActivityTitle: "Define New Activity in Weekly Plan",
    schedulesEditActivityTitle: "Edit Activity in Weekly Plan",
    schedulesErrorSave: "Error saving activity to D1 database",
    schedulesErrorDelete: "Error deleting activity from D1 database",
    schedulesAddRoutineBtn: "Add New Activity",
    schedulesRehabDescriptionPattern: "Physiotherapy & Spine Recovery Exercises ({{count}} moves)",
    schedulesTodayScheduleTitle: "Today's Schedule & Routine ({{day}})",
    schedulesTodayScheduleSub: "Mark your required tasks as done to update your daily status.",
    schedulesAddQuickRoutine: "Add to Today",
    schedulesNoRoutinesToday: "No routines scheduled for today!",
    schedulesNoRoutinesTodayDesc: "You can define work, educational, or athletic routines for today using the \"Weekly Management\" tab or the add button.",
    schedulesGoToManage: "Go to Weekly Management",
    schedulesCompletedStatus: "Completed",
    schedulesMarkComplete: "Mark Complete",
    schedulesRoutinesForDay: "Registered activities for {{day}}",
    schedulesFormTitlePlaceholder: "e.g. Work shift, physiotherapy, Swedish class, music practice...",
    schedulesFormDescPlaceholder: "Optional description, goals, or execution details for this activity...",
    markCompleted: "Mark Completed",
    schedulesPendingStatus: "Not Completed",
    doneUnit: "done",


    manageContactsHeaderBtn: "Approved Contacts ({{count}})",
    shopShareModalTitle: "Family Shopping List Sharing",
    shopShareModalSubtitle: "Share \"{{name}}\"",
    shopShareModalDesc: "Select an approved contact with one click or enter a new email.",
    approvedContactsQuickTitle: "Quick share with approved contacts:",
    manageContactsBtn: "Manage Contacts",
    noContactsYetHint: "No approved contacts added yet.",
    addFirstContact: "Add new contact (spouse, sibling, colleague...)",
    shopRecipientEmail: "Or enter contact email manually:",
    autoSaveToContactsCheck: "Automatically save this email to my approved contacts",
    shopMembersWithAccess: "Members with access to this list:",
    contactsManagerSubtitle: "Approved contacts list & authorized members",
    contactsManagerTitle: "Sharing Contacts Management",
    contactsManagerDesc: "Save your spouse, housemate, or colleagues' information so you don't need to retype emails when sharing.",
    addNewContactHeading: "Add New Contact:",
    contactNameLabel: "Name or title (e.g., Wife - Mary):",
    contactNamePlaceholder: "Contact name or title",
    contactEmailLabel: "Email Address:",
    contactRelationLabel: "Relationship / Category:",
    saveContactBtn: "Save Contact",
    savedContactsListHeader: "Saved Approved Contacts ({{count}}):",
    searchContactsPlaceholder: "Search contacts...",
    noContactsInList: "No approved contacts recorded. Add a new contact using the form above.",
    deleteContact: "Delete Contact",
    relationFamily: "Family (Spouse / Child / Sibling...)",
    relationFriend: "Friend / Housemate",
    relationWork: "Colleague / Work",
    relationOther: "Other",
    shopSharedSuccessWithName: "List successfully shared with {{name}} ({{email}}).",

    batchPastePlaceholder: "Paste your bank statement or export text here. Example:\n2026-08-01, Hemköp Stockholm, -485 SEK, Hemköp Card\n2026-08-02, SL Buss Månadskort, -970 SEK, Handelsbanken Debit\n2026-08-03, Swish to Ali, -250 SEK\n2026-08-07, Lön Handelsbanken, +38500 SEK",
    cancel: "Cancel",
    learningAiResponseTag: "AI Response",
    learningDocumentExtracted: "Extracted text from this document (summary 1800 chars):\n{{text}}",
    learningDocumentName: "Attachment file name: {{name}}",
    learningHeaderDesc: "Manage training courses, extract docs and videos, and interactive AI private tutoring",
    learningHeaderTitle: "Smart Learning Assistant & Resource Manager",
    learningTeacherNoteTag: "Teacher Note",
    learningUserMsgTag: "User Input / Topic",
    learningVideoUrlPlaceholder: "https://www.youtube.com/watch?v=... or direct video link",
    newsActiveTopicsLabel: "Active Topics for Live News Monitoring:",
    newsAddAndMonitorBtn: "Add & Monitor News",
    newsAiAnalyzingWait: "Monitoring and retrieving the latest 7 days news with AI...",
    newsAiSearchingEvents: "Searching for events and developments regarding your topics",
    newsCopiedSuccess: "Copied!",
    newsCopyFullReport: "Copy Full Report",
    newsDeleteTopicTooltip: "Delete topic",
    newsEmptyDescNoTopics: "Simply enter your favorite topics or cities in the box above to receive breaking weekly news.",
    newsEmptyDescReady: "Click the button below to have AI monitor and analyze the latest news on your topics.",
    newsEmptyTitleNoTopics: "Add Your Favorite Topics",
    newsEmptyTitleReady: "Ready to fetch latest 7 days news",
    newsErrorAddTopicFirst: "Please add at least one favorite topic first.",
    newsErrorAiFetch: "Error fetching news from AI. Please check internet connection.",
    newsFetchAiBtn: "Monitor & Fetch Last 7 Days News with AI",
    newsFetchingStatus: "Fetching & analyzing news...",
    newsHeaderDesc: "Monitor latest tech developments, AI-curated daily news briefings and event analyses",
    newsHeaderTitle: "Smart News, AI & Technology Radar",
    newsNoSearchResults: "### 🔍 No results found matching \"{{query}}\".\n\nPlease search for another term or click the refresh news button.",
    newsNoTopicsHint: "No topics added yet. Type your desired topic in the input box above!",
    newsPresetAi: "Latest AI & LLM News",
    newsPresetAiDesc: "New Gemini, OpenAI, Claude models and AI tools",
    newsPresetHardware: "Smart Glasses & Wearable Hardware",
    newsPresetHardwareDesc: "Wearable gadgets like Ray-Ban Meta and Vision Pro",
    newsPresetIsfahan: "City Events & Regional Developments",
    newsPresetIsfahanDesc: "Monitor urban news, projects, and regional events",
    newsPresetSemiconductors: "Tech Stocks & Semiconductor Market",
    newsPresetSemiconductorsDesc: "Analysis of chipsets, hardware, and tech market",
    newsPresetWulf: "Stocks & AI Data Centers",
    newsPresetWulfDesc: "Latest price analysis, earnings reports and contracts",
    newsQuickInputPlaceholder: "Type your topic (e.g., Tech news, AI stocks, Smart Glasses...)",
    newsQuickPresetsTitle: "Quick topic suggestions:",
    newsSaveAndConfirmBtn: "Save & Confirm",
    newsSearchPlaceholder: "Search received news...",
    newsSettingsModalTitle: "Topic Settings & Briefing Tone",
    newsSettingsToneBtn: "Settings & Tone",
    newsTitle: "News & AI Radar",
    newsToneAnalytical: "🎯 Analytical & Executive (Focus on market trends & opportunities)",
    newsToneDeepTech: "🔬 In-depth & Technical (Scientific & algorithm details)",
    newsToneFastSummary: "⚡ Quick & Bulleted (Concise summaries & key takeaways)",
    newsToneLabel: "News Briefing Personality & Tone:",
    newsToneStandard: "📰 Fluent Journalism & Engaging News",
    newsTopicLiveMonitorDesc: "Live monitoring of last 7 days news about {{topic}}",
    newsUpdate7DaysBtn: "Update Last 7 Days News",
    newsYourTopics: "Your Topics:",
    shopAllBoughtHint: "All items have been purchased or no items found in this category.",
    shopListEmptyHint: "This notebook is empty! Add needed items using the box above or quick presets.",
    shopOneKg: "1 kg",
    shopPresetBBQ: "BBQ & Picnic",
    shopPresetFruits: "Fruits & Vegetables",
    shopPresetHome: "Weekly Home Groceries",
    shopPresetOnline: "Online Shopping",
    shopPresetPharmacy: "Pharmacy & Health",
    shopPresetSupermarket: "Groceries & Supermarket",
    shopQty1kg: "1 kg",
    shopQty1pack: "1 pack",
    shopQty1pcs: "1 pcs",
    shopQty2kg: "2 kg",
    shopQty2pack: "2 packs",
    shopQty2pcs: "2 pcs",
    shopQty3kg: "3 kg",
    shopQty5kg: "5 kg",
    shopQtyHalfKg: "0.5 kg",
    "2d": '2D',
    actions: 'Actions',
    activeMonthlySavingsBudget: 'Active monthly savings budget:',
    activities: 'Activity Tracker',
    activityAthlete: 'Athlete / Heavy daily training',
    activityHigh: 'High Activity (6-7 days/week)',
    activityLight: 'Light Activity (1-3 days/week)',
    activityModerate: 'Moderate Activity (3-5 days/week)',
    activitySedentary: 'Sedentary / Little to no exercise',
    actualSpentHeader: 'Actual Spent:',
    add: 'Add',
    addBtn: 'Add',
    addFoodLog: 'Log New Meal',
    addGoogleCalendar: 'Add Directly to Google Calendar',
    addInvoiceCostBtn: 'Add Invoice / Expense',
    addItem: 'Add Item to List',
    addItemTitle: 'Item Title / Name',
    addNewRow: 'Add new row',
    addNewRowBtn: 'Add New Row',
    addReminder: 'Add New Reminder',
    addReminderBtn: 'Add New Reminder',
    addScheduleTask: 'Add New Schedule Entry',
    addTodoPlaceholder: 'Add new task...',
    addTransaction: 'Add New Transaction',
    adminBadge: 'Super Admin',
    advisorClearConfirm: 'Are you sure you want to clear and restart the financial advisor chat history?',
    advisorHeaderDesc: 'Live analysis of net income, spending behavior, budget caps, and financial goals for strategic recommendations',
    advisorLiveAnalysisDesc: 'Real-time analysis of net income, spending habits, budget caps, and savings goals for strategic guidance',
    advisorTab: 'AI Financial Advisor',
    advisorWelcomeText: 'Hello! I am your AI Senior Financial Advisor and Wealth Strategist. I have real-time awareness of your net income, expenses, budget caps, item consumption patterns, and active financial goals. Feel free to ask any question.',
    afterRecordingBudgetLabel: 'After recording:',
    afterRecordingMsg: 'After recording: {{amount}} {{currency}}',
    aiAnalysisTab: 'AI News Briefing',
    aiBriefingTitle: 'Exclusive AI Summary Briefing',
    aiFinancialAdvisor: 'AI Financial Advisor',
    aiScannerTab: 'AI Invoice Scanner',
    alertAiAnalysisError: 'AI analysis error',
    alertAiScanError: 'AI communication error while scanning receipt',
    alertBatchImportSuccess: '{{count}} transactions were successfully added to your ledger.',
    alertInvalidFileType: 'Please select a PDF, image, or text file.',
    alertInvoiceSavedSuccess: 'Invoice with all itemized rows has been recorded successfully!',
    alertNoRowsExtracted: 'No rows could be extracted. Please check the format of the copied text.',
    alertNoTextFoundInReceipt: 'No readable text was found in the receipt/invoice.',
    alertPasteBankStatement: 'Please paste your bank statement text in the box above first.',
    alertReceiptScannedSuccess: 'Receipt scanned and line items extracted successfully.',
    alertScanOrEnterFirst: 'Please scan a receipt or enter text first.',
    all: 'All',
    allCardsOption: '💳 All Cards & Accounts',
    allTxAssignedToCard: 'All {{count}} transactions will be assigned to this card',
    allTxsAssignedToCard: 'All {{count}} transactions will be assigned to this card.',
    allergiesDefault: 'No known allergies',
    allergiesNone: 'No known allergies',
    allocationSurplusOverCap: 'Excess allocation over total expense cap:',
    amount: 'Amount',
    amountColumnHeader: 'Amount',
    analyticsDashboardDesc: 'Distribution of items and invoice line-item expenses',
    analyticsDashboardTitle: 'Itemized & Spending Analytics',
    appAdminVersionList: 'View Version Changelog (Admin Only)',
    appAdminVersionListCustom: 'View Version Changelog (Admin salim.zarepour)',
    appCheckingAccount: 'Checking your account status...',
    appCloudDb: 'D1 Cloud',
    appCloudDbDesc: 'D1 Cloud Database • Secure Storage',
    appComponentStandby: 'Modules are in standby mode.',
    appLogoutMenu: 'Sign Out',
    appMobileMenuTitle: 'Progress Navigation',
    appName: 'Progress - Life & Health Manager',
    appShortName: 'Progress',
    appSlogan: 'Online Daily Progress Planning & Monitoring System',
    appVersionOnly: 'v{{version}}',
    appVersionPrefix: 'Progress v{{version}}',
    appWeeklyReminderBody: 'It is time for the activity "{{title}}".',
    appWeeklyReminderTitle: '⏰ Weekly Reminder: {{title}}',
    askDoctor: 'Describe your symptoms or ask a medical question...',
    askDoctorPlaceholder: 'Describe your medical symptoms, history, or questions...',
    autoAllocateCaps: 'Auto-estimate category caps ({{pct}}%)',
    back: 'Back',
    balance: 'Balance',
    balanceLabel: 'Remaining:',
    balanceShort: 'Balance: {{amount}} {{currency}}',
    baseCurrencyLabel: 'System Base Currency:',
    baseCurrencySyncDesc: 'Changing this option syncs all budgeting calculations, metric cards, AI scanner, and financial goals.',
    batchCardAccountConnected: 'Card / account linked to all transactions in this statement:',
    batchColAmount: 'Amount ({{currency}})',
    batchColTxTitle: 'Transaction Title',
    batchConfirmSave: 'Confirm & Save All to Database',
    batchDuplicate: '⚠️ Duplicate with {{title}} (skip redundant entry)',
    batchExtractedCount: 'Extracted transactions ({{count}} items)',
    batchImportDesc: 'Copy and paste statement text or CSV directly into the box below (no file upload required).',
    batchImportHeaderDesc: 'Copy your bank/store statement text or CSV and paste it directly into the box below (no file upload required).',
    batchImportHeaderTitle: 'Smart Batch Import of Bank Transactions & Statements',
    batchImportSectionTitle: 'Smart Batch Import of Bank Transactions & Statements',
    batchImportTab: 'Batch Statement Import',
    batchMatchBank: '🔄 Match with bank tx {{title}} (receipt details replace raw bank entry)',
    batchMatchPurchase: '⚡ Match with purchase {{title}} (bank card applied to purchase)',
    batchNew: '🟢 New',
    batchPreviewTableTitle: 'Extracted transactions preview ({{count}} items)',
    batchReadyToImportCount: '{{count}} selected transactions are ready for final import.',
    batchSelectedReady: '{{count}} selected transactions are ready for final recording.',
    batchTotalExpense: 'Total expenses: {{amount}} {{currency}}',
    batchTotalIncome: 'Total income/inflow: {{amount}} {{currency}}',
    batchUpload: 'Batch CSV / Statement Upload',
    bellyFat: 'Cardio & Fat Loss',
    bellyFatHeaderDesc: 'High-intensity interval fat burn workouts, custom set timers, and calorie burn estimates',
    bellyFatHeaderTitle: 'Cardio, Belly Fat Burn & Fitness',
    billsCategory: '💳 Bills & Finance',
    birthdaysCategory: '🎂 Birthdays & Events',
    bmiCategoryLabel: 'BMI Index Status',
    bought: 'Purchased',
    boughtCount: 'Purchased',
    branding: 'Theme & Colors',
    brandingHeaderDesc: 'Select accent color theme, dark/light mode, and customize card UI styles',
    brandingHeaderTitle: 'App Theme, Colors & Customization',
    budgetAllocationPercent: '{{percent}}% of Net Income',
    budgetAllocationSummary: 'Expenses ({{expense}}%) + Savings ({{saving}}%) = 100%',
    budgetAndNetIncome: 'Budgeting & Net Income',
    budgetCapHeader: 'Budget Cap:',
    budgetCapShort: 'Cap: {{amount}} {{currency}}',
    budgetExceeded: 'Budget Exceeded:',
    budgetExceededMsg: 'Budget exceeded: {{amount}} {{currency}} overspent!',
    budgetHistoryDesc: 'Comparative analysis of budget caps, actual spending, and balance/surplus across previous months',
    budgetHistorySectionDesc: 'Comparative review of budget caps, actual spending, and balance/overspend in previous months',
    budgetHistorySectionTitle: 'Budget History & Multi-Month Performance Summary',
    budgetHistoryTitle: 'Budget Performance History & Summary',
    budgetPatternNote: 'Budget cap template is automatically applied to all months; changing months is for reviewing that period\\\\\\\\\\\\\\\'s actual expenses.',
    budgetRemainingLabel: '✓ Balance: {{amount}} {{currency}}',
    budgetSettingsDesc: 'Configure monthly income and expense limits',
    budgetSettingsTitle: 'Budget Settings',
    budgetSpentShort: 'Spent: {{amount}} {{currency}}',
    budgetStatusLabel: 'Budget Status:',
    budgetSurplusLabel: '⚠️ Surplus: {{amount}} {{currency}}',
    budgetTotalUsedRatio: '{{pct}}% of total budget used',
    budgetUsagePercent: '{{percent}}% of budget cap',
    budgetUsageStatusIn: 'Budget usage status in {{month}}',
    budgetUsageStatusInMonth: 'Budget consumption in {{month}}',
    budgets: 'Budgets & Goals',
    bulkDeleteBtn: 'Delete Selected',
    calculateAiCalories: 'Calculate Target Calories with AI',
    calendarTab: 'Monthly Calendar View',
    calories: 'Calories',
    caloriesGoal: 'Daily Target Calories',
    capLabel: 'Cap:',
    carbs: 'Carbohydrates',
    carbsGoal: 'Carbohydrates (g)',
    cardBreakdownTitle: 'Breakdown by Cards & Accounts',
    cardConnectedToAllTxs: 'Card / account linked to all transactions in this statement:',
    catCarMaintenance: 'Car & Insurance',
    catCharityGifts: 'Gifts & Charity',
    catClothing: 'Clothing',
    catEducation: 'Education',
    catElectronics: 'Electronics',
    catEntertainment: 'Entertainment',
    catFamily: 'Family',
    catGroceries: 'Groceries',
    catHealth: 'Health & Care',
    catHomeDecor: 'Home & Furniture',
    catHousing: 'Housing',
    catInvestment: 'Investments',
    catMain: 'Main & Assistants',
    catOther: 'Other',
    catPets: 'Pets',
    catPlanning: 'Planning, Learning & Reports',
    catRestaurants: 'Restaurants',
    catSalary: 'Salary & Wages',
    catSettings: 'Settings & Admin',
    catSubscriptions: 'Subscriptions',
    catTransport: 'Transport',
    catUtilities: 'Utilities',
    categoriesWithBudgetCapCount: '{{count}} categories with budget cap',
    categoriesWithCapCount: '{{count}} categories with budget cap',
    categoriesWithoutCapTitle: 'Categories without specific caps (spending overview only):',
    category: 'Category',
    categoryCapsDesc: 'Set maximum spending caps for housing, groceries, utilities, transport, etc. (enter 0 for uncapped categories)',
    categoryCapsLabel: 'Category Budget Limits:',
    categoryInvestment: 'Investments',
    categoryPets: 'Pets',
    categorySalary: 'Salary',
    categorySubscriptions: 'Subscriptions & SaaS',
    categoryTitle: 'Item Category',
    clearAndStartChat: 'Clear & Start Conversation',
    clearChatHistoryTitle: 'Clear Chat History',
    clearCompleted: 'Clear Purchased Items',
    clearFilters: 'Clear Filters',
    close: 'Close',
    closeBtn: 'Close',
    cloudSyncActive: 'Cloud Sync Active',
    commonCancel: 'Cancel',
    confirm: 'Confirm',
    confirmBatchImportBtn: 'Confirm & Save All to Database',
    confirmClearAdvisorHistory: 'Are you sure you want to clear and reset the financial advisor chat history?',
    confirmDepositBtn: 'Confirm Deposit',
    createGoalBtn: 'Create Goal',
    createShoppingList: 'Create New Shopping List',
    currentCardsCount: 'Your current cards ({{count}} items):',
    currentExpensesShare: 'Current Living Expenses Share:',
    currentExpensesShareLabel: 'Current expenses share:',
    currentMonthBtn: 'Current Month',
    currentMonthLabel: 'Current Month',
    currentWeightLabel: 'Current Weight (kg)',
    dailyScore: 'Daily Score',
    darkMode: 'Dark Mode',
    dashAddBtn: 'Add',
    dashAllGoalsDone: '🎉 All daily exercises and goals completed!',
    dashBackToToday: 'Back to Today',
    dashBmiTarget: 'Anatomy Index & Weight Goal',
    dashCalorieExcessWarning: '⚠️ Calorie intake exceeded daily limit.',
    dashCalorieGoodDesc: 'Keep macronutrient ratios balanced to maintain or lose weight.',
    dashCaloriesToday: 'Calories Today',
    dashCompletedRemaining: 'Completed · {{remaining}} remaining',
    dashCurrentWeight: 'Current Weight: {{weight}} kg',
    dashDailyTasks: 'Daily Tasks Checklist (Today)',
    dashDiaryAdd: 'Add Physical Observations',
    dashDiaryTitle: 'Quick Review of Today\\\\\\\\\\\\\\\'s Status',
    dashDone: '✅ Done',
    dashEditProfile: 'Edit Profile & Calculations in Settings',
    dashFatDesc: '{{completed}} of {{total}} cardio activities done today',
    dashFatTitle: 'Fat Loss & Cardio Exercises',
    dashGoalsProgress: '⚡ {{completed}} of {{total}} goals completed today',
    dashGregorian: 'Gregorian:',
    dashHabitScore: 'Daily Habits Score',
    dashHeight: '| Height: {{height}} cm',
    dashHijri: 'Hijri:',
    dashHydration: 'Hydration Tracker',
    dashHydrationDesc: 'Drinking enough water protects spinal discs from shock.',
    dashIranEvent: 'Iranian Event:',
    dashLearningDesc: 'AI generated topics, notes and interactive quizzes',
    dashLearningTitle: 'Smart Learning Assistant',
    dashMaxScore: '/ {{max}} max',
    dashModulesChecklist: 'Quick Modules Checklist',
    dashMood: 'Mood:',
    dashNewTaskPlaceholder: 'Add new task for today... (e.g. meds, evening walk, Swedish study)',
    dashNewsDesc: 'Live monitoring of last 7 days news about your favorite topics and cities (e.g. economy or tech)',
    dashNewsHeadlines: '📌 Summary of latest news (Last 7 Days):',
    dashNewsLastUpdate: 'Last updated:',
    dashNewsLive: 'Live Analysis',
    dashNewsNoTopics: '✨ You haven\\\\\\\\\\\\\\\'t selected any news categories yet.',
    dashNewsTitle: 'AI Personalized News Radar',
    dashNewsTopics: 'Active Topics:',
    dashNewsView: 'View News & Analysis',
    dashNextDay: 'Next Day',
    dashNoSymptoms: 'No symptoms logged for today.',
    dashNoTasks: 'No tasks defined for today. Add one so you don\\\\\\\\\\\\\\\'t miss out!',
    dashNotDone: '❌ Off/Not Logged',
    dashNutritionDesc: 'Calories received today: {{calories}} kcal',
    dashNutritionTitle: 'Module 3 — Daily Nutrition Tracker',
    dashPainLevel: 'Spine Pain Level',
    dashPainLevelDesc: 'Level {{level}} of {{max}}',
    dashPrevDay: 'Previous Day',
    dashProgress: 'Program Progress',
    dashReadyForDay: '✨ Ready for an energetic and productive day',
    dashRehabDesc: '{{completed}} of {{total}} rehab exercises completed today',
    dashRehabTitle: 'Module 1 — Spine Rehab',
    dashRemainingKcalToTarget: 'Remaining to limit:',
    dashScheduleTitle: 'Module 5 — Weekly Routines & Schedules',
    dashScoreDesc: 'Composite index prioritizing spine rehab (40%) and belly fat cardio (25%).',
    dashScoreV2Title: 'Daily Performance Score',
    dashTimeWeightedPerformance: 'Daily Performance (Time-Weighted)',
    dashScheduledMinutesDone: '{{completed}} of {{total}} scheduled',
    dashTimeWeight: 'Time Weight: {{percent}}% ({{duration}})',
    dashTimeWeightedDesc: 'Precise time-weighted calculation based on total planned task duration',
    dashBonusMinutes: '+{{minutes}} bonus time',
    dashScoreV2Desc: 'Dynamic score calculated from due tasks in Weekly Planner (Single Source of Truth)',
    dashAvailablePoints: 'Available Points:',
    dashEarnedPoints: 'Earned Points:',
    dashBonusPoints: 'Optional Bonus Points:',
    dashCompletionRate: 'Completion Rate:',
    dashRequiredTasksCount: "Today's Required Tasks:",
    dashOpenWeeklyPlanner: 'Manage Weekly Planner',
    dashPointsShort: 'pts',
    dashTaskCompleted: 'Completed',
    dashTaskPending: 'Pending',
    dashTodayOccurrences: "Today's Scheduled Tasks & Routines",
    dashSelectedDayOccurrences: 'Scheduled Tasks & Routines for Selected Day',
    dashSelectedDay: 'Selected Day',
    dashSfiClass: 'Swedish Class: ',
    dashSfiDone: '✅ Attended',
    dashSfiNotDone: '❌ Absent/No Class',
    dashSleep: 'Daily Sleep Tracker',
    dashSleepBedtime: 'Bedtime:',
    dashSleepDesc: 'Sufficient sleep (7-8 hours) directly impacts spinal disc repair and back health.',
    dashSleepTarget: '/ 8 hrs goal',
    dashSleepWakeup: 'Wake up:',
    dashSwedenEvent: 'Swedish Event:',
    dashSwedishDesc: '{{completed}} of {{total}} Swedish self-study sections done today',
    dashSwedishTitle: 'Module 4 — Swedish Learning',
    dashSymptoms: 'Logged Physical Symptoms',
    dashTargetKcal: '/ {{target}} kcal',
    dashTasksCompleted: '{{completed}} of {{total}} tasks done',
    dashToday: 'Today',
    dashWeightGainRemaining: 'remaining to gain',
    dashWeightGoal: 'Your Weight Goal:',
    dashWeightLossRemaining: 'remaining to lose',
    dashWeightNoGoal: 'To set an accurate weight goal and calories, go to Settings.',
    dashWeightRemainingDiff: '({{diff}} kg {{status}})',
    dashWorkShift: 'Work Shift: ',
    dashboard: 'Health Dashboard',
    date: 'Date',
    dayFri: 'Fri',
    dayMon: 'Mon',
    dayOfWeekLabel: 'Day of Week',
    daySat: 'Sat',
    daySun: 'Sun',
    dayThu: 'Thu',
    dayTue: 'Tue',
    dayWed: 'Wed',
    decrease: 'Decrease',
    defaultCard: 'Bank Card',
    defaultCategoryForBatch: 'Default category for unclassified items:',
    defaultUser: 'User',
    defaultUserApp: 'Progress User',
    defineCategoryCapsHint: 'In the form above, use "Auto-Estimate" or enter amounts manually to set category caps and activate visual gauges.',
    defineExpenseCapsDesc: 'Set allowed spending caps for housing, groceries, utilities, transport, etc. (0 can be entered for categories with no expense)',
    delete: 'Delete',
    deleteAll: 'Delete All',
    deleteAllCards: 'Delete All',
    deleteItemTitle: 'Delete Item',
    deleteTransaction: 'Delete Transaction',
    depositModalTitle: 'Add Deposit: {{title}}',
    depositToGoalTitle: 'Deposit to Savings: {{title}}',
    descPlaceholder: 'e.g. Weekly grocery shopping',
    description: 'Description',
    deselectAll: 'Deselect All',
    dictionaryTab: 'Variables & Dictionary Reference',
    doctorAgeVal: '{{age}} years old',
    doctorAiAnswerTitle: 'Doctor\\\\\\\\\\\\\\\'s Advice & Clinical Notes',
    doctorAiError: 'Failed to communicate with AI Doctor',
    doctorAiSubmit: 'Send to AI Medical Assistant',
    doctorCancel: 'Cancel',
    doctorClearText: 'Clear Input',
    doctorCopyAnswer: 'Copy Response',
    doctorDeleteConfirm: 'Are you sure you want to delete this consultation history?',
    doctorDeleteError: 'Failed to delete history item',
    doctorDisclaimer: 'Note: AI-provided information is for educational purposes only and does not replace professional medical diagnosis.',
    doctorEditActivity: 'Physical Activity Level',
    doctorEditAge: 'Age (years)',
    doctorEditAllergies: 'Known Allergies',
    doctorEditAllergiesPh: 'e.g., Penicillin, Peanuts...',
    doctorEditGender: 'Gender',
    doctorEditGoals: 'Health Goals',
    doctorEditGoalsPh: 'e.g., Reach 75kg, improve blood pressure...',
    doctorEditHeight: 'Height (cm)',
    doctorEditMedCond: 'Chronic Diseases or Conditions',
    doctorEditMedCondPh: 'e.g., Hypertension, Diabetes Type 2...',
    doctorEditMeds: 'Current Medications',
    doctorEditMedsPh: 'e.g., Metformin, Vitamin D...',
    doctorEditProfileHeader: 'Update Personal Medical Data',
    doctorEditProfileTitle: 'Edit Medical Profile',
    doctorEditWeight: 'Weight (kg)',
    doctorGenderF: 'Female',
    doctorGenderM: 'Male',
    doctorHeaderDesc: 'Answer medical queries, analyze illness symptoms, advice medication interactions and lab reports',
    doctorHeaderTitle: 'Personal AI Doctor & Health Assistant',
    doctorHistoryCount: '{{count}} consultations recorded',
    doctorHistoryEmpty: 'No consultation history recorded yet',
    doctorHistoryEmptyDesc: 'Ask your first medical or health question above to see personalized advice here.',
    doctorHistoryLoading: 'Loading consultation history...',
    doctorHistoryQuestion: 'Consultation:',
    doctorHistoryTitle: 'Past Medical Consultations',
    doctorLiveCalories: 'Daily Calorie Estimate: {{cal}} kcal',
    doctorNewQueryDesc: 'Ask questions regarding symptoms, nutrition, lab tests, or medications',
    doctorNewQueryTitle: 'New Medical Consultation',
    doctorProfileActivity: 'Physical Activity Level',
    doctorProfileAgeGender: 'Age & Gender',
    doctorProfileAllergies: 'Allergies & Sensitivities',
    doctorProfileBadge: 'Confidential Data',
    doctorProfileDesc: 'Your health parameters for accurate AI diagnoses',
    doctorProfileEditBtn: 'Edit Profile',
    doctorProfileGoals: 'Health & Fitness Goals',
    doctorProfileHeightWeight: 'Height & Weight',
    doctorProfileMedCond: 'Medical Conditions',
    doctorProfileMeds: 'Current Medications',
    doctorProfileNoMeds: 'No medications taken',
    doctorProfileNotRegistered: 'Not registered',
    doctorProfileSaveError: 'Failed to save medical profile',
    doctorProfileTitle: 'Personal Medical Profile',
    doctorQ1: 'How can I safely optimize my fasting window and energy?',
    doctorQ2: 'What foods help reduce abdominal visceral fat faster?',
    doctorQ3: 'Can you analyze my recent symptoms and suggest lifestyle tweaks?',
    doctorQ4: 'What supplements support joint cartilage and muscle recovery?',
    doctorQueryPlaceholder: 'Type your question or medical inquiry here...',
    doctorSaveToDb: 'Save to Medical Record',
    doctorSaving: 'Saving...',
    doctorSpecialtyLabel: 'Desired Medical Specialty',
    doctorSuggestedQueries: 'Suggested questions:',
    doctorTitle: 'Personal AI Doctor',
    doctorWeightHeightVal: '{{weight}} kg / {{height}} cm',
    dueToday: 'Due Today',
    duplicateWithTx: 'Duplicate with {{title}} (ignored)',
    edit: 'Edit',
    email: 'Email',
    english: 'English',
    enterIncomeFirst: 'Please enter monthly net income first.',
    error: 'Error',
    estimatedFutureMonths: '{{count}} future months',
    estimatedMonthsFuture: 'In next {{count}} months',
    exerciseDuration: 'Duration (mins)',
    expense: 'Expense',
    exportCalendar: 'Export to Google Calendar / ICS',
    exportCalendarIcs: 'Export Calendar File (ICS)',
    exportExcelReport: 'Export Excel File',
    exportPdfReport: 'Download Comprehensive PDF Report',
    extraExpenseSuffix: 'over budget spent!',
    extractRowsSmartBtn: 'Extract & Smart Identify Rows',
    familyCategoriesTab: 'Categories & Family Members',
    familyCategory: '👨‍👩‍👧‍👦 Family Matters',
    fat: 'Fat',
    fatActivationDesc: 'Belly fat reduction is primarily achieved through walking, steady-state cardio, and isometric core contractions (without dangerous twisting or lower back bending). Avoid traditional risky crunches.',
    fatActivationTitle: 'Low-Impact Energy Activation',
    fatActiveKcal: 'Active Kcal',
    fatCalBurnedTitle: 'Estimated Calories Burned',
    fatCalories: 'Calories',
    fatExerciseXofY: 'Exercise {{current}} of {{total}}',
    fatExitSession: 'Exit Session',
    fatFullInstructions: 'Full Exercise Instructions:',
    fatGoal: 'Fat (g)',
    fatGuidedComplete: 'Outstanding! Fat Loss Workout Complete',
    fatGuidedCompleteDesc: 'You burned a significant amount of calories and activated your core muscles today.',
    fatGuidedSaveReturn: 'Save & Return to List',
    fatGuidedStatusPrepare: 'Standby',
    fatGuidedStatusRest: 'Rest & Breathe',
    fatGuidedStatusRunning: 'Running',
    fatKcalBurn: '{{kcal}} Kcal Burn',
    fatLossCardio: 'Fat Loss & Cardio',
    fatMute: 'Mute',
    fatNextEx: 'Save & Next',
    fatPause: 'Pause',
    fatPrevEx: 'Previous',
    fatProgressTitle: 'Daily Routine Progress',
    fatProgressXofY: '{{completed}} of {{total}} Exercises',
    fatReps: 'Reps',
    fatRest: 'Rest',
    fatResume: 'Resume',
    fatSeconds: 'Seconds',
    fatSets: 'Sets',
    fatSkipRest: 'Skip Rest',
    fatStartGuided: 'Start Voice-Guided Fat Loss Session',
    fatSubtitle: 'Aerobic exercises and isometric core contractions without lower back bending; supports spine and disc health.',
    fatTargetMuscles: 'Target Muscles',
    fatTargetPurpose: 'Purpose',
    fatTitle: 'Fat Loss & Cardio Training',
    fatTrainerName: 'Virtual Belly Fat Trainer',
    fatUnmute: 'Unmute',
    filter: 'Filter',
    filterAllCategories: 'All Categories',
    filterAllPayments: 'All Payment Methods',
    filterByMonth: 'Filter by Month',
    filterCard: 'Bank Card',
    filterCash: 'Cash',
    filterDateLabel: 'Date Filter:',
    filterFrom: 'From:',
    filterLast3Months: 'Last 3 Months',
    filterSwish: 'Swish',
    filterThisMonth: 'This Month',
    filterThisMonthTransactions: 'Filter this month\\\\\\\\\\\\\\\'s transactions',
    filterTo: 'To:',
    filterToday: 'Today',
    filterTransfer: 'Bank Transfer',
    filtered: 'Filtered',
    finalAmountRecorded: 'Final amount recorded: {{amount}} {{currency}}',
    finalAmountToRecord: 'Final Amount to Record:',
    finance: 'Finance & Invoices (AI)',
    financeAddCardBtn: 'Add Card',
    financeAddItemRow: '+ Add Item',
    financeAddItemsSection: 'Add Invoice Items (Itemized Goods):',
    financeAdvisorThinking: 'AI advisor is analyzing your invoices and compiling advice...',
    financeAiAddNewRow: 'Add New Row',
    financeAiAdvisorGreeting: 'Hello! I am your Senior AI Financial Advisor and Wealth Strategist. 💼🌟 I have full insight into your net income, expenses, budget caps, and savings goals.',
    financeAiAdvisorRole: 'AI Financial Advisor',
    financeAiAdvisorSubtitle: 'Live analysis of net income, spending habits, budget limits, and financial goals',
    financeAiAdvisorTitle: 'AI Financial Advisor & Wealth Strategist',
    financeAiAnalyzeBtn: 'Analyze Invoice with AI',
    financeAiBankMatchNotice: 'Matched bank charge found: {{store}} with {{amount}} {{currency}} ({{date}}). The detailed invoice will replace raw bank charge.',
    financeAiCardLabel: 'Bank Account / Card:',
    financeAiColAction: 'Delete',
    financeAiColCategory: 'Category',
    financeAiColItemName: 'Item Name (Editable)',
    financeAiColQty: 'Quantity',
    financeAiColTotal: 'Total',
    financeAiColUnitPrice: 'Unit Price',
    financeAiConfirmSave: 'Confirm & Save Invoice',
    financeAiDateLabel: 'Transaction Date:',
    financeAiExtractedItems: 'Extracted Items (Editable):',
    financeAiExtracting: 'Extracting items via AI...',
    financeAiFinalCharge: 'Final Amount to Record: {{amount}} {{currency}}',
    financeAiInvoiceAnalysis: 'Smart Analysis of {{store}} Invoice',
    financeAiNewInvoiceTitle: 'New Invoice',
    financeAiNoResponse: 'No response received from server',
    financeAiParseError: 'Failed to parse invoice details.',
    financeAiParsedTitle: 'AI Extraction Result (Editable)',
    financeAiPaymentMethod: 'Payment Method:',
    financeAiPurchaseFrom: 'Purchase from {{store}}',
    financeAiReadyToSave: 'Ready to Save',
    financeAiRowCount: '{{count}} rows',
    financeAiScannerDesc: 'Paste your receipt text (Swish, ICA, Willys...) to extract items, prices, and categories automatically.',
    financeAiScannerHeader: 'Smart AI Invoice Text Scanner & Parsing',
    financeAiScannerNote: 'Recorded by AI Scanner',
    financeAiSmartReplaceNote: 'Smartly replaced raw bank charge with scanned invoice details',
    financeAiStoreLabel: 'Store / Title:',
    financeAiTotalCalculated: 'Total Calculated Amount:',
    financeAskPh: 'Ask a financial question (e.g. How to control grocery expenses this month?)...',
    financeBatchCleanupSubtitle: 'Batch delete transactions by month, year, filter, or total reset',
    financeBatchCleanupTitle: 'Batch Management & Cleanup',
    financeBatchColAction: 'Delete',
    financeBatchColAmount: 'Amount ({{currency}})',
    financeBatchColCard: 'Card / Account',
    financeBatchColCategory: 'Category',
    financeBatchColDate: 'Date',
    financeBatchColSelect: 'Select',
    financeBatchColStore: 'Store / Title',
    financeBatchColType: 'Type',
    financeBatchConfirmBtn: 'Confirm & Save to Database',
    financeBatchDefaultNotes: 'Recorded from batch import',
    financeBatchMergeStoreNotes: 'Merged with receipt from {{store}}',
    financeBatchRowExpense: 'Expense',
    financeBatchRowIncome: 'Income',
    financeBatchRowSavings: 'Savings',
    financeBatchRowsReady: '{{count}} selected transactions ready for import.',
    financeBatchStatusBankMerge: '{{count}} bank transactions matched with store receipts',
    financeBatchStatusNew: '{{count}} new transactions recorded',
    financeBatchStatusSkip: '{{count}} duplicate items skipped',
    financeBatchStatusStoreMerge: '{{count}} store invoices replaced raw bank entries',
    financeBatchTotalExpense: 'Total Expense: {{amount}} {{currency}}',
    financeBatchTotalIncome: 'Total Income: {{amount}} {{currency}}',
    financeBulkDeleteAlert: 'Please type DELETE to confirm total wipeout.',
    financeCalcFromItems: 'Auto-calc from items ({{count}})',
    financeCancelBtn: 'Cancel',
    financeCardOrAccountLabel: 'Card / Account:',
    financeCardsModalSubtitle: 'Define your custom bank cards and accounts to use in transactions and batch imports.',
    financeCardsModalTitle: 'Manage Bank Cards & Personal Accounts',
    financeCategoryLabel: 'Rich Category:',
    financeCategoryNameCarMaintenance: 'Car Maintenance & Insurance',
    financeCategoryNameCharityGifts: 'Gifts & Charity',
    financeCategoryNameClothing: 'Clothing, Shoes & Beauty',
    financeCategoryNameDefault: 'Services & Miscellaneous',
    financeCategoryNameEducation: 'Education & Courses',
    financeCategoryNameElectronics: 'Electronics & Gadgets',
    financeCategoryNameEntertainment: 'Entertainment & Travel',
    financeCategoryNameFamily: 'Children & Family Care',
    financeCategoryNameGroceries: 'Groceries & Supermarket',
    financeCategoryNameHealth: 'Health, Pharmacy & Medical',
    financeCategoryNameHomeDecor: 'Home Goods & Furniture',
    financeCategoryNameHousing: 'Housing & Rent',
    financeCategoryNameInvestment: 'Savings & Investments',
    financeCategoryNamePets: 'Pets & Supplies',
    financeCategoryNameRestaurants: 'Restaurants, Cafes & Dining',
    financeCategoryNameSalary: 'Salary & Primary Income',
    financeCategoryNameSubscriptions: 'Subscriptions & AI Tools',
    financeCategoryNameTransport: 'Transport & Fuel',
    financeCategoryNameUtilities: 'Utilities, Energy & Internet',
    financeCurrencyIRR: 'Iranian Rial (IRR)',
    financeCurrencyToman: 'Iranian Toman (Toman)',
    financeCurrencySEK: 'Swedish Krona (SEK)',
    financeCurrencyEUR: 'Euro (EUR)',
    financeCurrencyUSD: 'US Dollar (USD)',
    financeClearAllCards: 'Clear All',
    financeCloseBtn: 'Close',
    financeConfirmDeposit: 'Confirm Deposit',
    financeCopied: 'Copied',
    financeCopyAnswer: 'Copy Answer',
    financeCreateGoalBtn: 'Create Goal',
    financeDateLabel: 'Date:',
    financeDefineNewCard: '➕ Add New Card...',
    financeDefineNewGoalBtn: 'Define New Goal',
    financeDeleteCardTitle: 'Delete this card',
    financeDeleteFilteredTxs: 'Delete Filtered Transactions',
    financeDeleteMonthTxs: 'Delete Month Transactions',
    financeDeleteMonthTxsDesc: 'Delete all invoices for selected month',
    financeDeleteYearTxs: 'Delete Year Transactions',
    financeDeleteYearTxsDesc: 'Delete all invoices for selected year',
    financeDepositAmountLabel: 'Deposit Amount:',
    financeDepositModalTitle: 'Add Savings Deposit: {{title}}',
    financeDescOptional: 'Notes (Optional):',
    financeDescPh: 'e.g., Week 2 grocery shopping',
    financeEditCardTitle: 'Edit card name',
    financeEditGoalBtn: 'Edit Goal',
    financeEditGoalModalTitle: 'Edit Savings Goal: {{title}}',
    financeSaveGoalChangesBtn: 'Save Goal Changes',
    financeGoalCategoryLabel: 'Goal Category:',
    financeGoalNotesLabel: 'Notes / Description:',
    financeGoalCategoryHousing: 'Housing & Property',
    financeGoalCategoryCar: 'Car & Vehicle',
    financeGoalCategoryTravel: 'Travel & Vacation',
    financeGoalCategoryEmergency: 'Emergency Fund',
    financeGoalCategoryInvestment: 'Investment & Wealth',
    financeGoalCategoryOther: 'Other & Miscellaneous',
    financeEditTx: 'Edit Transaction',
    financeEnterYearToDelete: 'Enter Year to Delete (e.g. 2026):',
    financeFilteredTxsCount: '{{count}} selected transactions',
    financeFinalDeleteBtn: 'Execute Final Deletion',
    financeFinancialHealthScore: 'Your Financial Health Score:',
    financeGoalAddDepositBtn: 'Deposit Savings',
    financeGoalCurrency: 'Currency:',
    financeGoalCurrentBalance: 'Current: {{amount}} {{currency}}',
    financeGoalDepositNote: 'Savings deposit to goal {{goalTitle}}',
    financeGoalDepositTitle: 'Savings for: {{goalTitle}}',
    financeGoalInitialSavings: 'Initial Savings:',
    financeGoalNameLabel: 'Goal Title:',
    financeGoalNamePh: 'e.g., House in Stockholm / Summer Vacation',
    financeGoalProgressPercent: '{{percent}}% achieved',
    financeGoalRemainingAmount: 'Remaining: {{amount}} {{currency}}',
    financeGoalTargetAmount: 'Target Amount:',
    financeGoalTargetAmountLabel: 'Goal: {{amount}} {{currency}}',
    financeGoalTargetDate: 'Target Date (Optional):',
    financeGoalTargetDateLabel: 'Target Date: {{date}}',
    financeGoalsTitle: 'Savings Goals & Financial Planning',
    financeHeaderDesc: 'Net income budgeting, automatic AI invoice scanning, and savings goal tracking',
    financeHeaderTitle: 'Smart Invoice, Budget & Financial Goals Management',
    financeItemNamePh: 'Item name (e.g., Milk)',
    financeItemQtyPh: 'Qty (1)',
    financeItemUnitPricePh: 'Unit Price',
    financeItemsRecorded: '{{count}} items recorded',
    financeNewCardInputPh: 'New card/account name (e.g. SEB Credit, ICA Kort, Swish...)',
    financeNewCardPh: 'Card name (e.g. Klarna, Mastercard...)',
    financeNewGoalTitle: 'Define New Financial / Savings Goal',
    financeNewTx: 'New Invoice / Financial Transaction',
    financeNoCardsYet: 'No cards defined yet. Enter a card name above and click Add, or reset to defaults.',
    financeNoGoalsYet: 'No savings goals created yet.',
    financeNoProductMatches: 'No product registered with this name.',
    financePaymentCard: 'Card',
    financePaymentCash: 'Cash',
    financePaymentMethodLabel: 'Payment Method:',
    financePaymentSwish: 'Swish',
    financePaymentTransfer: 'Transfer',
    financeProductAnalyticsTitle: 'Product Consumption Analytics (e.g. Milk, Bread purchases...)',
    financeProductAnalyticsTotal: 'Total Products: {{count}} distinct items',
    financePrompt1: '💡 Analyze this month\\\\\\\\\\\\\\\'s top spending and categories',
    financePrompt1Text: 'How can I increase my monthly savings by 10% based on my current spending?',
    financePrompt2: '🔍 5 practical ways to cut non-essential expenses',
    financePrompt2Text: 'Please analyze my expenses, budget caps, and consumption behavior this month in detail.',
    financePrompt3: '📈 How can I save smart with my current net income?',
    financePrompt3Text: 'Based on my net income and expenses, how should I invest my remaining savings surplus?',
    financePrompt4: '🛡️ Emergency fund building strategy',
    financePrompt4Text: 'What strategy do you recommend for building an emergency fund based on my monthly cost of living?',
    financePrompt5: '🎯 Acceleration plan for financial goals',
    financePrompt5Text: 'Review my active financial goals and give me an acceleration plan to achieve them sooner.',
    financeRemainingBudgetLabel: 'Remaining Monthly Budget:',
    financeResetChatConfirm: 'Are you sure you want to clear chat history?',
    financeResetToDefaultCards: 'Reset to default cards',
    financeSaveCard: 'Save',
    financeSaveTxBtn: 'Save Transaction',
    financeScoreExcellent: 'Excellent 🟢',
    financeScoreModerate: 'Moderate 🟡',
    financeScoreNeedsWork: 'Needs Attention 🔴',
    financeSearchPlaceholder: 'Search invoices, store names, cards, or item details...',
    financeSearchProductPh: 'Search product name (e.g. Milk, Bread, Chicken...)',
    financeSelectCleanupScope: 'Select Deletion Scope:',
    financeSelectMonthToDelete: 'Select Month to Delete:',
    financeSend: 'Send',
    financeStoreOrTitle: 'Store Name or Title:',
    financeStoreOrTitlePh: 'e.g., Willys / Monthly Salary',
    financeTitle: 'Finance & Invoice Management (AI)',
    financeTotalAmountLabel: 'Total Amount:',
    financeTotalPurchasedQty: 'Total Purchased Qty:',
    financeTotalSpentOnProd: 'Total Spent:',
    financeTotalTxsRecorded: '{{count}} total recorded transactions',
    financeTypeDeleteToConfirm: 'Type DELETE below to confirm final deletion:',
    financeTypeExpense: 'Expense / Invoice',
    financeTypeIncome: 'Income / Salary',
    financeTypeSavings: 'Savings / Transfer',
    financeWipeAllData: 'Complete Data Wipeout',
    financeWipeWarning: '⚠️ Critical Warning: This action is irreversible and deletes all {{count}} transactions!',
    financeYou: 'You',
    financeYourCurrentCards: 'Your current cards ({{count}} items):',
    financial_advisor: 'AI Financial Advisor',
    fixSalaryBtn: 'Auto-Fix to Income (+)',
    fixTransferBtn: 'Auto-Fix to Transfer/Savings',
    foodCat_Breakfast: 'Breakfast',
    foodCat_Dairy: 'Dairy',
    foodCat_Drinks: 'Drinks',
    foodCat_Fruits: 'Fruits & Citrus',
    foodCat_Nuts: 'Nuts & Seeds',
    foodCat_Persian: 'Authentic Persian',
    foodCat_Protein: 'Proteins',
    foodCat_RiceGrains: 'Rice & Grains',
    foodCat_Vegetables: 'Vegetables',
    foodCat_all: 'All Foods',
    glp1MealPlan: 'Exclusive GLP-1 Meal Plan',
    goalCompletedSuffix: 'completed',
    goalCurrentAmount: 'Current: {{amount}} {{currency}}',
    goalCurrentLabel: 'Saved:',
    goalForecastNote: 'By steadily allocating {{amount}} {{currency}} per month, this goal will be achieved in about {{months}} months.',
    goalProgressPercent: '{{pct}}% achieved',
    goalRemainingAmount: 'Remaining: {{amount}} {{currency}}',
    goalRemainingLabel: 'Remaining:',
    goalTargetAmount: 'Target: {{amount}} {{currency}}',
    goalTargetLabel: 'Target:',
    goalsDefault: 'Weight loss, general health, energy boost',
    goalsEmptyDesc: 'No savings goals recorded yet.',
    goalsForecastDesc: 'Smart calculation based on monthly savings allocation ({{ratio}}%)',
    goalsForecastLabel: 'Estimated time to achieve all goals:',
    goalsForecastTitle: 'Financial Goals Timeline & Forecasting Analysis',
    goalsSectionTitle: 'Savings Goals & Financial Planning',
    goalsSystemGuide: 'By steadily allocating {{amount}} {{currency}} per month to savings, you can reach all your defined goals on schedule.',
    goalsSystemTip: 'System Guide: By regularly allocating {{amount}} {{currency}} each month to your savings fund, you can realize all defined goals on schedule.',
    goalsTab: 'Financial Goals',
    goalsWeightLoss: 'Weight loss & fat reduction',
    graph1Subtitle: 'Sorted by highest percentage',
    graph1Title: '1. Expense Share by Category:',
    graph2Subtitle: 'Broken down by month',
    graph2Title: '2. Monthly Expenses & Savings Comparison:',
    healthScoreOf100: '{{score}}/100',
    highPriority: '🚨 High Priority (Urgent)',
    highestQtyProducts: 'Highest Quantity Items:',
    highestSavingsMonth: 'Highest Savings Month:',
    highestSpentProducts: 'Highest Spent Items:',
    income: 'Income',
    incomePlaceholder: 'e.g. 50,000 SEK',
    increase: 'Increase',
    increaseSavingsBtn: 'Add Deposit',
    initialSavingsLabel: 'Initial Savings:',
    insertCsvSample: 'Insert sample bank statement CSV',
    invoiceItemsTitle: 'Itemized Invoice Breakdown:',
    invoiceSamplePlaceholder: 'Sample invoice text: Store, items, prices...',
    invoices: 'Invoices & Receipts',
    item: 'Item',
    itemUnit: 'pcs',
    itemUnitRows: 'rows',
    itemsCountInRow: '{{count}} item rows',
    itemsCountSuffix: 'items',
    itemsDetails: 'Item Details',
    itemsRecordedCount: '{{count}} items recorded',
    itemsRecordedSuffix: 'items recorded',
    itemsUnitCount: 'pcs',
    labReportAnalysis: 'Lab Test Interpretation',
    language: 'App Language',
    languageSectionDesc: 'Choose your preferred UI language and layout direction.',
    languageSectionTitle: 'Language & Region',
    largestShare: 'Largest Share',
    latestHeadlinesTab: 'Top News Headlines',
    learningActionDeleteAttachment: 'Delete Attachment',
    learningActionDownload: 'Download',
    learningActionPlayVideo: 'Play Video',
    learningActionViewDoc: 'View Document',
    learningActionViewOnline: 'Open Online',
    learningAddMsgHint: 'Type markdown or text notes for this lesson',
    learningAddMsgTitle: 'Add Note / Entry',
    learningAddTeacherNote: 'Add Teacher / Instructor Notes',
    learningAddVideoFile: 'Add Video / Link',
    learningAiCustomPrompt: 'Custom AI Request...',
    learningAiInfoLabel: 'AI Powered Smart Learning Companion',
    learningAiKeyPoint: 'Key Takeaway:',
    learningAiModalCancel: 'Cancel',
    learningAiModalLabel: 'Ask anything about your study notes or materials:',
    learningAiModalPh: 'e.g., Summarize key points, explain difficult terms, make flashcards...',
    learningAiModalTitle: 'AI Learning Assistant Prompt',
    learningAiNoResponse: 'No response generated. Please try again.',
    learningAiPromptCustom: 'Custom AI prompt for topic notes',
    learningAiPromptQuiz: 'Generate 5 interactive quiz questions to test comprehension',
    learningAiPromptScenario: 'Create real-world clinical case study based on this lesson',
    learningAiPromptSummarize: 'Generate executive bullet-point summary and key take-aways',
    learningAiPromptTranslateFa: 'Translate selected notes to Persian with medical terminology explained',
    learningAiPromptTranslateSv: 'Translate selected notes to Swedish with high precision',
    learningAiQuiz: 'Generate Quiz',
    learningAiSummarize: 'AI Summarize',
    learningAiSummarizeDesc: 'Quick summary generated by AI',
    learningAiTransFa: 'Translate to Persian',
    learningAiTransSv: 'Translate to Swedish',
    learningAiTranslateFa: 'Translate to Persian',
    learningAiTranslateSv: 'Translate to Swedish (Svenska)',
    learningAllMessagesDeleted: 'All session entries cleared',
    learningAnalyzeGenerateBtn: 'Analyze & Generate with AI',
    learningAssistant: 'Learning Assistant',
    learningAttachmentOptions: 'Attachment Options',
    learningAttachments: 'Related Attachments & Documents',
    learningAttachmentsHint: 'Upload audio, video, PDF or images to enrich your study session.',
    learningAttachmentsLabel: 'Session Attachments',
    learningCopied: 'Copied!',
    learningCopyFullSession: 'Copy Full Lesson Notes',
    learningCopyText: 'Copy',
    learningCreateFirstTopic: 'Create your first study topic to organize sessions',
    learningCreateMainTopic: 'New Topic',
    learningDeleteAiMsg: 'Delete Message',
    learningDeleteConfirmBtn: 'Delete Permanently',
    learningDeleteModalDesc1: 'Are you sure you want to delete this topic and all its sessions?',
    learningDeleteSession: 'Delete Lesson',
    learningDeleteSubtopic: 'Delete Subtopic',
    learningDeleteTeacherNote: 'Delete note',
    learningDeleteTopic: 'Delete Topic',
    learningDirectionLTR: 'LTR',
    learningDirectionRTL: 'RTL',
    learningEditMainTopic: 'Edit Topic',
    learningExtractedTextTitle: 'Extracted Text from Attachment:',
    learningFileNotfound: 'File not found',
    learningFileR2Error: 'Storage error occurred',
    learningFileUploadError: 'Failed to upload attachment',
    learningFileVideoAlert: 'Please check video format or link',
    learningFormatSize: '{{size}} MB',
    learningGeneratingNotes: 'Generating smart notes with AI...',
    learningMainTopicDescPh: 'Course or module description...',
    learningMainTopicPh: 'e.g., Clinical Endocrinology & Nutrition',
    learningMainTopicTitle: 'Create Main Study Topic',
    learningMsgInputPh: 'Type note content here...',
    learningNewSession: 'New Session',
    learningNewSessionDesc: 'Record detailed notes, attach media, and generate smart quizzes',
    learningNewTopic: 'New Topic',
    learningNoAttachmentsYet: 'No attachments added to this session yet.',
    learningNoExtraDesc: 'No additional description',
    learningNoExtractedTextMsg: 'No text extracted from this file yet.',
    learningNoSessionMatch: 'No lessons found matching search criteria',
    learningNoTopicMatch: 'No topics match your query',
    learningNoTopicsYet: 'No study topics created yet',
    learningPromptGrammar: 'Check and refine grammar and flow of these notes',
    learningPromptGrammarBtn: 'Improve Grammar & Tone',
    learningPromptPresetsTitle: 'AI Study Tools & Action Prompts:',
    learningPromptQuiz: 'Quiz Generator',
    learningPromptQuizBtn: 'Generate Quiz',
    learningPromptScenario: 'Interactive Scenarios',
    learningPromptScenarioBtn: 'Clinical Scenarios',
    learningSearchClear: 'Clear Search',
    learningSearchPh: 'Search topics, lessons, or notes...',
    learningSearchPlaceholder: 'Search topics, sessions, or attachments...',
    learningSelectedTopic: 'Active Topic: {{name}}',
    learningSendAiPrompt: 'Submit Prompt',
    learningSessionAiDefaultReply: 'Hello! How can I assist your study of this topic today?',
    learningSessionAttachmentsTitle: 'Attached Media & Resources',
    learningSessionIntroPh: 'Brief introductory summary of this lesson or lecture...',
    learningSessionMinReq: 'Title must be at least 2 characters',
    learningSessionTitlePh: 'e.g., Chapter 4: Human Anatomy & Metabolism',
    learningSessionTitleReq: 'Please provide a title for the lesson',
    learningSessionUploadWait: 'Uploading media...',
    learningSessionsCount: '{{count}} lessons',
    learningSessionsRegistered: 'Registered Sessions',
    learningShareVideoBtn: 'Attach Video',
    learningShareVideoModalTitle: 'Attach Educational Video Link',
    learningShareVideoSm: 'Video',
    learningSharedFilesTab: 'Shared Files Management',
    learningSizeUnknown: 'Unknown size',
    learningStartNewSession: 'New Lesson',
    learningSubtopicNotesPh: 'Write detailed lecture notes, takeaways, formulas, or clinical pearls here...',
    learningSubtopicTitlePh: 'Subtopic name...',
    learningSubtopicsList: 'Subtopics & Modules',
    learningTeacherNoteLabel: 'Teacher Note:',
    learningTextCopied: 'Notes copied to clipboard!',
    learningTitle: 'Learning Assistant',
    learningToggleDirection: 'Toggle text direction (RTL/LTR)',
    learningTopicCreated: 'Topic created successfully',
    learningTopicLabel: 'Topic:',
    learningTopicTitle: 'My Learning Topics',
    learningTopicsCount: '{{count}} topics',
    learningTopicsOf: 'Lessons of {{topic}}',
    learningTotalSessions: 'Total Lessons:',
    learningUnknownError: 'An unexpected error occurred',
    learningUpdateTopicBtn: 'Save Changes',
    learningUploadingStatus: 'Processing and extracting text...',
    learningUploadingTitle: 'Uploading File...',
    learningUploadingWait: 'Please wait while file uploads...',
    learningUserMsgLabel: 'Student Note',
    learningVideoOnlineDefault: 'Educational Video',
    learningVideoOnlineLink: 'Online Video Link',
    learningVideoTitlePh: 'Video title or topic (optional)...',
    learningVideoUnsupported: 'Video format not supported directly in preview',
    learningVideoUrlHint: 'Paste direct URL or video link',
    learningVideoUrlLabel: 'Video URL (YouTube, Vimeo, MP4):',
    learning_assistant: 'AI Learning Assistant',
    lightMode: 'Light Mode',
    listColorLabel: 'Notebook Color Label',
    listNameLabel: 'Notebook Title',
    listNamePlaceholder: 'e.g. Weekly Groceries...',
    liveGaugesDesc: 'Monthly spending analysis vs allowable cap for each budgeted category',
    liveGaugesTitle: 'Live Gauges & Category Budget Tracker:',
    loading: 'Loading...',
    logWeightBtn: 'Log New Weight',
    login: 'Sign In',
    loginAppTitle: 'Progress',
    loginBadgeFinance: '💰 Finance & AI Invoices',
    loginBadgeGrowth: '🌱 Growth & Habits',
    loginBadgeRehab: '🩺 Rehab & Health',
    loginDescription: 'Smart system for health, daily routines & financial management',
    loginEmailLabel: 'Email Address',
    loginEmailSeparator: 'OR WITH EMAIL',
    loginErrorCreate: 'Error creating account',
    loginErrorFillAll: 'Please fill out all fields.',
    loginErrorGoogleToken: 'Error verifying Google account',
    loginErrorName: 'Please enter your name.',
    loginErrorPassLength: 'Password must be at least 6 characters long.',
    loginErrorServer: 'Error connecting to server.',
    loginErrorUnexpected: 'An unexpected error occurred. Please try again.',
    loginErrorWrong: 'Incorrect email or password.',
    loginFullNameLabel: 'Full Name',
    loginFullNamePlaceholder: 'e.g. Salim Zarepour',
    loginGoogle: 'Quick Sign In with Google',
    loginGoogleClientPrompt: 'To enable Google Login, set VITE_GOOGLE_CLIENT_ID in your environment variables.',
    loginGoogleError: 'Google sign-in was unsuccessful or cancelled by user.',
    loginGoogleManualInputClose: 'Close manual input form',
    loginGoogleManualInputPrompt: 'Or enter your Google Client ID here (Quick Test)',
    loginGoogleManualInputSave: 'Save and activate immediately',
    loginGuest: 'Continue as Guest',
    loginPasswordLabel: 'Password',
    loginSlogan: 'Comprehensive personal growth, rehabilitation, AI finance & invoice manager, health and life goal tracker',
    loginSubmitNewAccount: 'Create New Account',
    loginSubmitSignIn: 'Sign In to System',
    loginToggleToSignIn: 'Already have an account? Sign In',
    loginToggleToSignUp: 'Don\\\\\\\\\\\\\\\'t have an account? Sign up',
    loginVerifyingGoogle: 'Verifying Google account securely...',
    logout: 'Log Out',
    lowPriority: '🌱 Normal Priority',
    lowestSpentProducts: 'Lowest Spent Items:',
    manageFamilyMembers: 'Manage Family Members',
    manualAdd: 'Manual Add',
    matchWithBankTx: 'Matched with bank tx {{title}} (purchase details replace raw bank entry)',
    matchWithPurchase: 'Matched with purchase {{title}} (bank card applied to purchase)',
    matchingBankTxFoundMsg: 'Overlapping bank transaction found: {{title}} with amount {{amount}} {{currency}} (date {{date}}). Upon saving, this detailed scanned invoice will replace the raw bank record to prevent duplication.',
    matchingBankTxNotice: 'Matching bank transaction detected: {{title}} with amount {{amount}} {{currency}} (Date {{date}}). When saved, this scanned itemized invoice will replace the raw bank entry to prevent duplicates.',
    medCondDefault: 'None',
    medicalCategory: '🩺 Medical & Health',
    medicationAdvice: 'Medication & Interaction Guidance',
    mediumPriority: '⚡ Medium Priority',
    medsDefault: 'None',
    month1: 'January',
    month10: 'October',
    month11: 'November',
    month12: 'December',
    month2: 'February',
    month3: 'March',
    month4: 'April',
    month5: 'May',
    month6: 'June',
    month7: 'July',
    month8: 'August',
    month9: 'September',
    monthExpenseLabel: 'Expense: {{amount}}',
    monthSavingsLabel: 'Savings: {{amount}} {{currency}}',
    monthlyBudgetRemainingLabel: 'Remaining monthly expense budget:',
    monthlyCategoryAnalysisDesc: 'Current month expense analysis versus allowed cap for budgeted categories',
    monthlyExpenseCapLabel: 'Monthly Expense Cap ({{ratio}}%):',
    monthlySavingPower: 'Monthly Saving Capacity:',
    monthlySavingsShare: 'Monthly Savings Share:',
    monthlySavingsShareLabel: 'Monthly savings share:',
    monthsInHistory: '{{count}} months in history',
    monthsUnit: 'months',
    moodTracker: 'Daily Mood & Energy Assessment',
    mostExpensiveMonth: 'Highest Spending Month:',
    myCardsAndAccounts: '💳 My Cards & Accounts',
    navDashboard: 'Dashboard',
    navMenu: 'Menu',
    navNutrition: 'Nutrition',
    navReminders: 'Reminders',
    navSport: 'Sport',
    needToBuy: 'Need to Buy',
    netBalance: 'Net Balance',
    netMonthlyIncomeHeader: 'Net Monthly Income:',
    netMonthlyIncomeLabel: 'Monthly Net Income After Tax:',
    newGoalModalTitle: 'Define New Financial Goal & Savings',
    newItemPlaceholder: 'New Item',
    newListModalTitle: 'Create New Shopping Notebook',
    newNoteBtn: 'New Note',
    news: 'AI News Radar',
    newsCategoriesLabel: 'News Categories',
    newsRadarTitle: 'Latest AI & Tech News Radar',
    newsSource: 'Source',
    newsSourceLabel: 'News Source',
    newsTopicsTab: 'Topics & Keywords',
    news_radar: 'Health & News Radar',
    nextMonth: 'Next Month',
    noActiveGoals: 'No active goals',
    noBudgetPlaceholder: '0 (No budget)',
    noCappedCategoriesMsg: 'No categories have a defined budget cap for this month.',
    noCategoryCapsDefinedYet: 'No specific caps have been set for any category yet.',
    noCategoryCapsHelp: 'Use the Auto-estimate button above or enter amounts manually to set category caps and activate live gauges.',
    noCategoryCapsRecorded: 'No custom budget caps have been set for any categories yet.',
    noCategoryData: 'No transactions found for category chart.',
    noGoalsYet: 'No savings goals defined yet.',
    noMonthlyData: 'No monthly data found for comparison.',
    noProductFound: 'No products found.',
    noTransactionsFound: 'No invoices or transactions found.',
    notes: 'Notes & Mood',
    notesEnergyLevelTitle: 'Energy Level (1-10)',
    notesEnergyScoreLabel: 'Energy Score: {{score}}/10',
    notesHeaderDesc: 'Log thoughts, daily feelings, plans, and categorize notes by topic',
    notesHeaderTitle: 'Personal Notebook & Mood Tracker',
    notesLabel: 'Notes',
    notesMoodTitle: 'Mood & Mental Energy',
    notesNotebooksTitle: 'Health & Daily Journal Notebooks',
    notesObservationsLabel: 'Daily Health Observations',
    notesObservationsPlaceholder: 'Note down any physical changes, reactions to food, or wellness observations...',
    notesPainDesc0: 'No discomfort, feeling great',
    notesPainDesc10: 'Worst possible pain, emergency level',
    notesPainDesc2: 'Mild discomfort, barely noticeable',
    notesPainDesc4: 'Noticeable pain, manageable without meds',
    notesPainDesc6: 'Moderate to strong pain, interferes with tasks',
    notesPainDesc8: 'Severe pain, disabling, requires rest',
    notesPainLevelTitle: 'Pain & Physical Discomfort Scale',
    notesPainScale0: '0 - No Pain',
    notesPainScoreLabel: 'Pain Level: {{score}}/10',
    notesPhysicalStatusPrefix: 'Physical Status:',
    notesRemindersLabel: 'Health Reminders & Next Actions',
    notesRemindersPlaceholder: 'e.g. Schedule blood test, refill prescription, increase water intake...',
    notesSymptomsLabel: 'Observed Symptoms & Bodily Sensations',
    notificationsTitle: 'Notifications & Reminders',
    nutriAdd: 'Add',
    nutriAddFav: 'Add to favorites',
    nutriAiAnalysis: 'Custom / AI Analysis',
    nutriAiAnalyzing: 'AI Analyzing...',
    nutriAiEstimate: 'Estimate with AI',
    nutriAiQueryWeight: 'Query AI for calories and macros for this weight',
    nutriAiRecalculating: 'Recalculating weight with AI...',
    nutriBreakfast: 'Breakfast',
    nutriCalLabel: 'Calories (kcal)',
    nutriCalcResult: 'Calculated Nutrition',
    nutriCalories: 'Consumed Calories',
    nutriCarbLabel: 'Carbs (g)',
    nutriCarbShort: 'Carbs:',
    nutriCarbs: 'Carbs',
    nutriChatAssistant: 'Chat Assistant',
    nutriChatPlaceholder: 'e.g., What foods do you recommend for losing belly fat and building muscle?',
    nutriChatSubtitle: 'Ask specialized diet questions, calculate calories, and get meal plans',
    nutriChatTitle: 'Smart Nutrition & Diet Assistant',
    nutriCustomAddTitle: 'Log Custom Food or AI Auto-Analysis',
    nutriDeleteFood: 'Delete food',
    nutriDietTip: '💡 Today\\\\\\\\\\\\\\\'s Nutrition Tip',
    nutriDietTipText: 'برای دستیابی بهتر به اهداف ورزشی، پیشنهاد می‌شود پروتئین روزانه خود را در تمام ۴ وعده تقسیم کنید و حتماً حداقل ۲.۵ لیتر آب بنوشید.',
    nutriDinner: 'Dinner',
    nutriFat: 'Healthy Fats',
    nutriFatLabel: 'Fat (g)',
    nutriFatShort: 'Fat:',
    nutriFavorites: 'Favorites ({{count}})',
    nutriFoodNameDesc: 'Food Name / Description',
    nutriFoodNamePlaceholder: 'e.g., A plate of chicken rice with yogurt and salad',
    nutriFrom: 'of',
    nutriGlassWater: '1 Glass (+250ml)',
    nutriGrams: 'g',
    nutriHeaderTitle: 'Smart Nutrition & Calorie Tracker',
    nutriItem: 'item',
    nutriKcal: 'kcal',
    nutriLogBtn: 'Log',
    nutriLogToDiary: 'Log to Daily Diary',
    nutriLogToFoodDiary: 'Log to Food Diary',
    nutriLunch: 'Lunch',
    nutriMealCount: 'Meals:',
    nutriMealType: 'Meal Type',
    nutriNextDay: 'Next Day',
    nutriNoFoodForMeal: 'No food logged for this meal.',
    nutriOrEnterExactWeight: 'Or enter exact weight (g):',
    nutriPrevDay: 'Previous Day',
    nutriProtLabel: 'Protein (g)',
    nutriProtShort: 'Protein:',
    nutriProtein: 'Protein',
    nutriQtyPlaceholder: 'e.g., 150g / 1 full plate',
    nutriQtyWeight: 'Quantity / Weight / Serving',
    nutriQuickAdd: 'Quick Add',
    nutriReduceWater: 'Reduce',
    nutriRefUnit: 'Reference Unit:',
    nutriReport: 'Report',
    nutriReportTitle: 'Nutrition Progress Report',
    nutriSearchPlaceholder: 'Search food (e.g., chicken breast, rice, eggs...)',
    nutriSelectMeal: 'Select Meal:',
    nutriServingMultiplier: 'Serving Multiplier:',
    nutriSnack: 'Snack',
    nutriSourceAi: '✨ AI Generated',
    nutriSourceStd: '⚡ Standard Calc',
    nutriSummaryTitle: 'Today\\\\\\\\\\\\\\\'s Nutrition Summary',
    nutriToday: 'Today',
    nutriTodayMeals: 'Today\\\\\\\\\\\\\\\'s Logged Meals',
    nutriTotalCalToday: 'Total Calories Today',
    nutriTotalCarbToday: 'Carbs Today',
    nutriTotalProtToday: 'Protein Today',
    nutriWater: 'Water Intake:',
    nutriWaterConsumed: 'Water Consumed',
    nutriWaterTarget: '(Target: {{target}} ml)',
    nutriWeightPlaceholder: 'e.g., {{base}} (g)',
    nutrition: 'Nutrition Tracker',
    nutritionHeaderDesc: 'Calculate daily target calories, protein, carbs, and fats with AI meal photo scanning',
    nutritionHeaderTitle: 'Smart Nutrition & Macronutrient Tracker',
    ofIncome: 'of income',
    ofTotalBudget: 'of total budget',
    ofTotalBudgetUsed: 'of total budget used',
    offlineMode: 'Offline Mode (Local Storage)',
    offsetAtTime: 'At due time',
    offsetBefore: 'before',
    offsetDay: 'day',
    offsetHour: 'hour',
    offsetMin: 'minute',
    offsetWeek: 'week',
    or: 'OR',
    overAllocationWarning: '⚠️ Allocation exceeds {{title}}',
    overlappingBankTxFound: 'Overlapping bank transaction found: {{title}} with amount {{amount}} {{currency}} (Date: {{date}}). Saving will replace the raw bank entry with this itemized invoice.',
    overviewAndTxs: 'Overview & Transactions',
    painLevelTracker: 'Pain Score Assessment (1-10)',
    password: 'Password',
    paymentMethodCard: '💳 Bank Card (Card)',
    paymentMethodCash: '💵 Cash (Cash)',
    paymentMethodSwish: '📱 Swish (Swish)',
    paymentMethodTransfer: '🏦 Bank Transfer (Transfer)',
    pendingCount: 'Pending Purchase',
    perMonthSuffix: 'mo',
    persian: 'فارسی (Persian)',
    personalDoctor: 'Personal AI Doctor',
    preset15m: '15 minutes before',
    preset1d: '1 day before',
    preset1h: '1 hour before',
    preset1w: '1 week before',
    preset3d: '3 days before',
    presetAtTime: 'At due time',
    presetTitle: 'Quick Shopping Presets',
    prevMonth: 'Previous Month',
    productAnalyticsTab: 'Product Consumption Analytics',
    profileSettings: 'Profile & Health Preferences',
    progressCompleted: '{{progress}}% completed',
    protein: 'Protein',
    proteinGoal: 'Protein (g)',
    purchaseDateLabel: 'Suggested Purchase Date',
    quantity: 'Quantity',
    quantityCount: '{{count}} pcs',
    quantityTitle: 'Quantity / Count',
    quickAccess: 'Quick Access',
    quickCurrencyChange: 'Change Base Currency:',
    rankingProductsTitle: '3. Product & Item Ranking (Which product most or less):',
    recordedExpensesThisMonth: 'Expenses recorded this month:',
    recurringReminders: 'Recurring Reminders',
    refreshNews: 'Refresh News with AI',
    refreshNewsBtn: 'Refresh & Process News with AI',
    register: 'Register',
    registeredItemsCount: '{{count}} items recorded',
    rehab: 'Rehab & Physiotherapy',
    rehabAiAlert: 'Recommendations are generated by online AI. Stop the exercise if you experience unusual severe pain.',
    rehabAiFormEq: 'Available Equipment:',
    rehabAiFormEqPh: 'e.g., yoga mat, resistance band',
    rehabAiFormExp: 'Workout Experience:',
    rehabAiFormExpA: 'Advanced (Regular athlete)',
    rehabAiFormExpB: 'Beginner (No experience)',
    rehabAiFormExpM: 'Intermediate (Sporadic training)',
    rehabAiFormLevel: 'Pain Level ({{level}} of 10):',
    rehabAiFormLevelMax: 'Severe (10)',
    rehabAiFormLevelMid: 'Moderate (5)',
    rehabAiFormLevelMin: 'Very Mild (1)',
    rehabAiFormLimit: 'Movement Limitations:',
    rehabAiFormLimitPh: 'e.g., cannot bend over, hurts when sitting long',
    rehabAiFormLoc: 'Main Pain Location:',
    rehabAiFormLocPh: 'e.g., lower back, neck, knee',
    rehabAiFormTitle: 'Body & Pain Assessment',
    rehabAiSubtitle: 'Tailor specialized physiotherapy exercises based on a full assessment of your physical state and pain.',
    rehabAiTitle: 'Smart Rehab Generator (AI)',
    rehabAlertDesc: 'If you experience any increased localized pain or shooting pain down your leg/buttocks during these movements, STOP immediately. Decompression and stretch exercises must be pain-free.',
    rehabAlertTitle: 'Caution in Back Exercises',
    rehabCardCancel: 'Cancel',
    rehabCardEdit: 'Edit & Attach Media',
    rehabCardEditShort: 'Edit / Attach Media',
    rehabCardImageDel: 'Remove Image',
    rehabCardImageLabel: 'Attach Image/GIF Guide',
    rehabCardImagePreview: 'Image Preview:',
    rehabCardSave: 'Save Media & Exercise Changes',
    rehabCardTagImage: 'Image Guide',
    rehabCardTagRehab: 'Physiotherapy',
    rehabCardTagVideo: 'Video Guide',
    rehabCardVideoLabel: 'Attach Video Guide (Upload or Link)',
    rehabCardVideoPreview: 'Video Preview:',
    rehabChatApply: 'Add This Exercise to My Routine',
    rehabChatPh: 'Describe your pain fully or ask questions about movements...',
    rehabChatSub: 'Direct, smart answers based on your body assessment',
    rehabChatTitle: 'Rehab Design & Consultation Chat',
    rehabCustomAddSub: 'Add a custom movement or doctor-recommended exercise to your plan',
    rehabCustomAddTitle: 'Add Custom Rehab Exercise',
    rehabCustomClose: 'Close Form',
    rehabCustomDesc: 'Full Instructions',
    rehabCustomDescPh: 'Describe the movement exactly as a guide...',
    rehabCustomDiff: 'Difficulty',
    rehabCustomDiffA: 'Advanced',
    rehabCustomDiffB: 'Beginner',
    rehabCustomDiffM: 'Intermediate',
    rehabCustomImage: 'Training Image (Optional)',
    rehabCustomImageReady: 'Image Uploaded',
    rehabCustomName: 'Exercise Name',
    rehabCustomNamePh: 'e.g., Gentle Cat-Cow Stretch',
    rehabCustomOpen: 'Open Form',
    rehabCustomPurpose: 'Purpose (Why does it help?)',
    rehabCustomPurposePh: 'e.g., Reduces compression on L4-S1',
    rehabCustomReps: 'Reps / Hold',
    rehabCustomRest: 'Rest Duration',
    rehabCustomSets: 'Sets',
    rehabCustomSubmit: 'Save Custom Exercise',
    rehabCustomTarget: 'Target Muscles',
    rehabCustomTargetPh: 'e.g., Lower Back, Spine',
    rehabCustomTime: 'Time (mins)',
    rehabCustomTip1: 'By opening the form, you can add any exercise with full details (sets, reps, muscles, media) to your daily list.',
    rehabCustomTip2: 'Exercises added here will automatically appear in your daily routine and voice-guided sessions.',
    rehabCustomVideo: 'Training Video (Optional)',
    rehabCustomVideoDel: 'Remove Video',
    rehabCustomVideoPh: 'Or video link (Instagram, YouTube, MP4)...',
    rehabCustomVideoReady: 'Video is ready',
    rehabFolderBtnClose: 'Close Files Folder',
    rehabFolderBtnOpen: 'Rehab Files & Documents Folder',
    rehabFullInstructions: 'Step-by-Step Instructions:',
    rehabGraphicPlaceholder: '[Physio Schematic View]',
    rehabGuidedCompleteDesc: 'Your back recovery exercises have been successfully saved to your progress tracker.',
    rehabGuidedCompleteTitle: 'Great Job! Today\\\\\\\\\\\\\\\'s Routine Completed',
    rehabGuidedSaveReturn: 'Confirm & Return to List',
    rehabHeaderDesc: 'Personalized exercise therapy plan, muscle strengthening, and daily rehab tracking',
    rehabHeaderTitle: 'Physiotherapy, Corrective Exercises & Pain Relief',
    rehabLevelMid: 'Intermediate',
    rehabLevelSafe: 'Safe Beginner Level',
    rehabPlayImage: 'View Exercise Image',
    rehabPlayVideo: 'Watch Training Video',
    rehabProgress: 'Rehab & Exercises',
    rehabStartGuided: 'Start Voice-Guided Rehab Session',
    rehabStatsTimeActive: 'Active Workout Minutes',
    rehabStatsTimeTip: 'Consistency is the key to recovery!',
    rehabStatsTimeTitle: 'Effective Recovery Time',
    rehabStatsTitleCompleted: 'Completed Back Pain Exercises',
    rehabStatsTotalDaily: '/ {{total}} Daily Exercises',
    rehabStatusPrepare: 'Standby',
    rehabStatusRest: 'Rest & Recover',
    rehabStatusRunning: 'Running',
    rehabSubtitle: 'Specialized physiotherapy exercises to decompress discs, eliminate sciatic pain, and build core stability.',
    rehabTargetMuscles: 'Stabilizing Muscles:',
    rehabTargetPurpose: 'Key Purpose:',
    rehabTimerSkip: 'Skip Rest',
    rehabTimerStandby: 'Standby',
    rehabTimerStart30: 'Start 30 Seconds',
    rehabTimerTip: 'Taking a 30-second break between sets helps improve blood flow and recover connective tissues.',
    rehabTimerTitle: 'Free Rest Timer',
    rehabVideoIg: 'Instagram Post / Reel',
    rehabVideoIgOpen: 'Open Directly in Instagram App',
    rehabVideoWeb: 'Open Video Link (Instagram / Web)',
    rehabVoiceActive: 'Voice Assistant Active',
    voiceInputNormal: 'Voice Input',
    voiceInputStop: 'Stop Recording',
    voiceInputProcessing: 'Transcribing audio...',
    voiceInputProcessingShort: 'Transcribing...',
    voiceInputBtnLabel: 'Voice',
    voiceInputPermissionDenied: 'Microphone access was denied.',
    voiceInputRecordingError: 'Audio recording encountered an issue.',
    voiceInputTranscribeError: 'Transcription failed. Please try again.',
    voiceInputNoSpeechDetected: 'No speech detected to transcribe.',
    voiceInputTitleForField: 'Voice input for subtopic title',
    voiceInputTitleForNotes: 'Voice input for subtopic notes',
    rehabEmptyTitle: 'No exercises registered in this module yet',
    rehabEmptyDesc: 'You can import your exercises from a JSON file using the "Bulk Import Activities" button, or add a new exercise individually.',
    rehabNoExercisesAlert: 'Please add or import at least one exercise into this module first.',
    remainingAllowedExpense: 'Remaining allowed budget this month:',
    remainingBudgetCapHeader: 'Remaining Budget Cap:',
    remainingBudgetMonth: 'Remaining monthly budget: {{amount}} {{currency}}',
    remainingExpenseBudgetMsg: '✓ Remaining allowable expense this month: {{amount}} {{currency}}',
    reminderActiveCount: '{{count}} active reminder times',
    reminderAddBtn: 'New Reminder',
    reminderAddCustomOffsetBtn: 'Add',
    reminderAddForDate: 'Add for this date',
    reminderAddShort: 'Add',
    reminderAllCatsCount: 'All Categories ({{count}})',
    reminderAllPersons: 'All Persons',
    reminderCantRemoveMe: 'Cannot remove the primary "Me" contact',
    reminderCardAddGcal: 'Add directly to Google Calendar',
    reminderCardDelete: 'Delete',
    reminderCardEdit: 'Edit',
    reminderCardGcal: 'Google Calendar',
    reminderCardTime: 'at {{time}}',
    reminderCatBills: 'Bills & Finance',
    reminderCatBirthday: 'Birthdays & Anniversaries',
    reminderCatEvent: 'Events & Appointments',
    reminderCatFamily: 'Family Management',
    reminderCatMedical: 'Medical & Health',
    reminderCatPersonal: 'Personal & Admin',
    reminderCatSchool: 'School & Education',
    reminderCatShopping: 'Shopping & Packages',
    reminderCategoryLabel: 'Category',
    reminderClearAllBtn: 'Clear All',
    reminderCustomOffset: 'Custom time:',
    bulkImportModalTitle: 'Bulk Import Exercises & Activities (JSON Bulk Import)',
    bulkImportModalSubtitle: 'Persistent Storage in Cloudflare D1 Database',
    bulkImportD1NoticeTitle: 'Seamless Cloud Persistence in Cloudflare D1',
    bulkImportD1NoticeDesc: 'All imported activities are directly written into database tables with explicit module IDs, persisting across page navigation, hard refreshes, and device switches.',
    bulkImportModuleSelect: 'Destination Module:',
    module1RehabName: 'Physiotherapy & Corrective Exercises',
    module2BellyName: 'Fat Loss & Cardio Exercises',
    moduleCustomActivities: 'General Daily Activities',
    bulkImportStrategySelect: 'Duplicate Handling Strategy:',
    strategyUpdate: 'Update Existing + Insert New (Upsert)',
    strategySkip: 'Skip Duplicates + Insert New Only',
    strategyInsert: 'Always Insert as New Records',
    bulkImportJsonLabel: 'Exercises Array JSON Content:',
    copied: 'Copied',
    copySample: 'Copy Sample',
    loadSampleJson: 'Load Sample JSON',
    jsonEmptyError: 'Please enter JSON activities text into the box.',
    jsonNoItemsFound: 'No valid exercise objects or arrays found in JSON input.',
    jsonMissingNameError: 'All exercises must contain at least a "name" or "title" field.',
    jsonSyntaxError: 'JSON Syntax Error:',
    validItemsCount: 'Found {{count}} valid exercises ready for import:',
    readyToImport: 'Ready for D1 Database',
    importSuccessTitle: 'Database Bulk Import Completed Successfully!',
    importFailedTitle: 'Bulk Import Failed',
    importSummaryDesc: 'Total: {{total}} | Inserted: {{ins}} | Updated: {{upd}} | Skipped: {{skp}}',
    validateJsonBtn: 'Validate JSON Data',
    startImportBtn: 'Import to Database ({{count}} Activities)',
    importingProgress: 'Saving to D1 Cloud Database...',
    bulkImportOpenBtn: 'Bulk Import Activities (JSON Import)',
    reminderClearAllConfirm: 'Are you sure you want to delete all reminders? This action cannot be undone.',
    reminderClearAllTitle: 'Clear all current reminders',
    reminderDateLabel: 'Due Date',
    reminderDownloadIcsBtn: 'Download Calendar (.ics)',
    reminderDownloadIcsTitle: 'Download all active reminders as an .ics file for iPhone, Android, or Google Calendar',
    reminderEditTitle: 'Edit Reminder',
    reminderFamilyExist: 'This name is already registered.',
    reminderFormCancel: 'Cancel',
    reminderFormCatLabel: 'Category',
    reminderFormCustomPerson: 'New Custom Person...',
    reminderFormCustomPersonLabel: 'Custom Person Name',
    reminderFormCustomPersonPh: 'e.g., Alex / Maria',
    reminderFormDate: 'Date',
    reminderFormDesc: 'Additional Notes (Optional)',
    reminderFormDescPh: 'Clinic address, tracking code, essential notes...',
    reminderFormPersonLabel: 'Assigned To:',
    reminderFormPri: 'Priority',
    reminderFormRepeat: 'Repeat',
    reminderFormSubmitAdd: 'Create Reminder',
    reminderFormSubmitEdit: 'Save Changes',
    reminderFormTime: 'Time',
    reminderFormTitleLabel: 'Reminder Title',
    reminderFormTitlePh: 'e.g., Birthday / Bill Payment / Blood Test...',
    reminderHeaderDesc: 'Track medical appointments, bills, birthdays, and school events with cloud sync and calendar export',
    reminderHeaderTitle: 'Smart Family Reminders & Deadline Planner',
    reminderItemsCount: '{{count}} items',
    reminderManageMembersBtn: 'Manage Members',
    reminderManageMembersTitle: 'Manage, add, or remove family members',
    reminderMe: 'Me',
    reminderMembersAdd: 'Add',
    reminderMembersClose: 'Confirm & Close',
    reminderMembersCurrent: 'Registered Members ({{count}}):',
    reminderMembersDesc: 'Add or remove individuals to assign reminders to',
    reminderMembersPh: 'New member name (e.g., Maria, Alex)...',
    reminderMembersRemove: 'Remove {{member}}',
    reminderMembersTitle: 'Manage Family Members',
    reminderModalDesc: 'Set schedule, priority, and assign to a family member',
    reminderNewItem: 'New',
    reminderNewTitle: 'Create New Reminder',
    reminderNoForDate: 'No reminders scheduled for {{date}}.',
    reminderNoIcsError: 'No active reminders available for calendar export.',
    reminderNoInCat: 'No reminders found in this category.',
    reminderNoTodayDesc: 'Add a new reminder for your appointments today.',
    reminderNoTodayMsg: 'You have no pending reminders for today!',
    reminderNoUpcoming: 'No reminders scheduled for upcoming days.',
    reminderNoOffsets: 'No reminders',
    reminderOffsetsTitle: 'Notification & Reminder Schedule Before Due Date',
    reminderPastTitle: 'Past Reminders ({{count}})',
    reminderPersonFilter: 'Person:',
    reminderPersonLabel: 'Related Person / Family Member',
    reminderPresetsLabel: 'Quickly add common times:',
    reminderPreset1Name: 'Birthday & Anniversary',
    reminderPreset1Title: 'Birthday & Wedding Anniversary',
    reminderPreset2Name: 'Bill Payment',
    reminderPreset2Title: 'Electricity & Utility Bills',
    reminderPreset3Name: 'School / University',
    reminderPreset3Title: 'Parent-Teacher Meeting',
    reminderPreset4Name: 'Thyroid & Blood Test',
    reminderPreset4Title: 'Thyroid Blood Test & Checkup',
    reminderPreset5Name: 'Package Delivery',
    reminderPreset5Title: 'Track PostNord / Order Package',
    reminderPreset6Name: 'Family Gathering',
    reminderPreset6Title: 'Family Dinner & Gathering',
    reminderPriHigh: 'Urgent',
    reminderPriHighText: 'High / Urgent',
    reminderPriLow: 'Normal',
    reminderPriLowText: 'Low / Normal',
    reminderPriMed: 'Medium',
    reminderPriMedText: 'Medium',
    reminderPriorityLabel: 'Priority Level',
    reminderQuickPresets: 'Quick Presets:',
    reminderRegisteredCount: '{{count}} registered reminders',
    reminderRemoveOffsetBtn: 'Remove this reminder time',
    reminderRepeatDaily: 'Daily',
    reminderRepeatLabel: 'Repeat Reminder',
    reminderRepeatMonthly: 'Monthly',
    reminderRepeatNone: 'No Repeat',
    reminderRepeatWeekly: 'Weekly',
    reminderRepeatYearly: 'Yearly',
    reminderSearchPh: 'Search by reminder title, person, or notes...',
    reminderSelectedDate: 'Reminders for {{date}}',
    reminderStatsDone: 'Completed',
    reminderStatsMed: 'Medical & Health Tasks',
    reminderStatsToday: 'Today\\\\\\\\\\\\\\\'s Reminders',
    reminderStatsUpcoming: 'Upcoming Days',
    reminderTabCalendar: 'Monthly Calendar',
    reminderTabCategories: 'Categories',
    reminderTabToday: 'Today & Upcoming',
    reminderTimeLabel: 'Reminder Time',
    reminderTitleLabel: 'Reminder Title',
    reminderTodayTitle: 'Today',
    reminderUnknown: 'Unknown',
    reminderUpcomingTitle: 'Upcoming Days Ahead',
    reminders: 'Family Reminders',
    remindersTitle: 'Family Reminders Notebook',
    renameListTitle: 'Edit Notebook Details',
    repetitionCount: 'Repetition Count',
    reports: 'Reports & AI Export',
    reportsHeaderDesc: 'Export PDF & Excel summaries of health, budget, exercises, and AI doctor reports',
    reportsHeaderTitle: 'Comprehensive Analytics & AI Reports',
    reportsTitle: 'Comprehensive AI Analytics & Reports',
    adminAnonymousUser: 'Guest User',
    adminFilterAllPages: 'All Pages',
    adminModuleDesc: 'View registered users, last active timestamp, current active page, and activity history.',
    adminModuleTitle: 'User Management & Admin Panel',
    adminNoLogs: 'No activity logs found for this user.',
    adminRefreshBtn: 'Refresh List',
    adminSearchPlaceholder: 'Search user by name or email...',
    adminSystemUser: 'System User',
    adminThActions: 'Details',
    adminThEmail: 'Email',
    adminThJoined: 'Joined Date',
    adminThLastActive: 'Last Active',
    adminThLastPage: 'Current Page',
    adminThUser: 'User',
    adminTotalUsers: 'Total Registered Users:',
    adminUserLogsTitle: 'Recent User Activity Logs',
    adminUsersCount: '{{count}} users',
    adminSelectUserPromptTitle: 'Select User to Track Activity',
    adminSelectUserPromptDesc: 'Click on a user from the list to view their login details and visited pages history.',
    adminLoadingUsers: 'Loading active users list...',
    adminConnErrorTitle: 'Connection Error',
    adminNoUsersFound: 'No Users Found',
    adminNoUsersDesc: 'No users match your search query.',
    adminSysAdminBadge: 'System Admin 🛡️',
    adminPageLabel: 'Page:',
    adminJoinDate: 'Join Date:',
    adminLastActive: 'Last Active:',
    adminLastPage: 'Last Page:',
    adminRecentViews: 'Recent Page Visit History',
    adminLoggedUnit: 'logged',
    adminLoadingLogs: 'Loading activity logs...',
    adminPageView: 'Page View',
    adminUnknown: 'Unknown',
    settingsTitle: 'System Settings & Reminder Schedules',
    settingsDesc: 'Customize daily alarms, physical & calorie targets, username, and notification preferences.',
    settingsSaved: 'Settings Saved!',
    settingsSaveBtn: 'Save Settings',
    settingsProfileHeader: 'Personal Profile & Health Goals',
    settingsNameLabel: 'Your Name or Nickname',
    settingsCalorieGoalLabel: 'Daily Target Calorie Intake (kcal)',
    settingsWaterGoalLabel: 'Daily Target Water Intake (ml)',
    settingsLocalStorageNotice: 'All profile settings and health records are securely stored and directly synchronized in the Cloudflare D1 cloud database.',
    settingsCalcHeader: 'Height, Weight & Daily Calorie Calculator',
    settingsCalcSub: 'Standard Mifflin-St Jeor formula based on anatomy',
    settingsHeightLabel: 'Height (cm)',
    settingsWeightLabel: 'Current Weight (kg)',
    settingsWeightGoalLabel: 'Target Weight (kg)',
    settingsAgeLabel: 'Age (years)',
    settingsGenderLabel: 'Gender',
    genderMale: 'Male',
    genderFemale: 'Female',
    settingsActivityLevelLabel: 'Daily Activity Level',
    actSedentary: 'Sedentary (desk job)',
    actLight: 'Lightly Active (1-3 days exercise/walk)',
    actModerate: 'Moderately Active (3-5 days exercise/week)',
    actActive: 'Very Active (6-7 days heavy workout)',
    actVeryActive: 'Extra Active (professional athlete/physical job)',
    settingsGoalTypeLabel: 'Your Weight Goal',
    goalTypeLose: 'Weight Loss (healthy fat loss ~500 kcal deficit)',
    goalTypeMaintain: 'Weight Maintenance (keep current weight)',
    goalTypeGain: 'Weight Gain & Muscle Building (lean surplus)',
    settingsAlarmsTitle: 'Routine Alarms & Warning Schedules',
    settingsNotificationTestBtn: 'Test & Enable Notifications',
    settingsAlarmsIntegratedTitle: 'Integrated Daily Alarm & Notification Management in Weekly Schedule',
    settingsAlarmsIntegratedDesc: 'All your alarms, phone push alerts, and routine reminders are managed directly in the "Weekly Schedule & Routines" section. You can toggle phone push alerts and Google Calendar sync for any task.',
    settingsGoToWeeklySchedule: 'Open Weekly Schedule & Alarms',
    settingsCalendarExportTitle: 'Export All Weekly Routines & Family Reminders to Calendar (.ics)',
    settingsDownloadIcsBtn: 'Download Master Calendar (.ics)',
    settingsIcsGuide: '💡 Guide: Clicking above downloads a master .ics file containing all weekly routines and active family reminders. Import it into Google Calendar, iPhone, or Samsung Calendar to activate all native alarms.',
    settingsNotificationNoticeTitle: 'Device Notification Permission Notice',
    settingsNotificationNoticeDesc: 'Smart app notifications rely on browser permission. Please grant notification access in your mobile or desktop browser to receive scheduled alerts.',
    settingsIosNoticeTitle: '📱 iPhone (iOS) Guide to Activate Push Notifications',
    settingsIosNoticeDesc: 'Apple iOS disables web notifications on standard web pages. To fix this and receive alarms, please follow these short steps:',
    settingsIosStep1Title: 'Step 1: Add to Home Screen',
    settingsIosStep1Desc: 'In Safari on your iPhone, tap the Share button at the bottom and choose Add to Home Screen.',
    settingsIosStep2Title: 'Step 2: Confirm Permission',
    settingsIosStep2Desc: 'Open Pishraft from your iPhone home screen, navigate to Settings, and tap "Test & Enable Notifications" to allow permissions.',
    settingsMedicalCondLabel: 'Medical Conditions & History',
    settingsMedicalCondPh: 'e.g. Fatty liver, hypertension',
    settingsMedsLabel: 'Medications & Supplements',
    settingsMedsPh: 'e.g. Vitamin D3, Metformin',
    settingsAllergiesLabel: 'Allergies & Intolerances',
    settingsAllergiesPh: 'e.g. Penicillin, lactose intolerance',
    settingsDietGoalsLabel: 'Dietary & Health Goals',
    settingsDietGoalsPh: 'e.g. Belly fat loss, blood sugar regulation',
    settingsNamePlaceholder: 'Your name',
    settingsAiCalibrating: 'Analyzing and calculating with AI...',
    settingsAiCalibrateBtn: 'Smart Calorie Target Calculation with AI',
    targetWeightEtaTitle: 'Estimated Time to Target Weight',
    targetWeightEtaDesc: 'Calculate rate of weight change based on daily target calories',
    targetWeightReached: 'Congratulations! You are currently at your target weight.',
    targetWeightEstimatedTime: 'Estimated time to goal:',
    targetWeightWeeks: 'Approx. {{weeks}} weeks ({{months}} months)',
    targetWeightWeeklyTakt: 'Weekly weight change:',
    targetWeightMaintain: 'Calorie intake is at maintenance level (zero weight change)',
    settingsAiStatusTitle: 'Online AI Service Status',
    settingsAiStatusDesc: 'The app uses online AI services for nutrition analysis, meal calorie estimations, and rehab plans.',
    settingsAiStatusConnected: 'Connection to online AI service is active and connected.',
    medCondNone: 'None (Good Health)',
    medsNone: 'No medications',
    weightTrendOverallStatus: 'Overall Weight Trend Status:',
    weightTrendDown: 'Down by {{weight}} kg',
    weightTrendUp: 'Up by {{weight}} kg',
    weightTrendStable: 'Stable (No significant weight change)',
    weightPlateauTitle: 'Smart Weight Loss Plateau Diagnostic & Action Plan',
    weightPlateauDesc: 'If your weight has stalled for 1-2 weeks or more, these physiological factors and action steps will help break through your weight loss plateau.',
    weightPlateauDetectedBadge: 'Weight Plateau Stalled',
    weightPlateauNormalBadge: 'Normal Trend',
    weightPlateauAiAnalyzeBtn: 'Analyze My Plateau with AI Diagnostic',
    weightPlateauAnalyzing: 'Analyzing weight variations, calories and activities...',
    weightPlateauCause1Title: '1. Adaptive Thermogenesis (Metabolic Adaptation)',
    weightPlateauCause1Desc: 'In prolonged deficit diets, the body reduces Resting Metabolic Rate (RMR) to conserve energy. Solution: A 1-2 day Refeed Day at maintenance calories with complex carbs to restore leptin and thyroid hormones.',
    weightPlateauCause2Title: '2. Hidden Calories & Portion Measurement Drift',
    weightPlateauCause2Desc: 'Uncounted cooking oils, dressings, nuts, and liquids can easily add 200-400 hidden calories daily. Solution: Weigh all food and cooking oil with a digital kitchen scale for 3 days.',
    weightPlateauCause3Title: '3. Fluid Retention, High Sodium & Cortisol Stress',
    weightPlateauCause3Desc: 'Stress, under 7 hours sleep, or high sodium spikes cortisol, holding up to 2 kg of water that masks fat loss on the scale. Solution: Prioritize 7-8 hours sleep and drink 2.5L water daily.',
    weightPlateauCause4Title: '4. Simultaneous Muscle Gain & Fat Loss (Recomposition)',
    weightPlateauCause4Desc: 'Regular rehab exercises build muscle while burning fat. The scale stays flat, but your waist circumference shrinks! Solution: Measure waist size instead of relying solely on the scale.',
    weightPlateauCause5Title: '5. Unconscious Drop in Non-Exercise Activity (NEAT)',
    weightPlateauCause5Desc: 'In a calorie deficit, the body unconsciously reduces fidgeting and casual walking to save energy. Solution: Target 7,000–10,000 daily steps.',
    weightPlateauCause6Title: '6. Spine Disc Inflammation & Cortisol Response',
    weightPlateauCause6Desc: 'Chronic spinal pain triggers inflammation and local tissue fluid retention. Solution: Gentle spine rehydration stretches and anti-inflammatory teas.',
    brandingAboutP1: 'The previous name (Växa) meant gradual growth in Swedish. Based on user feedback, the official app name is "Pishraft" (Progress).',
    brandingAboutP2: 'Pishraft is a smart self-care companion with secure cloud storage designed for spine rehab, belly fat reduction, easy nutrition logging, daily Swedish learning, and Gemini AI reports.',
    brandingAboutTitle: 'About the App Brand "Pishraft / Växa"',
    brandingAccentSub: 'Selecting a palette will instantly update all buttons, charts, progress bars, and icons throughout the app.',
    brandingAccentTitle: 'Select Accent Color Palette',
    brandingHeaderSub: 'Customize your workspace accent color and visual theme to match your style.',
    brandingMockBackExercise: 'Back Exercise (Bird Dog)',
    brandingMockCompleted: '72% Completed',
    brandingMockHabitProgress: 'Daily Habit Progress',
    brandingMockHeader: 'Dashboard Preview',
    brandingMockRehabBtn: 'Do Rehab',
    brandingMockSaveBtn: 'Save Changes',
    brandingMockTwoSets: '2 sets done',
    brandingPresetAmberDesc: 'Dynamic, warm, motivating for cardio workouts.',
    brandingPresetAmberName: 'Golden Amber & Energy',
    brandingPresetEmeraldDesc: 'Natural, evoking active recovery, wellness, and health.',
    brandingPresetEmeraldName: 'Wellness Green',
    brandingPresetIndigoDesc: 'Calm, balanced, and great for focus and habit consistency.',
    brandingPresetIndigoName: 'Calm Blue (Default)',
    brandingPresetRoseDesc: 'Modern, vibrant, inspiring daily self-care routines.',
    brandingPresetRoseName: 'Modern Rose & Vitality',
    brandingPresetSkyDesc: 'Light, soothing, representing clarity and ease.',
    brandingPresetSkyName: 'Clear Sky Blue',
    brandingPresetVioletDesc: 'Deep, inspiring for Swedish language study and focus.',
    brandingPresetVioletName: 'Deep Violet & Focus',
    brandingPreviewSub: 'Observe live UI changes instantly in this mockup:',
    brandingPreviewTitle: 'Live Theme Preview',
    brandingSuccessMessage: 'Theme applied successfully system-wide',
    dictionaryCatAll: 'All Variables',
    dictionaryCatCommon: 'Common & Buttons',
    dictionaryCatFinance: 'Finance',
    dictionaryCatHealth: 'Health & Doctor',
    dictionaryCatNav: 'Navigation & Menus',
    dictionaryCatNews: 'News & AI',
    dictionaryCatReminders: 'Reminders',
    dictionaryCatSettings: 'Settings',
    dictionaryCatShopping: 'Shopping List',
    dictionaryCopyTooltip: 'Copy t(\'key\') command',
    dictionaryDesc: 'Centralized reference for all texts, titles, and keys in Persian (fa), English (en), and Swedish (sv)',
    dictionaryFilteredResults: 'Filtered results count:',
    dictionaryItemsUnit: 'items',
    dictionaryKeysUnit: 'keys',
    dictionarySearchPlaceholder: 'Search by key name, Persian, English, or Swedish text...',
    dictionaryThActions: 'Actions',
    dictionaryThEn: '🇬🇧 English (en)',
    dictionaryThFa: '🇮🇷 Persian (fa)',
    dictionaryThKey: 'Variable Key Name',
    dictionaryThSv: '🇸🇪 Swedish (sv)',
    dictionaryTotalKeys: 'Total defined dictionary keys:',
    reminderGeneralSettingsTitle: 'General Settings & Reminder Timers',
    reminderHeaderSub: 'Manage daily reminders, medical appointments, bill schedules, birthdays, and Google Calendar sync',
    notesMood_Calm: '😌 Calm',
    notesMood_Energetic: '⚡ Energetic',
    notesMood_SoreTense: '😣 Sore/Tense',
    notesMood_Tired: '🥱 Tired',
    notesMood_Anxious: '😰 Anxious',
    reportsActiveMinutes: 'Total Active Minutes:',
    reportsAiExportSub: 'Paste this text into AI chat to get ergonomic and health advice.',
    reportsAiExportTitle: 'Structured AI Prompt Export (ChatGPT / Gemini / Claude)',
    reportsAvgEnergyLabel: 'Avg Physical Energy Level:',
    reportsAvgPainLabel: 'Avg Back Pain Intensity:',
    reportsAvgSleepLabel: 'Avg Sleep:',
    reportsAvgWaterLabel: 'Hydration Status:',
    reportsCaloriesBurned: 'Workout Calories Burned:',
    reportsChart1LegendBar: 'Rehab exercise count',
    reportsChart1LegendLine: 'Pain level (0-10)',
    reportsChart1Sub: 'Compare completed spine exercises (green bars) with recorded pain level (orange line).',
    reportsChart1Title: 'Spine Rehab vs Pain Correlation',
    reportsChart1TtBar: 'Spine Exercises',
    reportsChart1TtLine: 'Spine Pain Intensity',
    reportsChart2Target: 'Target limit: {{target}} kcal',
    reportsChart2Title: 'Daily Calorie Intake & Protein',
    reportsChart2TtCal: 'Calories Consumed',
    reportsChart2TtProt: 'Protein Intake',
    reportsChart3Target: 'Water Goal: {{target}} ml',
    reportsChart3Title: 'Water Hydration (ml) & Sleep Hours',
    reportsChart3TtSleep: 'Sleep Hours',
    reportsChart3TtWater: 'Water Intake',
    reportsChart4Goal: 'Goal: {{goal}}',
    reportsChart4GoalLabel: 'Target Weight',
    reportsChart4Title: 'Weight Trajectory & Goal',
    reportsChart4TtWeight: 'Recorded Weight',
    reportsChart5Sub: 'Daily average protein, carbs & fat',
    reportsChart5Title: 'Macronutrient Ratio',
    reportsChartDatePrefix: 'Date:',
    reportsCopied: 'Copied!',
    reportsCopyBtn: 'Copy Full Output Text',
    reportsDailyWaterGoal: 'Daily Target: {{target}} ml',
    reportsDownloadCsvBtn: 'Download CSV Export (Excel / Medical)',
    reportsDownloadDesc: 'Export your data to CSV for Excel/doctors or download a full JSON backup file.',
    reportsDownloadJsonBtn: 'Download Full JSON Backup',
    reportsDownloadTitle: 'Download & Backup All Data',
    reportsEnergyPainSummaryTitle: 'Energy Level & Pain Control',
    reportsFatLossSub: 'Execution count for aerobic and calorie-burning exercises',
    reportsFatLossTitle: 'Cardio Fat Loss & Belly Fat Exercises',
    reportsFoodNotFound: 'No food items found in this period or matching your search.',
    reportsFoodSearchPlaceholder: 'Search food or meal...',
    reportsHoursUnit: 'hrs',
    reportsKpiCalories: 'Average Calories',
    reportsKpiCaloriesSub: 'Target: {{target}}',
    reportsKpiPain: 'Back Pain Index',
    reportsKpiPainSub: 'Avg spine pain intensity',
    reportsKpiRehab: 'Spine Rehab',
    reportsKpiRehabSub: 'Total completed exercises',
    reportsKpiRehabUnit: 'drills',
    reportsKpiScore: 'Consistency Score',
    reportsKpiScoreSub: 'Selected period average',
    reportsKpiSleep: 'Average Sleep',
    reportsKpiSleepSub: 'Target: 7 to 8 hours daily',
    reportsKpiSleepUnit: 'hrs',
    reportsKpiWater: 'Daily Water Intake',
    reportsKpiWaterSub: 'Goal: {{target}} ml',
    reportsMacroCarbs: 'Carbohydrates (g)',
    reportsMacroFat: 'Healthy Fat (g)',
    reportsMacroProtein: 'Protein (g)',
    reportsMealBreakfast: 'Breakfast',
    reportsMealDinner: 'Dinner',
    reportsMealLunch: 'Lunch',
    reportsMealSnack: 'Snack',
    reportsMinUnit: 'mins',
    reportsMoodCalm: 'Calm',
    reportsNoPain: '0 (No Pain)',
    reportsNutritionCount: 'Total foods logged in this period: {{count}} items',
    reportsNutritionTitle: 'Full List of Logged Food & Macronutrients',
    reportsOf10Unit: 'out of 10',
    reportsOf5Unit: 'out of 5',
    reportsPainOf10: 'out of 10',
    reportsPrintBtn: 'Print / PDF',
    reportsPrintTooltip: 'Print or save PDF',
    reportsRange30d: 'Last 30 Days',
    reportsRange7d: 'Last 7 Days',
    reportsRange90d: '90 Days',
    reportsRangeAll: 'All Time',
    reportsRehabDrillsSub: 'Completion count for each rehab drill in selected period',
    reportsRehabDrillsTitle: 'Spine Rehab Drills & Disc Healing Progress',
    reportsShiftWorkTag: 'Work Shift',
    reportsShiftsUnit: 'shifts',
    reportsSleepDiscRole: 'Role in Disc Healing:',
    reportsSleepDiscRoleVal: 'Very High (Key Factor)',
    reportsSleepGoalLabel: 'Sleep Standard Target:',
    reportsSleepGoalVal: '7 to 8 hours',
    reportsSleepGood: 'Good',
    reportsSleepIdeal: 'Optimal & Excellent',
    reportsSleepLow: 'Below Target',
    reportsSleepNotRecorded: 'Not recorded',
    reportsSleepSummaryTitle: 'Nightly Sleep & Recovery Summary',
    reportsTabAiExport: 'AI Export & Files',
    reportsTabCharts: 'Interactive Charts Dashboard',
    reportsTabNutrition: 'Full Nutrition & Food Log',
    reportsTabRehab: 'Rehab & Exercises Log',
    reportsTabSleepWork: 'Sleep & Work Shifts',
    reportsTable1Sub: 'Day-by-day log with rest hours, energy rating, and back pain score',
    reportsTable1Title: 'Daily Sleep & Recovery Log Table',
    reportsTable2Sub: 'Daily water intake in ml and percentage of target achieved',
    reportsTable2Title: 'Daily Water Consumption Log',
    reportsTargetLabel: 'Target',
    reportsThCalories: 'Calories (kcal)',
    reportsThCarbs: 'Carbs (g)',
    reportsThDate: 'Date',
    reportsThEnergy15: 'Energy (1-5)',
    reportsThFat: 'Fat (g)',
    reportsThFoodName: 'Food Name',
    reportsThGoalMl: 'Target (ml)',
    reportsThHydrationStatus: 'Hydration Status',
    reportsThMeal: 'Meal',
    reportsThMood: 'Mood',
    reportsThNotes: 'Notes & Symptoms',
    reportsThPain010: 'Pain (0-10)',
    reportsThProgressPercent: 'Progress %',
    reportsThProtein: 'Protein (g)',
    reportsThQty: 'Quantity',
    reportsThRestEval: 'Rest Assessment',
    reportsThShift: 'Work Shift',
    reportsThSleepHours: 'Sleep Duration (hrs)',
    reportsThWaterMl: 'Water (ml)',
    reportsTimesCount: '{{count}} times ({{percent}}%)',
    reportsTotalDaysCount: 'Total Days: {{count}} days',
    reportsUndefined: 'Not set',
    reportsUnitDrills: 'rehab drills',
    reportsUnitOf10: 'out of 10',
    reportsWaterFull: '💧 Fully Hydrated (Excellent)',
    reportsWaterGood: 'Good',
    reportsWaterLow: 'Low Intake',
    reportsWaterNeedMore: 'Needs More Water',
    reportsWorkDaysCount: 'Logged Work Shifts:',
    reportsWorkSummaryTitle: 'Work Shifts & Physical Activity',
    salaryMisclassifiedDesc: 'These transactions are named Salary/Lön but recorded as expenses. Click to fix them to Income (+).',
    salaryMisclassifiedTitle: 'Detected {{count}} Salary/Income Transactions (Lön)',
    save: 'Save',
    saveBtn: 'Save',
    saveBudgetFormulaBtn: 'Save Formula & Budget Limits',
    saveChanges: 'Save Changes',
    saveTransaction: 'Save Transaction',
    saveTransactionBtn: 'Save Transaction',
    savedSuccessfully: 'Saved successfully ✅',
    savingAndGoalsShare: 'Savings & Goals Allocation ({{ratio}}%):',
    savingsAndTargetShare: 'Savings & goals allocation ({{ratio}}%):',
    savingsGoalsAndPlanning: 'Savings Goals & Financial Planning',
    scanReceipt: 'Scan Receipt with AI',
    scannerSamplePlaceholder: 'Willys\\n2x MILK 1.5L - 37 SEK\\n1x BREAD - 28 SEK\\nTotal: 65 SEK\\nPaid with Card',
    schedules: 'Weekly Schedules',
    schedulesHeaderDesc: 'Plan and manage your personal, work, study, and daily routines for each day of the week.',
    schedulesHeaderTitle: 'Weekly Planner & Daily Routine',
    schedulesSearchPlaceholder: 'Search routine name or description...',
    schedulesPresetTemplates: 'Quick Preset Templates:',
    schedulesPresetWork: 'Work Shift (8 hours)',
    schedulesPresetRehab: 'Spine Rehab / Physio (30 mins)',
    schedulesPresetEducation: 'Study / Learning Session (2 hours)',
    schedulesPresetCardio: 'Cardio & Walking (45 mins)',
    schedulesPresetNutrition: 'Nutrition & Meal Care (30 mins)',
    schedulesPresetWorkTitle: 'Daily Work Shift',
    schedulesPresetWorkDesc: 'Work focus with 5-minute break intervals for back stretches.',
    schedulesPresetRehabTitle: 'Physiotherapy & Back Rehab Exercises',
    schedulesPresetRehabDesc: 'Back disc stretches, morning rehab, and core stabilization.',
    schedulesPresetEduTitle: 'Educational Session (Swedish / Course)',
    schedulesPresetEduDesc: 'Swedish class, specialized courses, or skill learning.',
    schedulesPresetCardioTitle: 'Cardio Workout & Fat Burning Walk',
    schedulesPresetCardioDesc: 'Brisk walking, low-impact cardio, and fat burning.',
    schedulesPresetNutritionTitle: 'Main Meal & Nutrition Planning',
    schedulesPresetNutritionDesc: 'Adequate protein intake, supplements, and hydration.',
    schedulesTotalWeeklyTasks: 'Total Weekly Activities',
    schedulesTotalScheduledHours: 'Scheduled Hours',
    schedulesTodayCompletion: "Today's Completion",
    schedulesNoFilteredRoutines: 'No activities found matching your filter.',
    schedulesGoogleCalDirectTitle: 'Add directly to Google Calendar (Web)',
    schedulesAddToGoogleCalDirect: 'Add to Google Cal',
    schedTaskCountUnit: 'tasks',
    schoolCategory: '🎓 School & Education',
    search: 'Search...',
    seasonalMealPlan: 'Seasonal Meal Plan (GLP-1)',
    seasonalRecipes: 'Seasonal Recipes',
    selectAll: 'Select All',
    selectLanguage: 'Select Language / Välj språk',
    selectMonthForBudgetAnalysis: 'Select Month for Budget Analysis:',
    selectedMonthLabel: 'Selected',
    selectedRowsCount: '{{count}} rows selected',
    settings: 'Settings & Sync',
    settingsHeaderDesc: 'Profile management, Cloudflare D1 cloud database connection, SMTP email setup, and AI API keys',
    settingsHeaderTitle: 'System Settings, Cloud Backup & D1 Sync',
    settingsSaveSuccess: '✓ Settings saved successfully',
    shareEmailLabel: 'Family Member or Colleague Email',
    shareEmailPlaceholder: 'e.g. family@example.com',
    shareError: 'Failed to add share email.',
    shareListBtn: 'Share Shopping List',
    shareModalTitle: 'Manage Access & Share Shopping List',
    shareSuccess: 'Access granted successfully.',
    shiftTypeLabel: 'Shift Type / Activity',
    shopAddItemBtn: 'Add',
    shopAddNewItemTo: 'Add item to {{name}}',
    shopAddNewList: 'Add New List',
    shopAddToListNamed: 'Add to {{name}}',
    shopAdjustQtyModalTitle: 'Adjust Item Quantity & Weight',
    shopAllItemsCount: 'All items ({{count}})',
    shopAllLists: 'All Notebooks ({{count}})',
    shopAllPresets: 'All ({{count}})',
    shopBoughtItems: '{{count}} purchased',
    shopCancel: 'Cancel',
    shopCatDairy: 'Dairy & Eggs',
    shopCatGrocery: 'Groceries & Staples',
    shopCatHousehold: 'Household & Care',
    shopCatMeat: 'Meat & Poultry',
    shopCatOther: 'Other / Misc',
    shopCatProduce: 'Fruits & Vegetables',
    shopClearAll: 'Clear All',
    shopClearBought: 'Clear Purchased',
    shopClickToAdjust: 'Click to adjust quantity and add',
    shopCloseModal: 'Close',
    shopCollaboratorAccess: 'Collaborator Access',
    shopCollaboratorTooltip: 'Only the owner can rename, delete, or manage sharing',
    shopConfirmClearAll: 'Are you sure you want to clear this entire list?',
    shopConfirmClearBought: 'Are you sure you want to clear all purchased items?',
    shopConfirmDeleteList: 'Are you sure you want to delete the list "{{name}}"? All items will be permanently removed.',
    shopAiTranslateList: 'Live Translate for Shopping (AI)',
    shopAiTranslateListTooltip: 'View temporary live translation in Swedish or English without altering database records',
    shopTranslateModalTitle: 'Temporary Grocery Translation (Zero DB Modification)',
    shopTranslateModalDesc: 'Select target language for shopping in store. This translation is for temporary display only and original database records are never modified:',
    shopTranslateTargetSv: '🇸🇪 Swedish (Svenska) - Perfect for ICA, Willys, Coop',
    shopTranslateTargetEn: '🇬🇧 English - International Grocery Terms',
    shopTranslateTargetFa: '🇮🇷 Persian (Farsi) - Standard Persian',
    shopTranslatingWait: 'Translating items with AI... Please wait a moment',
    shopTranslateSuccess: 'Live temporary translation to {{lang}} enabled! Original database records remain untouched.',
    shopActiveTranslationNotice: 'Showing temporary live translation in {{lang}} (Original records safely kept in DB)',
    shopTranslateNoDbHint: 'Original database records remain untouched and only temporary store translation badges are shown.',
    shopChangeTranslateLang: 'Change Language',
    shopHideTranslation: 'Close Translation',
    shopOriginalLabel: 'Original Name',
    shopTranslatedLabel: 'Store Translation',
    shopCopyTranslation: 'Copy Translations',
    shopCopied: 'Copied!',
    shopTranslationsOverview: 'Item Comparison & Store Translation Table',
    shopViewOnList: 'View on Shopping List',
    shopNoItemsToTranslate: 'No items in this list to translate.',
    shopTranslateFailed: 'Could not process AI translation response. Please try again.',
    shopCreateFirstBtn: 'Create New Shopping List',
    shopCreateListSubmit: 'Create List',
    shopCreatedBy: '🏠 Created by: {{name}}',
    shopCreating: 'Creating...',
    shopCustomQtyPh: 'e.g., 1.5 kg or 4 bottles',
    shopDateUnset: 'Not set',
    shopDecrease: 'Decrease',
    shopDeleteItem: 'Delete',
    shopDeleteList: 'Delete List',
    shopEditItem: 'Edit',
    shopEditTitleDate: 'Edit Title & Purchase Date',
    shopEmptyListHint: 'This list is empty! Add needed items above or use quick select.',
    shopEnterSharedList: 'Enter Shared List',
    shopIncrease: 'Increase',
    shopItemNamePh: 'Item name (e.g., Chicken, Milk, Rice...)',
    shopItemQtyPh: 'Qty/Weight (e.g., 2 kg, 1 pack)',
    shopListDateLabel: 'Purchase / Planned Date:',
    shopListNameLabel: 'List Title:',
    shopListNamePh: 'e.g., Friday BBQ, Pharmacy, Supermarket...',
    shopManageShare: 'Manage Sharing',
    shopMarkBought: 'Mark as purchased',
    shopMarkUnbought: 'Mark as unpurchased',
    shopMyLists: 'My Lists',
    shopNeededItems: 'Items to Buy ({{count}})',
    shopNewListBtn: 'New Shopping List',
    shopNewListModalSubtitle: 'Create personal or family shopping list',
    shopNewListModalTitle: 'New Shopping List',
    shopNewListTitleLabel: 'New List Title:',
    shopNoListsDesc: 'Click "Create First List" above to get started',
    shopNoListsYet: 'You haven\\\\\\\\\\\\\\\'t created any shopping lists yet',
    shopNoSharedDesc: 'You can ask family members to share their lists with you by entering your email.',
    shopNoSharedLists: 'No shopping lists have been shared with you yet',
    shopOpenList: 'Open List',
    shopOrCustomQty: 'Or Enter Custom Quantity:',
    shopOwnerYou: '👑 You are the Owner',
    shopPersonalOnly: 'Personal',
    shopPurchaseDateLabel: 'Purchase / Planned Date:',
    shopPurchasedSection: 'Purchased Items ({{count}})',
    shopQuickQtyPick: 'Quick Pick Quantity:',
    shopQuickSelectAdjust: 'Quick Select & Quantity Adjust:',
    shopQuickThemeCreate: 'Quick Theme Creation:',
    shopQuickTitleSuggestions: 'Quick Title Suggestions:',
    shopRemainingItems: '{{count}} remaining',
    shopRenameList: 'Rename List',
    shopRenameModalSubtitle: 'Rename list "{{name}}"',
    shopRenameModalTitle: 'Rename List',
    shopRevokeShare: 'Revoke Access',
    shopSave: 'Save',
    shopSaveRenameBtn: 'Save Changes',
    shopSendShareBtn: 'Send Share Invite',
    shopShareBtn: 'Share',
    shopShareRevokedSuccess: 'Access revoked for {{email}}.',
    shopShareTooltip: 'Share list with spouse or household members',
    shopSharedListFrom: '🏡 Shared List ({{name}})',
    shopSharedWith: 'Shared with: {{emails}}',
    shopSharedWithCount: 'Shared with {{count}} people',
    shopSharedWithMe: 'Shared With Me',
    shopTodayDateFmt: 'Today ({{date}})',
    shopYouAreOwner: '👑 You own this list',
    shopping: 'Smart Shopping List',
    shoppingCatReminder: '🛒 Shopping Tasks',
    shoppingCategories: 'Shopping Categories',
    shoppingHeaderDesc: 'Create custom lists, share with family members, schedule purchase dates, and get AI suggestions',
    shoppingHeaderDescActive: 'Add required items or check off purchased ones. Changes sync live for family members.',
    shoppingHeaderDescOverview: 'Create home, BBQ, or supermarket shopping lists and share them by entering email addresses.',
    shoppingHeaderTitle: 'Smart Shopping Lists & Notebooks Management',
    shoppingTitle: 'Shared Family Shopping Notebook',
    showAllCards: 'Show All Cards',
    signIn: 'Sign In',
    smartPromptSuggestions: 'Smart prompt suggestions for AI Advisor:',
    smtpTitle: 'Email Server Settings (SMTP)',
    sortNewestFirst: 'Sort: Newest First ⬇️',
    spentAmountLabel: 'Spent: {{amount}} {{currency}}',
    spentAmountShort: 'Spent: {{amount}} {{currency}}',
    spentLabel: 'Spent:',
    startDoctorConsultation: 'Start AI Doctor Consultation',
    startExercise: 'Start Workout',
    statBudgetBalance: 'Remaining Budget Balance',
    statBudgetCap: 'Monthly Budget Cap: {{amount}} {{currency}}',
    statExpenseSubtitle: 'Purchases, invoices, and payments',
    statIncomeSubtitle: 'Total salary and receipts',
    statSwishSubtitle: 'Online Swish transactions',
    statSwishTotal: 'Swish Payments',
    statTotalExpense: 'Expenses & Invoices',
    statTotalIncome: 'Total Recorded Income',
    status: 'Status',
    statusNew: 'New',
    storePlaceholder: 'e.g. ICA Supermarket Stockholm',
    success: 'Success',
    surplusAmountAlert: '{{amount}} {{currency}} surplus!',
    surplusExceeded: 'Surplus/Exceeded!',
    surplusLabel: 'Overspend:',
    surplusShort: 'Surplus: {{amount}} {{currency}}',
    swedish: 'Swedish Learning',
    swedishHeaderDesc: 'Daily Swedish vocabulary practice, smart quizzes, workplace dialogue, and Yrkessvenska prep',
    swedishHeaderTitle: 'Swedish Language Learning, SFI & Vocabulary',
    swedishLang: 'Svenska (Swedish)',
    swedishLearning: 'Swedish / SFI Practice',
    swedishSfiTitle: 'Swedish Language Learning (SFI & Professional)',
    symptomAnalyzer: 'Smart Symptom Analyzer',
    syncCloud: 'Cloud Sync',
    synced: 'Synced with Cloud',
    targetCalories: 'Daily Target Calories (kcal)',
    targetCardForBatch: 'Target card/account for all transactions:',
    targetWater: 'Daily Target Water (ml)',
    targetWeightLabel: 'Target Weight (kg)',
    title: 'Title',
    todaySummary: 'Today\\\\\\\\\\\\\\\'s Overview',
    todayUpcomingTab: 'Today & Upcoming Due Dates',
    todosList: 'Today\\\\\\\\\\\\\\\'s Tasks & Schedule',
    total: 'Total',
    totalAllocatedBudget: 'Total Allocated Budget:',
    totalBudgetCapLabel: 'Total Budget Cap:',
    totalExpenditure: 'Total Spent: {{amount}} {{currency}}',
    totalExpenseCap: 'Total Expense Cap:',
    totalExpenseLabel: 'Total Expense:',
    totalExpenses: 'Total Expenses',
    totalIncome: 'Total Income',
    totalIncomeLabel: 'Total Income/Deposits:',
    totalItemsCount: 'Total {{count}} items',
    totalProductsCount: 'Total Products: {{count}} types',
    totalProductsSummary: 'Total products: {{count}} types',
    totalSavingsNeeded: 'Total savings needed for goals:',
    totalSavingsRequiredForGoals: 'Total savings needed for active goals:',
    transactionListTitle: 'Transactions & Invoices List ({{count}})',
    transactionsSuffix: 'transactions',
    transferMisclassifiedDesc: 'These are card balance settlements or internal transfers. Click to convert them to Transfer/Savings.',
    transferMisclassifiedTitle: 'Detected {{count}} Credit Card Settlement / Transfer Transactions',
    txCountInMonth: '({{count}} transactions)',
    typeDeleteToConfirm: 'Type DELETE in the box below to confirm:',
    unallocatedBalanceLabel: '✓ Unallocated Balance (distributable/savable):',
    uncappedCategoriesDesc: 'Categories without dedicated caps (spending report only):',
    uncappedCategoriesTitle: 'Uncapped categories',
    unitDays: 'Days before',
    unitHours: 'Hours before',
    unitMinutes: 'Minutes before',
    unitWeeks: 'Weeks before',
    usedLabel: 'Spent:',
    userName: 'User Name',
    usersAdmin: 'User Management',
    usersAdminHeaderDesc: 'Monitor active users, permission levels, and multi-device sync status',
    usersAdminHeaderTitle: 'User Management & Admin Panel',
    version: 'Version',
    versionHistory: 'Version History',
    viewGaugesAction: 'View & Analyze Month',
    viewInTransactionsList: 'View in Transactions List →',
    viewInTxList: 'View in transactions list →',
    viewingGaugesAction: 'Viewing Gauges',
    visualGraphsTab: 'Visual Graphs & Reports',
    vocabularyQuiz: 'Vocabulary Quiz & Test',
    waterIntake: 'Daily Water Intake',
    waterTracker: 'Daily Water Tracker',
    weeklyMealPlanner: 'Weekly Meal Planner',
    weightAlertGoal: 'Please enter a valid target weight in kg',
    weightAlertHeight: 'Please enter a valid height in cm',
    weightAlertInvalid: 'Please enter a valid weight number',
    weightBmiHealthy: 'Healthy Range: 18.5 - 24.9',
    weightBmiIndex: 'BMI: {{val}}',
    weightBmiLabel: 'Body Mass Index',
    weightBmiNeedWeight: 'Enter height and weight to calculate BMI',
    weightBmiNormal: 'Normal Weight',
    weightBmiNormalAdv: 'Normal & Healthy BMI range - keep up the great work!',
    weightBmiObeseCat: 'Obese range - consulting a physician and guided diet advised',
    weightBmiOverweight: 'Overweight range - balanced calorie deficit recommended',
    weightBmiPendingDesc: 'Log your latest weight to compute current BMI status.',
    weightBmiTitle: 'Body Mass Index (BMI)',
    weightBmiUnder: 'Underweight',
    weightBmiUnderweight: 'Underweight range - consider nutrient-dense meals',
    weightChartFilter30: '30 Days',
    weightChartFilter7: '7 Days',
    weightChartFilter90: '90 Days',
    weightChartFilterAll: 'All Time',
    weightChartNoDataDesc: 'Log weights across multiple days to view progression graphs.',
    weightChartNoDataTitle: 'No weight logs in this timeframe',
    weightChartTitle: 'Weight Progress Chart',
    weightChartTooltipWeight: 'Weight: {{val}} kg',
    weightConfirmDel: 'Are you sure you want to delete this weight entry?',
    weightDirectInputBtn: 'Log Weight',
    weightDirectInputPh: 'Weight (e.g. 82.4)',
    weightGoalChartLabel: 'Target: {{goal}} kg',
    weightHeaderDesc: 'Track weight trends, smart BMI calculation, and progress charts',
    weightHeaderTitle: 'Weight, Body Fat & BMI Tracker',
    weightHistActions: 'Actions',
    weightHistBmi: 'BMI',
    weightHistDelTooltip: 'Delete this entry',
    weightHistWeight: 'Weight',
    weightHistoryCount: '{{count}} records logged',
    weightHistoryEmpty: 'No weight logs recorded yet',
    weightHistoryTitle: 'Weight Log History',
    weightMinus01: '-0.1 kg',
    weightMinus1: '-1 kg',
    weightPlus01: '+0.1 kg',
    weightPlus1: '+1 kg',
    weightProfileGoal: 'Target Weight (kg)',
    weightProfileGoalPh: 'e.g. 75',
    weightProfileHeight: 'Height (cm)',
    weightProfileSaved: 'Profile updated successfully',
    weightProfileTitle: 'Weight Profile & Target Settings',
    weightProfileUpdateBtn: 'Save Profile Settings',
    weightQuickAddTitle: 'Quick Weight Log',
    weightTitle: 'Weight & BMI Tracker',
    weightTracker: 'Weight & BMI Tracker',
    weightTrendDownFull: 'Weight is trending downward (-{{diff}} kg)',
    weightTrendOverallStatusFull: 'Overall Progress: {{status}}',
    weightTrendStableFull: 'Weight is stable ({{diff}} kg)',
    weightTrendUpFull: 'Weight is trending upward (+{{diff}} kg)',
    weightUnitKg: 'kg',
    welcomeBack: 'Welcome Back',
    workCategory: '💼 Work & Admin',
    you: 'You',
    commonCopy: 'Copy',
    doctorAiAnalyzing: 'AI is analyzing medical record...',
    doctorCopied: 'Copied successfully',
    doctorDeleteCons: 'Delete Consultation',
    doctorLiveContextTitle: 'Live Clinical Profile',
    doctorLiveWater: 'Today Water Intake',
    emailPlaceholder: 'Name or email of recipient...',
    fatCardDelete: 'Delete Card',
    financeAdvisorPrompt: 'You are a smart financial advisor and senior budget analyst.',
    financeAdvisorWelcome: 'Hello! I am your AI financial advisor. How can I assist you with budget management or spending analysis?',
    guide: 'Guide',
    learningAddDocSm: 'Attach Doc',
    learningAddSubtopic: 'Add New Sub-topic',
    learningAiCustom: 'Custom Request',
    learningAiFallbackReply: 'AI response generated based on lesson contents.',
    learningAiModalSubmit: 'Analyze & Submit with AI',
    learningAiNoteTitle: 'AI Analysis & Lesson Notes',
    learningAiPromptFromPdf: 'Please extract key points, definitions, and important exam questions from this file.',
    learningAiResponse: 'AI Response',
    learningAttFileNameLabel: 'Attached file name: {{name}}',
    learningAttLabel: 'Attachment',
    learningAttNotesFmt: '- File {{name}} (Type: {{type}})',
    learningAttachDocsBtn: 'Attach Documents (PDF/Word/PPT/Images)',
    learningAttachDocsSm: 'Attach File (Word / PPT / PDF / Image)',
    learningAttachedDocsHeader: 'Attached files and documents for this session:',
    learningBtnDownload: 'Download',
    learningBtnOpenFile: 'Open File',
    learningCancel: 'Cancel',
    learningCopyFullThread: 'Copy Full Lesson Text',
    learningDeleteModalDesc2: 'Are you sure? This action cannot be undone.',
    learningDeleteModalTitle: 'Delete {{type}}',
    learningDeleteUserMsg: 'Delete this user entry',
    learningEditTopic: 'Edit Topic',
    learningExtractedLabel: 'Extracted text from this document:',
    learningExtractedSummaryDoc: 'Extracted text from this document:',
    learningFileSizeLimit: 'File size of «{{name}}» exceeds maximum limit (300 MB).',
    learningInteractiveSession: 'Interactive Session & Note Taking',
    learningMainTopicDesc: 'Main Topic Description',
    learningMainTopicLabel: 'Main Topic: {{title}}',
    learningMainTopicsList: 'Registered Main Topics',
    learningMsgHint: 'You can use the form below to ask questions or add new notes.',
    learningMsgLabel: 'Message / Entry',
    learningNoSessionsYet: 'No lessons recorded for this topic yet.',
    learningNotesTopicsLabel: 'Notes/Topics:',
    learningOverallDesc: 'Overall Description:',
    learningPreviewDownload: 'Download Original File',
    learningPreviewOpenTab: 'Open File in New Tab',
    learningPreviewTitle: 'Study & Analyze Document: {{name}}',
    learningPromptSumm: 'Please provide a comprehensive, structured summary of the main concepts and key points of this topic with complete categorization.',
    learningPromptSummBtn: 'Comprehensive Summary & Key Points',
    learningPromptVocab: 'Please analyze all definitions, technical terms, and key concepts in an organized table with clear examples.',
    learningPromptVocabBtn: 'Terms & Definitions Table',
    learningSaveFirstSession: 'Record First Lesson with AI',
    learningSaveToSessionBtn: 'Save & Add to Lesson',
    learningSaveTopicBtn: 'Save Topic',
    learningSessionIntroOpt: 'Lesson Intro / Description (Optional)',
    learningSessionLabel: 'Lesson',
    learningSessionMainTitle: 'Lesson / Session Title',
    learningSessionStartDate: 'Start Date: {{date}}',
    learningSubtopicFmt: 'Sub-topic {{idx}}: {{title}}\\nNotes: {{notes}}',
    learningSubtopicTitleLabel: 'Sub-topic Title',
    learningTeacherNote: 'Teacher Note',
    learningThisItem: 'this item',
    learningTopicHint: 'You can add topics like "Swedish Language", "Docker Mastery", "Python Programming", "Cooking", or any custom subject.',
    learningTopicHistory: 'Session History for this Topic',
    learningTopicsDiscussed: 'Topics discussed in this lesson:',
    learningTotalTopics: 'Total Main Topics',
    learningTrainAiBtn: 'Analyze & Learn with AI',
    learningTrainingBtn: 'Analyzing & Training...',
    learningUploadingDesc: 'Please wait. Your file is uploading and extracting content for AI analysis.',
    learningVideoTitleLabel: 'Video Title / Name',
    learningViewSessionContinue: 'View Lesson & Continue Discussion',
    learningViewSessions: 'View Sessions',
    notesEnergyTooltip: 'Energy Level: {{level}}',
    notesPainScale10: '10 - Unbearable pain',
    notesPainScale5: '5 - Moderate',
    notesSymptomsPlaceholder: 'e.g. Morning back muscle tightness, slight tingling in left leg...',
    seasonalMealPlanAiAssistantDesc: 'Based on 5 scientific metabolic health rules to optimize meal plans, substitutions, and healthy recipes.',
    seasonalMealPlanAiAssistantTitle: 'GLP-1 Smart AI Nutrition Assistant',
    seasonalMealPlanAiGetAdvice: 'Get Advice from AI',
    seasonalMealPlanAiLoading: 'Receiving AI analysis and recipe...',
    seasonalMealPlanAiPromptPlaceholder: 'e.g., What are the benefits of cold brew coffee, or suggest a healthier alternative...',
    seasonalMealPlanAiPromptAlternative: 'Suggest a low-calorie or healthier alternative for {{foodName}} and snack.',
    seasonalMealPlanAiAnalysisHeader: 'Smart AI Analysis & Recommendation:',
    seasonalMealPlanAiResponse: 'AI Response',
    seasonalMealPlanAiError: 'An error occurred while receiving the AI response. Please try again.',
    seasonalMealPlanCoffeeNutritionInfo: 'Nutritional value of this drink:',
    seasonalMealPlanCoffeeTitle: 'Daily Habit: Healthy Coffee (Cold brew / Espresso + walnuts & chia)',
    seasonalMealPlanCoffeeRecipeTitle: 'Recipe & Golden Synergy for Healthy Coffee:',
    seasonalMealPlanCoffeeBenefits: 'Scientifically Proven Benefits:',
    seasonalMealPlanCopied: '{{title}} copied!',
    seasonalMealPlanDefaultMenu: 'Default Menu',
    seasonalMealPlanDefaultSnackName: 'Healthy Coffee + Greek yogurt & walnuts',
    seasonalMealPlanDefaultSnackIng: 'Cold brew + 150g Greek yogurt + 10g walnuts + 1 tsp chia seeds + turmeric & olive oil',
    seasonalMealPlanDefaultSnackPortion: '1 glass (250ml)',
    seasonalMealPlanDefineNewHabit: 'Define New Health Habit',
    seasonalMealPlanDeleteHabitTooltip: 'Delete Habit',
    seasonalMealPlanDiffEasy: 'Easy',
    seasonalMealPlanDiffMed: 'Medium',
    seasonalMealPlanDiffHard: 'Hard',
    seasonalMealPlanFilterWeek13: 'Weeks 1 & 3',
    seasonalMealPlanFilterWeek24: 'Weeks 2 & 4',
    seasonalMealPlanFoodNameLabel: 'Food Name:',
    seasonalMealPlanHeaderDesc: 'Smart meal planning and metabolic health optimization (GLP-1) with 5 key rules across four seasons.',
    seasonalMealPlanHeaderSubtitle: 'Seasonal Healthy Nutrition & Metabolic Optimization Plan',
    seasonalMealPlanHeaderTitle: 'Monthly & Seasonal GLP-1 Metabolic Meal Plan',
    seasonalMealPlanAiConsulting: 'AI Advice & Optimization',
    seasonalMealPlanRuleFatLabel: 'Healthy Fats',
    seasonalMealPlanRuleFatSub: 'Olives, walnuts, Greek yogurt',
    seasonalMealPlanRuleProteinLabel: 'High Protein',
    seasonalMealPlanRuleProteinSub: 'Chicken, lean beef, fish, legumes',
    seasonalMealPlanRuleFiberLabel: 'Fiber & Bitter Herbs',
    seasonalMealPlanRuleFiberSub: 'Watercress, parsley, okra, spinach',
    seasonalMealPlanRuleGoldenLabel: 'Golden Synergy',
    seasonalMealPlanRuleGoldenSub: 'Turmeric + black pepper + olive oil',
    seasonalMealPlanRuleStartLabel: 'Fiber Starter',
    seasonalMealPlanRuleStartSub: 'Begin meals with salad or greens',
    seasonalMealPlanCurrentSeasonLabel: 'Current Season',
    seasonalMealPlanTabGrid: '30-Day Lunch & Snack Plan',
    seasonalMealPlanTabHabits: 'Health Habits (GLP-1 Coffee)',
    seasonalMealPlanTabShopping: 'Weekly Shopping Checklist',
    seasonalMealPlanTabSummary: 'Monthly Summary',
    seasonalMealPlanTabNutrition: 'Nutritional Analysis',
    seasonalMealPlanTabTips: 'Meal Prep Tips',
    seasonalMealPlanMealFilterLabel: 'Meal:',
    seasonalMealPlanFilterAll: 'All',
    seasonalMealPlanFilterLunch: 'Lunch',
    seasonalMealPlanFilterSnack: 'Snack',
    seasonalMealPlanWeekFilterLabel: 'Week:',
    seasonalMealPlanGridInfo: 'Each day includes a nutrient-dense lunch and metabolic snack.',
    seasonalMealPlanDaysCount: 'Days: {{count}} days',
    seasonalMealPlanWeekNum: 'Week {{num}}',
    seasonalMealPlanEditMealsTitle: 'Edit Lunch & Snack',
    seasonalMealPlanLunchTitle: 'Lunch Meal',
    seasonalMealPlanPortionLabel: 'Portion:',
    seasonalMealPlanCalorie: 'Calories',
    seasonalMealPlanProtein: 'Protein',
    seasonalMealPlanCarb: 'Carbs',
    seasonalMealPlanFat: 'Fat',
    seasonalMealPlanSideDish: 'Side Dish:',
    seasonalMealPlanDailyProtocol: 'Special Daily Protocol',
    seasonalMealPlanGLP1Stimulation: 'Natural Stimulation of GLP-1 & GIP Hormones',
    seasonalMealPlanCompletedToday: 'Completed for Today ✨',
    seasonalMealPlanChecklistTitle: 'Metabolic Habits & Daily Protocols Checklist',
    seasonalMealPlanChecklistDesc: 'Daily adherence doubles fat oxidation and stabilizes glucose response.',
    seasonalMealPlanTodayStatus: 'Today\'s Status:',
    seasonalMealPlanStatusDone: 'Done ✨',
    seasonalMealPlanStatusPending: 'Not Done Yet',
    seasonalMealPlanMarkedDone: 'Completed',
    seasonalMealPlanShoppingListTitle: 'Weekly Shopping Checklist for {{seasonName}}',
    seasonalMealPlanShoppingListDesc: 'Key ingredients to supply fiber, healthy fats, and bitter compounds this season',
    seasonalMealPlanShoppingListCopyPrefix: 'Shopping List',
    seasonalMealPlanCopyAllList: 'Copy Full Shopping List',
    seasonalMealPlanCatProtein: 'Protein & Dairy Sources',
    seasonalMealPlanCatGrains: 'Rice & High-Fiber Legumes',
    seasonalMealPlanCatVeg: 'Vegetables & Bitter Herbs',
    seasonalMealPlanCatFat: 'Healthy Fats & Spices',
    seasonalMealPlanMonthlySummaryTitle: 'Monthly Ingredients Summary ({{seasonName}})',
    seasonalMealPlanSummProtein: 'Lean Meat & Poultry:',
    seasonalMealPlanSummProteinVal: 'Approx. 3.5 to 4 kg',
    seasonalMealPlanSummLegumes: 'Legumes & Dietary Fiber:',
    seasonalMealPlanSummLegumesVal: 'Approx. 3 to 4 kg',
    seasonalMealPlanNutritionAnalysisTitle: 'Nutritional Analysis & GLP-1 Weight Management Mechanism ({{seasonName}})',
    seasonalMealPlanNutrProtein: 'Protein Ratio',
    seasonalMealPlanNutrProteinVal: '30% of daily intake',
    seasonalMealPlanNutrCarb: 'Complex Carbohydrates',
    seasonalMealPlanNutrCarbVal: '40% (Portion-controlled rice)',
    seasonalMealPlanNutrFat: 'Healthy Fats',
    seasonalMealPlanNutrFatVal: '30% (Olive oil, walnuts)',
    seasonalMealPlanEditDayTitle: 'Edit Day {{dayName}} (Lunch & Snack)',
    seasonalMealPlanPortionSizeLabel: 'Portion Size:',
    seasonalMealPlanIngredientsLabel: 'Main Ingredients:',
    seasonalMealPlanProteinLabel: 'Protein (g):',
    seasonalMealPlanCarbLabel: 'Carbs (g):',
    seasonalMealPlanFatLabel: 'Fat (g):',
    seasonalMealPlanSideDishLabel: 'Recommended Side:',
    seasonalMealPlanSnackSettings: 'Snack Settings',
    seasonalMealPlanSaveToFirebase: 'Save Changes to Firebase',
    seasonalMealPlanHabitTitleLabel: 'Habit Title:',
    seasonalMealPlanHabitTitlePlaceholder: 'e.g., 20-Minute Post-Meal Walk',
    seasonalMealPlanHabitDescLabel: 'Brief Description:',
    seasonalMealPlanHabitDescPlaceholder: 'e.g., Light walking to blunt postprandial glucose spike',
    seasonalMealPlanHabitBenefitLabel: 'Key Health Benefit:',
    seasonalMealPlanHabitBenefitPlaceholder: 'e.g., Enhances insulin sensitivity and prevents post-meal lethargy',
    seasonalMealPlanQuestionLabel: 'Question or Recipe Request:',
    seasonalMealPlanSnackType: 'Snack',
    seasonalMealPlanLunchType: 'Lunch',
    seasonalMealPlanLogLunchTitle: 'Log Lunch to Nutrition Diary',
    seasonalMealPlanLogSnackTitle: 'Log Snack to Nutrition Diary',
    seasonalMealPlanMealLogged: '"{{foodTitle}}" logged to today\'s {{mealType}} 🍲',
    seasonalMealPlanSavedSuccess: 'Changes saved successfully ✨',
    seasonalMealPlanUpdatedLocally: 'Plan updated (Sign in to sync with cloud)',
    seasonalMealPlanSaveError: 'Error saving changes',
    seasonalMealPlanResetConfirm: 'Are you sure you want to reset {{seasonName}} plan to default?',
    seasonalMealPlanResetSuccess: '{{seasonName}} plan reset to default menu',
    seasonalMealPlanCustomHabitDesc: 'User custom health habit',
    seasonalMealPlanCustomHabitBenefit: 'Boosts energy and improves metabolic health',
    seasonalMealPlanCustomHabitAdded: 'New habit added successfully ✨',
    seasonalMealPlanCustomHabitRemoved: 'Custom habit deleted',
    seasonalMealPlanKeyBenefitsLabel: 'Key Benefits:',
    seasonalMealPlanLogCoffeeToday: 'Log today\'s coffee ☕',
    seasonalMealPlanLogLunch: 'Log Lunch',
    seasonalMealPlanLogSnack: 'Log Snack',
    seasonalMealPlanLogToday: 'Log Today',
    seasonalMealPlanLunchSettings: 'Lunch Settings',
    seasonalMealPlanPrepTipsTitle: 'Time-saving tips & quick meal prep',
    seasonalMealPlanResetTooltip: 'Reset this season\'s plan to default',
    seasonalMealPlanSaveHabitToFirebase: 'Save habit to Firebase',
    seasonalMealPlanSelectedFood: 'Selected Food:',
    seasonalMealPlanSnackIngredientsLabel: 'Snack Ingredients:',
    seasonalMealPlanSnackNameLabel: 'Snack Name:',
    seasonalMealPlanSnackTitle: 'Snack Meal',
    seasonalMealPlanSummOliveOil: 'Extra Virgin Olive Oil:',
    seasonalMealPlanSummOliveOilVal: '2 to 4 bottles for the family',
    weightBmiObese: 'Obesity (Obese)',
    weightBmiObeseAdv: 'Your BMI is in the obese range. Gradual weight reduction immediately decreases physical pressure on your spinal discs. Follow a balanced diet and regular low-impact cardio exercises.',
    weightBmiOver: 'Overweight',
    weightBmiOverAdv: 'You are slightly overweight. Moderate weight loss (approx. 0.5 kg/week) combined with calorie tracking and light core exercises will significantly relieve back pain.',
    weightBmiPending: 'Calculation awaiting height input',
    weightBmiUnderAdv: 'We recommend increasing daily caloric and protein intake. Light strength training will help build healthy muscle mass.',
    weightHistDate: 'Recorded Date',
    weightLogDate: 'Log Weight for: {{date}}',
    weightProfileHeightPh: 'e.g. 178',
    weightSaveBtn: 'Save weight for this date',
    weightSpecify: 'Specify your weight (kg)',
    targetWeightWeeklyRate: 'Estimated rate: {{rate}} kg/week',
    seasonalMealPlanAddCustomHabit: 'Add New Custom Habit',
    rehabDefaultPainLocation: 'Lower back & spine',
    rehabDefaultLimitations: 'Limited prolonged sitting and bending',
    rehabDefaultEquipment: 'Yoga mat, no special equipment',
    rehabIntakeUserInfo: 'User body assessment information:',
    rehabPromptAiInstructions: 'Important instruction: Keep the response very concise (max 2-3 sentences without any Markdown symbols like ## or ** or tables) so it can directly be saved as exercise instructions.',
    swedishModuleTitle: 'Module 4 — Swedish Language Learning Tracker',
    swedishModuleDesc: 'Track progress and goals learned across external apps; includes daily SFI skill enhancement tips.',
    sweTaskVerbsTitle: 'Practical Swedish Verbs (Svenska Verb)',
    sweTaskVerbsTopic: 'Mastery of action verbs, present/past tenses, and regular/irregular conjugation',
    sweTaskVerbsDur: '10-15 min',
    sweTaskEmpTitle: 'Workplace & Employment Vocabulary (Arbete & Jobb)',
    sweTaskEmpTopic: 'Office expressions, job applications, dialog with colleagues and managers',
    sweTaskEmpDur: '10-15 min',
    sweTaskIndepTitle: 'Independent Daily Practice & Study',
    sweTaskIndepTopic: 'Self-directed learning tracking across other apps and study materials',
    sweTaskIndepDur: '10-15 min',
    swedishTodayProgress: "Today's Goal Progress",
    swedishTopicsCount: '{{completed}} of {{total}} Swedish topics',
    swedishTodayStudyTime: 'Tracked Study Time Today',
    swedishMinutesEquivalent: 'equivalent minutes',
    swedishChecklistTitle: 'Self-Assessment Swedish Learning Checklists',
    swedishTopicDetail: 'Topic Details:',
    swedishNoticeBox: '💡 Please note: You complete these learning topics in external apps (such as Duolingo, Memrise, or SFI classes) and use Vexa to monitor and check off your daily goals.',
    swedishDailyTipsTitle: 'Daily Practical Tips (3 Key Swedish Insights)',
    swedishGetNewTips: 'Get 3 New Tips',
    swedishDailyKeyword: "Today's Keyword:",
    swedishKeywordColleague: 'Arbetskamrat (Colleague / Coworker)',
    swedishKeywordPronounce: 'Pronunciation: ar-bets-kam-rat',
    activityLogTitle: 'Module 7 — Daily Activity Log',
    activityLogDesc: 'Log commutes, physiotherapy visits, recreation, shopping, and miscellaneous learning while maintaining spinal alignment awareness.',
    activityLogActiveTime: 'Extra Activity Time',
    activityLogMinutesToday: 'minutes today',
    activityLogEstimatedCalories: 'Estimated Extra Calories',
    activityLogActiveCalories: 'active calories',
    activityLogPresetsTitle: 'Quick Preset Activity Templates',
    activityLogMinutesShort: 'min',
    activityLogManualFormTitle: 'Manual Custom Activity Entry',
    activityLogFieldTitle: 'Activity Title',
    activityLogFieldTitlePh: 'e.g., Gentle backstroke swimming',
    activityLogFieldStartTime: 'Start Time',
    activityLogFieldEndTime: 'End Time',
    activityLogFieldDuration: 'Duration (min)',
    activityLogFieldCalories: 'Extra Calories (Optional)',
    activityLogFieldCaloriesPh: 'e.g., 150',
    activityLogFieldNotes: 'Physical Notes / Comfort & Pain Observations',
    activityLogFieldNotesPh: 'e.g., No lumbar pain felt. Glutes and core were engaged smoothly.',
    activityLogSaveBtn: 'Save Activity',
    activityLogTodayListTitle: 'Logged Activities Today',
    activityLogEmptyState: 'No extra activities logged for today yet. Use quick presets or fill the manual form.',
    activityLogDeleteTooltip: 'Delete activity',
    activityLogApproxCal: 'Approx. burn: ~{{cal}} kcal',
    schedulesHeaderSubtitle: 'Weekly Planner & Routine Management',
    schedulesDownloadIcsBtn: 'Download Weekly Routine (.ics)',
    schedulesDownloadIcsTooltip: 'Download comprehensive .ics calendar file based on weekly routine for native phone alarms',
    schedulesTabToday: "📋 Today's Routine",
    schedulesTabManage: '⚙️ Manage Weekly Schedule',
    schedulesSelectedDayLabel: 'Selected day for monitoring and editing:',
    schedulesRoutineCount: '{{count}} routines',
    schedulesEmptyDay: 'Empty',
    schedulesTasksChecklistForDay: 'Activities and Routine Checklist for {{day}}',
    schedulesTasksCount: '{{count}} scheduled tasks',
    schedulesCopyAllWeek: '📋 Copy to whole week',
    schedulesCopyAllWeekTooltip: "Copy this day's schedule to all days of the week",
    schedulesNoTasksTitle: 'No schedule defined for {{day}}',
    schedulesNoTasksDesc: 'No default routines set for this day. Would you like to copy weekday routines or create a new activity?',
    schedulesCopyMonday: '📋 Copy Monday Routine to Today',
    schedulesAddManualTask: '➕ Add Manual Activity',
    schedulesWorkTag: 'Work Shift',
    schedulesStudyTag: 'Study / SFI',
    schedulesPhoneAlarm: 'Phone Alarm',
    schedulesPhoneAlarmTooltip: 'Alarm and phone notification are active',
    schedulesGoogleCalTooltip: 'Add to Google Calendar to receive personal reminder',
    schedulesGoogleCalendar: 'Google Calendar',
    schedulesManageRoutineTitle: '⚙️ Manage & Edit Routines for:',
    schedulesManageRoutineSubtitle: 'To toggle phone alarms or Google Calendar sync, click the corresponding chips on each card.',
    schedulesCopyThisDayToAll: 'Copy this day to whole week',
    schedulesAddNewRoutineBtn: 'Add New Activity',
    schedulesEditRoutineFormTitle: '📝 Edit Weekly Routine Activity',
    schedulesAddRoutineFormTitle: '➕ Add New Routine Activity',
    schedulesFormDayOfWeek: '📅 Day of the week for this activity:',
    schedulesFormQuickTime: '⚡ Quick Start Time Shortcuts:',
    schedulesFormStartTime: '🕒 Start Time',
    schedulesFormEndTime: '🕒 End Time (Optional)',
    schedulesFormTitle: '📝 Routine Activity Title *',
    schedulesFormTitlePh: 'e.g. Work shift, Morning workout, Swedish study...',
    schedulesFormDesc: '💬 Details or Goals (Optional)',
    schedulesFormDescPh: 'Additional notes, goals, or targets for this session...',
    schedulesFormSyncAttendance: '🔗 Auto-sync Attendance:',
    schedulesFormSyncWork: 'Auto-log "Work Shift"',
    schedulesFormSyncStudy: 'Auto-log "Educational Activity / Course"',
    sleepDuration: 'Sleep Duration',
    sleepOptimal: 'Optimal Sleep 😴',
    sleepLong: 'Long Sleep 💤',
    sleepModerate: 'Moderate Sleep 🌙',
    sleepLow: 'Low Sleep ⚠️',
    schedulesFormPhoneAlarmDesc: 'Sends native notification to your device when the activity starts.',
    schedulesFormGoogleCalDesc: 'This activity will be exported to the .ics calendar file for sync.',
    schedulesCancel: 'Cancel',
    schedulesSaveRoutine: 'Save Routine',
    schedulesNoRoutinesForDay: 'No routines scheduled for {{day}}.',
    schedulesNoRoutinesHint: 'Click "Add New Activity" or use "Copy this day to whole week" for fast setup.',
    schedulesPhoneAlarmActive: 'Phone Alarm: Active',
    schedulesPhoneAlarmInactive: 'Phone Alarm: Disabled',
    schedulesGoogleCalActive: 'Google Calendar: Active',
    schedulesGoogleCalInactive: 'Google Calendar: Disabled',
    schedulesQuickCopyTo: 'Quick copy to:',
    schedulesEditFull: 'Edit',
    schedulesDeleteActivity: 'Delete activity',
    schedulesWeeklyAttendanceStatus: 'Weekly Attendance Status (Mon - Sun)',
    schedulesWorkPresence: 'Work Shift',
    schedulesNonWorkDay: 'Off',
    schedulesClassPresence: 'Study Class',
    schedulesNoStudyDay: 'No Class',
    schedulesTotalWorkShifts: 'Total Work Shifts',
    schedulesWorkDaysThisWeek: 'work days this week',
    schedulesTotalClasses: 'Total Study Classes',
    schedulesClassesThisWeek: 'sessions this week',
    schedulesConfirmCopyWeek: 'Do you want to copy the schedule for {{day}} to all days of the week? This will overwrite existing routines.',
    schedulesConfirmCopyMonday: 'Do you want to copy the Monday routine for {{day}}?',
    schedulesConfirmDelete: 'Are you sure you want to delete this routine?',
    schedulesCopiedSuccess: 'Activity "{{title}}" was successfully copied to {{day}}.',
    schedulesNoCalendarAlert: 'No activities have been marked with "Google Calendar (Reminder)".\n\nPlease enable the "Google Calendar" chip on tasks in your weekly schedule to include them in the exported file.',
    schedMon: 'Monday (Mon)',
    schedTue: 'Tuesday (Tue)',
    schedWed: 'Wednesday (Wed)',
    schedThu: 'Thursday (Thu)',
    schedFri: 'Friday (Fri)',
    schedSat: 'Saturday (Sat)',
    schedSun: 'Sunday (Sun)',
    schedUnknownDay: 'Unknown',

    // Weight, Body Fat & BMI Module Translations
    weightBodyFatSpecify: "Body Fat % (Optional)",
    saveToD1Btn: "Save to Cloudflare D1",
    savingToD1Btn: "Saving...",
    physicalProfileTitle: "Anatomical Profile & Goals",
    heightCmLabel: "Height (cm)",
    targetWeightKgLabel: "Target Weight (kg)",
    targetBodyFatPctLabel: "Target Body Fat %",
    saveProfileBtn: "Update Profile Goals",
    profileSavedSuccess: "Profile goals updated successfully.",
    currentWeightTitle: "Current Weight",
    bmiIndexTitle: "BMI Index",
    bmiUnderweight: "Underweight",
    bmiNormal: "Normal weight",
    bmiOverweight: "Overweight",
    bmiObeseCat: "Obese",
    bmiAdviceUnder: "Your weight is below normal. Increasing muscle mass with protein nutrition supports your spine.",
    bmiAdviceNormal: "Your BMI is in an optimal range. This minimizes pressure on your lumbar vertebrae.",
    bmiAdviceOver: "Slightly overweight. Losing 3-5 kg reduces pressure on L4-L5 lumbar discs by up to 15%.",
    bmiAdviceObese: "BMI above 30 indicates significant joint and back strain. Gradual weight loss is recommended.",
    currentBodyFatTitle: "Current Body Fat",
    bodyFatNotLogged: "Not Logged",
    fatCatLow: "Very Low (Athletic)",
    fatCatOptimal: "Optimal & Fit",
    fatCatModerate: "Moderate",
    fatCatHigh: "High (Needs Fat Loss)",
    distanceToWeightGoal: "Distance to Target Weight",
    distanceToFatGoal: "Distance to Fat Goal",
    goalReached: "Goal Reached! 🎉",
    metricWeightToggle: "Weight (kg)",
    metricFatToggle: "Body Fat (%)",
    rangeAll: "All Records",
    range30Days: "Last 30 Days",
    range90Days: "Last 90 Days",
    targetWeightLine: "Target Weight Line",
    targetFatLine: "Target Fat Line",
    noChartData: "No measurement data logged yet. Log your first weight above.",
    noFatDataForRange: "No body fat data recorded in this period.",
    bodyCompAiTitle: "Smart Body Composition AI Analysis",
    bodyCompAiSubtitle: "Smart analysis of weight, fat and muscle based on real D1 records",
    analyzeCurrentStateBtn: "Analyze Current State",
    analyzingStateBtn: "Analyzing...",
    askMusclePreserveBtn: "How to Preserve Muscle?",
    calculatingBtn: "Calculating...",
    chipCurrentWeightD1: "Current D1 Weight",
    chipWeightGoalD1: "Target D1 Weight",
    chipBodyFatCurrent: "Current Body Fat",
    chipBodyFatGoalD1: "Target D1 Fat",
    requiresDataLog: "Data Log Required",
    aiBodyCompResultTitle: "Body Composition AI Diagnosis (Metabolic Doctor)",
    aiMuscleResultTitle: "Muscle Preservation Protocol During Fat Loss",
    recomTitle: "3 Practical Recommendations for Fat Loss & Muscle Preservation",
    recom1Text: "Adequate Protein Intake: Consume 1.6 to 2.2g of protein per kg of body weight daily to prevent muscle catabolism.",
    recom2Text: "Progressive Resistance Training: Perform strength training at least 3 times a week to keep muscle hypertrophy signals active.",
    recom3Text: "Moderate Caloric Deficit (15-20%): Avoid severe starvation diets so the body utilizes fat stores instead of muscle for fuel.",
    plateauTitle: "Weight Loss Plateau Diagnostic (Plateau AI)",
    plateauSubtitle: "If your weight has stalled for weeks, analyze physiological causes",
    analyzePlateauBtn: "Analyze Plateau Cause",
    measurementHistoryTitle: "Measurement History Table",
    colDate: "Date",
    colWeight: "Weight (kg)",
    colBodyFat: "Body Fat (%)",
    colBMI: "BMI",
    colActions: "Actions",
    deleteRecord: "Delete Record",
    confirmDeleteWeight: "Are you sure you want to delete this weight record?",
    d1DataSourceTag: "Data Source: Cloudflare D1",
    fetchingD1HealthData: "Fetching latest health data from Cloudflare D1...",
    nutriBackToToday: "Back to Today",
    nutriSelectDate: "Select Date",

    // Multi-Day Physiotherapy Program System
    multiDayProgramsTab: "Multi-Day Exercise Programs",
    exerciseLibraryTab: "Standalone Exercise Library",
    multiDayProgramsHeader: "Multi-Day Physiotherapy Program Manager",
    multiDayProgramsDesc: "Design multi-day programs, define daily exercises, import JSON, and sync with your weekly routine",
    importJsonBtn: "Import Program JSON",
    createNewProgramBtn: "Create New Program",
    noProgramsYetTitle: "No multi-day training programs defined yet",
    noProgramsYetDesc: "You can create a new multi-day program or import specialized physiotherapy JSON templates.",
    loadSampleProgramJson: "Load Ready Program (Sample JSON)",
    buildManualProgram: "Create Manual Program",
    activeProgramBadge: "Active Program",
    noProgramDesc: "No additional description",
    trainingDaysCount: "{{count}} Training Days",
    setAsActiveProgram: "Activate This Program",
    currentActiveProgram: "Current Active Program",
    editProgramTooltip: "Edit Title & Properties",
    deleteProgramTooltip: "Delete Program",
    editProgramTitleModal: "Edit Exercise Program",
    createProgramTitleModal: "Create New Exercise Program",
    programTitleLabel: "Program Title:",
    programTitlePlaceholder: "e.g. 21-Day Lumbar Disc Protocol",
    programDescLabel: "Description & Therapy Goals:",
    programDescPlaceholder: "e.g. 3-stage protocol for sciatic nerve decompression...",
    programDifficultyLabel: "Difficulty Level:",
    difficultyBeginnerOption: "Beginner / Light",
    difficultyIntermediateOption: "Intermediate / Standard",
    difficultyAdvancedOption: "Advanced / Specialized",
    savingProgramBtn: "Saving...",
    saveProgramBtn: "Save Program",
    confirmDeleteProgram: "Are you sure you want to delete this exercise program and all its days?",
    dbSaveError: "Error saving program to D1 database.",
    dbDeleteError: "Error deleting program from D1.",
    dbActivateError: "Error activating program.",
    dbUpdateDaysError: "Error updating program days in D1.",
    addNewProgramDayBtn: "Add New Training Day",
    programDayDefaultTitle: "Day {{day}} — Recovery & Strengthening",
    runWorkoutForDay: "Run Workout for This Day",
    runGuidedWorkoutForDay: "Run Guided Workout",
    scheduleDayInPlanner: "Schedule in Planner",
    scheduleDayBtn: "Add to Weekly Routine",
    editDayModalTitle: "Edit Day {{day}}",
    dayTitleInputLabel: "Day Title:",
    dayNotesInputLabel: "Day Notes & Guidance:",
    dayNotesPlaceholder: "e.g. Perform exercises in 2 sets morning and evening...",
    tabPickFromLibrary: "Pick from Library",
    tabAddCustomExercise: "Add Custom Exercise",
    tabJsonEditor: "JSON Text Editor",
    selectedExercisesCount: "Selected Exercises for this Day ({{count}}):",
    noExercisesSelectedForDay: "No exercises selected for this day yet.",
    availableLibraryExercises: "Available Library Exercises (Click to toggle):",
    searchExercisesPlaceholder: "Search exercises...",
    exerciseAddedTag: "Added",
    addCustomExNameLabel: "Custom Exercise Name:",
    addCustomExNamePh: "e.g. Resistance Band Lumbar Stretch",
    addCustomExSetsLabel: "Sets:",
    addCustomExRepsLabel: "Reps / Hold:",
    addCustomExRestLabel: "Rest Between Sets:",
    addCustomExDurationLabel: "Duration (min):",
    addCustomExPurposeLabel: "Exercise Purpose:",
    addCustomExTargetLabel: "Target Muscles:",
    addCustomExDescLabel: "Instructions:",
    addExerciseToDayBtn: "Add Exercise to Day",
    jsonArrayError: "JSON format must be an Array of exercises.",
    confirmDeleteDay: "Are you sure you want to delete this training day?",
    saveDayChangesBtn: "Save Day Changes",
    importJsonModalTitle: "Import Multi-Day Program (JSON)",
    jsonParseError: "Invalid JSON format: {{error}}",
    importSuccessMsg: "Training programs successfully saved to the system.",
    importFailed: "Failed to import training program.",
    pasteSampleJsonBtn: "Paste Full Sample JSON",
    uploadJsonFileLabel: "Upload JSON File",
    jsonInputLabel: "Structured Program JSON Content:",
    jsonInputPlaceholder: "Paste JSON content here...",
    importingPrograms: "Importing...",
    scheduleDayToPlanner: "Schedule Day to Weekly Planner",
    timeRequired: "Start time is required.",
    scheduledSuccessfully: "Workout scheduled successfully in weekly planner.",
    dayExerciseCountInfo: "Exercises in this day: {{count}}",
    selectWeekday: "Select Weekday:",
    startTime: "Start Time:",
    endTime: "End Time (optional):",
    enableReminder: "Enable Reminder & Alarm",
    scheduleConfirmBtn: "Schedule Workout",
    exerciseDetailModalTitle: "Physiotherapy Exercise Details",
    viewExerciseDetails: "View exercise details",
    exerciseDetailClose: "Close",
    addToProgramModalTitle: "Add Exercise to Multi-Day Program",
    targetProgramLabel: "Target Program:",
    selectProgramPlaceholder: "Select program...",
    noProgramsAvailableWarning: "No multi-day programs available. Create a program first.",
    targetDayLabel: "Target Training Day:",
    selectDayPlaceholder: "Select training day...",
    createNewDayOption: "+ Create a new training day in this program",
    newDayTitleLabel: "New Training Day Title:",
    newDayTitlePlaceholder: "e.g. Day focused on posterior chain strengthening",
    programDaySelectorOption: "Day {{num}}: {{title}}",
    exerciseSetsLabel: "Sets:",
    exerciseRepsLabel: "Reps / Hold:",
    exerciseRestLabel: "Rest:",
    exerciseDurationLabel: "Estimated Duration (minutes):",
    addToProgramBtn: "Add to Program",
    addingToProgram: "Adding...",
    exerciseAddedSuccess: "Exercise successfully added to training program.",
    exerciseAddFailed: "Failed to add exercise to program.",
    selectProgramAndDayWarning: "Please select both a program and a training day.",
    exerciseScopeLabel: "Scope:",
    exerciseScopeGlobal: "Global (System Template)",
    exerciseScopePersonal: "Personal (Custom)",
    exerciseBadgeGlobal: "Global",
    exerciseBadgePersonal: "Personal",
    exerciseScopeFilterAll: "All Exercises (Global & Personal)",
    exerciseScopeFilterGlobal: "Global Library",
    exerciseScopeFilterPersonal: "My Personal Exercises",
    exercisePrecautionsLabel: "Precautions & Safety Warnings:",
    exerciseEquipmentLabel: "Required Equipment:",
    exerciseEquipmentNone: "No equipment required (bodyweight only)",
    exerciseInstructionsLabel: "Instructions & Proper Technique:",
    exerciseVideoPlayerTitle: "Video Player",
    exerciseImageAlt: "Instructional image for {{name}}",
    exerciseCreatePersonalCopyBtn: "Create Personal Copy",
    exerciseCreatingCopy: "Creating personal copy...",
    exerciseCopySuccess: "Personal copy created and saved to your library.",
    exerciseCopyFailed: "Failed to create personal copy.",
    exerciseGlobalCannotEdit: "Global exercises cannot be edited or deleted directly. You can create a personal copy.",
    exerciseDeleteConfirm: "Are you sure you want to delete this personal exercise from your library?",
    exerciseDeleteSuccess: "Personal exercise deleted successfully.",
    exerciseDeleteFailed: "Failed to delete exercise.",
    exerciseAddToProgramAction: "Add to Program",
    rehabDaysCount: "{{count}} Training Days",
    rehabActiveProgramCurrent: "Current Active Program",
    rehabEditProgram: "Edit Training Program",
    rehabCreateProgram: "Create New Training Program",
    rehabProgramTitleLabel: "Program Title:",
    rehabProgramTitlePlaceholder: "e.g., 21-Day Lumbar Disc Recovery Protocol",
    rehabProgramDescLabel: "Description & Therapeutic Goals:",
    rehabProgramDescPlaceholder: "e.g., 3-stage protocol to decompress the sciatic nerve...",
    rehabDifficultyLabel: "Difficulty Level:",
    rehabDiffBeginner: "Beginner / Light",
    rehabDiffIntermediate: "Intermediate / Standard",
    rehabDiffAdvanced: "Advanced / Intensive",
    rehabBeginner: "Beginner",
    rehabIntermediate: "Intermediate",
    rehabAdvanced: "Advanced",
    rehabSaveBtn: "Save Program",
    dbProgramSaveError: "Error saving program to D1 database.",
    dbProgramDeleteError: "Error deleting program from D1.",
    dbProgramActivateError: "Error activating program.",
    dbProgramUpdateDaysError: "Error updating program days in D1.",
    manageProgramDaysTitle: "Manage Days for '{{title}}'",
    totalDaysDesigned: "Total designed days: {{count}} days",
    noDaysInProgramYet: "No training days defined for this program yet.",
    startGuidedWorkoutBtn: "Start Guided Workout",
    scheduleWorkoutBtn: "Schedule Workout",
    selectDayToViewLabel: "Select day to manage:",
    dayNumberLabel: "Day {{num}}",
    dayNumberOption: "Day {{num}}",
    editDayTitleAndNotes: "Edit Day Title & Notes",
    closeDayEdit: "Close",
    dayTitleFieldLabel: "Day Title:",
    dayTitleFieldPh: "e.g. Day 1 — Decompression & Psoas Stretch",
    dayNotesFieldLabel: "Training notes & clinical tips for this day:",
    dayNotesFieldPh: "e.g. Perform these exercises before breakfast...",
    saveDayDetailsBtn: "Save Day Changes",
    deleteThisDayBtn: "Delete This Day",
    addNewTrainingDayBtn: "Add New Training Day",
    openDayJsonEditorBtn: "Edit Day JSON",
    exercisesInDayCount: "{{count}} exercises in this day",
    exercisesInDayHeading: "Exercises registered for Day {{day}} ({{count}}):",
    hasVideoInstruction: "Includes instructional video",
    hasImageInstruction: "Includes guide image",
    viewCompleteExerciseDetails: "View complete exercise details & media",
    clickForCompleteDetails: "Click to view full details",
    addExerciseToDaySelect: "Add from exercise library...",
    addNewCustomExerciseToDay: "Create New Custom Exercise",
    noExercisesInDay: "No exercises defined for this day yet.",
    addFirstExercisePrompt: "Select an exercise from the library above or create a new one.",
    confirmRemoveExerciseFromDay: "Are you sure you want to remove this exercise from this day?",
    editDayExercisesJsonTitle: "Edit Day Exercises JSON",
    jsonSaveBtn: "Apply JSON Changes",
    customExerciseNameLabel: "Exercise Name:",
    customExerciseNamePh: "e.g. Seated Piriformis Stretch",
    customExerciseTargetLabel: "Target Muscles:",
    customExerciseTargetPh: "e.g. Gluteus, Sciatic Nerve",
    customExerciseCategoryLabel: "Category:",
    customExerciseDifficultyLabel: "Difficulty:",
    customExerciseSetsLabel: "Sets:",
    customExerciseRepsLabel: "Reps / Hold:",
    customExerciseRepsPh: "e.g. 10 reps or 30 seconds",
    customExerciseRestLabel: "Rest:",
    customExerciseRestPh: "e.g. 20 seconds",
    customExerciseDurationLabel: "Total Duration (minutes):",
    customExerciseDescLabel: "Instructions & Proper Technique:",
    customExerciseDescPh: "Describe step-by-step proper execution...",
    customExercisePrecautionsLabel: "Precautions & Safety Warnings:",
    customExercisePrecautionsPh: "e.g. Reduce stretch angle if knee discomfort occurs...",
    customExerciseEquipmentLabel: "Required Equipment:",
    customExerciseEquipmentPh: "e.g. Mat, resistance band, chair...",
    saveAndAddToDayBtn: "Save and Add to Day",
    copyTemplate: "Copy Template",
    sampleCopied: "Sample JSON template copied.",
    programStartImportBtn: "Import and Save to Database",
    programJsonEmptyError: "Please enter program JSON content.",
    programJsonSyntaxError: "JSON syntax error: {{err}}",
    catRehab: "Physiotherapy & Rehab",
    catCardio: "Cardio & Aerobic",
    catStrength: "Strength & Conditioning",
    catMobility: "Mobility & Stretching",
    rehabSets: "Sets",
    rehabReps: "Reps",
    rehabRest: "Rest",
    rehabDuration: "Duration",
    rehabTargetMusclesShort: "Target Muscles",
    rehabEquipmentShort: "Equipment",
    rehabPrecautionsShort: "Precautions",
    rehabCategoryShort: "Category",
    rehabDifficultyShort: "Difficulty",
    rehabNoDescription: "No additional description",
    rehabEditTitle: "Edit title and properties",
    rehabDeleteTitle: "Delete program",
    syncCloudTooltip: "Sync with Cloudflare D1 Database",
    syncCloudDbTooltip: "Sync with Cloudflare D1 Database",
    selectProgramError: "Please select a training program.",
    noMultiDayProgramsWarning: "No multi-day programs created yet. Create a program in the Multi-Day Programs section first.",
    dayPrefix: "Day",
    exerciseAddedToProgramSuccess: 'Exercise "{{name}}" was successfully added to the program.',
    dayDefaultTitle: "Day {{day}} — Recovery & Mobility",
    dayNumberFallback: "Day {{day}}",
    dayNotesLabel: "Day Notes",
    noExercisesInDayWarning: "No exercises in this day yet. Click Edit to add movements.",
    exercisesCountUnit: "exercises",
    rehabRestDefault: "20s",
    rehabFilterAll: "All Exercises",
    rehabFilterGlobal: "Global",
    rehabFilterPersonal: "Personal",
    rehabScopeGlobalBadge: "Global",
    rehabScopePersonalBadge: "Personal",
    rehabScopeGlobalDesc: "Global standard exercise shared across all users",
    rehabScopePersonalDesc: "Your personal custom exercise",
    confirmCreatePersonalCopy: "This is a global standard exercise and cannot be edited directly. Would you like to create a personal copy to customize it?",
    createPersonalCopyTooltip: "Create a personal copy to customize",
    globalExerciseLockedTooltip: "Global exercises are protected and cannot be deleted directly",
    createPersonalCopyConfirmPrompt: "A personal copy will be created to customize this global exercise. Continue?",
    addToMyProgramTooltip: "Add this exercise to your multi-day training programs",
    createPersonalCopyTooltip2: "Copy this global exercise into your personal list to edit it freely",
    viewCompleteDetailsTooltip: "View complete instructions, video, image, target muscles, and precautions",
    noExercisesInScopeCategory: "No exercises found in this category.",
    noPersonalExercisesYet: "You have not created any personal exercises yet. Start by adding a custom exercise or creating a personal copy of a global exercise.",
    copying: "Copying...",
    createPersonalCopy: "Create Personal Copy",
    publishToGlobal: "Publish to Global Library",
    publishToGlobalTooltip: "Publish this exercise to the global library for all users (Admin only)",
    publishingToGlobal: "Publishing...",
    publishToGlobalConfirm: "Are you sure you want to publish this exercise to the D1 Global Library? Once published, it will be available to all users as a standard global exercise.",
    publishToGlobalSuccess: 'Exercise "{{name}}" was successfully published to the D1 global library.',
    publishToGlobalError: "Error publishing exercise to global library: {{err}}",
    publishToGlobalForbidden: "Unauthorized: Only admin (salim.zarepour@gmail.com) is allowed to publish exercises to the Global library.",
    publishToGlobalGenericError: "Error publishing exercise to global library",
    publishAllToGlobal: "Publish All Personal Exercises to Global",
    publishAllToGlobalTooltip: "Bulk publish all eligible personal exercises to the D1 Global Library safely (Admin only)",
    publishAllConfirmTitle: "Bulk Publish Exercises to Global Library",
    publishAllConfirmDesc: "Are you sure you want to publish all {{count}} personal exercises to the D1 Global Library? This will link and update existing published records without creating duplicates and insert any new ones as global.",
    publishAllStatusProcessing: "Processing and bulk syncing with D1 Global Library...",
    publishAllResultsTitle: "Bulk Publish Results",
    publishAllStatTotal: "Total Processed",
    publishAllStatPublished: "Newly Published",
    publishAllStatAlready: "Already Published (Synced)",
    publishAllStatFailed: "Failed",
    publishAllNoPersonalFound: "No personal exercises found to publish.",
    publishAllCloseBtn: "Close & Refresh",
    startPublishAllBtn: "Start Bulk Publishing",
    publishedBadge: "Published to Global",
    publishedBadgeTooltip: "This exercise is linked with the Global Library; any changes you save will automatically sync.",
    syncGlobalNotice: "Auto-sync with Global record is active",
    editLibraryItem: "Edit Exercise",
    editLibraryItemTooltip: "Edit title, description, sets, reps and media of this exercise",
    globalEditNotAllowedWithCopy: "System global exercises can only be edited by admin. Would you like to create a personal copy first?",
  },
  sv: {
    languageLearningTitle: "Språkinlärning",
    languageLearningSubtitle: "Dagligt praktiskt språkträningssystem baserat på 4 färdigheter",
    langLearnSetupTitle: "Initial inställning för språkinlärning",
    langLearnSetupSubtitle: "Välj ditt modersmål och de målspråk du vill lära dig.",
    langLearnSourceLang: "Modersmål / Källspråk",
    langLearnTargetLangs: "Målspråk (språk att lära sig)",
    langLearnDailyAvail: "Total tillgänglig tid per dag (minuter)",
    langLearnDailyAvailDesc: "Systemet balanserar automatiskt denna tid mellan de 4 färdigheterna.",
    langLearnStartBtn: "Börja inlärningsresan",
    langLearnSaveSettings: "Spara inställningar & mål",
    langLearnAddTargetBtn: "Lägg till nytt målspråk",
    langLearnTargetLangName: "Målspråkets namn",
    langLearnTargetLangLevel: "Nuvarande CEFR-nivå",
    langLearnChangeLevel: "Ändra språknivå",
    langLearnLevelChangedSuccess: "Språknivån har uppdaterats. Nya övningar anpassas till denna nivå.",
    langLearnEditTargetBtn: "Redigera språk & nivå",
    langLearnDailyGoalMinutes: "Dagsmål för detta språk (minuter)",
    langLearnListening: "Hörförståelse",
    langLearnSpeaking: "Muntlig färdighet",
    langLearnReading: "Läsförståelse",
    langLearnWriting: "Skriftlig färdighet",
    langLearnListeningDesc: "Nyhetsljud, podcasts, videor och auditiv förståelse",
    langLearnSpeakingDesc: "Simulerad konversation, uttal och dialog",
    langLearnReadingDesc: "Nivåanpassade texter, enkla artiklar och ordförråd i kontext",
    langLearnWritingDesc: "Dagboksskrivande, uppsatser och AI-grammatikkontroll",
    langLearnTodayPlanTitle: "Dagens plan för språkinlärning",
    langLearnRecommendedSplit: "Smart tidsfördelning över 4 grundläggande färdigheter",
    langLearnCustomisePlan: "Justera planerade tider manuellt",
    langLearnTotalPlanned: "Totalt planerat: {{min}} min",
    langLearnCompletedMin: "{{min}} min avklarat",
    langLearnOfPlanned: "av {{total}} min",
    langLearnAllSkillsDone: "🎉 Fantastiskt! Alla planerade färdigheter för idag är slutförda.",
    langLearnStartPractice: "Träna",
    langLearnPracticeTitle: "Interaktivt övningsrum",
    langLearnAudioListen: "Spela upp och lyssna på uttal",
    langLearnSpeakNow: "Öva tal och uttal",
    langLearnReadContent: "Läsmaterial och läsförståelse",
    langLearnWriteResponse: "Ditt skriftliga svar eller text:",
    langLearnVoiceInputTip: "Använd mikrofonknappen för att tala och omvandla din röst till text.",
    langLearnGenerateAiExercise: "Generera AI-övning",
    langLearnRequestAiFeedback: "Granska & rätta med AI",
    langLearnAiGenerating: "Genererar övning anpassad till din nivå...",
    langLearnAiFeedbackTitle: "AI-återkoppling, rättelser och grammatiktips",
    langLearnCorrections: "Rättade delar:",
    langLearnOriginal: "Ursprunglig:",
    langLearnCorrected: "Korrigerad:",
    langLearnImprovementTip: "Handlingsbart tips:",
    langLearnCompleteSession: "Slutför & spara session",
    langLearnSessionSaved: "Övningssessionen sparades till molndatabasen.",
    langLearnResourcesTitle: "Externa lärresurser",
    langLearnResourcesSubtitle: "Verifierade webbplatser och kanaler för att öva varje färdighet",
    langLearnFilterAll: "Alla färdigheter",
    langLearnAddResourceBtn: "Lägg till egen resurslänk",
    langLearnResourceTitle: "Resurstitel",
    langLearnResourceUrl: "URL",
    langLearnResourceSource: "Källnamn / Webbplats",
    langLearnDifficultyLevel: "Svårighetsgrad",
    langLearnVisitResource: "Öppna extern resurs",
    langLearnDeleteResource: "Ta bort resurs",
    langLearnStatsTitle: "Övergripande framsteg & statistik",
    langLearnTotalTime: "Total övad tid",
    langLearnSessionsCount: "Genomförda sessioner",
    langLearnStreakDays: "Daglig svit (Streak)",
    langLearnHistoryTitle: "Registrerad övningshistorik",
    langLearnNoHistory: "Inga sessioner registrerade för detta språk än. Börja din första övning idag!",
    langLearnTargetLangRequired: "Minst ett målspråk krävs för att börja.",
    langLearnSelectSourcePlaceholder: "Välj ditt modersmål",
    langLearnSelectTargetPlaceholder: "Välj målspråk",
    langLearnLanguagePersian: "Persiska",
    langLearnLanguageSwedish: "Svenska",
    langLearnLanguageEnglish: "Engelska",
    langLearnLanguageGerman: "Tyska",
    langLearnLanguageFrench: "Franska",
    langLearnLanguageSpanish: "Spanska",
    langLearnLanguageItalian: "Italienska",
    langLearnLanguageArabic: "Arabiska",
    langLearnLanguageTurkish: "Turkiska",
    langLearnLevelA1: "Nivå A1 (Nybörjare)",
    langLearnLevelA2: "Nivå A2 (Grundläggande)",
    langLearnLevelB1: "Nivå B1 (Mellannivå)",
    langLearnLevelB2: "Nivå B2 (Övre mellannivå)",
    langLearnLevelC1: "Nivå C1 (Avancerad)",
    langLearnLevelAll: "Lämplig för alla nivåer",
    dashLanguageLearningTitle: "Språkinlärning: Dagsplan",
    dashLanguageLearningProgress: "{{completed}} av {{total}} min övat",
    sleep: "Sömntimmar",
    water: "Vattenintag",
    weight: "Vikt- & målspårning",
    dailyScratchpad: "Dagsanteckningar & snabbuppgifter",
    swedishTitle: "Svenska utbildning",
    viewingDate: "Visar ett annat datum",
    schedulesCurrentActiveTaskTitle: "📌 Din pågående aktivitet",
    schedulesTodayBadge: "Idag",
    prevDay: "Föregående dag",
    nextDay: "Nästa dag",
    schedulesBackToToday: "🕒 Tillbaka till idag",
    schedulesNowBadge: "Pågående nu | NOW",
    schedulesNextBadge: "Nästa händelse | NEXT",
    dashTodaysPlanTitle: "Dagschema och uppgifter",
    dashLoadingPlan: "Laddar dagens plan...",
    dashErrorLoadingPlan: "Misslyckades med att ladda dagens plan",
    retry: "Försök igen",
    dashTasksProgressSummary: "{{completed}} av {{total}} aktiviteter utförda",
    dashTodayExercisePlanTitle: "Dagens träningsplan: Fysioterapi & Ryggrehab",
    dashRehabProgress: "{{completed}} av {{total}} övningar utförda ({{percent}}%)",
    dashAllExercisesDone: "🎉 Utmärkt! Dagens alla planerade övningar har slutförts.",
    dashExpandExercises: "Visa hela övningslistan",
    dashCollapseExercises: "Dölj övningar",
    dashNoExercisesForToday: "Inga övningar definierade för dagens program.",
    dashManageInRehab: "Hantera i rehabmodul",
    dashViewExerciseList: "Visa dagens övningar ({{count}} övningar)",
    dashNoTasksToday: "Inga rutiner registrerade för denna dag",
    dashRestDayTitle: "Vilo- och återhämtningsdag",
    dashRestDayDesc: "Inga obligatoriska aktiviteter registrerade för denna dag.",
    schedulesAddActivity: "+ Lägg till aktivitet",
    dashNextCardTitle: "Nästa",
    dashTaskRequired: "Obligatorisk",
    dashTaskOptional: "Valfri",
    dashAllTasksDoneCongrats: "Alla planerade aktiviteter för idag har slutförts!",
    sleepStartTime: "Läggdags",
    sleepWakeTime: "Vakna tid",
    weightTargetReached: "🎉 Målvikt uppnådd",
    weightTargetProgress: "Mål: {{target}} kg ({{remaining}} kg kvar)",
    weightTargetEstDate: "Beräknat måldatum:",
    viewProfileMetrics: "Visa viktdiagram och spårning",
    quickAccessModules: "Snabbåtkomst till moduler",
    newsBulletin: "Visa nyhetsbulletin",
    rehabTitle: "Fysioterapi & Ryggrehab",
    fatLossTitle: "Fettförbränning & Kondition",
    nutritionTitle: "Kost & Kalorier",
    notesTitle: "Anteckningar & Dagbok",
    schedulesTitle: "Veckoplanering & Dagliga rutiner",
    allCategories: "Alla kategorier",
    taskReqStandard: "Obligatorisk / Standard",
    taskReqBonus: "Valfri / Bonus",
    schedulesCatWork: "Arbete & Sysselsättning",
    schedulesCatRehab: "Fysioterapi & Ryggrehab",
    schedulesCatFatLoss: "Träning & Kondition",
    schedulesCatSwedish: "Utbildning & Lärande (Svenska/SFI)",
    schedulesCatNutrition: "Kost & Hälsa",
    schedulesCatRoutine: "Personlig rutin",
    schedulesNoTasksFilter: "Inga aktiviteter hittades med valt filter.",
    schedulesCurrentActiveTask: "Aktiv nu",


    manageContactsHeaderBtn: "Godkända kontakter ({{count}})",
    shopShareModalTitle: "Familjedelning av inköpslista",
    shopShareModalSubtitle: "Dela \"{{name}}\"",
    shopShareModalDesc: "Välj en godkänd kontakt med ett klick eller ange en ny e-postadress.",
    approvedContactsQuickTitle: "Snabbdelning med godkända kontakter:",
    manageContactsBtn: "Hantera kontakter",
    noContactsYetHint: "Inga godkända kontakter tillagda ännu.",
    addFirstContact: "Lägg till ny kontakt (partner, syskon, kollega...)",
    shopRecipientEmail: "Eller ange kontaktens e-post manuellt:",
    autoSaveToContactsCheck: "Spara automatiskt denna e-postadress till mina godkända kontakter",
    shopMembersWithAccess: "Medlemmar med åtkomst till denna lista:",
    contactsManagerSubtitle: "Lista över godkända kontakter och behöriga medlemmar",
    contactsManagerTitle: "Hantering av delningskontakter",
    contactsManagerDesc: "Spara information om din partner, sambo eller kollegor så du slipper skriva e-postadresser igen vid delning.",
    addNewContactHeading: "Lägg till ny kontakt:",
    contactNameLabel: "Namn eller titel (t.ex. Partner - Anna):",
    contactNamePlaceholder: "Kontaktens namn eller titel",
    contactEmailLabel: "E-postadress:",
    contactRelationLabel: "Relation / Kategori:",
    saveContactBtn: "Spara kontakt",
    savedContactsListHeader: "Sparade godkända kontakter ({{count}}):",
    searchContactsPlaceholder: "Sök kontakter...",
    noContactsInList: "Inga godkända kontakter registrerade. Lägg till en ny kontakt i formuläret ovan.",
    deleteContact: "Ta bort kontakt",
    relationFamily: "Familj (Partner / Barn / Syskon...)",
    relationFriend: "Vän / Sambo",
    relationWork: "Kollega / Arbete",
    relationOther: "Övrigt",
    shopSharedSuccessWithName: "Listan delades framgångsrikt med {{name}} ({{email}}).",

    batchPastePlaceholder: "Klistra in ditt kontoutdrag eller exporterad text här. Exempel:\n2026-08-01, Hemköp Stockholm, -485 SEK, Hemköp Card\n2026-08-02, SL Buss Månadskort, -970 SEK, Handelsbanken Debit\n2026-08-03, Swish to Ali, -250 SEK\n2026-08-07, Lön Handelsbanken, +38500 SEK",
    cancel: "Avbryt",
    learningAiResponseTag: "AI-svar",
    learningDocumentExtracted: "Extraherad text från detta dokument (sammanfattning 1800 tecken):\n{{text}}",
    learningDocumentName: "Bifogad fil: {{name}}",
    learningHeaderDesc: "Hantera kurser, extrahera dokument och videor samt interaktiv AI-privatundervisning",
    learningHeaderTitle: "Smart Inlärningsassistent & Resurshanterare",
    learningTeacherNoteTag: "Läraranteckning",
    learningUserMsgTag: "Användarfråga / Ämne",
    learningVideoUrlPlaceholder: "https://www.youtube.com/watch?v=... eller direkt videolänk",
    newsActiveTopicsLabel: "Aktiva ämnen för live nyhetsbevakning:",
    newsAddAndMonitorBtn: "Lägg till & bevaka nyheter",
    newsAiAnalyzingWait: "Bevakar och hämtar de senaste 7 dagarnas nyheter med AI...",
    newsAiSearchingEvents: "Söker efter händelser och utveckling gällande dina ämnen",
    newsCopiedSuccess: "Kopierat!",
    newsCopyFullReport: "Kopiera hela rapporten",
    newsDeleteTopicTooltip: "Ta bort ämne",
    newsEmptyDescNoTopics: "Ange bara dina favoritområden eller städer i rutan ovan för att få veckans hetaste nyheter.",
    newsEmptyDescReady: "Klicka på knappen nedan så att AI kan bevaka och analysera de senaste nyheterna om dina ämnen.",
    newsEmptyTitleNoTopics: "Lägg till dina favoritintressen",
    newsEmptyTitleReady: "Redo att hämta senaste 7 dagarnas nyheter",
    newsErrorAddTopicFirst: "Vänligen lägg till minst ett favoritämne först.",
    newsErrorAiFetch: "Fel vid hämtning av nyheter från AI. Kontrollera internetanslutningen.",
    newsFetchAiBtn: "Bevaka & hämta senaste 7 dagarnas nyheter med AI",
    newsFetchingStatus: "Hämtar och analyserar nyheter...",
    newsHeaderDesc: "Bevaka de senaste tekniska framstegen, AI-sammanfattade nyhetsbulletiner och händelseanalyser",
    newsHeaderTitle: "Smart Nyhets-, AI- & Teknikradar",
    newsNoSearchResults: "### 🔍 Inga resultat matchade \"{{query}}\".\n\nVänligen sök efter en annan term eller klicka på uppdatera nyheter.",
    newsNoTopicsHint: "Inga ämnen har lagts till ännu. Skriv ditt önskade ämne i rutan ovan!",
    newsPresetAi: "Senaste AI- & LLM-nyheter",
    newsPresetAiDesc: "Nya Gemini-, OpenAI-, Claude-modeller och AI-verktyg",
    newsPresetHardware: "Smart Glasses & Bärbar teknik",
    newsPresetHardwareDesc: "Bärbara prylar som Ray-Ban Meta och Vision Pro",
    newsPresetIsfahan: "Stadshändelser & Regionala nyheter",
    newsPresetIsfahanDesc: "Bevaka stadsnyheter, projekt och regionala händelser",
    newsPresetSemiconductors: "Teknikaktier & Halvledarmarknad",
    newsPresetSemiconductorsDesc: "Analys av kretsar, hårdvara och teknikmarknad",
    newsPresetWulf: "Aktier & AI-datacenter",
    newsPresetWulfDesc: "Senaste prisanalys, finansiella rapporter och avtal",
    newsQuickInputPlaceholder: "Skriv önskat ämne (t.ex. Tekniknyheter, AI-aktier, Smart Glasses...)",
    newsQuickPresetsTitle: "Snabbförslag på ämnen:",
    newsSaveAndConfirmBtn: "Spara & bekräfta",
    newsSearchPlaceholder: "Sök i hämtade nyheter...",
    newsSettingsModalTitle: "Ämnesinställningar & Rapportton",
    newsSettingsToneBtn: "Inställningar & Ton",
    newsTitle: "Nyhets- & AI-radar",
    newsToneAnalytical: "🎯 Analytisk & Ledarskap (Fokus på marknad & möjligheter)",
    newsToneDeepTech: "🔬 Djupgående & Teknisk (Vetenskapliga & tekniska detaljer)",
    newsToneFastSummary: "⚡ Snabb & Punktform (Korta sammanfattningar & nyckelpunkter)",
    newsToneLabel: "Nyhetsrapportens ton & personlighet:",
    newsToneStandard: "📰 Flytande journalistik & engagerande nyheter",
    newsTopicLiveMonitorDesc: "Livebevakning av senaste 7 dagarnas nyheter om {{topic}}",
    newsUpdate7DaysBtn: "Uppdatera senaste 7 dagarnas nyheter",
    newsYourTopics: "Dina ämnen:",
    shopAllBoughtHint: "Alla varor har köpts eller inga artiklar hittades i denna kategori.",
    shopListEmptyHint: "Denna inköpslista är tom! Lägg till nödvändiga varor i rutan ovan eller via snabbval.",
    shopOneKg: "1 kg",
    shopPresetBBQ: "Grill & Picknick",
    shopPresetFruits: "Frukt & Grönt",
    shopPresetHome: "Veckoinköp Hem",
    shopPresetOnline: "Onlineköp",
    shopPresetPharmacy: "Apotek & Hälsa",
    shopPresetSupermarket: "Matvaror & Stormarknad",
    shopQty1kg: "1 kg",
    shopQty1pack: "1 förp",
    shopQty1pcs: "1 st",
    shopQty2kg: "2 kg",
    shopQty2pack: "2 förp",
    shopQty2pcs: "2 st",
    shopQty3kg: "3 kg",
    shopQty5kg: "5 kg",
    shopQtyHalfKg: "0.5 kg",
    "2d": '2D',
    actions: 'Åtgärder',
    activeMonthlySavingsBudget: 'Aktiv månatlig sparbudget:',
    activities: 'Aktivitetsdagbok',
    activityAthlete: 'Idrottare / Hård daglig träning',
    activityHigh: 'Hög aktivitet (6-7 dagar/vecka)',
    activityLight: 'Lätt aktivitet (1-3 dagar/vecka)',
    activityModerate: 'Måttlig aktivitet (3-5 dagar/vecka)',
    activitySedentary: 'Stillasittande / Lite eller ingen motion',
    actualSpentHeader: 'Faktisk kostnad:',
    add: 'Lägg till',
    addBtn: 'Lägg till',
    addFoodLog: 'Logga ny måltid',
    addGoogleCalendar: 'Lägg till direkt i Google Kalender',
    addInvoiceCostBtn: 'Lägg till ny faktura / utgift',
    addItem: 'Lägg till artikel i listan',
    addItemTitle: 'Artikelnamn',
    addNewRow: 'Lägg till ny rad',
    addNewRowBtn: 'Lägg till ny rad',
    addReminder: 'Lägg till ny påminnelse',
    addReminderBtn: 'Lägg till ny påminnelse',
    addScheduleTask: 'Lägg till ny schemapost',
    addTodoPlaceholder: 'Lägg till ny uppgift...',
    addTransaction: 'Lägg till ny transaktion',
    adminBadge: 'Huvudadministratör',
    advisorClearConfirm: 'Är du säker på att du vill rensa och starta om chatthistoriken med AI-rådgivaren?',
    advisorHeaderDesc: 'Realtidsanalys av nettoinkomst, utgiftsbeteende, budgettak och sparmål för strategiska rekommendationer',
    advisorLiveAnalysisDesc: 'Realtidsanalys av nettoinkomst, utgiftsbeteende, budgettak och sparmål för strategisk rådgivning',
    advisorTab: 'AI Finansiell Rådgivare',
    advisorWelcomeText: 'Hej! Jag är din AI Senior Finansiella Rådgivare och Förmögenhetsstrateg. Jag har realtidsinsikt i din nettoinkomst, utgifter, budgettak, förbrukningsmönster och aktiva finansiella mål. Fråga mig vad du vill.',
    afterRecordingBudgetLabel: 'Efter registrering:',
    afterRecordingMsg: 'Efter registrering: {{amount}} {{currency}}',
    aiAnalysisTab: 'AI-Nyhetsrapport',
    aiBriefingTitle: 'Exklusiv AI-Sammanfattning',
    aiFinancialAdvisor: 'AI Finansiell Rådgivare',
    aiScannerTab: 'AI Kvittoskanner',
    alertAiAnalysisError: 'AI-analysfel',
    alertAiScanError: 'AI-kommunikationsfel vid skanning av kvitto',
    alertBatchImportSuccess: '{{count}} transaktioner har lagts till i din ekonomiska översikt.',
    alertInvalidFileType: 'Vänligen välj en PDF-, bild- eller textfil.',
    alertInvoiceSavedSuccess: 'Fakturan med alla specificerade rader har sparats framgångsrikt!',
    alertNoRowsExtracted: 'Inga rader kunde extraheras. Kontrollera formatet på den kopierade texten.',
    alertNoTextFoundInReceipt: 'Ingen läsbar text hittades i kvittot/fakturan.',
    alertPasteBankStatement: 'Vänligen klistra in ditt kontoutdrag i rutan ovan först.',
    alertReceiptScannedSuccess: 'Kvittot har skannats och varor har extraherats.',
    alertScanOrEnterFirst: 'Skanna ett kvitto eller ange text först.',
    all: 'Alla',
    allCardsOption: '💳 Alla kort & konton',
    allTxAssignedToCard: 'Alla {{count}} transaktioner tilldelas detta kort',
    allTxsAssignedToCard: 'Alla {{count}} transaktioner tilldelas detta kort.',
    allergiesDefault: 'Inga kända allergier',
    allergiesNone: 'Inga kända allergier',
    allocationSurplusOverCap: 'Överskottstilldelning utöver totalt utgiftstak:',
    amount: 'Belopp',
    amountColumnHeader: 'Belopp',
    analyticsDashboardDesc: 'Fördelning av varor och detaljerade fakturautgifter',
    analyticsDashboardTitle: 'Artikel- & utgiftsanalys',
    appAdminVersionList: 'Visa versionshistorik (Endast Admin)',
    appAdminVersionListCustom: 'Visa versionshistorik (Admin salim.zarepour)',
    appCheckingAccount: 'Kontrollerar din kontostatus...',
    appCloudDb: 'D1 Moln',
    appCloudDbDesc: 'D1 Molndatabas • Säker lagring',
    appComponentStandby: 'Moduler är i vänteläge.',
    appLogoutMenu: 'Logga ut',
    appMobileMenuTitle: 'Framsteg Navigering',
    appName: 'Progress - Livs- & Hälsoplanerare',
    appShortName: 'Progress',
    appSlogan: 'Online Daglig Framstegsplanering & Övervakningssystem',
    appVersionOnly: 'v{{version}}',
    appVersionPrefix: 'Framsteg v{{version}}',
    appWeeklyReminderBody: 'Det är dags för aktiviteten "{{title}}".',
    appWeeklyReminderTitle: '⏰ Veckopåminnelse: {{title}}',
    askDoctor: 'Beskriv dina symtom eller ställ en medicinsk fråga...',
    askDoctorPlaceholder: 'Beskriv dina symtom, historia eller frågor...',
    autoAllocateCaps: 'Automatisk uppskattning av kategoritak ({{pct}}%)',
    back: 'Tillbaka',
    balance: 'Saldo',
    balanceLabel: 'Kvar:',
    balanceShort: 'Saldo: {{amount}} {{currency}}',
    baseCurrencyLabel: 'Systemets basvaluta:',
    baseCurrencySyncDesc: 'Ändring av detta val synkroniserar alla budgetberäkningar, mätkort, AI-skanner och finansiella mål.',
    batchCardAccountConnected: 'Kort / konto kopplat till alla transaktioner i detta kontoutdrag:',
    batchColAmount: 'Belopp ({{currency}})',
    batchColTxTitle: 'Transaktionstitel',
    batchConfirmSave: 'Bekräfta och spara alla i databasen',
    batchDuplicate: '⚠️ Dubblett med {{title}} (hoppar över dubblettregistrering)',
    batchExtractedCount: 'Extraherade transaktioner ({{count}} st)',
    batchImportDesc: 'Kopiera och klistra in kontoutdragstext eller CSV direkt i textrutan nedan (ingen filuppladdning krävs).',
    batchImportHeaderDesc: 'Kopiera text eller CSV från ditt kontoutdrag/butikskvitto och klistra in direkt i rutan nedan (ingen filuppladdning krävs).',
    batchImportHeaderTitle: 'Smart batchimport av banktransaktioner & kontoutdrag',
    batchImportSectionTitle: 'Smart batchimport av banktransaktioner och kontoutdrag',
    batchImportTab: 'Batchimport (CSV / Kontoutdrag)',
    batchMatchBank: '🔄 Matchar med banktransaktion {{title}} (kvittodetaljer ersätter rå bankpost)',
    batchMatchPurchase: '⚡ Matchar med köp {{title}} (bankkort tillämpas på köpet)',
    batchNew: '🟢 Ny',
    batchPreviewTableTitle: 'Förhandsgranskning av extraherade transaktioner ({{count}} st)',
    batchReadyToImportCount: '{{count}} valda transaktioner är redo för slutlig import.',
    batchSelectedReady: '{{count}} valda transaktioner är redo för slutgiltig registrering.',
    batchTotalExpense: 'Totala utgifter: {{amount}} {{currency}}',
    batchTotalIncome: 'Total inkomst/inflöde: {{amount}} {{currency}}',
    batchUpload: 'Ladda upp kontoutdrag / CSV',
    bellyFat: 'Kondition & Förbränning',
    bellyFatHeaderDesc: 'Högintensiva intervallpass, anpassad timertid och uppskattad kaloriförbränning',
    bellyFatHeaderTitle: 'Kondition, Magfettförbränning & Fitness',
    billsCategory: '💳 Räkningar & Ekonomi',
    birthdaysCategory: '🎂 Födelsedagar & Händelser',
    bmiCategoryLabel: 'BMI-status',
    bought: 'Inköpt',
    boughtCount: 'Inköpta',
    branding: 'Tema & Färger',
    brandingHeaderDesc: 'Välj accentfärg, mörkt/ljust läge och anpassa kortstilar',
    brandingHeaderTitle: 'Apptema, Färger & Anpassning',
    budgetAllocationPercent: '{{percent}}% av Nettoinkomst',
    budgetAllocationSummary: 'Utgifter ({{expense}}%) + Sparande ({{saving}}%) = 100%',
    budgetAndNetIncome: 'Budgetering & Nettoinkomst',
    budgetCapHeader: 'Budgetgräns:',
    budgetCapShort: 'Tak: {{amount}} {{currency}}',
    budgetExceeded: 'Budgetöverskridande:',
    budgetExceededMsg: 'Budgetöverskridande: {{amount}} {{currency}} extra förbrukat!',
    budgetHistoryDesc: 'Jämförande analys av budgettak, faktiska utgifter och saldo/överskott över tidigare månader',
    budgetHistorySectionDesc: 'Jämförande översikt över budgettak, faktiska utgifter och kvarstående/överskott tidigare månader',
    budgetHistorySectionTitle: 'Budgethistorik & sammanfattning av prestation över flera månader',
    budgetHistoryTitle: 'Historik och sammanfattning av budgetprestanda',
    budgetPatternNote: 'Budgetmall tillämpas automatiskt på alla månader; byte av månad visar den periodens faktiska utgifter.',
    budgetRemainingLabel: '✓ Saldo: {{amount}} {{currency}}',
    budgetSettingsDesc: 'Konfigurera månadsinkomst och utgiftsgränser',
    budgetSettingsTitle: 'Budgetinställningar',
    budgetSpentShort: 'Förbrukat: {{amount}} {{currency}}',
    budgetStatusLabel: 'Budgetstatus:',
    budgetSurplusLabel: '⚠️ Överskridande: {{amount}} {{currency}}',
    budgetTotalUsedRatio: '{{pct}}% av total budget förbrukad',
    budgetUsagePercent: '{{percent}}% av budgettaket',
    budgetUsageStatusIn: 'Budgetstatus för {{month}}',
    budgetUsageStatusInMonth: 'Budgetförbrukning i {{month}}',
    budgets: 'Budget & Mål',
    bulkDeleteBtn: 'Radera markerade',
    calculateAiCalories: 'Beräkna Kalorimål med AI',
    calendarTab: 'Månadskalender',
    calories: 'Kalorier',
    caloriesGoal: 'Dagligt Kalorimål',
    capLabel: 'Tak:',
    carbs: 'Kolhydrater',
    carbsGoal: 'Kolhydrater (g)',
    cardBreakdownTitle: 'Uppdelning per kort & konton',
    cardConnectedToAllTxs: 'Kort / konto kopplat till alla transaktioner i detta kontoutdrag:',
    catCarMaintenance: 'Bil & Försäkring',
    catCharityGifts: 'Gåvor & Välgörenhet',
    catClothing: 'Kläder',
    catEducation: 'Utbildning',
    catElectronics: 'Elektronik',
    catEntertainment: 'Nöje & Fritid',
    catFamily: 'Familj',
    catGroceries: 'Matvaror',
    catHealth: 'Hälsa & Vård',
    catHomeDecor: 'Hem & Inredning',
    catHousing: 'Boende',
    catInvestment: 'Investeringar',
    catMain: 'Huvudmeny & Assistenter',
    catOther: 'Övrigt',
    catPets: 'Husdjur',
    catPlanning: 'Planering, Inlärning & Rapporter',
    catRestaurants: 'Restaurang',
    catSalary: 'Lön & Inkomst',
    catSettings: 'Inställningar & Administration',
    catSubscriptions: 'Abonnemang',
    catTransport: 'Transport',
    catUtilities: 'Räkningar & El',
    categoriesWithBudgetCapCount: '{{count}} kategorier med budgettak',
    categoriesWithCapCount: '{{count}} kategorier med budgetgräns',
    categoriesWithoutCapTitle: 'Kategorier utan specifikt tak (endast utgiftsöversikt):',
    category: 'Kategori',
    categoryCapsDesc: 'Ange maximala utgiftsgränser för boende, mat, räkningar, transport etc. (ange 0 för obudgeterade sektioner)',
    categoryCapsLabel: 'Kategoriernas budgetgränser:',
    categoryInvestment: 'Investeringar',
    categoryPets: 'Husdjur',
    categorySalary: 'Lön',
    categorySubscriptions: 'Abonnemang & SaaS',
    categoryTitle: 'Artikelkategori',
    clearAndStartChat: 'Rensa & starta konversation',
    clearChatHistoryTitle: 'Rensa chatthistorik',
    clearCompleted: 'Rensa köpta artiklar',
    clearFilters: 'Rensa Filter',
    close: 'Stäng',
    closeBtn: 'Stäng',
    cloudSyncActive: 'Molnsynkronisering Aktiv',
    commonCancel: 'Avbryt',
    confirm: 'Bekräfta',
    confirmBatchImportBtn: 'Bekräfta & spara alla i databasen',
    confirmClearAdvisorHistory: 'Är du säker på att du vill rensa och återställa chatthistoriken med den finansiella rådgivaren?',
    confirmDepositBtn: 'Bekräfta insättning',
    createGoalBtn: 'Skapa mål',
    createShoppingList: 'Skapa ny inköpslista',
    currentCardsCount: 'Dina nuvarande kort ({{count}} st):',
    currentExpensesShare: 'Andel löpande utgifter:',
    currentExpensesShareLabel: 'Andel löpande utgifter:',
    currentMonthBtn: 'Nuvarande månad',
    currentMonthLabel: 'Innevarande månad',
    currentWeightLabel: 'Nuvarande vikt (kg)',
    dailyScore: 'Dagens poäng',
    darkMode: 'Mörkt läge',
    dashAddBtn: 'Lägg till',
    dashAllGoalsDone: '🎉 Alla dagliga övningar och mål klara!',
    dashBackToToday: 'Tillbaka till idag',
    dashBmiTarget: 'Anatomi Index & Viktmål',
    dashCalorieExcessWarning: '⚠️ Kaloriintaget översteg daglig gräns.',
    dashCalorieGoodDesc: 'Håll makronutrientfördelningen balanserad för vikt.',
    dashCaloriesToday: 'Kalorier idag',
    dashCompletedRemaining: 'Avklarade · {{remaining}} återstår',
    dashCurrentWeight: 'Nuvarande Vikt: {{weight}} kg',
    dashDailyTasks: 'Checklista Dagliga Uppgifter (Idag)',
    dashDiaryAdd: 'Lägg till Fysiska Observationer',
    dashDiaryTitle: 'Snabböversikt över dagens status',
    dashDone: '✅ Klart',
    dashEditProfile: 'Redigera profil & beräkningar i Inställningar',
    dashFatDesc: '{{completed}} av {{total}} kardioaktiviteter avklarade idag',
    dashFatTitle: 'Modul 2 — Magfett Kardio',
    dashGoalsProgress: '⚡ {{completed}} av {{total}} mål avklarade idag',
    dashGregorian: 'Gregoriansk:',
    dashHabitScore: 'Dagliga Vanor Poäng',
    dashHeight: '| Längd: {{height}} cm',
    dashHijri: 'Hijri:',
    dashHydration: 'Vätskespårare (Vatten)',
    dashHydrationDesc: 'Att dricka tillräckligt med vatten skyddar ryggdiskarna från stötar.',
    dashIranEvent: 'Iransk händelse:',
    dashLearningDesc: 'AI-genererade ämnen, anteckningar och interaktiva quiz',
    dashLearningTitle: 'Smart Lärandeassistent',
    dashMaxScore: '/ {{max}} max',
    dashModulesChecklist: 'Snabb Checklista För Moduler',
    dashMood: 'Humör:',
    dashNewTaskPlaceholder: 'Lägg till uppgift... (t.ex. medicin, kvällspromenad, svenskstudier)',
    dashNewsDesc: 'Live-övervakning av de senaste 7 dagarnas nyheter om dina favoritämnen och städer',
    dashNewsHeadlines: '📌 Sammanfattning av de senaste nyheterna (7 dagar):',
    dashNewsLastUpdate: 'Senast uppdaterad:',
    dashNewsLive: 'Live Analys',
    dashNewsNoTopics: '✨ Du har inte valt några nyhetskategorier än.',
    dashNewsTitle: 'AI Personlig Nyhetsradar',
    dashNewsTopics: 'Aktiva ämnen:',
    dashNewsView: 'Visa Nyheter & Analys',
    dashNextDay: 'Nästa dag',
    dashNoSymptoms: 'Inga symtom loggade för idag.',
    dashNoTasks: 'Inga uppgifter definierade för idag. Lägg till en så du inte missar något!',
    dashNotDone: '❌ Ledig/Ej loggat',
    dashNutritionDesc: 'Kalorier idag: {{calories}} kcal',
    dashNutritionTitle: 'Modul 3 — Daglig Näringsspårare',
    dashPainLevel: 'Ryggsmärtnivå',
    dashPainLevelDesc: 'Nivå {{level}} av {{max}}',
    dashPrevDay: 'Föregående dag',
    dashProgress: 'Program Framsteg',
    dashReadyForDay: '✨ Redo för en energisk och produktiv dag',
    dashRehabDesc: '{{completed}} av {{total}} rehabövningar avklarade idag',
    dashRehabTitle: 'Modul 1 — Ryggrehab',
    dashRemainingKcalToTarget: 'Kvar till gräns:',
    dashScheduleTitle: 'Modul 5 — Veckorutiner & Schema',
    dashScoreDesc: 'Kombinerat index med prioritering på ryggrehab (40%) och magfett kardio (25%).',
    dashScoreV2Title: 'Dagligt Resultat och Poäng',
    dashScoreV2Desc: 'Dynamiskt resultat beräknat direkt från schemalagda aktiviteter i veckoplaneraren',
    dashAvailablePoints: 'Tillgängliga poäng:',
    dashEarnedPoints: 'Intjänade poäng:',
    dashBonusPoints: 'Valfria bonuspoäng:',
    dashCompletionRate: 'Slutförandegrad:',
    dashRequiredTasksCount: 'Dagens obligatoriska uppgifter:',
    dashOpenWeeklyPlanner: 'Hantera veckoplanerare',
    dashPointsShort: 'p',
    dashTaskCompleted: 'Slutförd',
    dashTaskPending: 'Väntar',
    dashTodayOccurrences: 'Dagens schemalagda uppgifter och rutiner',
    dashSelectedDayOccurrences: 'Schemalagda uppgifter för vald dag',
    dashSelectedDay: 'Vald dag',
    dashSfiClass: 'Svenskalektion (SFI): ',
    dashSfiDone: '✅ Närvarade',
    dashSfiNotDone: '❌ Frånvarande/Ingen lektion',
    dashSleep: 'Daglig Sömnspårare',
    dashSleepBedtime: 'Läggdags:',
    dashSleepDesc: 'Tillräcklig sömn (7-8 timmar) påverkar direkt reparationen av ryggdiskar och rygghälsa.',
    dashSleepTarget: '/ 8 tim mål',
    dashSleepWakeup: 'Uppvaknande:',
    dashSwedenEvent: 'Svensk händelse:',
    dashSwedishDesc: '{{completed}} av {{total}} självstudier i svenska avklarade idag',
    dashSwedishTitle: 'Modul 4 — Svenskstudier',
    dashSymptoms: 'Loggade Fysiska Symtom',
    dashTargetKcal: '/ {{target}} kcal',
    dashTasksCompleted: '{{completed}} av {{total}} uppgifter klara',
    dashToday: 'Idag',
    dashWeightGainRemaining: 'kvar att gå upp',
    dashWeightGoal: 'Ditt Viktmål:',
    dashWeightLossRemaining: 'kvar att gå ner',
    dashWeightNoGoal: 'För att ställa in exakt viktmål och kalorier, gå till Inställningar.',
    dashWeightRemainingDiff: '({{diff}} kg {{status}})',
    dashWorkShift: 'Arbetspass: ',
    dashboard: 'Hälsoöversikt',
    date: 'Datum',
    dayFri: 'Fre',
    dayMon: 'Mån',
    dayOfWeekLabel: 'Veckodag',
    daySat: 'Lör',
    daySun: 'Sön',
    dayThu: 'Tor',
    dayTue: 'Tis',
    dayWed: 'Ons',
    decrease: 'Minska',
    defaultCard: 'Bankkort',
    defaultCategoryForBatch: 'Standardkategori för oklassificerade poster:',
    defaultUser: 'Användare',
    defaultUserApp: 'Framsteg Användare',
    defineCategoryCapsHint: 'I formuläret ovan kan du använda "Automatisk uppskattning" eller ange belopp manuellt för att sätta tak och aktivera mätare.',
    defineExpenseCapsDesc: 'Ställ in tillåtet utgiftstak för boende, matvaror, räkningar, transport m.m. (0 kan anges för kategorier utan utgift)',
    delete: 'Radera',
    deleteAll: 'Ta bort alla',
    deleteAllCards: 'Radera alla',
    deleteItemTitle: 'Radera vara',
    deleteTransaction: 'Radera Transaktion',
    depositModalTitle: 'Öka sparande: {{title}}',
    depositToGoalTitle: 'Sätt in på sparmål: {{title}}',
    descPlaceholder: 't.ex. Veckohandling',
    description: 'Beskrivning',
    deselectAll: 'Avmarkera alla',
    dictionaryTab: 'Variabelreferens & Lexikon',
    doctorAgeVal: '{{age}} år',
    doctorAiAnswerTitle: 'Läkarens råd & kliniska anteckningar',
    doctorAiError: 'Kunde inte kommunicera med AI-läkaren',
    doctorAiSubmit: 'Skicka till AI-läkaren',
    doctorCancel: 'Avbryt',
    doctorClearText: 'Rensa inmatning',
    doctorCopyAnswer: 'Kopiera svar',
    doctorDeleteConfirm: 'Är du säker på att du vill radera denna konsultationshistorik?',
    doctorDeleteError: 'Kunde inte radera historikposten',
    doctorDisclaimer: 'Obs: AI-information är endast i utbildningssyfte och ersätter inte professionell läkardiagnos.',
    doctorEditActivity: 'Fysisk aktivitetsnivå',
    doctorEditAge: 'Ålder (år)',
    doctorEditAllergies: 'Kända allergier',
    doctorEditAllergiesPh: 't.ex. Penicillin, Jordnötter...',
    doctorEditGender: 'Kön',
    doctorEditGoals: 'Hälsomål',
    doctorEditGoalsPh: 't.ex. Nå 75 kg, förbättra blodtryck...',
    doctorEditHeight: 'Längd (cm)',
    doctorEditMedCond: 'Kroniska sjukdomar eller tillstånd',
    doctorEditMedCondPh: 't.ex. Hypertoni, Diabetes typ 2...',
    doctorEditMeds: 'Nuvarande medicinering',
    doctorEditMedsPh: 't.ex. Metformin, D-vitamin...',
    doctorEditProfileHeader: 'Uppdatera personliga hälsouppgifter',
    doctorEditProfileTitle: 'Redigera medicinsk profil',
    doctorEditWeight: 'Vikt (kg)',
    doctorGenderF: 'Kvinna',
    doctorGenderM: 'Man',
    doctorHeaderDesc: 'Svara på medicinska frågor, analysera symtom, rådgör om mediciner och provsvar',
    doctorHeaderTitle: 'Personlig AI-Läkare & Hälsoreddare',
    doctorHistoryCount: '{{count}} konsultationer sparade',
    doctorHistoryEmpty: 'Ingen konsultationshistorik ännu',
    doctorHistoryEmptyDesc: 'Ställ din första medicinska fråga ovan för att se personliga råd här.',
    doctorHistoryLoading: 'Laddar konsultationshistorik...',
    doctorHistoryQuestion: 'Konsultation:',
    doctorHistoryTitle: 'Tidigare medicinska konsultationer',
    doctorLiveCalories: 'Uppskattat dagsbehov: {{cal}} kcal',
    doctorNewQueryDesc: 'Ställ frågor om symtom, kost, labbprover eller mediciner',
    doctorNewQueryTitle: 'Ny medicinsk rådgivning',
    doctorProfileActivity: 'Fysisk aktivitetsnivå',
    doctorProfileAgeGender: 'Ålder & Kön',
    doctorProfileAllergies: 'Allergier & överkänslighet',
    doctorProfileBadge: 'Sekretessbelagda uppgifter',
    doctorProfileDesc: 'Dina hälsoparametrar för precisa AI-diagnoser',
    doctorProfileEditBtn: 'Redigera profil',
    doctorProfileGoals: 'Hälso- & fitnessmål',
    doctorProfileHeightWeight: 'Längd & Vikt',
    doctorProfileMedCond: 'Medicinska tillstånd',
    doctorProfileMeds: 'Nuvarande mediciner',
    doctorProfileNoMeds: 'Inga mediciner tas',
    doctorProfileNotRegistered: 'Ej registrerad',
    doctorProfileSaveError: 'Kunde inte spara medicinsk profil',
    doctorProfileTitle: 'Personlig medicinsk profil',
    doctorQ1: 'Hur kan jag optimera mina fastefönster och energi på ett säkert sätt?',
    doctorQ2: 'Vilka livsmedel hjälper till att minska bukfett snabbast?',
    doctorQ3: 'Kan du analysera mina symtom och föreslå livsstilsjusteringar?',
    doctorQ4: 'Vilka kosttillskott stödjer leder och muskelåterhämtning?',
    doctorQueryPlaceholder: 'Skriv din fråga eller medicinska fundering här...',
    doctorSaveToDb: 'Spara i journal',
    doctorSaving: 'Sparar...',
    doctorSpecialtyLabel: 'Önskad medicinsk specialitet',
    doctorSuggestedQueries: 'Förslagna frågor:',
    doctorTitle: 'Personlig AI-Läkare',
    doctorWeightHeightVal: '{{weight}} kg / {{height}} cm',
    dueToday: 'Förfaller idag',
    duplicateWithTx: 'Dubblett med {{title}} (ignoreras)',
    edit: 'Redigera',
    email: 'E-post',
    english: 'English (Engelska)',
    enterIncomeFirst: 'Ange månatlig nettoinkomst först.',
    error: 'Fel',
    estimatedFutureMonths: '{{count}} framtida månader',
    estimatedMonthsFuture: 'Inom {{count}} månader',
    exerciseDuration: 'Varaktighet (minuter)',
    expense: 'Utgift',
    exportCalendar: 'Exportera till Google Kalender / ICS',
    exportCalendarIcs: 'Exportera kalenderfil (ICS)',
    exportExcelReport: 'Exportera Excel-fil',
    exportPdfReport: 'Ladda ner omfattande PDF-rapport',
    extraExpenseSuffix: 'överskjutande utgifter!',
    extractRowsSmartBtn: 'Extrahera och identifiera rader smart',
    familyCategoriesTab: 'Kategorier & Familjemedlemmar',
    familyCategory: '👨‍👩‍👧‍👦 Familjeärenden',
    fat: 'Fett',
    fatActivationDesc: 'Magfettminskning uppnås främst genom promenader, jämn konditionsträning och isometriska bålkontraktioner (utan farliga vridningar eller ryggböjningar). Undvik traditionella riskfyllda situps.',
    fatActivationTitle: 'Lågeffektiv Energiaktivering',
    fatActiveKcal: 'Aktiva Kcal',
    fatCalBurnedTitle: 'Uppskattade Förbrända Kalorier',
    fatCalories: 'Kalorier',
    fatExerciseXofY: 'Övning {{current}} av {{total}}',
    fatExitSession: 'Avsluta Session',
    fatFullInstructions: 'Fullständiga Övningsinstruktioner:',
    fatGoal: 'Fett (g)',
    fatGuidedComplete: 'Enastående! Fettförbränningspasset är Klart',
    fatGuidedCompleteDesc: 'Du förbrände en betydande mängd kalorier och aktiverade dina bålmuskler idag.',
    fatGuidedSaveReturn: 'Spara & Återgå till Lista',
    fatGuidedStatusPrepare: 'Redo',
    fatGuidedStatusRest: 'Vila & Andas',
    fatGuidedStatusRunning: 'Körs',
    fatKcalBurn: '{{kcal}} Kcal Förbränning',
    fatLossCardio: 'Fettförbränning & Kondition',
    fatMute: 'Ljud av',
    fatNextEx: 'Spara & Nästa',
    fatPause: 'Pausa',
    fatPrevEx: 'Föregående',
    fatProgressTitle: 'Dagliga Rutinframsteg',
    fatProgressXofY: '{{completed}} av {{total}} Övningar',
    fatReps: 'Reps',
    fatRest: 'Vila',
    fatResume: 'Återuppta',
    fatSeconds: 'Sekunder',
    fatSets: 'Set',
    fatSkipRest: 'Hoppa över vila',
    fatStartGuided: 'Starta Röstguidad Fettförbränningssession',
    fatSubtitle: 'Aeroba övningar och isometriska bålkontraktioner utan ländryggsböjning; stöder ryggrads- och diskhälsa.',
    fatTargetMuscles: 'Målmuskler',
    fatTargetPurpose: 'Syfte',
    fatTitle: 'Modul 2 — Magfett & Bålstyrka',
    fatTrainerName: 'Virtuell Magfetts-tränare',
    fatUnmute: 'Ljud på',
    filter: 'Filtrera',
    filterAllCategories: 'Alla Kategorier',
    filterAllPayments: 'Alla Betalsätt',
    filterByMonth: 'Filtrera per månad',
    filterCard: 'Bankkort',
    filterCash: 'Kontant',
    filterDateLabel: 'Datumfilter:',
    filterFrom: 'Från:',
    filterLast3Months: 'Senaste 3 Månader',
    filterSwish: 'Swish',
    filterThisMonth: 'Denna Månad',
    filterThisMonthTransactions: 'Filtrera denna månads transaktioner',
    filterTo: 'Till:',
    filterToday: 'Idag',
    filterTransfer: 'Banköverföring',
    filtered: 'Filtrerad',
    finalAmountRecorded: 'Slutgiltigt belopp att registrera: {{amount}} {{currency}}',
    finalAmountToRecord: 'Slutgiltigt belopp att bokföra:',
    finance: 'Ekonomi & Kvitton (AI)',
    financeAddCardBtn: 'Lägg till kort',
    financeAddItemRow: '+ Lägg till Vara',
    financeAddItemsSection: 'Lägg till Varor (Fakturaspecifikation):',
    financeAdvisorThinking: 'AI-rådgivaren analyserar dina fakturor och förbereder råd...',
    financeAiAddNewRow: 'Lägg till Ny Rad',
    financeAiAdvisorGreeting: 'Hej! Jag är din AI-seniorrådgivare inom ekonomi och förmögenhetsstrategi. 💼🌟 Jag har full insikt i din nettoinkomst, utgifter, budgettak och sparmål.',
    financeAiAdvisorRole: 'AI Ekonomisk Rådgivare',
    financeAiAdvisorSubtitle: 'Realtidsanalys av nettoinkomst, utgifter, budgettak och sparmål',
    financeAiAdvisorTitle: 'AI Ekonomisk Rådgivare & Förmögenhetsstrateg',
    financeAiAnalyzeBtn: 'Analysera Faktura med AI',
    financeAiBankMatchNotice: 'Matchad banktransaktion hittades: {{store}} med {{amount}} {{currency}} ({{date}}). Den detaljerade fakturan ersätter bankposten.',
    financeAiCardLabel: 'Bankkonto / Kort:',
    financeAiColAction: 'Radera',
    financeAiColCategory: 'Kategori',
    financeAiColItemName: 'Varans Namn (Redigerbar)',
    financeAiColQty: 'Antal',
    financeAiColTotal: 'Totalt',
    financeAiColUnitPrice: 'Styckpris',
    financeAiConfirmSave: 'Bekräfta & Spara Faktura',
    financeAiDateLabel: 'Transaktionsdatum:',
    financeAiExtractedItems: 'Extraherade Varor (Redigerbara):',
    financeAiExtracting: 'Extraherar varor via AI...',
    financeAiFinalCharge: 'Slutbelopp att Bokföra: {{amount}} {{currency}}',
    financeAiInvoiceAnalysis: 'Smart Analys av Faktura från {{store}}',
    financeAiNewInvoiceTitle: 'Ny Faktura',
    financeAiNoResponse: 'Inget svar från servern',
    financeAiParseError: 'Kunde inte tolka fakturauppgifter.',
    financeAiParsedTitle: 'AI Fakturaresultat (Redigerbart)',
    financeAiPaymentMethod: 'Betalningsmetod:',
    financeAiPurchaseFrom: 'Köp från {{store}}',
    financeAiReadyToSave: 'Redo att Spara',
    financeAiRowCount: '{{count}} rader',
    financeAiScannerDesc: 'Klistra in kvitto-/fakturatext (Swish, ICA, Willys...) för att extrahera varor, priser och kategorier.',
    financeAiScannerHeader: 'Smart AI Fakturatextskanning & Analys',
    financeAiScannerNote: 'Registrerad via AI-skanning',
    financeAiSmartReplaceNote: 'Ersatte rå banktransaktion med skannade fakturadetaljer',
    financeAiStoreLabel: 'Butik / Titel:',
    financeAiTotalCalculated: 'Totalt Beräknat Belopp:',
    financeAskPh: 'Ställ en ekonomisk fråga (t.ex. Hur kontrollerar jag matkostnaderna denna månad?)...',
    financeBatchCleanupSubtitle: 'Massradera transaktioner per månad, år, filter eller total återställning',
    financeBatchCleanupTitle: 'Masshantering & Rensa Transaktioner',
    financeBatchColAction: 'Radera',
    financeBatchColAmount: 'Belopp ({{currency}})',
    financeBatchColCard: 'Kort / Konto',
    financeBatchColCategory: 'Kategori',
    financeBatchColDate: 'Datum',
    financeBatchColSelect: 'Välj',
    financeBatchColStore: 'Butik / Titel',
    financeBatchColType: 'Typ',
    financeBatchConfirmBtn: 'Bekräfta & Spara till Databas',
    financeBatchDefaultNotes: 'Registrerad från batchimport',
    financeBatchMergeStoreNotes: 'Sammanslagen med kvitto från {{store}}',
    financeBatchRowExpense: 'Utgift',
    financeBatchRowIncome: 'Inkomst',
    financeBatchRowSavings: 'Sparande',
    financeBatchRowsReady: '{{count}} valda transaktioner redo för import.',
    financeBatchStatusBankMerge: '{{count}} banktransaktioner matchade med butikskvitton',
    financeBatchStatusNew: '{{count}} nya transaktioner registrerade',
    financeBatchStatusSkip: '{{count}} dubbletter hoppades över',
    financeBatchStatusStoreMerge: '{{count}} butiksfakturor ersatte råa bankposter',
    financeBatchTotalExpense: 'Total Utgift: {{amount}} {{currency}}',
    financeBatchTotalIncome: 'Total Inkomst: {{amount}} {{currency}}',
    financeBulkDeleteAlert: 'Skriv DELETE för att bekräfta fullständig radering.',
    financeCalcFromItems: 'Automatisk beräkning ({{count}})',
    financeCancelBtn: 'Avbryt',
    financeCardOrAccountLabel: 'Kort / Betalkonto:',
    financeCardsModalSubtitle: 'Definiera dina anpassade bankkort och konton för transaktioner och batchimport.',
    financeCardsModalTitle: 'Hantera bankkort & personliga konton',
    financeCategoryLabel: 'Kategori:',
    financeCategoryNameCarMaintenance: 'Bilservice & Försäkring',
    financeCategoryNameCharityGifts: 'Presenter & Välgörenhet',
    financeCategoryNameClothing: 'Kläder, Skor & Skönhet',
    financeCategoryNameDefault: 'Tjänster & Övrigt',
    financeCategoryNameEducation: 'Utbildning & Kurser',
    financeCategoryNameElectronics: 'Elektronik & Prylar',
    financeCategoryNameEntertainment: 'Nöje, Sport & Resor',
    financeCategoryNameFamily: 'Barn & Familj',
    financeCategoryNameGroceries: 'Matbutik & Dagligvaror',
    financeCategoryNameHealth: 'Hälsa, Apotek & Vård',
    financeCategoryNameHomeDecor: 'Hemartiklar & Möbler',
    financeCategoryNameHousing: 'Boende & Hyra',
    financeCategoryNameInvestment: 'Sparande & Investeringar',
    financeCategoryNamePets: 'Husdjur & Tillbehör',
    financeCategoryNameRestaurants: 'Restauranger, Kaféer & Mat',
    financeCategoryNameSalary: 'Lön & Primär Inkomst',
    financeCategoryNameSubscriptions: 'Prenumerationer & AI-verktyg',
    financeCategoryNameTransport: 'Transport & Drivmedel',
    financeCategoryNameUtilities: 'Räkningar, El & Bredband',
    financeCurrencyIRR: 'Iransk Rial (IRR)',
    financeCurrencyToman: 'Iransk Toman (Toman)',
    financeCurrencySEK: 'Svensk krona (SEK)',
    financeCurrencyEUR: 'Euro (EUR)',
    financeCurrencyUSD: 'Amerikansk dollar (USD)',
    financeClearAllCards: 'Radera Alla',
    financeCloseBtn: 'Stäng',
    financeConfirmDeposit: 'Bekräfta Insättning',
    financeCopied: 'Kopierat',
    financeCopyAnswer: 'Kopiera Svar',
    financeCreateGoalBtn: 'Skapa Mål',
    financeDateLabel: 'Datum:',
    financeDefineNewCard: '➕ Lägg till Nytt Kort...',
    financeDefineNewGoalBtn: 'Skapa Nytt Mål',
    financeDeleteCardTitle: 'Ta bort detta kort',
    financeDeleteFilteredTxs: 'Radera Filtrerade Transaktioner',
    financeDeleteMonthTxs: 'Radera Månadstransaktioner',
    financeDeleteMonthTxsDesc: 'Radera alla fakturor för vald månad',
    financeDeleteYearTxs: 'Radera Årstransaktioner',
    financeDeleteYearTxsDesc: 'Radera alla fakturor för valt år',
    financeDepositAmountLabel: 'Insättningsbelopp:',
    financeDepositModalTitle: 'Öka Sparande: {{title}}',
    financeDescOptional: 'Anteckningar (Valfritt):',
    financeDescPh: 't.ex. Vecka 2 matinköp',
    financeEditCardTitle: 'Redigera kortnamn',
    financeEditGoalBtn: 'Redigera Mål',
    financeEditGoalModalTitle: 'Redigera Sparmål: {{title}}',
    financeSaveGoalChangesBtn: 'Spara Måländringar',
    financeGoalCategoryLabel: 'Målkategori:',
    financeGoalNotesLabel: 'Anteckningar / Beskrivning:',
    financeGoalCategoryHousing: 'Boende & Fastighet',
    financeGoalCategoryCar: 'Bil & Fordon',
    financeGoalCategoryTravel: 'Resor & Semester',
    financeGoalCategoryEmergency: 'Buffert & Nödfall',
    financeGoalCategoryInvestment: 'Investering & Sparande',
    financeGoalCategoryOther: 'Övrigt',
    financeEditTx: 'Redigera Transaktion',
    financeEnterYearToDelete: 'Ange År att Radera (t.ex. 2026):',
    financeFilteredTxsCount: '{{count}} valda transaktioner',
    financeFinalDeleteBtn: 'Utför Slutgiltig Radering',
    financeFinancialHealthScore: 'Ditt Ekonomiska Hälsotal:',
    financeGoalAddDepositBtn: 'Öka Sparande',
    financeGoalCurrency: 'Valuta:',
    financeGoalCurrentBalance: 'Nuvarande: {{amount}} {{currency}}',
    financeGoalDepositNote: 'Insättning till målet {{goalTitle}}',
    financeGoalDepositTitle: 'Sparande till: {{goalTitle}}',
    financeGoalInitialSavings: 'Startsparande:',
    financeGoalNameLabel: 'Måltitel:',
    financeGoalNamePh: 't.ex. Lägenhet i Stockholm / Sommarsemester',
    financeGoalProgressPercent: '{{percent}}% uppnått',
    financeGoalRemainingAmount: 'Återstår: {{amount}} {{currency}}',
    financeGoalTargetAmount: 'Målbelopp:',
    financeGoalTargetAmountLabel: 'Mål: {{amount}} {{currency}}',
    financeGoalTargetDate: 'Måldatum (Valfritt):',
    financeGoalTargetDateLabel: 'Måldatum: {{date}}',
    financeGoalsTitle: 'Sparmål & Ekonomisk Planering',
    financeHeaderDesc: 'Budgetering av nettoinkomst, automatisk AI-fakturaskanning och sparmålsuppföljning',
    financeHeaderTitle: 'Hantering av Smarta Fakturor, Budget & Ekonomiska Mål',
    financeItemNamePh: 'Varans namn (t.ex. Mjölk)',
    financeItemQtyPh: 'Antal (1)',
    financeItemUnitPricePh: 'Styckpris',
    financeItemsRecorded: '{{count}} varor registrerade',
    financeNewCardInputPh: 'Nytt kort-/kontonamn (t.ex. SEB Credit, ICA Kort, Swish...)',
    financeNewCardPh: 'Kortnamn (t.ex. Klarna, Mastercard...)',
    financeNewGoalTitle: 'Skapa Nytt Sparmål',
    financeNewTx: 'Ny Faktura / Finansiell Transaktion',
    financeNoCardsYet: 'Inga kort har definierats än. Ange ett kortnamn ovan och klicka på Lägg till, eller återställ till standard.',
    financeNoGoalsYet: 'Inga sparmål skapade än.',
    financeNoProductMatches: 'Ingen produkt registrerad med detta namn.',
    financePaymentCard: 'Kort',
    financePaymentCash: 'Kontant',
    financePaymentMethodLabel: 'Betalningsmetod:',
    financePaymentSwish: 'Swish',
    financePaymentTransfer: 'Överföring',
    financeProductAnalyticsTitle: 'Produkt- & Konsumtionsanalys (t.ex. Mjölk, Bröd...)',
    financeProductAnalyticsTotal: 'Totalt: {{count}} olika varor',
    financePrompt1: '💡 Analysera månadens största utgifter och kategorier',
    financePrompt1Text: 'Hur kan jag öka mitt månatliga sparande med 10 % baserat på mina nuvarande utgifter?',
    financePrompt2: '🔍 5 praktiska sätt att minska onödiga utgifter',
    financePrompt2Text: 'Vänligen analysera mina utgifter, budgettak och konsumtionsmönster denna månad i detalj.',
    financePrompt3: '📈 Hur sparar jag smart med min nuvarande nettoinkomst?',
    financePrompt3Text: 'Hur bör jag investera mitt sparöverskott baserat på min nettoinkomst och mina utgifter?',
    financePrompt4: '🛡️ Strategi för buffertsparande',
    financePrompt4Text: 'Vilken strategi rekommenderar du för att bygga en buffertfond baserat på mina månadskostnader?',
    financePrompt5: '🎯 Snabbare plan för ekonomiska mål',
    financePrompt5Text: 'Granska mina aktiva sparmål och ge mig en plan för att nå dem snabbare.',
    financeRemainingBudgetLabel: 'Återstående Månadsbudget:',
    financeResetChatConfirm: 'Är du säker på att du vill rensa chatthistoriken?',
    financeResetToDefaultCards: 'Återställ till standardkort',
    financeSaveCard: 'Spara',
    financeSaveTxBtn: 'Spara Transaktion',
    financeScoreExcellent: 'Utmärkt 🟢',
    financeScoreModerate: 'Måttlig 🟡',
    financeScoreNeedsWork: 'Behöver Åtgärd 🔴',
    financeSearchPlaceholder: 'Sök fakturor, butiksnamn, kort eller varor...',
    financeSearchProductPh: 'Sök produktnamn (t.ex. Mjölk, Bröd, Kött...)',
    financeSelectCleanupScope: 'Välj Raderingsomfattning:',
    financeSelectMonthToDelete: 'Välj Månad att Radera:',
    financeSend: 'Skicka',
    financeStoreOrTitle: 'Butiksnamn eller Titel:',
    financeStoreOrTitlePh: 't.ex. Willys / Månadslön',
    financeTitle: 'Ekonomi & Kvitton (AI)',
    financeTotalAmountLabel: 'Totalbelopp:',
    financeTotalPurchasedQty: 'Total Inköpt Mängd:',
    financeTotalSpentOnProd: 'Totalt Spenderat:',
    financeTotalTxsRecorded: '{{count}} totalt registrerade transaktioner',
    financeTypeDeleteToConfirm: 'Skriv DELETE nedan för att bekräfta radering:',
    financeTypeExpense: 'Utgift / Faktura',
    financeTypeIncome: 'Inkomst / Lön',
    financeTypeSavings: 'Sparande / Överföring',
    financeWipeAllData: 'Fullständig Dataåterställning',
    financeWipeWarning: '⚠️ Varning: Denna åtgärd går inte att ångra och raderar alla {{count}} transaktioner!',
    financeYou: 'Du',
    financeYourCurrentCards: 'Dina nuvarande kort ({{count}} st):',
    financial_advisor: 'AI Finansiell Rådgivare',
    fixSalaryBtn: 'Ändra automatiskt till Inkomst (+)',
    fixTransferBtn: 'Ändra till Överföring/Sparande',
    foodCat_Breakfast: 'Frukost',
    foodCat_Dairy: 'Mejeri',
    foodCat_Drinks: 'Drycker',
    foodCat_Fruits: 'Frukt & Citrus',
    foodCat_Nuts: 'Nötter & Frön',
    foodCat_Persian: 'Äkta Persisk',
    foodCat_Protein: 'Proteiner',
    foodCat_RiceGrains: 'Ris & Spannmål',
    foodCat_Vegetables: 'Grönsaker',
    foodCat_all: 'Alla Livsmedel',
    glp1MealPlan: 'Exklusiv GLP-1 Kostplan',
    goalCompletedSuffix: 'slutfört',
    goalCurrentAmount: 'Nuvarande: {{amount}} {{currency}}',
    goalCurrentLabel: 'Sparat:',
    goalForecastNote: 'Genom att regelbundet avsätta {{amount}} {{currency}} per månad uppnås målet om cirka {{months}} månader.',
    goalProgressPercent: '{{pct}}% uppnått',
    goalRemainingAmount: 'Återstår: {{amount}} {{currency}}',
    goalRemainingLabel: 'Kvar:',
    goalTargetAmount: 'Mål: {{amount}} {{currency}}',
    goalTargetLabel: 'Mål:',
    goalsDefault: 'Viktminskning, allmän hälsa, mer energi',
    goalsEmptyDesc: 'Inga sparmål registrerade ännu.',
    goalsForecastDesc: 'Smart beräkning baserad på månatlig sparandel ({{ratio}}%)',
    goalsForecastLabel: 'Beräknad tid för att uppnå alla mål:',
    goalsForecastTitle: 'Tidslinje & prognosanalys för ekonomiska mål',
    goalsSectionTitle: 'Sparmål och finansiell planering',
    goalsSystemGuide: 'Genom att regelbundet avsätta {{amount}} {{currency}} per månad till sparande kan du nå alla dina definierade mål i tid.',
    goalsSystemTip: 'Systemvägledning: Genom att regelbundet avsätta {{amount}} {{currency}} varje månad till ditt sparande kan du nå alla uppsatta mål i tid.',
    goalsTab: 'Ekonomiska Mål',
    goalsWeightLoss: 'Viktminskning och fettförbränning',
    graph1Subtitle: 'Sorterat efter högst andel',
    graph1Title: '1. Utgiftsfördelning per Kategori:',
    graph2Subtitle: 'Uppdelat per månad',
    graph2Title: '2. Månatlig Jämförelse av Utgifter & Sparande:',
    healthScoreOf100: '{{score}}/100',
    highPriority: '🚨 Hög prioritet (Brådskande)',
    highestQtyProducts: 'Varor med Högst Antal:',
    highestSavingsMonth: 'Månad med Högst Sparande:',
    highestSpentProducts: 'Varor med Högst Totalbelopp:',
    income: 'Inkomst',
    incomePlaceholder: 't.ex. 50 000 SEK',
    increase: 'Öka',
    increaseSavingsBtn: 'Öka sparande',
    initialSavingsLabel: 'Startsparande:',
    insertCsvSample: 'Klistra in exempel på bankkontoutdrag (CSV)',
    invoiceItemsTitle: 'Fakturaspecifikation & Varor:',
    invoiceSamplePlaceholder: 'Exempel på fakturatext: Butik, artiklar, priser...',
    invoices: 'Fakturor & Kvitton',
    item: 'Vara',
    itemUnit: 'st',
    itemUnitRows: 'rader',
    itemsCountInRow: '{{count}} produktrader',
    itemsCountSuffix: 'varor',
    itemsDetails: 'Varudetaljer',
    itemsRecordedCount: '{{count}} artiklar registrerade',
    itemsRecordedSuffix: 'varor registrerade',
    itemsUnitCount: 'st',
    labReportAnalysis: 'Tolkning av provsvar',
    language: 'Appspråk',
    languageSectionDesc: 'Välj gränssnittsspråk och layoutriktning.',
    languageSectionTitle: 'Språk och Region',
    largestShare: 'Största Andel',
    latestHeadlinesTab: 'Heta rubriker',
    learningActionDeleteAttachment: 'Radera bilaga',
    learningActionDownload: 'Ladda ner',
    learningActionPlayVideo: 'Spela video',
    learningActionViewDoc: 'Visa dokument',
    learningActionViewOnline: 'Öppna online',
    learningAddMsgHint: 'Skriv markdown eller textanteckningar för lektionen',
    learningAddMsgTitle: 'Lägg till anteckning / post',
    learningAddTeacherNote: 'Lägg till läraranteckning',
    learningAddVideoFile: 'Lägg till video / länk',
    learningAiCustomPrompt: 'Anpassad AI-förfrågan...',
    learningAiInfoLabel: 'Smart AI-driven studiekompis',
    learningAiKeyPoint: 'Viktigaste slutsats:',
    learningAiModalCancel: 'Avbryt',
    learningAiModalLabel: 'Fråga vad som helst om dina anteckningar eller material:',
    learningAiModalPh: 't.ex. Sammanfatta huvudpunkter, förklara svåra begrepp, skapa flashcards...',
    learningAiModalTitle: 'Prompt för AI-studieassistent',
    learningAiNoResponse: 'Inget svar genererades. Försök igen.',
    learningAiPromptCustom: 'Anpassad AI-prompt för lektionsanteckningar',
    learningAiPromptQuiz: 'Generera 5 interaktiva frågor för att testa förståelse',
    learningAiPromptScenario: 'Skapa ett kliniskt fall baserat på denna lektion',
    learningAiPromptSummarize: 'Skapa en sammanfattning med punktlistor och viktigaste slutsatser',
    learningAiPromptTranslateFa: 'Översätt markerade anteckningar till persiska med medicinska termer förklarade',
    learningAiPromptTranslateSv: 'Översätt markerade anteckningar till svenska med hög precision',
    learningAiQuiz: 'Skapa quiz',
    learningAiSummarize: 'AI-Sammanfattning',
    learningAiSummarizeDesc: 'Snabbsammanfattning genererad av AI',
    learningAiTransFa: 'Översätt till persiska',
    learningAiTransSv: 'Översätt till svenska',
    learningAiTranslateFa: 'Översätt till persiska',
    learningAiTranslateSv: 'Översätt till svenska',
    learningAllMessagesDeleted: 'Alla lektionsposter rensade',
    learningAnalyzeGenerateBtn: 'Analysera & generera med AI',
    learningAssistant: 'Inlärningsassistent',
    learningAttachmentOptions: 'Bilagealternativ',
    learningAttachments: 'Relaterade bilagor & dokument',
    learningAttachmentsHint: 'Ladda upp ljud, video, PDF eller bilder för att berika lektionen.',
    learningAttachmentsLabel: 'Lektionsbilagor',
    learningCopied: 'Kopierat!',
    learningCopyFullSession: 'Kopiera hela lektionens anteckningar',
    learningCopyText: 'Kopiera',
    learningCreateFirstTopic: 'Skapa ditt första studieämne för att organisera lektioner',
    learningCreateMainTopic: 'Nytt ämne',
    learningDeleteAiMsg: 'Radera meddelande',
    learningDeleteConfirmBtn: 'Radera permanent',
    learningDeleteModalDesc1: 'Är du säker på att du vill radera detta ämne och alla dess lektioner?',
    learningDeleteSession: 'Radera lektion',
    learningDeleteSubtopic: 'Radera delämne',
    learningDeleteTeacherNote: 'Radera anteckning',
    learningDeleteTopic: 'Radera ämne',
    learningDirectionLTR: 'LTR',
    learningDirectionRTL: 'RTL',
    learningEditMainTopic: 'Redigera ämne',
    learningExtractedTextTitle: 'Extraherad text från bilaga:',
    learningFileNotfound: 'Filen hittades inte',
    learningFileR2Error: 'Ett lagringsfel uppstod',
    learningFileUploadError: 'Kunde inte ladda upp bilagan',
    learningFileVideoAlert: 'Kontrollera videoformat eller länk',
    learningFormatSize: '{{size}} MB',
    learningGeneratingNotes: 'Genererar smarta anteckningar med AI...',
    learningMainTopicDescPh: 'Beskrivning av kurs eller modul...',
    learningMainTopicPh: 't.ex. Klinisk endokrinologi & nutrition',
    learningMainTopicTitle: 'Skapa huvudstudieämne',
    learningMsgInputPh: 'Skriv anteckningstext här...',
    learningNewSession: 'Ny session',
    learningNewSessionDesc: 'För detaljerade anteckningar, bifoga media och skapa smarta quiz',
    learningNewTopic: 'Nytt ämne',
    learningNoAttachmentsYet: 'Inga bilagor har lagts till i denna lektion ännu.',
    learningNoExtraDesc: 'Ingen extra beskrivning',
    learningNoExtractedTextMsg: 'Ingen text har extraherats från filen ännu.',
    learningNoSessionMatch: 'Inga lektioner matchar sökkriterierna',
    learningNoTopicMatch: 'Inga ämnen matchar din sökning',
    learningNoTopicsYet: 'Inga studieämnen skapade ännu',
    learningPromptGrammar: 'Kontrollera och finslipa grammatik och flyt i dessa anteckningar',
    learningPromptGrammarBtn: 'Förbättra grammatik & ton',
    learningPromptPresetsTitle: 'AI-studieverktyg & snabbkommandon:',
    learningPromptQuiz: 'Quizgenerator',
    learningPromptQuizBtn: 'Generera quiz',
    learningPromptScenario: 'Interaktiva scenarier',
    learningPromptScenarioBtn: 'Kliniska scenarier',
    learningSearchClear: 'Rensa sökning',
    learningSearchPh: 'Sök bland ämnen, lektioner eller anteckningar...',
    learningSearchPlaceholder: 'Sök ämnen, sessioner eller bilagor...',
    learningSelectedTopic: 'Aktivt ämne: {{name}}',
    learningSendAiPrompt: 'Skicka prompt',
    learningSessionAiDefaultReply: 'Hej! Hur kan jag hjälpa dig med dina studier i detta ämne idag?',
    learningSessionAttachmentsTitle: 'Bifogad media & resurser',
    learningSessionIntroPh: 'Kort introducerande sammanfattning av lektionen...',
    learningSessionMinReq: 'Titeln måste vara minst 2 tecken',
    learningSessionTitlePh: 't.ex. Kapitel 4: Människans anatomi & metabolism',
    learningSessionTitleReq: 'Ange en titel för lektionen',
    learningSessionUploadWait: 'Laddar upp media...',
    learningSessionsCount: '{{count}} lektioner',
    learningSessionsRegistered: 'Registrerade lektioner',
    learningShareVideoBtn: 'Koppla video',
    learningShareVideoModalTitle: 'Koppla utbildningsvideo / länk',
    learningShareVideoSm: 'Video',
    learningSharedFilesTab: 'Delade filer',
    learningSizeUnknown: 'Okänd storlek',
    learningStartNewSession: 'Ny lektion',
    learningSubtopicNotesPh: 'Skriv detaljerade anteckningar, slutsatser, formler eller kliniska tips här...',
    learningSubtopicTitlePh: 'Delämnets namn...',
    learningSubtopicsList: 'Delämnen & moduler',
    learningTeacherNoteLabel: 'Läraranteckning:',
    learningTextCopied: 'Anteckningar kopierade till urklipp!',
    learningTitle: 'Inlärningsassistent',
    learningToggleDirection: 'Växla textriktning (RTL/LTR)',
    learningTopicCreated: 'Ämnet skapades framgångsrikt',
    learningTopicLabel: 'Ämne:',
    learningTopicTitle: 'Mina inlärningsämnen',
    learningTopicsCount: '{{count}} ämnen',
    learningTopicsOf: 'Lektioner i {{topic}}',
    learningTotalSessions: 'Totalt antal lektioner:',
    learningUnknownError: 'Ett oväntat fel uppstod',
    learningUpdateTopicBtn: 'Spara ändringar',
    learningUploadingStatus: 'Bearbetar och extraherar text...',
    learningUploadingTitle: 'Laddar upp fil...',
    learningUploadingWait: 'Vänligen vänta medan filen laddas upp...',
    learningUserMsgLabel: 'Studentanteckning',
    learningVideoOnlineDefault: 'Utbildningsvideo',
    learningVideoOnlineLink: 'Online videolänk',
    learningVideoTitlePh: 'Videotitel eller ämne (valfritt)...',
    learningVideoUnsupported: 'Videoformatet stöds inte direkt i förhandsgranskningen',
    learningVideoUrlHint: 'Klistra in direktlänk till video',
    learningVideoUrlLabel: 'Video-URL (YouTube, Vimeo, MP4):',
    learning_assistant: 'AI Studieassistent',
    lightMode: 'Ljust läge',
    listColorLabel: 'Färgetikett för blocket',
    listNameLabel: 'Titel på inköpsblocket',
    listNamePlaceholder: 't.ex. Veckohandel...',
    liveGaugesDesc: 'Analys av månadens utgifter mot tillåtet tak för varje budgeterad kategori',
    liveGaugesTitle: 'Realtidsmätare & kategoribudget:',
    loading: 'Laddar...',
    logWeightBtn: 'Logga ny vikt',
    login: 'Logga in',
    loginAppTitle: 'Progress',
    loginBadgeFinance: '💰 Ekonomi & AI-Kvitton',
    loginBadgeGrowth: '🌱 Tillväxt & Vanor',
    loginBadgeRehab: '🩺 Rehab & Hälsa',
    loginDescription: 'Smarta verktyg för hälsa, vardagsrutiner och privatekonomi',
    loginEmailLabel: 'E-postadress',
    loginEmailSeparator: 'ELLER MED E-POST',
    loginErrorCreate: 'Fel vid skapande av konto',
    loginErrorFillAll: 'Vänligen fyll i alla fält.',
    loginErrorGoogleToken: 'Fel vid verifiering av Google-konto',
    loginErrorName: 'Vänligen ange ditt namn.',
    loginErrorPassLength: 'Lösenordet måste vara minst 6 tecken långt.',
    loginErrorServer: 'Fel vid anslutning till server.',
    loginErrorUnexpected: 'Ett oväntat fel inträffade. Försök igen.',
    loginErrorWrong: 'Felaktig e-post eller lösenord.',
    loginFullNameLabel: 'Fullständigt namn',
    loginFullNamePlaceholder: 't.ex. Salim Zarepour',
    loginGoogle: 'Snabb inloggning med Google',
    loginGoogleClientPrompt: 'För att aktivera Google-inloggning, ställ in VITE_GOOGLE_CLIENT_ID i dina miljövariabler.',
    loginGoogleError: 'Google-inloggningen misslyckades eller avbröts av användaren.',
    loginGoogleManualInputClose: 'Stäng manuellt inmatningsformulär',
    loginGoogleManualInputPrompt: 'Eller ange ditt Google Client ID här (Snabbtest)',
    loginGoogleManualInputSave: 'Spara och aktivera omedelbart',
    loginGuest: 'Fortsätt som gäst',
    loginPasswordLabel: 'Lösenord',
    loginSlogan: 'Omfattande plattform för personlig utveckling, rehabilitering, AI-ekonomi, hälsa och livsmål',
    loginSubmitNewAccount: 'Skapa nytt konto',
    loginSubmitSignIn: 'Logga in i systemet',
    loginToggleToSignIn: 'Har du redan ett konto? Logga in',
    loginToggleToSignUp: 'Har du inget konto? Registrera dig',
    loginVerifyingGoogle: 'Verifierar Google-konto säkert...',
    logout: 'Logga ut',
    lowPriority: '🌱 Normal prioritet',
    lowestSpentProducts: 'Varor med Lägst Totalbelopp:',
    manageFamilyMembers: 'Hantera familjemedlemmar',
    manualAdd: 'Manuell registrering',
    matchWithBankTx: 'Matchad med banktransaktion {{title}} (köpuppgifter ersätter bankpost)',
    matchWithPurchase: 'Matchad med köp {{title}} (bankkort tillämpas på köp)',
    matchingBankTxFoundMsg: 'Överlappande banktransaktion hittades: {{title}} med belopp {{amount}} {{currency}} (datum {{date}}). Vid registrering kommer denna detaljerade skannade faktura att ersätta den råa bankposten för att förhindra dubbletter.',
    matchingBankTxNotice: 'Matchande banktransaktion hittades: {{title}} med belopp {{amount}} {{currency}} (Datum {{date}}). Vid sparande kommer denna detaljerade faktura att ersätta den råa bankposten för att förhindra dubbletter.',
    medCondDefault: 'Inga',
    medicalCategory: '🩺 Medicin & Hälsa',
    medicationAdvice: 'Rådgivning om läkemedel',
    mediumPriority: '⚡ Medium prioritet',
    medsDefault: 'Inga',
    month1: 'Januari',
    month10: 'Oktober',
    month11: 'November',
    month12: 'December',
    month2: 'Februari',
    month3: 'Mars',
    month4: 'April',
    month5: 'Maj',
    month6: 'Juni',
    month7: 'Juli',
    month8: 'Augusti',
    month9: 'September',
    monthExpenseLabel: 'Utgift: {{amount}}',
    monthSavingsLabel: 'Sparande: {{amount}} {{currency}}',
    monthlyBudgetRemainingLabel: 'Återstående månatlig utgiftsbudget:',
    monthlyCategoryAnalysisDesc: 'Månadsanalys av utgifter mot tillåtet tak för budgeterade kategorier',
    monthlyExpenseCapLabel: 'Maximala månatliga utgifter ({{ratio}}%):',
    monthlySavingPower: 'Månatlig sparkapacitet:',
    monthlySavingsShare: 'Månatlig sparandel:',
    monthlySavingsShareLabel: 'Andel månatligt sparande:',
    monthsInHistory: '{{count}} månader i historik',
    monthsUnit: 'månader',
    moodTracker: 'Daglig mående- & energibedömning',
    mostExpensiveMonth: 'Månad med Högst Utgifter:',
    myCardsAndAccounts: '💳 Mina kort & konton',
    navDashboard: 'Översikt',
    navMenu: 'Meny',
    navNutrition: 'Näring',
    navReminders: 'Påminnelser',
    navSport: 'Träning',
    needToBuy: 'Behöver köpas',
    netBalance: 'Nettosaldo',
    netMonthlyIncomeHeader: 'Månatlig nettoinkomst:',
    netMonthlyIncomeLabel: 'Månatlig Nettoinkomst efter Skatt:',
    newGoalModalTitle: 'Definiera nytt ekonomiskt mål & sparande',
    newItemPlaceholder: 'Ny vara',
    newListModalTitle: 'Skapa ett nytt inköpsblock',
    newNoteBtn: 'Ny anteckning',
    news: 'AI Nyhetsradar',
    newsCategoriesLabel: 'Nyhetskategorier',
    newsRadarTitle: 'Senaste AI- & Tekniknyheter',
    newsSource: 'Källa',
    newsSourceLabel: 'Källa',
    newsTopicsTab: 'Ämnen & Nyckelord',
    news_radar: 'Hälso- & nyhetsradar',
    nextMonth: 'Nästa månad',
    noActiveGoals: 'Inga aktiva mål',
    noBudgetPlaceholder: '0 (Ingen budget)',
    noCappedCategoriesMsg: 'Inga kategorier har en definierad budgetgräns för denna månad.',
    noCategoryCapsDefinedYet: 'Inga specifika tak har satts för någon kategori än.',
    noCategoryCapsHelp: 'Använd knappen Automatisk uppskattning ovan eller ange belopp manuellt för att sätta kategoritak och aktivera realtidsmätare.',
    noCategoryCapsRecorded: 'Inga anpassade budgettak har ställts in för några kategorier ännu.',
    noCategoryData: 'Inga transaktioner för kategoridiagram.',
    noGoalsYet: 'Inga sparmål definierade än.',
    noMonthlyData: 'Ingen månadsdata för jämförelse.',
    noProductFound: 'Inga varor hittades.',
    noTransactionsFound: 'Inga fakturor eller transaktioner hittades.',
    notes: 'Anteckningar & Mående',
    notesEnergyLevelTitle: 'Energinivå (1-10)',
    notesEnergyScoreLabel: 'Energipoäng: {{score}}/10',
    notesHeaderDesc: 'Logga tankar, dagliga känslor, planer och kategorisera anteckningar',
    notesHeaderTitle: 'Personlig Anteckningsbok & Måendedagbok',
    notesLabel: 'Anteckningar',
    notesMoodTitle: 'Humör & mental energi',
    notesNotebooksTitle: 'Hälso- & Dagboksanteckningar',
    notesObservationsLabel: 'Dagliga hälsoobservationer',
    notesObservationsPlaceholder: 'Anteckna fysiska förändringar, matreaktioner eller allmänt mående...',
    notesPainDesc0: 'Inget obehag alls, mår toppen',
    notesPainDesc10: 'Värsta tänkbara smärta, akut nivå',
    notesPainDesc2: 'Milt obehag, knappt märkbart',
    notesPainDesc4: 'Märkbar smärta, hanterbar utan läkemedel',
    notesPainDesc6: 'Måttlig till stark smärta, stör aktiviteter',
    notesPainDesc8: 'Svår smärta, handikappande, kräver vila',
    notesPainLevelTitle: 'Skala för smärta & fysiskt obehag',
    notesPainScale0: '0 - Ingen smärta',
    notesPainScoreLabel: 'Smärtnivå: {{score}}/10',
    notesPhysicalStatusPrefix: 'Fysisk status:',
    notesRemindersLabel: 'Hälsopåminnelser & nästa steg',
    notesRemindersPlaceholder: 't.ex. Boka blodprov, hämta recept, dricka mer vatten...',
    notesSymptomsLabel: 'Observerade symtom & kroppsförnimmelser',
    notificationsTitle: 'Aviseringar & Påminnelser',
    nutriAdd: 'Lägg till',
    nutriAddFav: 'Lägg till som favorit',
    nutriAiAnalysis: 'Anpassad / AI Analys',
    nutriAiAnalyzing: 'AI Analyserar...',
    nutriAiEstimate: 'Uppskatta med AI',
    nutriAiQueryWeight: 'Fråga AI om kalorier och makros för denna vikt',
    nutriAiRecalculating: 'Omräknar vikt med AI...',
    nutriBreakfast: 'Frukost',
    nutriCalLabel: 'Kalorier (kcal)',
    nutriCalcResult: 'Beräknad Näring',
    nutriCalories: 'Konsumerade kalorier',
    nutriCarbLabel: 'Kolhydrater (g)',
    nutriCarbShort: 'Kolhydrat:',
    nutriCarbs: 'Kolhydrater',
    nutriChatAssistant: 'Chattassistent',
    nutriChatPlaceholder: 't.ex., Vilka livsmedel rekommenderar du för att bränna magfett?',
    nutriChatSubtitle: 'Ställ specialiserade dietfrågor, beräkna kalorier och få måltidsplaner',
    nutriChatTitle: 'Smart Närings- och Dietassistent',
    nutriCustomAddTitle: 'Logga Anpassad Mat eller AI Auto-analys',
    nutriDeleteFood: 'Ta bort mat',
    nutriDietTip: '💡 Dagens näringstips',
    nutriDietTipText: 'För att nå dina träningsmål rekommenderas att du delar upp ditt dagliga protein på alla 4 måltiderna och dricker minst 2,5 liter vatten.',
    nutriDinner: 'Middag',
    nutriFat: 'Hälsosamma fetter',
    nutriFatLabel: 'Fett (g)',
    nutriFatShort: 'Fett:',
    nutriFavorites: 'Favoriter ({{count}})',
    nutriFoodNameDesc: 'Matens namn / Beskrivning',
    nutriFoodNamePlaceholder: 't.ex., En tallrik kyckling och ris med yoghurt',
    nutriFrom: 'av',
    nutriGlassWater: '1 Glas (+250ml)',
    nutriGrams: 'g',
    nutriHeaderTitle: 'Smart Närings- och Kalorispårare',
    nutriItem: 'objekt',
    nutriKcal: 'kcal',
    nutriLogBtn: 'Logga',
    nutriLogToDiary: 'Logga i Dagboken',
    nutriLogToFoodDiary: 'Logga i Matdagbok',
    nutriLunch: 'Lunch',
    nutriMealCount: 'Måltider:',
    nutriMealType: 'Måltidstyp',
    nutriNextDay: 'Nästa dag',
    nutriNoFoodForMeal: 'Ingen mat loggad för denna måltid.',
    nutriOrEnterExactWeight: 'Eller ange exakt vikt (g):',
    nutriPrevDay: 'Föregående dag',
    nutriProtLabel: 'Protein (g)',
    nutriProtShort: 'Protein:',
    nutriProtein: 'Protein',
    nutriQtyPlaceholder: 't.ex., 150g / 1 hel tallrik',
    nutriQtyWeight: 'Mängd / Vikt / Portion',
    nutriQuickAdd: 'Snabb tillägg',
    nutriReduceWater: 'Minska',
    nutriRefUnit: 'Referensenhet:',
    nutriReport: 'Rapport',
    nutriReportTitle: 'Näringsuppföljningsrapport',
    nutriSearchPlaceholder: 'Sök mat (t.ex. kycklingbröst, ris, ägg...)',
    nutriSelectMeal: 'Välj Måltid:',
    nutriServingMultiplier: 'Portionsmultiplikator:',
    nutriSnack: 'Mellanmål',
    nutriSourceAi: '✨ AI Genererad',
    nutriSourceStd: '⚡ Standardberäkning',
    nutriSummaryTitle: 'Dagens näringssammanfattning',
    nutriToday: 'Idag',
    nutriTodayMeals: 'Dagens loggade måltider',
    nutriTotalCalToday: 'Totala Kalorier Idag',
    nutriTotalCarbToday: 'Kolhydrater Idag',
    nutriTotalProtToday: 'Protein Idag',
    nutriWater: 'Vattenintag:',
    nutriWaterConsumed: 'Konsumerat Vatten',
    nutriWaterTarget: '(Mål: {{target}} ml)',
    nutriWeightPlaceholder: 't.ex., {{base}} (g)',
    nutrition: 'Kost & Näring',
    nutritionHeaderDesc: 'Beräkna dagligt kalorimål, protein, kolhydrater och fett med AI-måltidsscanning',
    nutritionHeaderTitle: 'Smart Närings- & Makrospårning',
    ofIncome: 'av inkomst',
    ofTotalBudget: 'av total budget',
    ofTotalBudgetUsed: 'av total budget använd',
    offlineMode: 'Offlineläge (Lokal lagring)',
    offsetAtTime: 'Vid förfallotid',
    offsetBefore: 'innan',
    offsetDay: 'dag',
    offsetHour: 'timme',
    offsetMin: 'minut',
    offsetWeek: 'vecka',
    or: 'ELLER',
    overAllocationWarning: '⚠️ Allokering överskrider {{title}}',
    overlappingBankTxFound: 'Överlappande banktransaktion hittades: {{title}} med belopp {{amount}} {{currency}} (Datum: {{date}}). Sparande ersätter rå bankpost med detta specificerade kvitto.',
    overviewAndTxs: 'Översikt & Transaktioner',
    painLevelTracker: 'Skattning av smärtnivå (1-10)',
    password: 'Lösenord',
    paymentMethodCard: '💳 Bankkort (Card)',
    paymentMethodCash: '💵 Kontant (Cash)',
    paymentMethodSwish: '📱 Swish (Swish)',
    paymentMethodTransfer: '🏦 Banköverföring (Transfer)',
    pendingCount: 'Väntar på inköp',
    perMonthSuffix: 'mån',
    persian: 'فارسی (Persiska)',
    personalDoctor: 'Personlig AI-Läkare',
    preset15m: '15 minuter innan',
    preset1d: '1 dag innan',
    preset1h: '1 timme innan',
    preset1w: '1 vecka innan',
    preset3d: '3 dagar innan',
    presetAtTime: 'Vid tidpunkten',
    presetTitle: 'Snabbval för inköp',
    prevMonth: 'Föregående månad',
    productAnalyticsTab: 'Produktanalys & Förbrukning',
    profileSettings: 'Profil & Hälsomål',
    progressCompleted: '{{progress}}% slutfört',
    protein: 'Protein',
    proteinGoal: 'Protein (g)',
    purchaseDateLabel: 'Föreslaget inköpsdatum',
    quantity: 'Antal',
    quantityCount: '{{count}} st',
    quantityTitle: 'Mängd / Antal',
    quickAccess: 'Snabbåtkomst',
    quickCurrencyChange: 'Ändra Basvaluta:',
    rankingProductsTitle: '3. Produkt- & Varurankning (Vilken produkt mest eller minst):',
    recordedExpensesThisMonth: 'Registrerade utgifter denna månad:',
    recurringReminders: 'Återkommande påminnelser',
    refreshNews: 'Uppdatera nyheter med AI',
    refreshNewsBtn: 'Uppdatera & Bearbeta nyheter med AI',
    register: 'Registrera',
    registeredItemsCount: '{{count}} varor registrerade',
    rehab: 'Rehab & Fysioterapi',
    rehabAiAlert: 'Rekommendationer genereras av online AI. Sluta övningen om du upplever ovanlig stark smärta.',
    rehabAiFormEq: 'Tillgänglig Utrustning:',
    rehabAiFormEqPh: 't.ex. yogamatta, gummiband',
    rehabAiFormExp: 'Träningserfarenhet:',
    rehabAiFormExpA: 'Avancerad (Regelbunden idrottare)',
    rehabAiFormExpB: 'Nybörjare (Ingen erfarenhet)',
    rehabAiFormExpM: 'Medel (Sporadisk träning)',
    rehabAiFormLevel: 'Smärtnivå ({{level}} av 10):',
    rehabAiFormLevelMax: 'Svår (10)',
    rehabAiFormLevelMid: 'Måttlig (5)',
    rehabAiFormLevelMin: 'Mycket Mild (1)',
    rehabAiFormLimit: 'Rörelsebegränsningar:',
    rehabAiFormLimitPh: 't.ex. kan inte böja mig, gör ont när jag sitter länge',
    rehabAiFormLoc: 'Huvudsaklig Smärtplats:',
    rehabAiFormLocPh: 't.ex. ländrygg, nacke, knä',
    rehabAiFormTitle: 'Kropps- & Smärtbedömning',
    rehabAiSubtitle: 'Anpassa specialiserade fysioterapiövningar baserat på en fullständig bedömning av ditt fysiska tillstånd och smärta.',
    rehabAiTitle: 'Smart Rehab-generator (AI)',
    rehabAlertDesc: 'Om du upplever ökad lokaliserad smärta eller skjutande smärta längs benet/rumpan under dessa rörelser, STOPPA omedelbart. Dekompression- och stretchövningar måste vara smärtfria.',
    rehabAlertTitle: 'Försiktighet vid Ryggövningar',
    rehabCardCancel: 'Avbryt',
    rehabCardEdit: 'Redigera & Bifoga Media',
    rehabCardEditShort: 'Redigera / Bifoga Media',
    rehabCardImageDel: 'Ta Bort Bild',
    rehabCardImageLabel: 'Bifoga Bild/GIF Guide',
    rehabCardImagePreview: 'Bildförhandsgranskning:',
    rehabCardSave: 'Spara Media & Övningsändringar',
    rehabCardTagImage: 'Bildguide',
    rehabCardTagRehab: 'Fysioterapi',
    rehabCardTagVideo: 'Videoguide',
    rehabCardVideoLabel: 'Bifoga Videoguide (Ladda upp eller Länk)',
    rehabCardVideoPreview: 'Videoförhandsgranskning:',
    rehabChatApply: 'Lägg Till Denna Övning i Mitt Program',
    rehabChatPh: 'Beskriv din smärta fullt ut eller ställ frågor om rörelser...',
    rehabChatSub: 'Direkta, smarta svar baserade på din kroppsbedömning',
    rehabChatTitle: 'Chatt för Rehabdesign & Konsultation',
    rehabCustomAddSub: 'Lägg till en anpassad rörelse eller läkarrekommenderad övning i din plan',
    rehabCustomAddTitle: 'Lägg Till Anpassad Rehabövning',
    rehabCustomClose: 'Stäng Formulär',
    rehabCustomDesc: 'Fullständiga Instruktioner',
    rehabCustomDescPh: 'Beskriv rörelsen exakt som en guide...',
    rehabCustomDiff: 'Svårighetsgrad',
    rehabCustomDiffA: 'Avancerad',
    rehabCustomDiffB: 'Nybörjare',
    rehabCustomDiffM: 'Medel',
    rehabCustomImage: 'Träningsbild (Valfritt)',
    rehabCustomImageReady: 'Bild Uppladdad',
    rehabCustomName: 'Övningens Namn',
    rehabCustomNamePh: 't.ex. Mild Katt-Ko Stretch',
    rehabCustomOpen: 'Öppna Formulär',
    rehabCustomPurpose: 'Syfte (Varför hjälper det?)',
    rehabCustomPurposePh: 't.ex. Minskar kompression på L4-S1',
    rehabCustomReps: 'Reps / Håll',
    rehabCustomRest: 'Vilolängd',
    rehabCustomSets: 'Set',
    rehabCustomSubmit: 'Spara Anpassad Övning',
    rehabCustomTarget: 'Målmuskler',
    rehabCustomTargetPh: 't.ex. Ländrygg, Ryggrad',
    rehabCustomTime: 'Tid (min)',
    rehabCustomTip1: 'Genom att öppna formuläret kan du lägga till vilken övning som helst med fullständiga detaljer (set, reps, muskler, media) till din dagliga lista.',
    rehabCustomTip2: 'Övningar som läggs till här kommer automatiskt att visas i din dagliga rutin och röststyrda pass.',
    rehabCustomVideo: 'Träningsvideo (Valfritt)',
    rehabCustomVideoDel: 'Ta Bort Video',
    rehabCustomVideoPh: 'Eller videolänk (Instagram, YouTube, MP4)...',
    rehabCustomVideoReady: 'Videon är redo',
    rehabFolderBtnClose: 'Stäng Filer Mapp',
    rehabFolderBtnOpen: 'Mapp för Rehabfiler & Dokument',
    rehabFullInstructions: 'Steg-för-steg Instruktioner:',
    rehabGraphicPlaceholder: '[Fysio Schematisk Vy]',
    rehabGuidedCompleteDesc: 'Dina ryggåterhämtningsövningar har sparats framgångsrikt i din framstegsmätare.',
    rehabGuidedCompleteTitle: 'Bra jobbat! Dagens rutin avklarad',
    rehabGuidedSaveReturn: 'Bekräfta & Återgå till Lista',
    rehabHeaderDesc: 'Anpassad träningsterapi, muskelstärkande övningar och daglig rehabspårning',
    rehabHeaderTitle: 'Fysioterapi, Korrigerande övningar & Smärtlindring',
    rehabLevelMid: 'Medel',
    rehabLevelSafe: 'Säker Nybörjarnivå',
    rehabPlayImage: 'Visa Övningsbild',
    rehabPlayVideo: 'Se Träningsvideo',
    rehabProgress: 'Rehab & Träning',
    rehabStartGuided: 'Starta Röstguidad Rehabsession',
    rehabStatsTimeActive: 'Aktiva Träningsminuter',
    rehabStatsTimeTip: 'Kontinuitet är nyckeln till återhämtning!',
    rehabStatsTimeTitle: 'Effektiv Återhämtningstid',
    rehabStatsTitleCompleted: 'Slutförda Ryggsmärtövningar',
    rehabStatsTotalDaily: '/ {{total}} Dagliga Övningar',
    rehabStatusPrepare: 'Redo',
    rehabStatusRest: 'Vila & Återhämta',
    rehabStatusRunning: 'Körs',
    rehabSubtitle: 'Specialiserade fysioterapiövningar för att dekomprimera diskar, eliminera ischiassmärta och bygga bålstabilitet.',
    rehabTargetMuscles: 'Stabiliserande Muskler:',
    rehabTargetPurpose: 'Huvudsyfte:',
    rehabTimerSkip: 'Hoppa över vila',
    rehabTimerStandby: 'Redo',
    rehabTimerStart30: 'Starta 30 Sekunder',
    rehabTimerTip: 'Att ta en 30-sekunders paus mellan seten hjälper till att förbättra blodflödet och återhämta bindväv.',
    rehabTimerTitle: 'Fri Vilotimer',
    rehabVideoIg: 'Instagram-inlägg / Reel',
    rehabVideoIgOpen: 'Öppna Direkt i Instagram-appen',
    rehabVideoWeb: 'Öppna Videolänk (Instagram / Webb)',
    rehabVoiceActive: 'Röstassistent Aktiv',
    voiceInputNormal: 'Röstinmatning',
    voiceInputStop: 'Stoppa inspelning',
    voiceInputProcessing: 'Omvandlar ljud till text...',
    voiceInputProcessingShort: 'Omvandlar...',
    voiceInputBtnLabel: 'Röst',
    voiceInputPermissionDenied: 'Åtkomst till mikrofon nekades.',
    voiceInputRecordingError: 'Ljudinspelning misslyckades.',
    voiceInputTranscribeError: 'Kunde inte omvandla ljud till text. Försök igen.',
    voiceInputNoSpeechDetected: 'Inget tal upptäcktes att omvandla.',
    voiceInputTitleForField: 'Röstinmatning för delämnestitel',
    voiceInputTitleForNotes: 'Röstinmatning för delämnesanteckningar',
    rehabEmptyTitle: 'Inga övningar registrerade i denna modul ännu',
    rehabEmptyDesc: 'Du kan importera dina övningar från en JSON-fil med knappen "Massimportera aktiviteter" eller lägga till en ny övning manuellt.',
    rehabNoExercisesAlert: 'Vänligen lägg till eller importera minst en övning till denna modul först.',
    remainingAllowedExpense: 'Återstående tillåten budget denna månad:',
    remainingBudgetCapHeader: 'Återstående budgetutrymme:',
    remainingBudgetMonth: 'Återstående månadsbudget: {{amount}} {{currency}}',
    remainingExpenseBudgetMsg: '✓ Återstående tillåtna utgifter denna månad: {{amount}} {{currency}}',
    reminderActiveCount: '{{count}} aktiva påminnelsetider',
    reminderAddBtn: 'Ny Påminnelse',
    reminderAddCustomOffsetBtn: 'Lägg till',
    reminderAddForDate: 'Lägg till för detta datum',
    reminderAddShort: 'Lägg till',
    reminderAllCatsCount: 'Alla Kategorier ({{count}})',
    reminderAllPersons: 'Alla Personer',
    reminderCantRemoveMe: 'Kan inte ta bort primärkontakten "Jag"',
    reminderCardAddGcal: 'Lägg till i Google Calendar',
    reminderCardDelete: 'Radera',
    reminderCardEdit: 'Redigera',
    reminderCardGcal: 'Google Kalender',
    reminderCardTime: 'kl. {{time}}',
    reminderCatBills: 'Räkningar & Ekonomi',
    reminderCatBirthday: 'Födelsedagar & Jubileum',
    reminderCatEvent: 'Händelser & Möten',
    reminderCatFamily: 'Familjehantering',
    reminderCatMedical: 'Medicin & Hälsa',
    reminderCatPersonal: 'Personligt & Administration',
    reminderCatSchool: 'Skola & Utbildning',
    reminderCatShopping: 'Inköp & Paket',
    reminderCategoryLabel: 'Kategori',
    reminderClearAllBtn: 'Rensa Allt',
    reminderCustomOffset: 'Anpassad tid:',
    bulkImportModalTitle: 'Massimportera Övningar & Aktiviteter (JSON Bulk Import)',
    bulkImportModalSubtitle: 'Permanent lagring i Cloudflare D1-databas',
    bulkImportD1NoticeTitle: 'Säker och permanent molnlagring i Cloudflare D1',
    bulkImportD1NoticeDesc: 'Alla importerade aktiviteter sparas direkt i databastabellen med modulkoppling och överlever sidnavigering, hård uppdatering och omstart.',
    bulkImportModuleSelect: 'Målmodul:',
    module1RehabName: 'Modul 1 — Fysioterapi, rehab och smärtlindring',
    module2BellyName: 'Modul 2 — Fettförbränning och magträning',
    moduleCustomActivities: 'Allmänna Dagliga Aktiviteter',
    bulkImportStrategySelect: 'Hantering av dubbletter:',
    strategyUpdate: 'Uppdatera befintliga + Lägg till nya (Upsert)',
    strategySkip: 'Hoppa över dubbletter + Lägg till endast nya',
    strategyInsert: 'Skapa alltid som nya poster',
    bulkImportJsonLabel: 'JSON-innehåll för övningsmatris:',
    copied: 'Kopierad',
    copySample: 'Kopiera exempel',
    loadSampleJson: 'Ladda exempel-JSON',
    jsonEmptyError: 'Vänligen ange JSON-text för aktiviteterna i rutan.',
    jsonNoItemsFound: 'Inga giltiga övningsobjekt hittades i JSON-datan.',
    jsonMissingNameError: 'Alla övningar måste ha minst ett fält för "name" eller "title".',
    jsonSyntaxError: 'JSON Syntaxfel:',
    validItemsCount: 'Hittade {{count}} giltiga övningar redo för import:',
    readyToImport: 'Klar för D1-databas',
    importSuccessTitle: 'Massimport till databasen slutfördes framgångsrikt!',
    importFailedTitle: 'Massimport misslyckades',
    importSummaryDesc: 'Totalt: {{total}} | Tillagda: {{ins}} | Uppdaterade: {{upd}} | Hoppade över: {{skp}}',
    validateJsonBtn: 'Validera JSON-data',
    startImportBtn: 'Importera till databas ({{count}} aktiviteter)',
    importingProgress: 'Sparar till D1-molndatabas...',
    bulkImportOpenBtn: 'Massimportera Aktiviteter (JSON Import)',
    reminderClearAllConfirm: 'Är du säker på att du vill ta bort alla påminnelser? Detta går inte att ångra.',
    reminderClearAllTitle: 'Rensa alla påminnelser',
    reminderDateLabel: 'Förfallodatum',
    reminderDownloadIcsBtn: 'Ladda ner Kalender (.ics)',
    reminderDownloadIcsTitle: 'Ladda ner alla aktiva påminnelser som .ics-fil för iPhone, Android eller Google Kalender',
    reminderEditTitle: 'Redigera Påminnelse',
    reminderFamilyExist: 'Detta namn är redan registrerat.',
    reminderFormCancel: 'Avbryt',
    reminderFormCatLabel: 'Kategori',
    reminderFormCustomPerson: 'Ny Anpassad Person...',
    reminderFormCustomPersonLabel: 'Anpassat Personnamn',
    reminderFormCustomPersonPh: 't.ex. Alex / Maria',
    reminderFormDate: 'Datum',
    reminderFormDesc: 'Ytterligare anteckningar (valfritt)',
    reminderFormDescPh: 'Klinikadress, spårningsnummer, viktiga anteckningar...',
    reminderFormPersonLabel: 'Tilldelad person:',
    reminderFormPri: 'Prioritet',
    reminderFormRepeat: 'Upprepa',
    reminderFormSubmitAdd: 'Skapa Påminnelse',
    reminderFormSubmitEdit: 'Spara Ändringar',
    reminderFormTime: 'Tid',
    reminderFormTitleLabel: 'Påminnelsetitel',
    reminderFormTitlePh: 't.ex. Födelsedag / Betala räkning / Blodprov...',
    reminderHeaderDesc: 'Hantera läkarbesök, räkningar, födelsedagar och skola med molnsynk och kalenderexport',
    reminderHeaderTitle: 'Smart Familjepåminnelsebok & Deadlineplanerare',
    reminderItemsCount: '{{count}} ärenden',
    reminderManageMembersBtn: 'Hantera Medlemmar',
    reminderManageMembersTitle: 'Hantera, lägg till eller ta bort familjemedlemmar',
    reminderMe: 'Jag',
    reminderMembersAdd: 'Lägg till',
    reminderMembersClose: 'Bekräfta & Stäng',
    reminderMembersCurrent: 'Registrerade Medlemmar ({{count}}):',
    reminderMembersDesc: 'Lägg till eller ta bort personer för att tilldela påminnelser',
    reminderMembersPh: 'Ny medlems namn (t.ex. Maria, Alex)...',
    reminderMembersRemove: 'Ta bort {{member}}',
    reminderMembersTitle: 'Hantera Familjemedlemmar',
    reminderModalDesc: 'Ställ in schema, prioritet och tilldela familjemedlem',
    reminderNewItem: 'Ny',
    reminderNewTitle: 'Skapa Ny Påminnelse',
    reminderNoForDate: 'Inga påminnelser schemalagda för {{date}}.',
    reminderNoIcsError: 'Inga aktiva påminnelser finns för kalenderexport.',
    reminderNoInCat: 'Inga påminnelser finns i denna kategori.',
    reminderNoTodayDesc: 'Lägg till en ny påminnelse för dagens bokningar.',
    reminderNoTodayMsg: 'Du har inga väntande påminnelser för idag!',
    reminderNoUpcoming: 'Inga påminnelser schemalagda för kommande dagar.',
    reminderNoOffsets: 'Inga påminnelser',
    reminderOffsetsTitle: 'Avisering- och påminnelseschema före förfallotid',
    reminderPastTitle: 'Tidigare Påminnelser ({{count}})',
    reminderPersonFilter: 'Person:',
    reminderPersonLabel: 'Relaterad person / Familjemedlem',
    reminderPresetsLabel: 'Snabbval av vanliga tider:',
    reminderPreset1Name: 'Födelsedag & Jubileum',
    reminderPreset1Title: 'Födelsedag & Bröllopsdag',
    reminderPreset2Name: 'Räkningsbetalning',
    reminderPreset2Title: 'El- & Hushållsräkningar',
    reminderPreset3Name: 'Skola / Universitet',
    reminderPreset3Title: 'Föräldramöte i Skolan',
    reminderPreset4Name: 'Sköldkörtel- & Blodprov',
    reminderPreset4Title: 'Sköldkörtel- & Hälsokontroll',
    reminderPreset5Name: 'Paketleverans',
    reminderPreset5Title: 'Spåra Paketleverans',
    reminderPreset6Name: 'Familjeträff',
    reminderPreset6Title: 'Familjemiddag & Kalas',
    reminderPriHigh: 'Brådskande',
    reminderPriHighText: 'Hög / Brådskande',
    reminderPriLow: 'Normal',
    reminderPriLowText: 'Låg / Normal',
    reminderPriMed: 'Medel',
    reminderPriMedText: 'Medel',
    reminderPriorityLabel: 'Prioritetsnivå',
    reminderQuickPresets: 'Snabba Förval:',
    reminderRegisteredCount: '{{count}} registrerade påminnelser',
    reminderRemoveOffsetBtn: 'Ta bort denna påminnelsetid',
    reminderRepeatDaily: 'Dagligen',
    reminderRepeatLabel: 'Upprepa påminnelse',
    reminderRepeatMonthly: 'Varje månad',
    reminderRepeatNone: 'Ingen upprepning',
    reminderRepeatWeekly: 'Varje vecka',
    reminderRepeatYearly: 'Varje år',
    reminderSearchPh: 'Sök efter titel, person eller anteckningar...',
    reminderSelectedDate: 'Påminnelser för {{date}}',
    reminderStatsDone: 'Avklarade',
    reminderStatsMed: 'Läkar- & Medicinärenden',
    reminderStatsToday: 'Dagens påminnelser',
    reminderStatsUpcoming: 'Kommande Dagar',
    reminderTabCalendar: 'Månadskalender',
    reminderTabCategories: 'Kategorier',
    reminderTabToday: 'Idag & Kommande',
    reminderTimeLabel: 'Påminnelsetid',
    reminderTitleLabel: 'Titel på påminnelse',
    reminderTodayTitle: 'Idag',
    reminderUnknown: 'Okänd',
    reminderUpcomingTitle: 'Kommande Dagar',
    reminders: 'Familjepåminnelser',
    remindersTitle: 'Familjepåminnelsebok',
    renameListTitle: 'Redigera information för blocket',
    repetitionCount: 'Antal repetitioner',
    reports: 'Rapporter & AI-Export',
    reportsHeaderDesc: 'Exportera PDF- & Excel-sammanfattningar av hälsa, budget, träning och AI-läkarrapporter',
    reportsHeaderTitle: 'Omfattande Analys & AI-Rapporter',
    reportsTitle: 'Omfattande Rapporter & AI-Analys',
    adminAnonymousUser: 'Gästanvändare',
    adminFilterAllPages: 'Alla Sidor',
    adminModuleDesc: 'Visa registrerade användare, senaste aktivitet, nuvarande sida och aktivitetsloggar.',
    adminModuleTitle: 'Användarhantering & Adminpanel',
    adminNoLogs: 'Inga aktivitetsloggar hittades för denna användare.',
    adminRefreshBtn: 'Uppdatera Lista',
    adminSearchPlaceholder: 'Sök användare på namn eller e-post...',
    adminSystemUser: 'Systemanvändare',
    adminThActions: 'Detaljer',
    adminThEmail: 'E-post',
    adminThJoined: 'Blev Medlem',
    adminThLastActive: 'Senaste Aktivitet',
    adminThLastPage: 'Nuvarande Sida',
    adminThUser: 'Användare',
    adminTotalUsers: 'Totalt Registrerade Användare:',
    adminUserLogsTitle: 'Senaste Aktivitetslogg för Användaren',
    adminUsersCount: '{{count}} användare',
    adminSelectUserPromptTitle: 'Välj användare för spårning',
    adminSelectUserPromptDesc: 'Klicka på en användare i listan för att visa inloggningsdetaljer och besökta sidor.',
    adminLoadingUsers: 'Laddar lista över aktiva användare...',
    adminConnErrorTitle: 'Anslutningsfel',
    adminNoUsersFound: 'Inga användare hittades',
    adminNoUsersDesc: 'Inga användare matchar din sökning.',
    adminSysAdminBadge: 'Systemadministratör 🛡️',
    adminPageLabel: 'Sida:',
    adminJoinDate: 'Blev medlem:',
    adminLastActive: 'Senast aktiv:',
    adminLastPage: 'Senaste sida:',
    adminRecentViews: 'Senaste sidvisningar',
    adminLoggedUnit: 'registrerade',
    adminLoadingLogs: 'Laddar aktivitetslogg...',
    adminPageView: 'Sidvisning',
    adminUnknown: 'Okänd',
    settingsTitle: 'Systeminställningar & Larmscheman',
    settingsDesc: 'Anpassa dagliga larm, fysiska och kalorimål, användarnamn och aviseringsinställningar.',
    settingsSaved: 'Inställningar sparade!',
    settingsSaveBtn: 'Spara inställningar',
    settingsProfileHeader: 'Personlig Profil & Hälsomål',
    settingsNameLabel: 'Ditt namn eller smeknamn',
    settingsCalorieGoalLabel: 'Dagligt kalorimål (kcal)',
    settingsWaterGoalLabel: 'Dagligt vattenmål (ml)',
    settingsLocalStorageNotice: 'Alla dina inställningar och hälsodata sparas och synkroniseras säkert och direkt i Cloudflare D1-molndatabasen.',
    settingsCalcHeader: 'Kalkylator för längd, vikt och dagligt kalorimål',
    settingsCalcSub: 'Standardiserad Mifflin-St Jeor-formel baserad på anatomi',
    settingsHeightLabel: 'Längd (cm)',
    settingsWeightLabel: 'Nuvarande vikt (kg)',
    settingsWeightGoalLabel: 'Målvikt (kg)',
    settingsAgeLabel: 'Ålder (år)',
    settingsGenderLabel: 'Kön',
    genderMale: 'Man',
    genderFemale: 'Kvinna',
    settingsActivityLevelLabel: 'Daglig aktivitetsnivå',
    actSedentary: 'Stillasittande (skrivbordsarbete)',
    actLight: 'Lätt aktiv (1-3 dagar träning/promenad)',
    actModerate: 'Måttligt aktiv (3-5 dagar träning/vecka)',
    actActive: 'Mycket aktiv (6-7 dagar hård träning)',
    actVeryActive: 'Extremt aktiv (professionell idrottare/fysiskt arbete)',
    settingsGoalTypeLabel: 'Ditt viktmål',
    goalTypeLose: 'Viktminskning (hälsosam fettminskning ~500 kcal underskott)',
    goalTypeMaintain: 'Viktstabilitet (behåll nuvarande vikt)',
    goalTypeGain: 'Viktökning & Muskeluppbyggnad (kontrollerat överskott)',
    settingsAlarmsTitle: 'Schema för larm och rutinpåminnelser',
    settingsNotificationTestBtn: 'Testa och aktivera aviseringar',
    settingsAlarmsIntegratedTitle: 'Integrerad hantering av dagliga larm och aviseringar i veckoschemat',
    settingsAlarmsIntegratedDesc: 'Alla dina larm, mobilaviseringar och rutinpåminnelser hanteras direkt under "Veckoplanering & Rutiner". Du kan aktivera mobilaviseringar och Google Calendar-synk för varje aktivitet.',
    settingsGoToWeeklySchedule: 'Öppna veckoschema & larminställningar',
    settingsCalendarExportTitle: 'Exportera hela veckoschemat och alla familjepåminnelser (.ics)',
    settingsDownloadIcsBtn: 'Ladda ner universell kalender (.ics)',
    settingsIcsGuide: '💡 Guide: Klicka ovan för att ladda ner en samlad .ics-fil med alla veckorutiner och aktiva familjepåminnelser. Importera till Google Calendar, iPhone eller Samsung för att aktivera alla mobillarm.',
    settingsNotificationNoticeTitle: 'Information om enhetsaviseringar',
    settingsNotificationNoticeDesc: 'Smarta aviseringar kräver webbläsartillstånd (Notification Permission). Tillåt aviseringar i din mobil eller dator för att få regelbundna påminnelser.',
    settingsIosNoticeTitle: '📱 Guide för iPhone-användare (iOS) för att aktivera aviseringar',
    settingsIosNoticeDesc: 'Apple iOS inaktiverar webbmeddelanden på vanliga webbsidor. För att få larm på iPhone, följ dessa enkla steg:',
    settingsIosStep1Title: 'Steg 1: Lägg till på hemskärmen',
    settingsIosStep1Desc: 'I Safari på din iPhone, tryck på Dela-knappen i botten och välj Lägg till på hemskärmen.',
    settingsIosStep2Title: 'Steg 2: Bekräfta tillstånd',
    settingsIosStep2Desc: 'Öppna Pishraft från hemskärmen på din iPhone, gå till Inställningar och tryck på "Testa och aktivera aviseringar".',
    settingsMedicalCondLabel: 'Medicinska tillstånd & historik',
    settingsMedicalCondPh: 't.ex. fettlever, högt blodtryck',
    settingsMedsLabel: 'Läkemedel & kosttillskott',
    settingsMedsPh: 't.ex. Vitamin D3, Metformin',
    settingsAllergiesLabel: 'Allergier & överkänslighet',
    settingsAllergiesPh: 't.ex. Penicillin, laktosintolerans',
    settingsDietGoalsLabel: 'Kost- och hälsomål',
    settingsDietGoalsPh: 't.ex. Minska bukfett, reglera blodsocker',
    settingsNamePlaceholder: 'Ditt namn',
    settingsAiCalibrating: 'Analyserar och beräknar med AI...',
    settingsAiCalibrateBtn: 'Beräkna smart kalorimål med AI',
    targetWeightEtaTitle: 'Uppskattad tid till målvikt',
    targetWeightEtaDesc: 'Beräkna viktförändringstakt baserat på dagligt kalorimål',
    targetWeightReached: 'Grattis! Du är för närvarande i din målvikt.',
    targetWeightEstimatedTime: 'Beräknad tid till målvikt:',
    targetWeightWeeks: 'Ca {{weeks}} veckor ({{months}} månader)',
    targetWeightWeeklyTakt: 'Veckovis viktförändring:',
    targetWeightMaintain: 'Kaloriintaget är på underhållsnivå (ingen viktförändring)',
    settingsAiStatusTitle: 'Online AI-tjänstestatus',
    settingsAiStatusDesc: 'Appen använder online AI-tjänst för näringsanalys, måltidskalorier och rehabplaner.',
    settingsAiStatusConnected: 'Anslutningen till AI-tjänsten är aktiv och uppkopplad.',
    medCondNone: 'Inga (God hälsa)',
    medsNone: 'Inga mediciner',
    weightTrendOverallStatus: 'Övergripande vikttrend:',
    weightTrendDown: 'Minskning med {{weight}} kg',
    weightTrendUp: 'Ökning med {{weight}} kg',
    weightTrendStable: 'Stabil (Ingen märkbar förändring)',
    weightPlateauTitle: 'Smart Analys av Viktplatå & AI-Handlingsplan',
    weightPlateauDesc: 'Om din vikt har stått stilla i 1–2 veckor eller mer, hjälper dessa fysiologiska faktorer och åtgärder dig att bryta viktplatån snabbt.',
    weightPlateauDetectedBadge: 'Viktplatå identifierad',
    weightPlateauNormalBadge: 'Normal vikttrend',
    weightPlateauAiAnalyzeBtn: 'Analysera min viktplatå med AI',
    weightPlateauAnalyzing: 'Analyserar viktvariationer, kalorier och aktiviteter...',
    weightPlateauCause1Title: '1. Metabolisk anpassning (Adaptiv termogenes)',
    weightPlateauCause1Desc: 'Vid långvarigt kaloriunderskott minskar kroppen sin grundläggande ämnesomsättning (RMR) för att spara energi. Lösning: 1–2 dagar med underhållskalorier (Refeed) med komplexa kolhydrater för att återställa leptin och sköldkörtelhormoner.',
    weightPlateauCause2Title: '2. Dolda kalorier & mätfel vid matportioner',
    weightPlateauCause2Desc: 'Matlagningsoljor, såser, nötter och drycker kan obemärkt lägga till 200–400 extra kalorier dagligen. Lösning: Väg all mat och olja med en digital köksvåg i 3 dagar.',
    weightPlateauCause3Title: '3. Vätskeansamling, natrium & kortisolstress',
    weightPlateauCause3Desc: 'Stress, under 7 timmars sömn eller högt natriumintag höjer kortisol, vilket binder upp till 2 kg vatten och döljer fettminskning på vågen. Lösning: Prioritera 7–8 timmars sömn och drick 2,5 liter vatten dagligen.',
    weightPlateauCause4Title: '4. Samtidig muskeluppbyggnad & fettförbränning',
    weightPlateauCause4Desc: 'Regelbunden träning bygger muskler samtidigt som fett förbränns. Vågen står stilla, men ditt midjemått minskar! Lösning: Mät midjemåttet istället för att bara lita på vågen.',
    weightPlateauCause5Title: '5. Omedveten minskning av vardagsmotion (NEAT)',
    weightPlateauCause5Desc: 'Vid kaloriunderskott minskar kroppen omedvetet rastlöshet och vardagliga steg för att spara energi. Lösning: Sikta på 7 000–10 000 steg om dagen.',
    weightPlateauCause6Title: '6. Ryggdisk inflammation & kortisolrespons',
    weightPlateauCause6Desc: 'Kronisk ryggsmärta utlöser inflammation och lokal vätskeansamling. Lösning: Skonsam ryggstretching och antiinflammatoriskt te.',
    brandingAboutP1: 'Appens tidigare namn (Växa) betydde gradvis tillväxt på svenska. Baserat på användarfeedback är det officiella namnet "Pishraft" (Framsteg).',
    brandingAboutP2: 'Pishraft är en smart egencare-app med säker molnlagring för ryggrehabilitering, näringsloggning, dagliga svenskstudier och Gemini AI-rapporter.',
    brandingAboutTitle: 'Om Appens Varumärke "Pishraft / Växa"',
    brandingAccentSub: 'När du väljer en palett uppdateras alla knappar, diagram, framstegsstaplar och ikoner direkt.',
    brandingAccentTitle: 'Välj Accentfärgspalett',
    brandingHeaderSub: 'Anpassa din arbetsyta med accentfärger och visuellt tema efter din smak.',
    brandingMockBackExercise: 'Ryggövning (Bird Dog)',
    brandingMockCompleted: '72% Slutfört',
    brandingMockHabitProgress: 'Dagliga Vanors Framsteg',
    brandingMockHeader: 'Förhandsgranskning Instrumentpanel',
    brandingMockRehabBtn: 'Gör Rehab',
    brandingMockSaveBtn: 'Spara Ändringar',
    brandingMockTwoSets: '2 set klart',
    brandingPresetAmberDesc: 'Dynamisk, varm och motiverande för konditionsträning.',
    brandingPresetAmberName: 'Guld Bärnsten & Energi',
    brandingPresetEmeraldDesc: 'Naturlig, framhäver hälsa och aktiv rehabilitering.',
    brandingPresetEmeraldName: 'Hälso- & Återhämtningsgrön',
    brandingPresetIndigoDesc: 'Lugn, balanserad och perfekt för fokus och vanor.',
    brandingPresetIndigoName: 'Lugn Blå (Standard)',
    brandingPresetRoseDesc: 'Modern, livfull och inspirerande för egencare.',
    brandingPresetRoseName: 'Modern Rosa & Friskhet',
    brandingPresetSkyDesc: 'Lätt, lugnande och representerar klarhet.',
    brandingPresetSkyName: 'Klar Himmelsblå',
    brandingPresetVioletDesc: 'Djup, inspirerande för svenska studier och fokus.',
    brandingPresetVioletName: 'Djup Violett & Fokus',
    brandingPreviewSub: 'Se användargränssnittets ändringar direkt i denna mockup:',
    brandingPreviewTitle: 'Förhandsgranskning av Tema',
    brandingSuccessMessage: 'Temat har applicerats i hela systemet',
    dictionaryCatAll: 'Alla Variabler',
    dictionaryCatCommon: 'Allmänt & Knappar',
    dictionaryCatFinance: 'Finans',
    dictionaryCatHealth: 'Hälsa & Läkare',
    dictionaryCatNav: 'Navigering & Menyer',
    dictionaryCatNews: 'Nyheter & AI',
    dictionaryCatReminders: 'Påminnelser',
    dictionaryCatSettings: 'Inställningar',
    dictionaryCatShopping: 'Inköpslista',
    dictionaryCopyTooltip: 'Kopiera t(\'key\')-kommando',
    dictionaryDesc: 'Centraliserad referens för alla texter och nycklar på persiska (fa), engelska (en) och svenska (sv)',
    dictionaryFilteredResults: 'Filtrerade resultat:',
    dictionaryItemsUnit: 'poster',
    dictionaryKeysUnit: 'nycklar',
    dictionarySearchPlaceholder: 'Sök efter nyckelnamn, persisk, engelsk eller svensk text...',
    dictionaryThActions: 'Åtgärder',
    dictionaryThEn: '🇬🇧 Engelska (en)',
    dictionaryThFa: '🇮🇷 Persiska (fa)',
    dictionaryThKey: 'Nyckelnamn',
    dictionaryThSv: '🇸🇪 Svenska (sv)',
    dictionaryTotalKeys: 'Totalt definierade ordlistenycklar:',
    reminderGeneralSettingsTitle: 'Allmänna Inställningar & Påminnelsetider',
    reminderHeaderSub: 'Hantera dagliga påminnelser, läkarbesök, räkningar, födelsedagar och Google Kalender-synk',
    notesMood_Calm: '😌 Lugn',
    notesMood_Energetic: '⚡ Energifylld',
    notesMood_SoreTense: '😣 Öm/Spänd',
    notesMood_Tired: '🥱 Trött',
    notesMood_Anxious: '😰 Orolig',
    reportsActiveMinutes: 'Totala aktiva minuter:',
    reportsAiExportSub: 'Klistra in denna text i AI-chatt för ergonomisk och hälsorådgivning.',
    reportsAiExportTitle: 'Strukturerad AI-Exportkod (ChatGPT / Gemini / Claude)',
    reportsAvgEnergyLabel: 'Genomsnittlig energinivå:',
    reportsAvgPainLabel: 'Genomsnittlig ryggsmärta:',
    reportsAvgSleepLabel: 'Genomsnittlig sömn:',
    reportsAvgWaterLabel: 'Hydreringsstatus:',
    reportsCaloriesBurned: 'Förbrända träningskalorier:',
    reportsChart1LegendBar: 'Antal rehabövningar',
    reportsChart1LegendLine: 'Smärtnivå (0-10)',
    reportsChart1Sub: 'Jämför genomförda ryggövningar (gröna staplar) med registrerad smärtnivå (orange linje).',
    reportsChart1Title: 'Korrelation mellan Ryggrehab & Smärtlindring',
    reportsChart1TtBar: 'Ryggövningar',
    reportsChart1TtLine: 'Ryggsmärtaintensitet',
    reportsChart2Target: 'Målgräns: {{target}} kcal',
    reportsChart2Title: 'Dagligt Kaloriintag & Protein',
    reportsChart2TtCal: 'Kalorier förbrukade',
    reportsChart2TtProt: 'Proteinintag',
    reportsChart3Target: 'Vattenmål: {{target}} ml',
    reportsChart3Title: 'Vattenhydrering (ml) & Sömntimmar',
    reportsChart3TtSleep: 'Sömntimmar',
    reportsChart3TtWater: 'Vattenintag',
    reportsChart4Goal: 'Mål: {{goal}}',
    reportsChart4GoalLabel: 'Målvikt',
    reportsChart4Title: 'Viktutveckling & Mål',
    reportsChart4TtWeight: 'Registrerad vikt',
    reportsChart5Sub: 'Dagligt genomsnitt av protein, kolhydrater & fett',
    reportsChart5Title: 'Makronäringsämnesfördelning',
    reportsChartDatePrefix: 'Datum:',
    reportsCopied: 'Kopierat!',
    reportsCopyBtn: 'Kopiera hela exporttexten',
    reportsDailyWaterGoal: 'Dagligt Mål: {{target}} ml',
    reportsDownloadCsvBtn: 'Ladda ner CSV-export (Excel / Läkare)',
    reportsDownloadDesc: 'Exportera din data till CSV för Excel/läkare eller ladda ner en fullständig JSON-säkerhetskopia.',
    reportsDownloadJsonBtn: 'Ladda ner fullständig JSON-säkerhetskopia',
    reportsDownloadTitle: 'Ladda ner & Säkerhetskopiera Alla Data',
    reportsEnergyPainSummaryTitle: 'Energinivå & Smärtkontroll',
    reportsFatLossSub: 'Genomförande av aerobisk och kaloriförbrännande träning',
    reportsFatLossTitle: 'Konditions- & Magfettförbränningsövningar',
    reportsFoodNotFound: 'Inga livsmedel hittades för denna period eller sökning.',
    reportsFoodSearchPlaceholder: 'Sök mat eller måltid...',
    reportsHoursUnit: 'timmar',
    reportsKpiCalories: 'Genomsnittlig kalori',
    reportsKpiCaloriesSub: 'Mål: {{target}}',
    reportsKpiPain: 'Ryggsmärtindex',
    reportsKpiPainSub: 'Genomsnittlig ryggsmärta',
    reportsKpiRehab: 'Ryggrehabilitering',
    reportsKpiRehabSub: 'Totalt genomförda övningar',
    reportsKpiRehabUnit: 'övningar',
    reportsKpiScore: 'Stabilitetspoäng',
    reportsKpiScoreSub: 'Genomsnitt för vald period',
    reportsKpiSleep: 'Genomsnittlig sömn',
    reportsKpiSleepSub: 'Mål: 7 till 8 timmar dagligen',
    reportsKpiSleepUnit: 'timmar',
    reportsKpiWater: 'Dagligt vattenintag',
    reportsKpiWaterSub: 'Mål: {{target}} ml',
    reportsMacroCarbs: 'Kolhydrater (g)',
    reportsMacroFat: 'Hälsosamt Fett (g)',
    reportsMacroProtein: 'Protein (g)',
    reportsMealBreakfast: 'Frukost',
    reportsMealDinner: 'Middag',
    reportsMealLunch: 'Lunch',
    reportsMealSnack: 'Mellanmål',
    reportsMinUnit: 'min',
    reportsMoodCalm: 'Lugn',
    reportsNoPain: '0 (Ingen smärta)',
    reportsNutritionCount: 'Totalt antal registrerade livsmedel under perioden: {{count}}',
    reportsNutritionTitle: 'Fullständig lista över registrerad mat & makronäringsämnen',
    reportsOf10Unit: 'av 10',
    reportsOf5Unit: 'av 5',
    reportsPainOf10: 'av 10',
    reportsPrintBtn: 'Skriv ut / PDF',
    reportsPrintTooltip: 'Skriv ut eller spara PDF',
    reportsRange30d: 'Senaste 30 dagarna',
    reportsRange7d: 'Senaste 7 dagarna',
    reportsRange90d: '90 dagar',
    reportsRangeAll: 'Hela historiken',
    reportsRehabDrillsSub: 'Genomförandefrekvens för varje rehabövning i vald period',
    reportsRehabDrillsTitle: 'Ryggrehab & Diskläkningsförlopp',
    reportsShiftWorkTag: 'Arbetspass',
    reportsShiftsUnit: 'pass',
    reportsSleepDiscRole: 'Roll i diskläkning:',
    reportsSleepDiscRoleVal: 'Mycket hög (Nyckelfaktor)',
    reportsSleepGoalLabel: 'Standardmål för sömn:',
    reportsSleepGoalVal: '7 till 8 timmar',
    reportsSleepGood: 'Bra & Lämplig',
    reportsSleepIdeal: 'Utmärkt & Optimal',
    reportsSleepLow: 'Under standard',
    reportsSleepNotRecorded: 'Ej registrerat',
    reportsSleepSummaryTitle: 'Nattlig Sömn- & Återhämtningssammanfattning',
    reportsTabAiExport: 'AI-Export & Filer',
    reportsTabCharts: 'Interaktiv diagraminstrumentpanel',
    reportsTabNutrition: 'Omfattande närings- & matrapport',
    reportsTabRehab: 'Rehab & Övningsrapport',
    reportsTabSleepWork: 'Sömn & Arbetspass',
    reportsTable1Sub: 'Daglig logg med vila, energinivå och ryggsmärta',
    reportsTable1Title: 'Daglig Sömn- & Återhämtningslogg',
    reportsTable2Sub: 'Dagligt vattenintag i ml och procentuell uppnåelse',
    reportsTable2Title: 'Daglig Vattenförbrukningslogg',
    reportsTargetLabel: 'Mål',
    reportsThCalories: 'Kalorier (kcal)',
    reportsThCarbs: 'Kolhydrater (g)',
    reportsThDate: 'Datum',
    reportsThEnergy15: 'Energinivå (1-5)',
    reportsThFat: 'Fett (g)',
    reportsThFoodName: 'Livsmedelsnamn',
    reportsThGoalMl: 'Mål (ml)',
    reportsThHydrationStatus: 'Hydreringsstatus',
    reportsThMeal: 'Måltid',
    reportsThMood: 'Humör (Mood)',
    reportsThNotes: 'Anteckningar & Symtom',
    reportsThPain010: 'Smärta (0-10)',
    reportsThProgressPercent: 'Framsteg %',
    reportsThProtein: 'Protein (g)',
    reportsThQty: 'Mängd',
    reportsThRestEval: 'Viloöversikt',
    reportsThShift: 'Arbetspass',
    reportsThSleepHours: 'Sömntid (timmar)',
    reportsThWaterMl: 'Vattenmängd (ml)',
    reportsTimesCount: '{{count}} gånger ({{percent}}%)',
    reportsTotalDaysCount: 'Totalt antal dagar: {{count}} dagar',
    reportsUndefined: 'Inte angivet',
    reportsUnitDrills: 'rehabövningar',
    reportsUnitOf10: 'av 10',
    reportsWaterFull: '💧 Fullt hydrerad (Utmärkt)',
    reportsWaterGood: 'Lämplig',
    reportsWaterLow: 'Lågt intag',
    reportsWaterNeedMore: 'Behöver mer vatten',
    reportsWorkDaysCount: 'Registrerade arbetspass:',
    reportsWorkSummaryTitle: 'Arbetspass & Fysisk Aktivitet',
    salaryMisclassifiedDesc: 'Dessa transaktioner heter Lön/Insättning men är sparade som utgifter. Klicka för att ändra till Inkomst (+).',
    salaryMisclassifiedTitle: 'Upptäckte {{count}} Lön/Insättningstransaktioner',
    save: 'Spara',
    saveBtn: 'Spara',
    saveBudgetFormulaBtn: 'Spara formel & budgettak',
    saveChanges: 'Spara ändringar',
    saveTransaction: 'Spara transaktion',
    saveTransactionBtn: 'Spara transaktion',
    savedSuccessfully: 'Sparades framgångsrikt ✅',
    savingAndGoalsShare: 'Andel sparande & mål ({{ratio}}%):',
    savingsAndTargetShare: 'Sparande & måltilldelning ({{ratio}}%):',
    savingsGoalsAndPlanning: 'Sparmål & ekonomisk planering',
    scanReceipt: 'Skanna kvitto med AI',
    scannerSamplePlaceholder: 'Willys\\n2x MJÖLK 1.5L - 37 SEK\\n1x BRÖD - 28 SEK\\nTotalt: 65 SEK\\nBetalt med Swish',
    schedules: 'Veckoplanering',
    schedulesHeaderDesc: 'Planera och hantera dina personliga aktiviteter, arbete, studier och dagliga rutiner för veckans alla dagar.',
    schedulesHeaderTitle: 'Veckoplanerare & Dagliga Rutiner',
    schedulesSearchPlaceholder: 'Sök rutinnamn eller beskrivning...',
    schedulesPresetTemplates: 'Snabbmallar för aktiviteter:',
    schedulesPresetWork: 'Arbetspass (8 timmar)',
    schedulesPresetRehab: 'Ryggrehab / Sjukgymnastik (30 min)',
    schedulesPresetEducation: 'Studier / Lärandesession (2 timmar)',
    schedulesPresetCardio: 'Kondition & Promenad (45 min)',
    schedulesPresetNutrition: 'Näring & Måltidsomsorg (30 min)',
    schedulesPresetWorkTitle: 'Dagligt arbetspass',
    schedulesPresetWorkDesc: 'Arbetsfokus med 5-minuters pauser för ryggstretching.',
    schedulesPresetRehabTitle: 'Fysioterapi & Ryggrehabövningar',
    schedulesPresetRehabDesc: 'Ryggstretching, morgonrehab och bålstabilisering.',
    schedulesPresetEduTitle: 'Lärandesession (Svenska / Kurs)',
    schedulesPresetEduDesc: 'Svensklektion, specialkurser eller kompetensutveckling.',
    schedulesPresetCardioTitle: 'Konditionsträning & Fettförbränningspromenad',
    schedulesPresetCardioDesc: 'Rask promenad, skonsam konditionsträning och fettförbränning.',
    schedulesPresetNutritionTitle: 'Huvudmåltid & Måltidsplanering',
    schedulesPresetNutritionDesc: 'Tillräckligt proteinintag, kosttillskott och hydrering.',
    schedulesTotalWeeklyTasks: 'Totalt antal veckoaktiviteter',
    schedulesTotalScheduledHours: 'Schemalagda timmar',
    schedulesTodayCompletion: 'Slutfört idag',
    schedulesNoFilteredRoutines: 'Inga aktiviteter hittades med ditt valda filter.',
    schedulesGoogleCalDirectTitle: 'Lägg till direkt i Google Kalender (Webb)',
    schedulesAddToGoogleCalDirect: 'Lägg till i Google Cal',
    schedTaskCountUnit: 'uppgifter',
    schoolCategory: '🎓 Skola & Utbildning',
    search: 'Sök...',
    seasonalMealPlan: 'Säsongsanpassad Kostplan (GLP-1)',
    seasonalRecipes: 'Säsongens recept',
    selectAll: 'Markera alla',
    selectLanguage: 'Välj språk / Select Language',
    selectMonthForBudgetAnalysis: 'Välj månad för budgetanalys:',
    selectedMonthLabel: 'Vald',
    selectedRowsCount: '{{count}} rader valda',
    settings: 'Inställningar & Synk',
    settingsHeaderDesc: 'Profilhantering, Cloudflare D1-molndatabasanslutning, SMTP-konfiguration och AI-nycklar',
    settingsHeaderTitle: 'Systeminställningar, Molnsäkerhetskopia & D1-Synk',
    settingsSaveSuccess: '✓ Inställningarna sparades',
    shareEmailLabel: 'E-post till familjemedlem eller kollega',
    shareEmailPlaceholder: 't.ex. familj@example.com',
    shareError: 'Kunde inte lägga till e-postadressen.',
    shareListBtn: 'Dela inköpslista',
    shareModalTitle: 'Hantera åtkomst & Dela inköpslista',
    shareSuccess: 'Åtkomst beviljades framgångsrikt.',
    shiftTypeLabel: 'Skifttyp / Aktivitet',
    shopAddItemBtn: 'Lägg till',
    shopAddNewItemTo: 'Lägg till vara i {{name}}',
    shopAddNewList: 'Lägg till ny lista',
    shopAddToListNamed: 'Lägg till i {{name}}',
    shopAdjustQtyModalTitle: 'Justera Varans Mängd & Vikt',
    shopAllItemsCount: 'Alla varor ({{count}})',
    shopAllLists: 'Alla Inköpslistor ({{count}})',
    shopAllPresets: 'Alla ({{count}})',
    shopBoughtItems: '{{count}} köpta',
    shopCancel: 'Avbryt',
    shopCatDairy: 'Mejeri & Ägg',
    shopCatGrocery: 'Matvaror & Skafferi',
    shopCatHousehold: 'Hem & Hygien',
    shopCatMeat: 'Kött & Fågel',
    shopCatOther: 'Övrigt',
    shopCatProduce: 'Frukt & Grönsaker',
    shopClearAll: 'Radera Allt',
    shopClearBought: 'Rensa Köpta',
    shopClickToAdjust: 'Klicka för att justera mängd och lägga till',
    shopCloseModal: 'Stäng',
    shopCollaboratorAccess: 'Samarbetsåtkomst',
    shopCollaboratorTooltip: 'Endast ägaren kan byta namn, radera eller hantera delning',
    shopConfirmClearAll: 'Är du säker på att du vill rensa hela listan?',
    shopConfirmClearBought: 'Är du säker på att du vill rensa alla köpta varor?',
    shopConfirmDeleteList: 'Är du säker på att du vill radera listan "{{name}}"? Alla varor kommer att tas bort permanent.',
    shopAiTranslateList: 'Live-översätt för inköp (AI)',
    shopAiTranslateListTooltip: 'Visa tillfällig live-översättning till svenska eller engelska utan att ändra databasen',
    shopTranslateModalTitle: 'Tillfällig Varors Översättning (Ingen DB-ändring)',
    shopTranslateModalDesc: 'Välj målspråk för att underlätta inköp i butiken. Denna översättning visas endast tillfälligt och databasens originalposter ändras aldrig:',
    shopTranslateTargetSv: '🇸🇪 Svenska - Perfekt för shopping på ICA, Willys, Coop',
    shopTranslateTargetEn: '🇬🇧 Engelska - Internationella matvarutermer',
    shopTranslateTargetFa: '🇮🇷 Persiska (Farsi) - Standardspråk',
    shopTranslatingWait: 'Översätter varor med AI... Vänligen vänta',
    shopTranslateSuccess: 'Tillfällig live-översättning till {{lang}} aktiverad! Databasens originalnamn är helt oförändrade.',
    shopActiveTranslationNotice: 'Visar tillfällig live-översättning på {{lang}} (Originalnamn är säkrade i DB)',
    shopTranslateNoDbHint: 'Databasens originalposter förblir oförändrade och endast tillfälliga butiksöversättningsetiketter visas.',
    shopChangeTranslateLang: 'Byt språk',
    shopHideTranslation: 'Avsluta översättning',
    shopOriginalLabel: 'Ursprungligt namn',
    shopTranslatedLabel: 'Butiksöversättning',
    shopCopyTranslation: 'Kopiera översättningar',
    shopCopied: 'Kopierat!',
    shopTranslationsOverview: 'Varujämförelse & Butiksöversättningstabell',
    shopViewOnList: 'Visa på inköpslistan',
    shopNoItemsToTranslate: 'Det finns inga varor i listan att översätta.',
    shopTranslateFailed: 'Kunde inte behandla AI-översättningssvaret. Vänligen försök igen.',
    shopCreateFirstBtn: 'Skapa Ny Inköpslista',
    shopCreateListSubmit: 'Skapa Lista',
    shopCreatedBy: '🏠 Skapad av: {{name}}',
    shopCreating: 'Skapar...',
    shopCustomQtyPh: 't.ex. 1.5 kg eller 4 flaskor',
    shopDateUnset: 'Inte inställt',
    shopDecrease: 'Minska',
    shopDeleteItem: 'Ta bort',
    shopDeleteList: 'Radera Lista',
    shopEditItem: 'Redigera',
    shopEditTitleDate: 'Redigera Titel & Inköpsdatum',
    shopEmptyListHint: 'Denna lista är tom! Lägg till varor ovan eller använd snabbval.',
    shopEnterSharedList: 'Gå till Delad Lista',
    shopIncrease: 'Öka',
    shopItemNamePh: 'Varans namn (t.ex. Kyckling, Mjölk, Ris...)',
    shopItemQtyPh: 'Mängd/Vikt (t.ex. 2 kg, 1 paket)',
    shopListDateLabel: 'Inköpsdatum / Planerat:',
    shopListNameLabel: 'Listtitel:',
    shopListNamePh: 't.ex. Fredagsgrill, Apotek, Matbutik...',
    shopManageShare: 'Hantera Delning',
    shopMarkBought: 'Markera som köpt',
    shopMarkUnbought: 'Markera som ej köpt',
    shopMyLists: 'Mina Listor',
    shopNeededItems: 'Varor att Köpa ({{count}})',
    shopNewListBtn: 'Ny Inköpslista',
    shopNewListModalSubtitle: 'Skapa personlig eller familjens inköpslista',
    shopNewListModalTitle: 'Ny Inköpslista',
    shopNewListTitleLabel: 'Ny Listtitel:',
    shopNoListsDesc: 'Klicka på "Skapa första listan" ovan för att komma igång',
    shopNoListsYet: 'Du har inte skapat några inköpslistor än',
    shopNoSharedDesc: 'Be dina familjemedlemmar att dela sina listor med dig genom att ange din e-post.',
    shopNoSharedLists: 'Inga inköpslistor har delats med dig än',
    shopOpenList: 'Öppna Lista',
    shopOrCustomQty: 'Eller Ange Egen Mängd:',
    shopOwnerYou: '👑 Du är Ägaren',
    shopPersonalOnly: 'Personlig',
    shopPurchaseDateLabel: 'Inköpsdatum / Planerat:',
    shopPurchasedSection: 'Köpta Varor ({{count}})',
    shopQuickQtyPick: 'Snabbval Mängd:',
    shopQuickSelectAdjust: 'Snabbval & Mängdjustering:',
    shopQuickThemeCreate: 'Snabbt Skapande av Temalista:',
    shopQuickTitleSuggestions: 'Snabba Titelförslag:',
    shopRemainingItems: '{{count}} återstår',
    shopRenameList: 'Byt namn på lista',
    shopRenameModalSubtitle: 'Byt namn på listan "{{name}}"',
    shopRenameModalTitle: 'Byt Namn på Lista',
    shopRevokeShare: 'Ta bort behörighet',
    shopSave: 'Spara',
    shopSaveRenameBtn: 'Spara Ändringar',
    shopSendShareBtn: 'Skicka Delningsinbjudan',
    shopShareBtn: 'Dela',
    shopShareRevokedSuccess: 'Åtkomst borttagen för {{email}}.',
    shopShareTooltip: 'Dela lista med partner eller hushållsmedlemmar',
    shopSharedListFrom: '🏡 Delad Lista ({{name}})',
    shopSharedWith: 'Delad med: {{emails}}',
    shopSharedWithCount: 'Delad med {{count}} personer',
    shopSharedWithMe: 'Delat Med Mig',
    shopTodayDateFmt: 'Idag ({{date}})',
    shopYouAreOwner: '👑 Du äger denna lista',
    shopping: 'Smarter Inköpslista',
    shoppingCatReminder: '🛒 Inköpsuppgifter',
    shoppingCategories: 'Inköpskategorier',
    shoppingHeaderDesc: 'Skapa anpassade listor, dela med familjemedlemmar, schemalägg inköpsdatum och få AI-förslag',
    shoppingHeaderDescActive: 'Lägg till varor eller bocka av köpta. Ändringar synkroniseras direkt med familjen.',
    shoppingHeaderDescOverview: 'Skapa inköpslistor för hemmet, grillen eller matbutiken och dela med e-post.',
    shoppingHeaderTitle: 'Hantering av Smarta Inköpslistor',
    shoppingTitle: 'Delad Familjeinköpslista',
    showAllCards: 'Visa Alla Kort',
    signIn: 'Logga in',
    smartPromptSuggestions: 'Smarta snabbfrågor till finansiella AI-rådgivaren:',
    smtpTitle: 'E-postserver (SMTP)',
    sortNewestFirst: 'Sortering: Nyast Först ⬇️',
    spentAmountLabel: 'Förbrukat: {{amount}} {{currency}}',
    spentAmountShort: 'Förbrukat: {{amount}} {{currency}}',
    spentLabel: 'Förbrukat:',
    startDoctorConsultation: 'Starta konsultation med AI-Läkare',
    startExercise: 'Starta träning',
    statBudgetBalance: 'Återstående Budgetsaldo',
    statBudgetCap: 'Månatligt Utgiftstak: {{amount}} {{currency}}',
    statExpenseSubtitle: 'Inköp, fakturor och betalningar',
    statIncomeSubtitle: 'Total lön och inkomster',
    statSwishSubtitle: 'Online Swish-transaktioner',
    statSwishTotal: 'Swish-betalningar',
    statTotalExpense: 'Utgifter & Fakturor',
    statTotalIncome: 'Total Registrerad Inkomst',
    status: 'Status',
    statusNew: 'Ny',
    storePlaceholder: 't.ex. ICA Supermarket Stockholm',
    success: 'Framgång',
    surplusAmountAlert: '{{amount}} {{currency}} överskott!',
    surplusExceeded: 'Överskott/Överträdelse!',
    surplusLabel: 'Överskott/Överträdelse:',
    surplusShort: 'Överskridande: {{amount}} {{currency}}',
    swedish: 'Svenska SFI-Studier',
    swedishHeaderDesc: 'Daglig svensk ordträning, smarta quiz, arbetsplatsdialoger och Yrkessvenska-förberedelse',
    swedishHeaderTitle: 'Svenskstudier, SFI & Ordförråd',
    swedishLang: 'Svenska',
    swedishLearning: 'Svenska / SFI-träning',
    swedishSfiTitle: 'Svenska studier (SFI & Yrkesutbildning)',
    symptomAnalyzer: 'Smart Symtomanalysator',
    syncCloud: 'Molnsynkronisering',
    synced: 'Synkroniserad med molnet',
    targetCalories: 'Dagligt Kalorimål (kcal)',
    targetCardForBatch: 'Målkort / konto för alla transaktioner i detta kontoutdrag:',
    targetWater: 'Dagligt Vattenmål (ml)',
    targetWeightLabel: 'Målvikt (kg)',
    title: 'Titel',
    todaySummary: 'Dagens översikt',
    todayUpcomingTab: 'Idag & Kommande förfallodatum',
    todosList: 'Dagens uppgifter & schema',
    total: 'Totalt',
    totalAllocatedBudget: 'Total Tilldelad Budget:',
    totalBudgetCapLabel: 'Totalt budgettak:',
    totalExpenditure: 'Totalt Spenderat: {{amount}} {{currency}}',
    totalExpenseCap: 'Totalt Utgiftstak:',
    totalExpenseLabel: 'Totala utgifter:',
    totalExpenses: 'Totala utgifter',
    totalIncome: 'Totala inkomster',
    totalIncomeLabel: 'Total inkomst/insättningar:',
    totalItemsCount: 'Totalt {{count}} varor',
    totalProductsCount: 'Totalt antal varor: {{count}} sorter',
    totalProductsSummary: 'Totalt antal artiklar: {{count}} typer',
    totalSavingsNeeded: 'Totalt sparande som krävs för målen:',
    totalSavingsRequiredForGoals: 'Totalt sparande som behövs för aktiva mål:',
    transactionListTitle: 'Transaktions- & Fakturalista ({{count}})',
    transactionsSuffix: 'transaktioner',
    transferMisclassifiedDesc: 'Dessa är kortavbetalningar eller interna överföringar. Klicka för att ändra till Överföring/Sparande.',
    transferMisclassifiedTitle: 'Upptäckte {{count}} Kortfaktura / Överföringstransaktioner',
    txCountInMonth: '({{count}} transaktioner)',
    typeDeleteToConfirm: 'Skriv DELETE i rutan nedan för att bekräfta:',
    unallocatedBalanceLabel: '✓ Oallokerat saldo (kan fördelas eller sparas):',
    uncappedCategoriesDesc: 'Kategorier utan särskilt tak (endast utgiftsrapport):',
    uncappedCategoriesTitle: 'Kategorier utan budgettak',
    unitDays: 'Dagar innan',
    unitHours: 'Timmar innan',
    unitMinutes: 'Minuter innan',
    unitWeeks: 'Veckor innan',
    usedLabel: 'Använt:',
    userName: 'Användarnamn',
    usersAdmin: 'Användarhantering',
    usersAdminHeaderDesc: 'Övervaka aktiva användare, behörighetsnivåer och enhetssynkroniseringsstatus',
    usersAdminHeaderTitle: 'Användarhantering & Adminpanel',
    version: 'Version',
    versionHistory: 'Versionshistorik',
    viewGaugesAction: 'Visa & analysera månad',
    viewInTransactionsList: 'Visa i transaktionslistan →',
    viewInTxList: 'Visa i transaktionslistan →',
    viewingGaugesAction: 'Visar mätare',
    visualGraphsTab: 'Visualisering & Rapporter',
    vocabularyQuiz: 'Ordförråd & Snabbtest',
    waterIntake: 'Dagligt vattenintag',
    waterTracker: 'Dagligt vattenintag',
    weeklyMealPlanner: 'Veckans måltidsplanerare',
    weightAlertGoal: 'Ange en giltig målvikt i kg',
    weightAlertHeight: 'Ange en giltig längd i cm',
    weightAlertInvalid: 'Ange en giltig vikt',
    weightBmiHealthy: 'Hälsosamt intervall: 18,5 - 24,9',
    weightBmiIndex: 'BMI: {{val}}',
    weightBmiLabel: 'Kroppsmasseindex',
    weightBmiNeedWeight: 'Ange längd och vikt för att beräkna BMI',
    weightBmiNormal: 'Normalvikt',
    weightBmiNormalAdv: 'Normalt och hälsosamt BMI - fortsätt det fina arbetet!',
    weightBmiObeseCat: 'Fetmaintervall - läkarkonsultation och guidad kost rekommenderas',
    weightBmiOverweight: 'Överviktsintervall - balanserat kaloriunderskott rekommenderas',
    weightBmiPendingDesc: 'Registrera din senaste vikt för att beräkna aktuell BMI-status.',
    weightBmiTitle: 'Kroppsmasseindex (BMI)',
    weightBmiUnder: 'Undervikt',
    weightBmiUnderweight: 'Underviktsintervall - överväg näringstät kost',
    weightChartFilter30: '30 dagar',
    weightChartFilter7: '7 dagar',
    weightChartFilter90: '90 dagar',
    weightChartFilterAll: 'All tid',
    weightChartNoDataDesc: 'Registrera vikt under flera dagar för att se utvecklingskurvor.',
    weightChartNoDataTitle: 'Inga viktloggar för denna tidsperiod',
    weightChartTitle: 'Viktkurva & Framsteg',
    weightChartTooltipWeight: 'Vikt: {{val}} kg',
    weightConfirmDel: 'Är du säker på att du vill radera denna viktpost?',
    weightDirectInputBtn: 'Registrera vikt',
    weightDirectInputPh: 'Vikt (t.ex. 82,4)',
    weightGoalChartLabel: 'Mål: {{goal}} kg',
    weightHeaderDesc: 'Spåra vikttrender, smart BMI-beräkning och framstegsgrafer',
    weightHeaderTitle: 'Vikt-, Kroppsfett- & BMI-Spårning',
    weightHistActions: 'Åtgärder',
    weightHistBmi: 'BMI',
    weightHistDelTooltip: 'Radera denna post',
    weightHistWeight: 'Vikt',
    weightHistoryCount: '{{count}} loggade poster',
    weightHistoryEmpty: 'Inga viktloggar registrerade ännu',
    weightHistoryTitle: 'Vikthistorik',
    weightMinus01: '-0,1 kg',
    weightMinus1: '-1 kg',
    weightPlus01: '+0,1 kg',
    weightPlus1: '+1 kg',
    weightProfileGoal: 'Målvikt (kg)',
    weightProfileGoalPh: 't.ex. 75',
    weightProfileHeight: 'Längd (cm)',
    weightProfileSaved: 'Profilen har sparats',
    weightProfileTitle: 'Viktprofil & Målinställningar',
    weightProfileUpdateBtn: 'Spara profilinställningar',
    weightQuickAddTitle: 'Snabblogga vikt',
    weightTitle: 'Vikt- & BMI-Koll',
    weightTracker: 'Vikt & BMI-Koll',
    weightTrendDownFull: 'Vikten trendar nedåt (-{{diff}} kg)',
    weightTrendOverallStatusFull: 'Övergripande utveckling: {{status}}',
    weightTrendStableFull: 'Vikten är stabil ({{diff}} kg)',
    weightTrendUpFull: 'Vikten trendar uppåt (+{{diff}} kg)',
    weightUnitKg: 'kg',
    welcomeBack: 'Välkommen tillbaka',
    workCategory: '💼 Arbete & Admin',
    you: 'Du',
    commonCopy: 'Kopiera',
    doctorAiAnalyzing: 'AI analyserar journalen...',
    doctorCopied: 'Kopierat',
    doctorDeleteCons: 'Ta bort konsultation',
    doctorLiveContextTitle: 'Levande klinisk profil',
    doctorLiveWater: 'Dagens vattenintag',
    emailPlaceholder: 'Mottagarens namn eller e-post...',
    fatCardDelete: 'Ta bort kort',
    financeAdvisorPrompt: 'Du är en smart finansiell rådgivare och senior budgetanalytiker.',
    financeAdvisorWelcome: 'Hej! Jag är din smarta finansiella rådgivare. Hur kan jag hjälpa dig med budgethantering eller utgiftsanalys?',
    guide: 'Guide',
    learningAddDocSm: 'Bifoga dokument',
    learningAddSubtopic: 'Lägg till nytt delämne',
    learningAiCustom: 'Anpassad förfrågan',
    learningAiFallbackReply: 'AI-svar genererat baserat på lektionsinnehållet.',
    learningAiModalSubmit: 'Analysera och skicka med AI',
    learningAiNoteTitle: 'AI-analys & lektionsanteckningar',
    learningAiPromptFromPdf: 'Vänligen extrahera nyckelpunkter, definitioner och viktiga provfrågor från denna fil.',
    learningAiResponse: 'AI-svar',
    learningAttFileNameLabel: 'Bifogat filnamn: {{name}}',
    learningAttLabel: 'Bilaga',
    learningAttNotesFmt: '- Fil {{name}} (Typ: {{type}})',
    learningAttachDocsBtn: 'Bifoga dokument (PDF/Word/PPT/bilder)',
    learningAttachDocsSm: 'Bifoga fil (Word / PPT / PDF / bild)',
    learningAttachedDocsHeader: 'Bifogade filer och dokument för denna lektion:',
    learningBtnDownload: 'Ladda ner',
    learningBtnOpenFile: 'Öppna fil',
    learningCancel: 'Avbryt',
    learningCopyFullThread: 'Kopiera hela lektionstexten',
    learningDeleteModalDesc2: 'Är du säker? Denna åtgärd kan inte ångras.',
    learningDeleteModalTitle: 'Ta bort {{type}}',
    learningDeleteUserMsg: 'Ta bort detta inlägg',
    learningEditTopic: 'Redigera ämne',
    learningExtractedLabel: 'Extraherad text från detta dokument:',
    learningExtractedSummaryDoc: 'Extraherad text från detta dokument:',
    learningFileSizeLimit: 'Filstorleken för «{{name}}» överskrider maxgränsen (300 MB).',
    learningInteractiveSession: 'Interaktiv lektion & anteckningar',
    learningMainTopicDesc: 'Beskrivning av huvudämne',
    learningMainTopicLabel: 'Huvudämne: {{title}}',
    learningMainTopicsList: 'Registrerade huvudämnen',
    learningMsgHint: 'Du kan använda formuläret nedan för att ställa frågor eller lägga till anteckningar.',
    learningMsgLabel: 'Meddelande / inlägg',
    learningNoSessionsYet: 'Inga lektioner har registrerats för detta ämne ännu.',
    learningNotesTopicsLabel: 'Anteckningar/ämnen:',
    learningOverallDesc: 'Allmän beskrivning:',
    learningPreviewDownload: 'Ladda ner originalfil',
    learningPreviewOpenTab: 'Öppna fil i ny flik',
    learningPreviewTitle: 'Studera & analysera dokument: {{name}}',
    learningPromptSumm: 'Vänligen tillhandahåll en omfattande och strukturerad sammanfattning av huvudbegreppen och nyckelpunkterna för detta ämne.',
    learningPromptSummBtn: 'Omfattande sammanfattning & nyckelpunkter',
    learningPromptVocab: 'Vänligen analysera alla definitioner, facktermer och nyckelbegrepp i en tabell med tydliga exempel.',
    learningPromptVocabBtn: 'Tabell över termer & definitioner',
    learningSaveFirstSession: 'Skapa första lektionen med AI',
    learningSaveToSessionBtn: 'Spara och lägg till i lektionen',
    learningSaveTopicBtn: 'Spara ämne',
    learningSessionIntroOpt: 'Lektionsintroduktion / allmän beskrivning (valfritt)',
    learningSessionLabel: 'Lektion',
    learningSessionMainTitle: 'Lektionens övergripande titel',
    learningSessionStartDate: 'Startdatum: {{date}}',
    learningSubtopicFmt: 'Delämne {{idx}}: {{title}}\\nAnteckningar: {{notes}}',
    learningSubtopicTitleLabel: 'Titel på delämne',
    learningTeacherNote: 'Lärarens anteckning',
    learningThisItem: 'detta objekt',
    learningTopicHint: 'Du kan lägga till ämnen som "Svenska språket", "Docker-utbildning", "Python-programmering", "Matlagning" eller valfritt ämne.',
    learningTopicHistory: 'Lektionshistorik för detta ämne',
    learningTopicsDiscussed: 'Ämnen som diskuterades under denna lektion:',
    learningTotalTopics: 'Totalt antal huvudämnen',
    learningTrainAiBtn: 'Analysera & lär med AI',
    learningTrainingBtn: 'Analyserar & bearbetar...',
    learningUploadingDesc: 'Vänligen vänta. Din fil laddas upp och innehållet extraheras för AI-analys.',
    learningVideoTitleLabel: 'Videotitel / namn',
    learningViewSessionContinue: 'Visa lektion och fortsätt diskussionen',
    learningViewSessions: 'Visa lektioner',
    notesEnergyTooltip: 'Energinivå: {{level}}',
    notesPainScale10: '10 - Outhärdlig smärta',
    notesPainScale5: '5 - Måttlig',
    notesSymptomsPlaceholder: 't.ex. Morgonstelhet i ryggmuskler, lätt stickande känsla i vänster ben...',
    seasonalMealPlanAiAssistantDesc: 'Baserat på 5 vetenskapliga metaboliska hälsoregler för att optimera måltidsplaner, ersättningar och hälsosamma recept.',
    seasonalMealPlanAiAssistantTitle: 'GLP-1 Smart AI-näringsassistent',
    seasonalMealPlanAiGetAdvice: 'Få rådgivning från AI',
    seasonalMealPlanAiLoading: 'Hämtar AI-analys och recept...',
    seasonalMealPlanAiPromptPlaceholder: 't.ex. Vad har kallbryggt kaffe för fördelar, eller föreslå ett nyttigare alternativ...',
    seasonalMealPlanAiPromptAlternative: 'Föreslå ett kalorisnålare eller hälsosammare alternativ till {{foodName}} och mellanmål.',
    seasonalMealPlanAiAnalysisHeader: 'Smart AI-analys & rekommendation:',
    seasonalMealPlanAiResponse: 'AI-svar',
    seasonalMealPlanAiError: 'Ett fel uppstod vid hämtning av AI-svar. Vänligen försök igen.',
    seasonalMealPlanCoffeeNutritionInfo: 'Näringsvärde för denna dryck:',
    seasonalMealPlanCoffeeTitle: 'Daglig vana: Hälsokaffe (Kallbryggt / espresso + valnötter & chia)',
    seasonalMealPlanCoffeeRecipeTitle: 'Tillagning & gyllene formel för hälsokaffe:',
    seasonalMealPlanCoffeeBenefits: 'Vetenskapligt bevisade hälsofördelar:',
    seasonalMealPlanCopied: '{{title}} kopierad!',
    seasonalMealPlanDefaultMenu: 'Standardmeny',
    seasonalMealPlanDefaultSnackName: 'Hälsokaffe + grekisk yoghurt och valnötter',
    seasonalMealPlanDefaultSnackIng: 'Kallbryggt kaffe + 150 g grekisk yoghurt + 10 g valnötter + 1 tsk chiafrön + gurkmeja & olivolja',
    seasonalMealPlanDefaultSnackPortion: '1 glas (250 ml)',
    seasonalMealPlanDefineNewHabit: 'Definiera ny hälsovana',
    seasonalMealPlanDeleteHabitTooltip: 'Ta bort vana',
    seasonalMealPlanDiffEasy: 'Lätt',
    seasonalMealPlanDiffMed: 'Medel',
    seasonalMealPlanDiffHard: 'Svår',
    seasonalMealPlanFilterWeek13: 'Vecka 1 & 3',
    seasonalMealPlanFilterWeek24: 'Vecka 2 & 4',
    seasonalMealPlanFoodNameLabel: 'Maträttens namn:',
    seasonalMealPlanHeaderDesc: 'Smart måltidsplanering och metabolisk hälsooptimering (GLP-1) med 5 nyckelregler under alla årstider.',
    seasonalMealPlanHeaderSubtitle: 'Säsongsbetonad hälsosam kost & metabol optimeringsplan',
    seasonalMealPlanHeaderTitle: 'Månadsvis & Säsongsbaserad GLP-1 Måltidsplan',
    seasonalMealPlanAiConsulting: 'AI-rådgivning & Optimering',
    seasonalMealPlanRuleFatLabel: 'Nyttiga fetter',
    seasonalMealPlanRuleFatSub: 'Oliver, valnötter, grekisk yoghurt',
    seasonalMealPlanRuleProteinLabel: 'Hög proteinhalt',
    seasonalMealPlanRuleProteinSub: 'Kyckling, magert kött, fisk, baljväxter',
    seasonalMealPlanRuleFiberLabel: 'Fiber & bittra örter',
    seasonalMealPlanRuleFiberSub: 'Vattenkrasse, persilja, okra, spenat',
    seasonalMealPlanRuleGoldenLabel: 'Gyllene formeln',
    seasonalMealPlanRuleGoldenSub: 'Gurkmeja + svartpeppar + olivolja',
    seasonalMealPlanRuleStartLabel: 'Fiberförrätt',
    seasonalMealPlanRuleStartSub: 'Börja måltiden med sallad eller grönt',
    seasonalMealPlanCurrentSeasonLabel: 'Aktuell säsong',
    seasonalMealPlanTabGrid: '30-dagars lunch- & mellanmålsplan',
    seasonalMealPlanTabHabits: 'Hälsovanor (GLP-1 Hälsokaffe)',
    seasonalMealPlanTabShopping: 'Veckovis inköpslista',
    seasonalMealPlanTabSummary: 'Månatlig råvarusammanfattning',
    seasonalMealPlanTabNutrition: 'Näringsanalys',
    seasonalMealPlanTabTips: 'Tips för Meal Prep',
    seasonalMealPlanMealFilterLabel: 'Måltid:',
    seasonalMealPlanFilterAll: 'Alla',
    seasonalMealPlanFilterLunch: 'Lunch',
    seasonalMealPlanFilterSnack: 'Mellanmål',
    seasonalMealPlanWeekFilterLabel: 'Vecka:',
    seasonalMealPlanGridInfo: 'Varje dag innehåller en näringsrik lunch och ett mättande mellanmål.',
    seasonalMealPlanDaysCount: 'Dagar: {{count}} dagar',
    seasonalMealPlanWeekNum: 'Vecka {{num}}',
    seasonalMealPlanEditMealsTitle: 'Redigera lunch & mellanmål',
    seasonalMealPlanLunchTitle: 'Lunchmåltid',
    seasonalMealPlanPortionLabel: 'Portion:',
    seasonalMealPlanCalorie: 'Kalorier',
    seasonalMealPlanProtein: 'Protein',
    seasonalMealPlanCarb: 'Kolhydrater',
    seasonalMealPlanFat: 'Fett',
    seasonalMealPlanSideDish: 'Tillbehör:',
    seasonalMealPlanDailyProtocol: 'Särskilt dagligt protokoll',
    seasonalMealPlanGLP1Stimulation: 'Naturlig stimulering av GLP-1 & GIP-hormoner',
    seasonalMealPlanCompletedToday: 'Slutförd för idag ✨',
    seasonalMealPlanChecklistTitle: 'Metabola vanor & dagliga protokoll',
    seasonalMealPlanChecklistDesc: 'Att följa dessa vanor dagligen fördubblar fettförbränningen och stabiliserar blodsockret.',
    seasonalMealPlanTodayStatus: 'Dagens status:',
    seasonalMealPlanStatusDone: 'Slutförd ✨',
    seasonalMealPlanStatusPending: 'Inte utförd än',
    seasonalMealPlanMarkedDone: 'Klar',
    seasonalMealPlanShoppingListTitle: 'Veckans inköpslista för {{seasonName}}',
    seasonalMealPlanShoppingListDesc: 'Nyckelråvaror för att tillgodose fibrer, nyttiga fetter och bittra ämnen denna säsong',
    seasonalMealPlanShoppingListCopyPrefix: 'Inköpslista',
    seasonalMealPlanCopyAllList: 'Kopiera hela inköpslistan',
    seasonalMealPlanCatProtein: 'Protein- & mejerikällor',
    seasonalMealPlanCatGrains: 'Ris & fiberrika baljväxter',
    seasonalMealPlanCatVeg: 'Grönsaker & bittra örter',
    seasonalMealPlanCatFat: 'Nyttiga fetter & kryddor',
    seasonalMealPlanMonthlySummaryTitle: 'Månatlig råvaruöversikt ({{seasonName}})',
    seasonalMealPlanSummProtein: 'Magert kött & fågel:',
    seasonalMealPlanSummProteinVal: 'Cirka 3,5 till 4 kg',
    seasonalMealPlanSummLegumes: 'Baljväxter & kostfiber:',
    seasonalMealPlanSummLegumesVal: 'Cirka 3 till 4 kg',
    seasonalMealPlanNutritionAnalysisTitle: 'Näringsanalys & GLP-1 Viktkontrollmekanism ({{seasonName}})',
    seasonalMealPlanNutrProtein: 'Proteinandel',
    seasonalMealPlanNutrProteinVal: '30% av dagligt energiintag',
    seasonalMealPlanNutrCarb: 'Komplexa kolhydrater',
    seasonalMealPlanNutrCarbVal: '40% (Portionskontrollerat ris)',
    seasonalMealPlanNutrFat: 'Nyttiga fetter',
    seasonalMealPlanNutrFatVal: '30% (Olivolja, valnötter)',
    seasonalMealPlanEditDayTitle: 'Redigera dag {{dayName}} (Lunch & mellanmål)',
    seasonalMealPlanPortionSizeLabel: 'Portionsstorlek:',
    seasonalMealPlanIngredientsLabel: 'Huvudingredienser:',
    seasonalMealPlanProteinLabel: 'Protein (g):',
    seasonalMealPlanCarbLabel: 'Kolhydrater (g):',
    seasonalMealPlanFatLabel: 'Fett (g):',
    seasonalMealPlanSideDishLabel: 'Rekommenderat tillbehör:',
    seasonalMealPlanSnackSettings: 'Mellanmålsinställningar',
    seasonalMealPlanSaveToFirebase: 'Spara ändringar i Firebase',
    seasonalMealPlanHabitTitleLabel: 'Vanans titel:',
    seasonalMealPlanHabitTitlePlaceholder: 't.ex. 20 minuters promenad efter lunch',
    seasonalMealPlanHabitDescLabel: 'Kort beskrivning:',
    seasonalMealPlanHabitDescPlaceholder: 't.ex. Lätt promenad för att dämpa blodsockerstoppen efter maten',
    seasonalMealPlanHabitBenefitLabel: 'Huvudsaklig hälsofördel:',
    seasonalMealPlanHabitBenefitPlaceholder: 't.ex. Ökar insulinkänsligheten och motverkar trötthet efter måltid',
    seasonalMealPlanQuestionLabel: 'Fråga eller önskemål om recept:',
    seasonalMealPlanSnackType: 'Mellanmål',
    seasonalMealPlanLunchType: 'Lunch',
    seasonalMealPlanLogLunchTitle: 'Registrera lunch i näringsdagboken',
    seasonalMealPlanLogSnackTitle: 'Registrera mellanmål i näringsdagboken',
    seasonalMealPlanMealLogged: '"{{foodTitle}}" registrerades som dagens {{mealType}} 🍲',
    seasonalMealPlanSavedSuccess: 'Ändringarna sparades framgångsrikt ✨',
    seasonalMealPlanUpdatedLocally: 'Planen uppdaterades lokalt (Logga in för att synka till molnet)',
    seasonalMealPlanSaveError: 'Fel vid sparande av ändringar',
    seasonalMealPlanResetConfirm: 'Är du säker på att du vill återställa planen för {{seasonName}} till standardmenyn?',
    seasonalMealPlanResetSuccess: 'Planen för {{seasonName}} återställdes till standardmenyn',
    seasonalMealPlanCustomHabitDesc: 'Användaranpassad hälsovana',
    seasonalMealPlanCustomHabitBenefit: 'Ökar energin och förbättrar metabol hälsa',
    seasonalMealPlanCustomHabitAdded: 'Ny vana har lagts till ✨',
    seasonalMealPlanCustomHabitRemoved: 'Anpassad vana togs bort',
    seasonalMealPlanKeyBenefitsLabel: 'Huvudfördelar:',
    seasonalMealPlanLogCoffeeToday: 'Registrera dagens kaffe ☕',
    seasonalMealPlanLogLunch: 'Registrera lunch',
    seasonalMealPlanLogSnack: 'Registrera mellanmål',
    seasonalMealPlanLogToday: 'Registrera idag',
    seasonalMealPlanLunchSettings: 'Lunchinställningar',
    seasonalMealPlanPrepTipsTitle: 'Tidsbesparande tips & snabb matlagning (Meal Prep)',
    seasonalMealPlanResetTooltip: 'Återställ denna säsongs plan till standard',
    seasonalMealPlanSaveHabitToFirebase: 'Spara vana i Firebase',
    seasonalMealPlanSelectedFood: 'Vald maträtt:',
    seasonalMealPlanSnackIngredientsLabel: 'Mellanmålsingredienser:',
    seasonalMealPlanSnackNameLabel: 'Mellanmålets namn:',
    seasonalMealPlanSnackTitle: 'Mellanmål',
    seasonalMealPlanSummOliveOil: 'Extra jungfruolivolja:',
    seasonalMealPlanSummOliveOilVal: '2 till 4 flaskor för familjen',
    weightBmiObese: 'Fetma (Obese)',
    weightBmiObeseAdv: 'Ditt BMI ligger i intervallet för fetma. Gradvis viktminskning minskar omedelbart det fysiska trycket på dina ryggdiskar. Följ en balanserad kost och regelbunden lågintensiv konditionsträning.',
    weightBmiOver: 'Övervikt',
    weightBmiOverAdv: 'Du är lätt överviktig. Måttlig viktminskning (ca 0,5 kg/vecka) i kombination med kalorispårning och lätta bålövningar minskar ryggsmärtor avsevärt.',
    weightBmiPending: 'Beräkning inväntar din längd',
    weightBmiUnderAdv: 'Vi rekommenderar att öka det dagliga kalori- och proteinintaget. Lätt styrketräning hjälper till att bygga hälsosam muskelmassa.',
    weightHistDate: 'Registreringsdatum',
    weightLogDate: 'Registrera vikt för: {{date}}',
    weightProfileHeightPh: 't.ex. 178',
    weightSaveBtn: 'Spara vikt för detta datum',
    weightSpecify: 'Ange din vikt (kg)',
    targetWeightWeeklyRate: 'Uppskattad takt: {{rate}} kg per vecka',
    seasonalMealPlanAddCustomHabit: 'Lägg till ny personlig vana',
    rehabDefaultPainLocation: 'Ländrygg & ryggrad',
    rehabDefaultLimitations: 'Begränsning vid långvarigt sittande och böjning',
    rehabDefaultEquipment: 'Yogamatta, ingen specialutrustning',
    rehabIntakeUserInfo: 'Användarens kroppsbedömningsinformation:',
    rehabPromptAiInstructions: 'Viktig instruktion: Håll svaret mycket kortfattat (max 2-3 meningar utan Markdown-symboler som ## eller ** eller tabeller) så att det direkt kan sparas som träningsinstruktioner.',
    swedishModuleTitle: 'Modul 4 — Uppföljning av Svenskainlärning',
    swedishModuleDesc: 'För att registrera framsteg och mål från andra appar; tillsammans med dagliga SFI-tips.',
    sweTaskVerbsTitle: 'Praktiska svenska verb (Svenska Verb)',
    sweTaskVerbsTopic: 'Behärskning av handlingsverb, presens, preteritum och verbböjningar',
    sweTaskVerbsDur: '10-15 min',
    sweTaskEmpTitle: 'Arbetsplats- & anställningsordförråd (Arbete & Jobb)',
    sweTaskEmpTopic: 'Kontorsuttryck, jobbansökningar, dialog med kollegor och arbetsgivare',
    sweTaskEmpDur: '10-15 min',
    sweTaskIndepTitle: 'Självständig daglig träning och studier',
    sweTaskIndepTopic: 'Uppföljning av självstudier som genomförts i andra appar',
    sweTaskIndepDur: '10-15 min',
    swedishTodayProgress: 'Dagens målframsteg',
    swedishTopicsCount: '{{completed}} av {{total}} svenska moduler',
    swedishTodayStudyTime: 'Registrerad studietid idag',
    swedishMinutesEquivalent: 'motsvarande minuter',
    swedishChecklistTitle: 'Självskattningsmoduler för svenska',
    swedishTopicDetail: 'Moduldetaljer:',
    swedishNoticeBox: '💡 Observera: Du genomför inlärningen i andra appar (såsom Duolingo, Memrise eller SFI-lektioner) och använder Vexa för kontinuerlig uppföljning av dina dagliga mål.',
    swedishDailyTipsTitle: 'Dagliga praktiska tips (3 nyckelregler i svenska)',
    swedishGetNewTips: 'Få 3 nya tips',
    swedishDailyKeyword: 'Dagens nyckelord:',
    swedishKeywordColleague: 'Arbetskamrat (Kollega)',
    swedishKeywordPronounce: 'Uttal: ar-bets-kam-rat',
    activityLogTitle: 'Modul 7 — Daglig aktivitetslogg',
    activityLogDesc: 'Registrera pendling, fysioterapibesök, rekreation, shopping och övrigt lärande med fokus på ryggradens balans.',
    activityLogActiveTime: 'Extra aktivitetstid',
    activityLogMinutesToday: 'minuter idag',
    activityLogEstimatedCalories: 'Uppskattade extra kalorier',
    activityLogActiveCalories: 'aktiva kalorier',
    activityLogPresetsTitle: 'Snabbmallar för dagliga aktiviteter',
    activityLogMinutesShort: 'min',
    activityLogManualFormTitle: 'Manuell registrering av anpassad aktivitet',
    activityLogFieldTitle: 'Aktivitetens titel',
    activityLogFieldTitlePh: 't.ex. Skonsam ryggsim',
    activityLogFieldStartTime: 'Starttid',
    activityLogFieldEndTime: 'Sluttid',
    activityLogFieldDuration: 'Varaktighet (min)',
    activityLogFieldCalories: 'Extra kalorier (valfritt)',
    activityLogFieldCaloriesPh: 't.ex. 150',
    activityLogFieldNotes: 'Kroppsliga anteckningar / smärt- & komfortobservationer',
    activityLogFieldNotesPh: 't.ex. Ingen smärta i ländryggen. Sätes- och bålmuskler aktiverades väl.',
    activityLogSaveBtn: 'Spara aktivitet',
    activityLogTodayListTitle: 'Registrerade aktiviteter idag',
    activityLogEmptyState: 'Inga extra aktiviteter registrerade för idag ännu. Använd snabbmallar eller fyll i formuläret.',
    activityLogDeleteTooltip: 'Ta bort aktivitet',
    activityLogApproxCal: 'Ungefärlig förbränning: ~{{cal}} kcal',
    schedulesHeaderSubtitle: 'Veckoplanerare & Rutinhantering',
    schedulesDownloadIcsBtn: 'Ladda ner veckoschema (.ics)',
    schedulesDownloadIcsTooltip: 'Ladda ner .ics-kalenderfil baserad på veckoschemat för nativa mobilalarm',
    schedulesTabToday: '📋 Dagens rutin',
    schedulesTabManage: '⚙️ Redigera veckoschema',
    schedulesSelectDayToManage: 'Välj veckodag för att redigera och planera:',
    schedulesCopyDayToAllWeek: 'Kopiera denna dag till hela veckan',
    schedulesCopyDayToAllWeekTooltip: 'Kopiera alla aktiviteter från den valda dagen till alla dagar i veckan',
    schedulesFormDay: 'Veckodag:',
    schedulesFormCategory: 'Kategori:',
    isRequiredTaskLabel: 'Obligatorisk aktivitet (visas i den dagliga att-göra-listan)',
    schedulesFormIsWork: 'Registrera som arbetspass',
    schedulesAddActivityTitle: 'Definiera ny aktivitet i veckoplanen',
    schedulesEditActivityTitle: 'Redigera aktivitet i veckoplanen',
    schedulesAddRoutineBtn: 'Lägg till ny aktivitet',
    schedulesRehabDescriptionPattern: 'Fysioterapi- & ryggrehabövningar ({{count}} rörelser)',
    schedulesTodayScheduleTitle: "Dagens schema & rutiner ({{day}})",
    schedulesTodayScheduleSub: "Markera dina obligatoriska uppgifter som klara för att uppdatera din dagliga status.",
    schedulesAddQuickRoutine: "Lägg till i dag",
    schedulesNoRoutinesToday: "Inga rutiner schemalagda för idag!",
    schedulesNoRoutinesTodayDesc: "Du kan definiera arbets-, utbildnings- eller träningsrutiner för idag med fliken \"Hantera veckoschema\" eller lägg till-knappen.",
    schedulesGoToManage: "Gå till veckohantering",
    schedulesCompletedStatus: "Slutförd",
    schedulesMarkComplete: "Markera som klar",
    schedulesRoutinesForDay: "Registrerade aktiviteter för {{day}}",
    schedulesFormTitlePlaceholder: "t.ex. Arbetspass, fysioterapi, svenskaklass, musikträning...",
    schedulesFormDescPlaceholder: "Valfri beskrivning, mål eller utförandedetaljer för denna aktivitet...",
    markCompleted: "Registrera slutförande",
    schedulesPendingStatus: "Ej slutförd",
    doneUnit: "klar",
    dashTimeWeightedPerformance: 'Tidsviktad prestation',
    dashScheduledMinutesDone: 'Slutförda schemalagda minuter',
    dashTimeWeight: 'Tidsvikt',
    dashTimeWeightedDesc: 'Beräknas baserat på den tid som lagts ner på varje obligatorisk händelse.',
    dashBonusMinutes: 'Bonusminuter',
    schedulesErrorSave: 'Fel vid sparning av aktivitet i D1-databasen',
    schedulesErrorDelete: 'Fel vid radering av aktivitet från D1-databasen',
    schedulesSelectedDayLabel: 'Vald dag för uppföljning och redigering:',
    schedulesRoutineCount: '{{count}} rutiner',
    schedulesEmptyDay: 'Tom',
    schedulesTasksChecklistForDay: 'Checklista för aktiviteter och rutin {{day}}',
    schedulesTasksCount: '{{count}} schemalagda aktiviteter',
    schedulesCopyAllWeek: '📋 Kopiera till hela veckan',
    schedulesCopyAllWeekTooltip: 'Kopiera schemat för denna dag till alla veckodagar',
    schedulesNoTasksTitle: 'Inget schema definierat för {{day}}',
    schedulesNoTasksDesc: 'Inga standardrutiner för denna dag. Vill du kopiera vardagsrutiner eller skapa en ny aktivitet?',
    schedulesCopyMonday: '📋 Kopiera måndagsrutin till idag',
    schedulesAddManualTask: '➕ Lägg till manuell aktivitet',
    schedulesWorkTag: 'Arbetspass',
    schedulesStudyTag: 'Utbildning / SFI',
    schedulesPhoneAlarm: 'Mobilalarm',
    schedulesPhoneAlarmTooltip: 'Alarm och mobilnotis är aktiva',
    schedulesGoogleCalTooltip: 'Lägg till i Google Kalender för personlig påminnelse',
    schedulesGoogleCalendar: 'Google Kalender',
    schedulesManageRoutineTitle: '⚙️ Redigera och ställ in rutiner för:',
    schedulesManageRoutineSubtitle: 'För att aktivera/inaktivera mobilalarm eller Google Kalender-synk, klicka direkt på knapparna på varje kort.',
    schedulesCopyThisDayToAll: 'Kopiera denna dag till hela veckan',
    schedulesAddNewRoutineBtn: 'Lägg till ny aktivitet',
    schedulesEditRoutineFormTitle: '📝 Redigera veckorutin',
    schedulesAddRoutineFormTitle: '➕ Lägg till ny rutin',
    schedulesFormDayOfWeek: '📅 Veckodag för denna aktivitet:',
    schedulesFormQuickTime: '⚡ Snabbval för starttid:',
    schedulesFormStartTime: '🕒 Starttid',
    schedulesFormEndTime: '🕒 Sluttid (valfritt)',
    schedulesFormTitle: '📝 Rutinens titel *',
    schedulesFormTitlePh: 't.ex. Arbetspass, Morgonträning, Svenska studier...',
    schedulesFormDesc: '💬 Detaljer eller mål (valfritt)',
    schedulesFormDescPh: 'Ytterligare anteckningar, mål eller instruktioner...',
    schedulesFormSyncAttendance: '🔗 Autosynkronisera närvaro:',
    schedulesFormSyncWork: 'Autoregistrera "Arbetspass"',
    schedulesFormSyncStudy: 'Autoregistrera "Utbildningsaktivitet / Kurs"',
    schedulesFormIsEducation: 'Detta är en utbildningsaktivitet (kurs/lektioner/musik)',
    sleepDuration: 'Sömntid',
    sleepOptimal: 'Optimal sömn 😴',
    sleepLong: 'Lång sömn 💤',
    sleepModerate: 'Måttlig sömn 🌙',
    sleepLow: 'För lite sömn ⚠️',
    schedulesFormPhoneAlarm: 'Mobilalarm & Notis',
    schedulesFormPhoneAlarmDesc: 'Skickar mobilnotis när aktiviteten startar.',
    schedulesFormGoogleCal: 'Google Kalender (Påminnelse)',
    schedulesFormGoogleCalDesc: 'Denna aktivitet inkluderas i .ics-filen för synkronisering.',
    schedulesCancel: 'Avbryt',
    schedulesSaveRoutine: 'Spara rutin',
    schedulesNoRoutinesForDay: 'Inga rutiner schemalagda för {{day}}.',
    schedulesNoRoutinesHint: 'Klicka på "Lägg till ny aktivitet" eller använd "Kopiera denna dag till hela veckan" för snabb installation.',
    schedulesPhoneAlarmActive: 'Mobilalarm: Aktivt',
    schedulesPhoneAlarmInactive: 'Mobilalarm: Inaktivt',
    schedulesGoogleCalActive: 'Google Kalender: Aktiv',
    schedulesGoogleCalInactive: 'Google Kalender: Inaktiv',
    schedulesQuickCopyTo: 'Snabbkopiera till:',
    schedulesEditFull: 'Redigera',
    schedulesDeleteActivity: 'Ta bort aktivitet',
    schedulesWeeklyAttendanceStatus: 'Veckovis närvarostatus (Mån - Sön)',
    schedulesWorkPresence: 'Arbetspass',
    schedulesNonWorkDay: 'Ledig',
    schedulesClassPresence: 'Utbildningspass',
    schedulesNoStudyDay: 'Ingen lektion',
    schedulesTotalWorkShifts: 'Totala arbetspass',
    schedulesWorkDaysThisWeek: 'arbetsdagar denna vecka',
    schedulesTotalClasses: 'Totala lektioner',
    schedulesClassesThisWeek: 'sessioner denna vecka',
    schedulesConfirmCopyWeek: 'Vill du kopiera schemat för {{day}} till alla veckodagar? Detta ersätter befintliga rutiner.',
    schedulesConfirmCopyMonday: 'Vill du kopiera måndagsrutinen till {{day}}?',
    schedulesConfirmDelete: 'Är du säker på att du vill ta bort denna rutin?',
    schedulesCopiedSuccess: 'Aktiviteten "{{title}}" har kopierats till {{day}}.',
    schedulesNoCalendarAlert: 'Inga aktiviteter har markerats med "Google Kalender (Påminnelse)".\n\nAktivera "Google Kalender"-knappen på aktiviteter i veckoschemat för att inkludera dem i exportfilen.',
    schedMon: 'Måndag (Mån)',
    schedTue: 'Tisdag (Tis)',
    schedWed: 'Onsdag (Ons)',
    schedThu: 'Torsdag (Tor)',
    schedFri: 'Fredag (Fre)',
    schedSat: 'Lördag (Lör)',
    schedSun: 'Söndag (Sön)',
    schedUnknownDay: 'Okänd',

    // Weight, Body Fat & BMI Module Translations
    weightBodyFatSpecify: "Kroppsfett % (Valfritt)",
    saveToD1Btn: "Spara till Cloudflare D1",
    savingToD1Btn: "Sparar...",
    physicalProfileTitle: "Anatomisk profil & mål",
    heightCmLabel: "Längd (cm)",
    targetWeightKgLabel: "Målvikt (kg)",
    targetBodyFatPctLabel: "Målkroppsfett %",
    saveProfileBtn: "Uppdatera mätmål",
    profileSavedSuccess: "Profilens mål har uppdaterats.",
    currentWeightTitle: "Nuvarande vikt",
    bmiIndexTitle: "BMI-index",
    bmiUnderweight: "Undervikt",
    bmiNormal: "Normalvikt",
    bmiOverweight: "Övervikt",
    bmiObeseCat: "Fetma",
    bmiAdviceUnder: "Din vikt är under det normala. Ökad muskelmassa med rätt näring stöder din ryggrad.",
    bmiAdviceNormal: "Ditt BMI är i ett optimalt område. Detta minskar trycket på ländkotorna.",
    bmiAdviceOver: "Något överviktig. Att gå ner 3-5 kg minskar trycket på L4-L5-diskarna med upp till 15%.",
    bmiAdviceObese: "BMI över 30 tyder på stor belastning på leder och rygg. Gradvis viktminskning rekommenderas.",
    currentBodyFatTitle: "Nuvarande kroppsfett",
    bodyFatNotLogged: "Ej loggat",
    fatCatLow: "Mycket låg (Atletisk)",
    fatCatOptimal: "Optimal & Vältränad",
    fatCatModerate: "Måttlig",
    fatCatHigh: "Hög (Behöver fettminskning)",
    distanceToWeightGoal: "Avstånd till målvikt",
    distanceToFatGoal: "Avstånd till målkroppsfett",
    goalReached: "Mål nått! 🎉",
    metricWeightToggle: "Vikt (kg)",
    metricFatToggle: "Kroppsfett (%)",
    rangeAll: "Alla poster",
    range30Days: "Senaste 30 dagarna",
    range90Days: "Senaste 90 dagarna",
    targetWeightLine: "Målvikt linje",
    targetFatLine: "Målkroppsfett linje",
    noChartData: "Inga mätdata loggade ännu. Logga din första vikt ovan.",
    noFatDataForRange: "Ingen kroppsfettdata registrerad under denna period.",
    bodyCompAiTitle: "Smart AI-analys av kroppssammansättning",
    bodyCompAiSubtitle: "Smart analys av vikt, fett och muskler baserat på D1-data",
    analyzeCurrentStateBtn: "Analysera nuvarande status",
    analyzingStateBtn: "Analyserar...",
    askMusclePreserveBtn: "Hur bevarar jag muskler?",
    calculatingBtn: "Beräknar...",
    chipCurrentWeightD1: "Nuvarande D1-vikt",
    chipWeightGoalD1: "D1 Målvikt",
    chipBodyFatCurrent: "Nuvarande kroppsfett",
    chipBodyFatGoalD1: "D1 Målkroppsfett",
    requiresDataLog: "Kräver datalogg",
    aiBodyCompResultTitle: "AI-analysresultat för kroppssammansättning",
    aiMuscleResultTitle: "Specialprotokoll för muskelbevarande vid fettminskning",
    recomTitle: "3 praktiska rekommendationer för fettminskning & muskelbevarande",
    recom1Text: "Tillräckligt proteinintag: Konsumera 1.6 till 2.2g protein per kg kroppsvikt dagligen för att förhindra muskelnedbrytning.",
    recom2Text: "Progressiv styrketräning: Utför styrketräning minst 3 gånger i veckan för att hålla muskelbevarande signaler aktiva.",
    recom3Text: "Måttligt kaloriunderskott (15-20%): Undvik svältdieter så att kroppen använder fettreserver istället för muskler som bränsle.",
    plateauTitle: "Smart felsökning för viktplatå (Plateau AI)",
    plateauSubtitle: "Om din vikt stått stilla i flera veckor, analysera fysiologiska orsaker",
    analyzePlateauBtn: "Analysera platåorsak",
    measurementHistoryTitle: "Mäthistoriktabell",
    colDate: "Datum",
    colWeight: "Vikt (kg)",
    colBodyFat: "Kroppsfett (%)",
    colBMI: "BMI",
    colActions: "Åtgärder",
    deleteRecord: "Radera post",
    confirmDeleteWeight: "Är du säker på att du vill radera denna viktpost?",
    d1DataSourceTag: "Datakälla: Cloudflare D1",
    fetchingD1HealthData: "Hämtar senaste hälsodata från Cloudflare D1...",
    nutriBackToToday: "Tillbaka till idag",
    nutriSelectDate: "Välj datum",

    // Multi-Day Physiotherapy Program System
    multiDayProgramsTab: "Flerdagars träningsprogram",
    exerciseLibraryTab: "Fristående övningsbibliotek",
    multiDayProgramsHeader: "Hantera flerdagars fysioterapi träningsprogram",
    multiDayProgramsDesc: "Skapa flerdagarsprogram, definiera dagliga övningar, importera JSON och synka med din veckorutin",
    importJsonBtn: "Importera program JSON",
    createNewProgramBtn: "Skapa nytt träningsprogram",
    noProgramsYetTitle: "Inga flerdagarsprogram har definierats ännu",
    noProgramsYetDesc: "Du kan skapa ett nytt flerdagarsprogram eller importera specialiserade JSON-mallar för fysioterapi.",
    loadSampleProgramJson: "Ladda färdigt program (JSON-exempel)",
    buildManualProgram: "Skapa manuellt program",
    activeProgramBadge: "Aktivt program",
    noProgramDesc: "Ingen ytterligare beskrivning",
    trainingDaysCount: "{{count}} träningsdagar",
    setAsActiveProgram: "Aktivera detta program",
    currentActiveProgram: "Nuvarande aktivt program",
    editProgramTooltip: "Redigera titel och egenskaper",
    deleteProgramTooltip: "Ta bort program",
    editProgramTitleModal: "Redigera träningsprogram",
    createProgramTitleModal: "Skapa nytt träningsprogram",
    programTitleLabel: "Programtitel:",
    programTitlePlaceholder: "t.ex. 21-dagars ländryggsprotokoll",
    programDescLabel: "Beskrivning & Behandlingsmål:",
    programDescPlaceholder: "t.ex. 3-stegs protokoll för ischiasavlastning...",
    programDifficultyLabel: "Svårighetsgrad:",
    difficultyBeginnerOption: "Nybörjare / Lätt",
    difficultyIntermediateOption: "Medel / Standard",
    difficultyAdvancedOption: "Avancerad / Specialiserad",
    savingProgramBtn: "Sparar...",
    saveProgramBtn: "Spara program",
    confirmDeleteProgram: "Är du säker på att du vill ta bort detta träningsprogram och alla dess dagar?",
    dbSaveError: "Fel vid sparande av program i D1-databasen.",
    dbDeleteError: "Fel vid borttagning av program från D1.",
    dbActivateError: "Fel vid aktivering av program.",
    dbUpdateDaysError: "Fel vid uppdatering av programdagar i D1.",
    addNewProgramDayBtn: "Lägg till ny träningsdag",
    programDayDefaultTitle: "Dag {{day}} — Återhämtning & Stärkning",
    runWorkoutForDay: "Kör träningspass för denna dag",
    runGuidedWorkoutForDay: "Kör guidat träningspass",
    scheduleDayInPlanner: "Schemalägg i planeraren",
    scheduleDayBtn: "Lägg till i veckorutin",
    editDayModalTitle: "Redigera dag {{day}}",
    dayTitleInputLabel: "Träningsdagstitel:",
    dayNotesInputLabel: "Anteckningar & Vägledning för denna dag:",
    dayNotesPlaceholder: "t.ex. Utför övningarna i 2 omgångar morgon och kväll...",
    tabPickFromLibrary: "Välj från bibliotek",
    tabAddCustomExercise: "Lägg till anpassad övning",
    tabJsonEditor: "JSON-textredigerare",
    selectedExercisesCount: "Valda övningar för denna dag ({{count}}):",
    noExercisesSelectedForDay: "Inga övningar valda för denna dag ännu.",
    availableLibraryExercises: "Tillgängliga biblioteksövningar (Klicka för att välja):",
    searchExercisesPlaceholder: "Sök övningar...",
    exerciseAddedTag: "Tillagd",
    addCustomExNameLabel: "Anpassat övningsnamn:",
    addCustomExNamePh: "t.ex. Gummiband ländryggssträckning",
    addCustomExSetsLabel: "Set:",
    addCustomExRepsLabel: "Repetitioner / Håll:",
    addCustomExRestLabel: "Vila mellan set:",
    addCustomExDurationLabel: "Tid (min):",
    addCustomExPurposeLabel: "Övningssyfte:",
    addCustomExTargetLabel: "Målmuskler:",
    addCustomExDescLabel: "Instruktioner:",
    addExerciseToDayBtn: "Lägg till övning i dagen",
    jsonArrayError: "JSON-formatet måste vara en matris (Array) av övningar.",
    confirmDeleteDay: "Är du säker på att du vill ta bort denna träningsdag?",
    saveDayChangesBtn: "Spara dagändringar",
    importJsonModalTitle: "Importera flerdagarsprogram (JSON)",
    jsonParseError: "Ogiltigt JSON-format: {{error}}",
    importSuccessMsg: "Träningsprogram har sparats i systemet.",
    importFailed: "Misslyckades med att importera träningsprogram.",
    pasteSampleJsonBtn: "Klistra in komplett prov-JSON",
    uploadJsonFileLabel: "Ladda upp JSON-fil",
    jsonInputLabel: "Strukturerat program-JSON-innehåll:",
    jsonInputPlaceholder: "Klistra in JSON-innehåll här...",
    importingPrograms: "Importerar...",
    scheduleDayToPlanner: "Schemalägg träningsdag i veckoplaneraren",
    timeRequired: "Starttid krävs.",
    scheduledSuccessfully: "Träningspasset schemalades i veckoplaneraren.",
    dayExerciseCountInfo: "Antal övningar denna dag: {{count}}",
    selectWeekday: "Välj veckodag:",
    startTime: "Starttid:",
    endTime: "Sluttid (valfritt):",
    enableReminder: "Aktivera påminnelse och larm",
    scheduleConfirmBtn: "Schemalägg träningspass",
    exerciseDetailModalTitle: "Fysioterapeutiska övningsdetaljer",
    viewExerciseDetails: "Visa övningsdetaljer",
    exerciseDetailClose: "Stäng",
    addToProgramModalTitle: "Lägg till övning i flerdagarsprogram",
    targetProgramLabel: "Målprogram:",
    selectProgramPlaceholder: "Välj program...",
    noProgramsAvailableWarning: "Inga flerdagarsprogram har skapats än. Skapa ett program först.",
    targetDayLabel: "Målträningsdag:",
    selectDayPlaceholder: "Välj träningsdag...",
    createNewDayOption: "+ Skapa en ny träningsdag i detta program",
    newDayTitleLabel: "Rubrik för ny träningsdag:",
    newDayTitlePlaceholder: "t.ex. Dag med fokus på bakre kedjan och ryggstabilitet",
    programDaySelectorOption: "Dag {{num}}: {{title}}",
    exerciseSetsLabel: "Set:",
    exerciseRepsLabel: "Repetitioner / Hålltid:",
    exerciseRestLabel: "Vila:",
    exerciseDurationLabel: "Uppskattad tid (minuter):",
    addToProgramBtn: "Lägg till i program",
    addingToProgram: "Lägger till...",
    exerciseAddedSuccess: "Övningen har lagts till i träningsprogrammet.",
    exerciseAddFailed: "Kunde inte lägga till övningen i programmet.",
    selectProgramAndDayWarning: "Vänligen välj både program och träningsdag.",
    exerciseScopeLabel: "Omfattning:",
    exerciseScopeGlobal: "Allmän (Systemmall)",
    exerciseScopePersonal: "Personlig (Anpassad)",
    exerciseBadgeGlobal: "Allmän",
    exerciseBadgePersonal: "Personlig",
    exerciseScopeFilterAll: "Alla övningar (Allmänna & Personliga)",
    exerciseScopeFilterGlobal: "Allmänt bibliotek",
    exerciseScopeFilterPersonal: "Mina personliga övningar",
    exercisePrecautionsLabel: "Säkerhetsföreskrifter & Försiktighet:",
    exerciseEquipmentLabel: "Utrustning som krävs:",
    exerciseEquipmentNone: "Ingen utrustning krävs (endast kroppsvikt)",
    exerciseInstructionsLabel: "Instruktioner & Rätt teknik:",
    exerciseVideoPlayerTitle: "Videospelare",
    exerciseImageAlt: "Instruktionsbild för {{name}}",
    exerciseCreatePersonalCopyBtn: "Skapa personlig kopia",
    exerciseCreatingCopy: "Skapar personlig kopia...",
    exerciseCopySuccess: "Personlig kopia har skapats och sparats i ditt bibliotek.",
    exerciseCopyFailed: "Kunde inte skapa personlig kopia.",
    exerciseGlobalCannotEdit: "Allmänna övningar kan inte redigeras eller raderas direkt. Du kan skapa en personlig kopia.",
    exerciseDeleteConfirm: "Är du säker på att du vill ta bort denna personliga övning från biblioteket?",
    exerciseDeleteSuccess: "Den personliga övningen har tagits bort.",
    exerciseDeleteFailed: "Kunde inte ta bort övningen.",
    exerciseAddToProgramAction: "Lägg till i program",
    rehabDaysCount: "{{count}} träningsdagar",
    rehabActiveProgramCurrent: "Nuvarande aktivt program",
    rehabEditProgram: "Redigera träningsprogram",
    rehabCreateProgram: "Skapa nytt träningsprogram",
    rehabProgramTitleLabel: "Programrubrik:",
    rehabProgramTitlePlaceholder: "t.ex. 21-dagars program för diskbråck och ryggstabilitet",
    rehabProgramDescLabel: "Beskrivning & Rehabiliteringsmål:",
    rehabProgramDescPlaceholder: "t.ex. 3-stegs protokoll för att avlasta ischiasnerven...",
    rehabDifficultyLabel: "Svårighetsgrad:",
    rehabDiffBeginner: "Nybörjare / Lätt",
    rehabDiffIntermediate: "Medel / Standard",
    rehabDiffAdvanced: "Avancerad / Intensiv",
    rehabBeginner: "Nybörjare",
    rehabIntermediate: "Medel",
    rehabAdvanced: "Avancerad",
    rehabSaveBtn: "Spara program",
    dbProgramSaveError: "Fel vid sparande av program i D1-databasen.",
    dbProgramDeleteError: "Fel vid borttagning av program från D1.",
    dbProgramActivateError: "Fel vid aktivering av program.",
    dbProgramUpdateDaysError: "Fel vid uppdatering av programdagar i D1.",
    manageProgramDaysTitle: "Hantera dagar för '{{title}}'",
    totalDaysDesigned: "Totalt designade dagar: {{count}} dagar",
    noDaysInProgramYet: "Inga träningsdagar har definierats för detta program än.",
    startGuidedWorkoutBtn: "Starta röstguidat träningspass",
    scheduleWorkoutBtn: "Schemalägg träningspass",
    selectDayToViewLabel: "Välj dag att hantera:",
    dayNumberLabel: "Dag {{num}}",
    dayNumberOption: "Dag {{num}}",
    editDayTitleAndNotes: "Redigera dagens rubrik & anteckningar",
    closeDayEdit: "Stäng",
    dayTitleFieldLabel: "Dagens rubrik:",
    dayTitleFieldPh: "t.ex. Dag 1 — Dekompression & Psoas-stretch",
    dayNotesFieldLabel: "Träningsanteckningar och kliniska råd för denna dag:",
    dayNotesFieldPh: "t.ex. Gör dessa övningar före frukost...",
    saveDayDetailsBtn: "Spara dagändringar",
    deleteThisDayBtn: "Ta bort denna dag",
    addNewTrainingDayBtn: "Lägg till ny träningsdag",
    openDayJsonEditorBtn: "Redigera dagens JSON",
    exercisesInDayCount: "{{count}} övningar denna dag",
    exercisesInDayHeading: "Registrerade övningar för dag {{day}} ({{count}}):",
    hasVideoInstruction: "Innehåller instruktionsvideo",
    hasImageInstruction: "Innehåller guidebild",
    viewCompleteExerciseDetails: "Visa fullständiga övningsdetaljer och media",
    clickForCompleteDetails: "Klicka för fullständiga detaljer",
    addExerciseToDaySelect: "Lägg till från övningsbiblioteket...",
    addNewCustomExerciseToDay: "Skapa ny anpassad övning",
    noExercisesInDay: "Inga övningar har definierats för denna dag än.",
    addFirstExercisePrompt: "Välj en övning från biblioteket ovan eller skapa en ny.",
    confirmRemoveExerciseFromDay: "Är du säker på att du vill ta bort denna övning från denna dag?",
    editDayExercisesJsonTitle: "Redigera JSON för dagens övningar",
    jsonSaveBtn: "Tillämpa JSON-ändringar",
    customExerciseNameLabel: "Övningsnamn:",
    customExerciseNamePh: "t.ex. Sittande piriformis-stretch",
    customExerciseTargetLabel: "Målmuskler:",
    customExerciseTargetPh: "t.ex. Sätesmuskel, Ischiasnerv",
    customExerciseCategoryLabel: "Kategori:",
    customExerciseDifficultyLabel: "Svårighetsgrad:",
    customExerciseSetsLabel: "Set:",
    customExerciseRepsLabel: "Repetitioner / Hålltid:",
    customExerciseRepsPh: "t.ex. 10 repetitioner eller 30 sekunder",
    customExerciseRestLabel: "Vila:",
    customExerciseRestPh: "t.ex. 20 sekunder",
    customExerciseDurationLabel: "Total tid (minuter):",
    customExerciseDescLabel: "Instruktioner & Rätt teknik:",
    customExerciseDescPh: "Beskriv korrekt utförande steg för steg...",
    customExercisePrecautionsLabel: "Säkerhetsföreskrifter & Försiktighet:",
    customExercisePrecautionsPh: "t.ex. Minska stretchvinkeln om obehag i knät uppstår...",
    customExerciseEquipmentLabel: "Utrustning som krävs:",
    customExerciseEquipmentPh: "t.ex. Matta, gummiband, stol...",
    saveAndAddToDayBtn: "Spara och lägg till i dagen",
    copyTemplate: "Kopiera mall",
    sampleCopied: "JSON-mallen kopierades till urklipp.",
    programStartImportBtn: "Importera och spara i databasen",
    programJsonEmptyError: "Vänligen ange JSON-innehåll för programmet.",
    programJsonSyntaxError: "JSON-syntaxfel: {{err}}",
    catRehab: "Fysioterapi & Rehab",
    catCardio: "Kondition & Kardio",
    catStrength: "Styrka & Uthållighet",
    catMobility: "Rörlighet & Stretch",
    rehabSets: "Set",
    rehabReps: "Repetitioner",
    rehabRest: "Vila",
    rehabDuration: "Varaktighet",
    rehabTargetMusclesShort: "Målmuskler",
    rehabEquipmentShort: "Utrustning",
    rehabPrecautionsShort: "Försiktighet",
    rehabCategoryShort: "Kategori",
    rehabDifficultyShort: "Svårighetsgrad",
    rehabNoDescription: "Ingen ytterligare beskrivning",
    rehabEditTitle: "Redigera rubrik & egenskaper",
    rehabDeleteTitle: "Ta bort program",
    syncCloudTooltip: "Synka med Cloudflare D1-databasen",
    syncCloudDbTooltip: "Synka med Cloudflare D1-databasen",
    selectProgramError: "Vänligen välj ett träningsprogram.",
    noMultiDayProgramsWarning: "Inga flerdagarsprogram har skapats än. Skapa ett program under Flerdagarsprogram först.",
    dayPrefix: "Dag",
    exerciseAddedToProgramSuccess: 'Övningen "{{name}}" har lagts till i träningsprogrammet.',
    dayDefaultTitle: "Dag {{day}} — Återhämtning & Styrka",
    dayNumberFallback: "Dag {{day}}",
    dayNotesLabel: "Dagsanteckningar",
    noExercisesInDayWarning: "Inga övningar har registrerats för denna dag än. Klicka på Redigera för att lägga till övningar.",
    exercisesCountUnit: "övningar",
    rehabRestDefault: "20s",
    rehabFilterAll: "Alla övningar",
    rehabFilterGlobal: "Gemensamma",
    rehabFilterPersonal: "Personliga",
    rehabScopeGlobalBadge: "Gemensam",
    rehabScopePersonalBadge: "Personlig",
    rehabScopeGlobalDesc: "Gemensam standardövning som delas av alla användare",
    rehabScopePersonalDesc: "Din personliga anpassade övning",
    confirmCreatePersonalCopy: "Detta är en gemensam övning och kan inte redigeras direkt. Vill du skapa en personlig kopia för att anpassa den?",
    createPersonalCopyTooltip: "Skapa en personlig kopia för anpassning",
    globalExerciseLockedTooltip: "Gemensamma övningar är skyddade och kan inte tas bort direkt",
    createPersonalCopyConfirmPrompt: "En personlig kopia skapas för att anpassa denna gemensamma övning. Fortsätta?",
    addToMyProgramTooltip: "Lägg till denna övning i dina flerdagarsprogram",
    createPersonalCopyTooltip2: "Kopiera denna gemensamma övning till din personliga lista för fri anpassning",
    viewCompleteDetailsTooltip: "Visa fullständiga instruktioner, video, bild, målmuskler och försiktighetsåtgärder",
    noExercisesInScopeCategory: "Inga övningar hittades i denna kategori.",
    noPersonalExercisesYet: "Du har inte skapat några personliga övningar än. Börja med att lägga till en anpassad övning eller skapa en personlig kopia av en gemensam övning.",
    copying: "Kopierar...",
    createPersonalCopy: "Skapa personlig kopia",
    publishToGlobal: "Publicera till gemensamt bibliotek",
    publishToGlobalTooltip: "Publicera denna övning till det gemensamma biblioteket för alla användare (endast admin)",
    publishingToGlobal: "Publicerar...",
    publishToGlobalConfirm: "Är du säker på att du vill publicera denna övning till D1 gemensamma bibliotek? Efter publicering kommer den att vara tillgänglig för alla användare som en standardövning.",
    publishToGlobalSuccess: 'Övningen "{{name}}" har publicerats till D1 gemensamma bibliotek.',
    publishToGlobalError: "Fel vid publicering av övning till gemensamt bibliotek: {{err}}",
    publishToGlobalForbidden: "Obehörig: Endast admin (salim.zarepour@gmail.com) kan publicera övningar till det gemensamma biblioteket.",
    publishToGlobalGenericError: "Fel vid publicering av övning till gemensamt bibliotek",
    publishAllToGlobal: "Publicera alla personliga övningar till gemensamt bibliotek",
    publishAllToGlobalTooltip: "Publicera alla behöriga personliga övningar till D1 gemensamma bibliotek på ett säkert sätt (Endast admin)",
    publishAllConfirmTitle: "Masspublicera övningar till gemensamt bibliotek",
    publishAllConfirmDesc: "Är du säker på att du vill publicera alla {{count}} personliga övningar till D1 gemensamma bibliotek? Befintliga publiceringar uppdateras säkert utan dubbletter och nya registreras som gemensamma.",
    publishAllStatusProcessing: "Bearbetar och synkar i grupp med D1 gemensamma bibliotek...",
    publishAllResultsTitle: "Resultat för masspublicering",
    publishAllStatTotal: "Totalt bearbetade",
    publishAllStatPublished: "Nypublicerade",
    publishAllStatAlready: "Redan publicerade (synkade)",
    publishAllStatFailed: "Misslyckades",
    publishAllNoPersonalFound: "Inga personliga övningar hittades att publicera.",
    publishAllCloseBtn: "Stäng & Uppdatera",
    startPublishAllBtn: "Starta masspublicering",
    publishedBadge: "Publicerad till gemensamt",
    publishedBadgeTooltip: "Denna övning är kopplad till det gemensamma biblioteket; dina ändringar synkas automatiskt.",
    syncGlobalNotice: "Automatisk synkronisering med gemensam post är aktiv",
  }
};

export function applyLanguageToDocument(lang: Language): void {
  const dir = lang === 'fa' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lang);
}

export function getAppLanguage(): Language {
  const saved = localStorage.getItem('app_language');
  if (saved === 'en' || saved === 'sv' || saved === 'fa') {
    return saved;
  }
  return 'fa';
}

export function setAppLanguage(lang: Language): void {
  localStorage.setItem('app_language', lang);
  applyLanguageToDocument(lang);
  window.dispatchEvent(new CustomEvent('app-language-changed', { detail: { lang } }));
}

export function translate(
  lang: Language,
  key: string,
  defaultTextOrParams?: string | Record<string, string | number>,
  paramsObject?: Record<string, string | number>
): string {
  const langDict = translations[lang] || translations.fa;
  let defaultText = '';
  let params: Record<string, string | number> | undefined;

  if (typeof defaultTextOrParams === 'string') {
    defaultText = defaultTextOrParams;
    params = paramsObject;
  } else if (typeof defaultTextOrParams === 'object' && defaultTextOrParams !== null) {
    params = defaultTextOrParams as Record<string, string | number>;
  } else if (paramsObject && typeof paramsObject === 'object') {
    params = paramsObject;
  }

  // Strict non-cross-contamination: do not fall back to Persian when user selected Swedish or English
  let text = langDict[key];
  if (!text) {
    if (lang === 'sv') {
      text = translations.en?.[key] || (defaultText && !/[\u0600-\u06FF]/.test(defaultText) ? defaultText : '') || key;
    } else if (lang === 'en') {
      text = (defaultText && !/[\u0600-\u06FF]/.test(defaultText) ? defaultText : '') || key;
    } else {
      text = translations.fa?.[key] || defaultText || key;
    }
  }

  if (params) {
    Object.keys(params).forEach(param => {
      text = text.split(`{{${param}}}`).join(String(params![param] ?? ''));
    });
  }
  return text;
}

export interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: string, defaultTextOrParams?: string | Record<string, string | number>, params?: Record<string, string | number>) => string;
  dir: 'rtl' | 'ltr';
}

export const LanguageContext = createContext<LanguageContextType>({
  lang: 'fa',
  setLang: () => {},
  t: (key: string, defaultTextOrParams?: string | Record<string, string | number>, params?: Record<string, string | number>) => {
    return translate('fa', key, defaultTextOrParams, params);
  },
  dir: 'rtl',
});

export const useLanguage = () => useContext(LanguageContext);

export function formatNumberByLang(num: string | number | undefined | null, lang: Language): string {
  if (num === undefined || num === null) return '';
  const str = String(num);
  if (lang === 'fa') {
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return str.replace(/[0-9]/g, (w) => persianDigits[parseInt(w, 10)]);
  }
  return str;
}
